webpackJsonp([1],Array(886).concat([
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year())) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(1125)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)(module)))

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return H1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return H2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return H3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return H4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return H5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return H6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return T1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return T2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return L1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return L2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return L2R; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return L3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return L4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return L4R; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return P1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return P1R; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return P2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_react__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typography_css__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typography_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__typography_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Text = function (_MyPureComponent) {
  _inherits(Text, _MyPureComponent);

  function Text(props) {
    _classCallCheck(this, Text);

    var _this = _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).call(this, props));

    _this.config = {
      component: 'p'
    };
    return _this;
  }

  _createClass(Text, [{
    key: 'render',
    value: function render() {
      var Component = this.config.component;

      var _props = this.props,
          className = _props.className,
          otherProps = _objectWithoutProperties(_props, ['className']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Component,
        _extends({
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a[this.config.className], _defineProperty({}, className, className))
        }, otherProps),
        this.props.children
      );
    }
  }]);

  return Text;
}(__WEBPACK_IMPORTED_MODULE_5__lib_react__["a" /* MyPureComponent */]);

var Header = function (_Text) {
  _inherits(Header, _Text);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  return Header;
}(Text);

var Label = function (_Text2) {
  _inherits(Label, _Text2);

  function Label(props) {
    _classCallCheck(this, Label);

    var _this3 = _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).call(this, props));

    _this3.config = _extends({}, _this3.config, {
      component: 'span'
    });
    return _this3;
  }

  return Label;
}(Text);

var Paragraph = function (_Text3) {
  _inherits(Paragraph, _Text3);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).apply(this, arguments));
  }

  return Paragraph;
}(Text);

var H1Comp = function (_Header) {
  _inherits(H1Comp, _Header);

  function H1Comp(props) {
    _classCallCheck(this, H1Comp);

    var _this5 = _possibleConstructorReturn(this, (H1Comp.__proto__ || Object.getPrototypeOf(H1Comp)).call(this, props));

    _this5.config = _extends({}, _this5.config, {
      component: 'h1',
      className: 'H1'
    });
    return _this5;
  }

  return H1Comp;
}(Header);

var H1 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(H1Comp);

var H2Comp = function (_Header2) {
  _inherits(H2Comp, _Header2);

  function H2Comp(props) {
    _classCallCheck(this, H2Comp);

    var _this6 = _possibleConstructorReturn(this, (H2Comp.__proto__ || Object.getPrototypeOf(H2Comp)).call(this, props));

    _this6.config = _extends({}, _this6.config, {
      component: 'h2',
      className: 'H2'
    });
    return _this6;
  }

  return H2Comp;
}(Header);

var H2 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(H2Comp);

var H3Comp = function (_Header3) {
  _inherits(H3Comp, _Header3);

  function H3Comp(props) {
    _classCallCheck(this, H3Comp);

    var _this7 = _possibleConstructorReturn(this, (H3Comp.__proto__ || Object.getPrototypeOf(H3Comp)).call(this, props));

    _this7.config = _extends({}, _this7.config, {
      component: 'h3',
      className: 'H3'
    });
    return _this7;
  }

  return H3Comp;
}(Header);

var H3 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(H3Comp);

var H4Comp = function (_Header4) {
  _inherits(H4Comp, _Header4);

  function H4Comp(props) {
    _classCallCheck(this, H4Comp);

    var _this8 = _possibleConstructorReturn(this, (H4Comp.__proto__ || Object.getPrototypeOf(H4Comp)).call(this, props));

    _this8.config = _extends({}, _this8.config, {
      component: 'h4',
      className: 'H4'
    });
    return _this8;
  }

  return H4Comp;
}(Header);

var H4 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(H4Comp);

var H5Comp = function (_Header5) {
  _inherits(H5Comp, _Header5);

  function H5Comp(props) {
    _classCallCheck(this, H5Comp);

    var _this9 = _possibleConstructorReturn(this, (H5Comp.__proto__ || Object.getPrototypeOf(H5Comp)).call(this, props));

    _this9.config = _extends({}, _this9.config, {
      component: 'h5',
      className: 'H5'
    });
    return _this9;
  }

  return H5Comp;
}(Header);

var H5 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(H5Comp);

var H6Comp = function (_Header6) {
  _inherits(H6Comp, _Header6);

  function H6Comp(props) {
    _classCallCheck(this, H6Comp);

    var _this10 = _possibleConstructorReturn(this, (H6Comp.__proto__ || Object.getPrototypeOf(H6Comp)).call(this, props));

    _this10.config = _extends({}, _this10.config, {
      component: 'h6',
      className: 'H6'
    });
    return _this10;
  }

  return H6Comp;
}(Header);

var H6 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(H6Comp);

var T1Comp = function (_H1Comp) {
  _inherits(T1Comp, _H1Comp);

  function T1Comp(props) {
    _classCallCheck(this, T1Comp);

    var _this11 = _possibleConstructorReturn(this, (T1Comp.__proto__ || Object.getPrototypeOf(T1Comp)).call(this, props));

    _this11.config = _extends({}, _this11.config, {
      className: 'T1'
    });
    return _this11;
  }

  return T1Comp;
}(H1Comp);

var T1 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(T1Comp);

var T2Comp = function (_H2Comp) {
  _inherits(T2Comp, _H2Comp);

  function T2Comp(props) {
    _classCallCheck(this, T2Comp);

    var _this12 = _possibleConstructorReturn(this, (T2Comp.__proto__ || Object.getPrototypeOf(T2Comp)).call(this, props));

    _this12.config = _extends({}, _this12.config, {
      className: 'T2'
    });
    return _this12;
  }

  return T2Comp;
}(H2Comp);

var T2 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(T2Comp);

var L1Comp = function (_Label) {
  _inherits(L1Comp, _Label);

  function L1Comp(props) {
    _classCallCheck(this, L1Comp);

    var _this13 = _possibleConstructorReturn(this, (L1Comp.__proto__ || Object.getPrototypeOf(L1Comp)).call(this, props));

    _this13.config = _extends({}, _this13.config, {
      className: 'L1'
    });
    return _this13;
  }

  return L1Comp;
}(Label);

var L1 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(L1Comp);

var L2Comp = function (_Label2) {
  _inherits(L2Comp, _Label2);

  function L2Comp(props) {
    _classCallCheck(this, L2Comp);

    var _this14 = _possibleConstructorReturn(this, (L2Comp.__proto__ || Object.getPrototypeOf(L2Comp)).call(this, props));

    _this14.config = _extends({}, _this14.config, {
      className: 'L2'
    });
    return _this14;
  }

  return L2Comp;
}(Label);

var L2 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(L2Comp);

var L2RComp = function (_L2Comp) {
  _inherits(L2RComp, _L2Comp);

  function L2RComp(props) {
    _classCallCheck(this, L2RComp);

    var _this15 = _possibleConstructorReturn(this, (L2RComp.__proto__ || Object.getPrototypeOf(L2RComp)).call(this, props));

    _this15.config = _extends({}, _this15.config, {
      className: 'L2R'
    });
    return _this15;
  }

  return L2RComp;
}(L2Comp);

var L2R = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(L2RComp);

var L3Comp = function (_Label3) {
  _inherits(L3Comp, _Label3);

  function L3Comp(props) {
    _classCallCheck(this, L3Comp);

    var _this16 = _possibleConstructorReturn(this, (L3Comp.__proto__ || Object.getPrototypeOf(L3Comp)).call(this, props));

    _this16.config = _extends({}, _this16.config, {
      className: 'L3'
    });
    return _this16;
  }

  return L3Comp;
}(Label);

var L3 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(L3Comp);

var L4Comp = function (_Label4) {
  _inherits(L4Comp, _Label4);

  function L4Comp(props) {
    _classCallCheck(this, L4Comp);

    var _this17 = _possibleConstructorReturn(this, (L4Comp.__proto__ || Object.getPrototypeOf(L4Comp)).call(this, props));

    _this17.config = _extends({}, _this17.config, {
      className: 'L4'
    });
    return _this17;
  }

  return L4Comp;
}(Label);

var L4 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(L4Comp);

var L4RComp = function (_L4Comp) {
  _inherits(L4RComp, _L4Comp);

  function L4RComp(props) {
    _classCallCheck(this, L4RComp);

    var _this18 = _possibleConstructorReturn(this, (L4RComp.__proto__ || Object.getPrototypeOf(L4RComp)).call(this, props));

    _this18.config = _extends({}, _this18.config, {
      className: 'L4R'
    });
    return _this18;
  }

  return L4RComp;
}(L4Comp);

var L4R = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(L4RComp);

var P1Comp = function (_Paragraph) {
  _inherits(P1Comp, _Paragraph);

  function P1Comp(props) {
    _classCallCheck(this, P1Comp);

    var _this19 = _possibleConstructorReturn(this, (P1Comp.__proto__ || Object.getPrototypeOf(P1Comp)).call(this, props));

    _this19.config = _extends({}, _this19.config, {
      className: 'P1'
    });
    return _this19;
  }

  return P1Comp;
}(Paragraph);

var P1 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(P1Comp);

var P1RComp = function (_P1Comp) {
  _inherits(P1RComp, _P1Comp);

  function P1RComp(props) {
    _classCallCheck(this, P1RComp);

    var _this20 = _possibleConstructorReturn(this, (P1RComp.__proto__ || Object.getPrototypeOf(P1RComp)).call(this, props));

    _this20.config = _extends({}, _this20.config, {
      className: 'P1R'
    });
    return _this20;
  }

  return P1RComp;
}(P1Comp);

var P1R = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(P1RComp);

var P2Comp = function (_Paragraph2) {
  _inherits(P2Comp, _Paragraph2);

  function P2Comp(props) {
    _classCallCheck(this, P2Comp);

    var _this21 = _possibleConstructorReturn(this, (P2Comp.__proto__ || Object.getPrototypeOf(P2Comp)).call(this, props));

    _this21.config = _extends({}, _this21.config, {
      className: 'P2'
    });
    return _this21;
  }

  return P2Comp;
}(Paragraph);

var P2 = __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__typography_css___default.a)(P2Comp);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Brandmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return Wordmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Caret; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Details; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return Refresh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return Grid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EmotionHappy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return EmotionSad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EmotionExciting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EmotionChill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EmotionDark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return Info; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return Inside; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return Outside; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return Working; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return Profile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Arrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return Filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return Search; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Check; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return Money; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return TakeAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return VideoCamera; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CheckedBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Bundle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return WordCloud; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MegaPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Calendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return LineArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return MoneyCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return MotionDesigner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GraphicDesigner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CopyWriter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return VideoEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return Videographer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ContentStrategist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return LongLineArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CostArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CirclePlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ThumbsUp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_react__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Style__ = __webpack_require__(350);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Icon = function (_MyPureComponent) {
  _inherits(Icon, _MyPureComponent);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  return Icon;
}(__WEBPACK_IMPORTED_MODULE_4__lib_react__["a" /* MyPureComponent */]);

Icon.propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Icon.defaultProps = {
  style: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */],
  color: __WEBPACK_IMPORTED_MODULE_5__Style__["a" /* default */].Colors.black
};

var _ref = _jsx('path', {
  d: 'M7.778 30.095c2.578 0 4.667-2.144 4.667-4.79s-2.09-4.79-4.667-4.79-4.667 2.144-4.667 4.79 2.09 4.79 4.67 4.79zm0 3.194C3.482 33.29 0 29.71 0 25.3s3.482-7.985 7.778-7.985c4.296 0 7.78 3.574 7.78 7.984s-3.484 7.98-7.78 7.98zm35.9-3.2c2.578 0 4.667-2.15 4.667-4.79s-2.09-4.79-4.667-4.79-4.667 2.14-4.667 4.79 2.09 4.79 4.67 4.79zm0 3.19c-4.296 0-7.778-3.58-7.778-7.99s3.482-7.99 7.778-7.99c4.296 0 7.78 3.572 7.78 7.982s-3.484 7.984-7.78 7.984z'
});

var _ref2 = _jsx('path', {
  d: 'M31.668 3.596c.41.567.886 1.502 1.502 2.933.306.71 1.526 3.69 1.823 4.39 1.18 2.77 2.17 4.72 3.303 6.26 1.562 2.13 3.32 3.33 5.388 3.31l-.028-3.2c-.9.005-1.846-.64-2.872-2.04-.95-1.3-1.85-3.06-2.94-5.627-.283-.67-1.508-3.66-1.828-4.404-.705-1.637-1.265-2.74-1.853-3.55-.36-.496-.735-.885-1.157-1.165-.57-.375-1.21-.54-1.875-.423-.63.11-1.18.455-1.66.98-.39.423-.74.98-1.09 1.68-1.28 2.583-2.61 7.623-4.18 15.84-1.83 9.617-3.51 16.676-5.03 21.42-.7 2.17-1.36 3.83-1.98 5.01-.51.974-.96 1.55-1.28 1.75-.21-.154-.51-.538-.85-1.144-.69-1.26-1.36-3.094-2.26-6.065l-.343-1.157c-.04-.125-.167-.555-.17-.573-.07-.227-.12-.4-.173-.57-.275-.91-.477-1.565-.674-2.173-.527-1.62-.964-2.72-1.434-3.495-.23-.38-.475-.69-.76-.94-.42-.366-.92-.585-1.49-.57l.08 3.19c-.157.006-.3-.024-.426-.08-.08-.032-.138-.07-.177-.104.046.06.084.117.127.19.305.497.67 1.42 1.124 2.815.187.58.383 1.22.65 2.11l.17.566c.004.02.133.45.17.577l.35 1.17c.97 3.18 1.688 5.16 2.53 6.69.584 1.05 1.206 1.83 1.95 2.3 1.02.64 2.19.65 3.24-.02 1.63-1.04 3.054-3.74 4.58-8.48C23.7 36.11 25.4 28.93 27.26 19.192c1.513-7.93 2.793-12.77 3.9-15.01.153-.31.296-.553.423-.732l.096.125z'
});

var _ref3 = _jsx('path', {
  d: 'M21 41.514h7.822V6.682h-7.82v34.832zM31.935 3.376V44.82H17.89V3.376h14.044z'
});

var Brandmark = function (_Icon) {
  _inherits(Brandmark, _Icon);

  function Brandmark() {
    _classCallCheck(this, Brandmark);

    return _possibleConstructorReturn(this, (Brandmark.__proto__ || Object.getPrototypeOf(Brandmark)).apply(this, arguments));
  }

  _createClass(Brandmark, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          style = _props.style,
          otherProps = _objectWithoutProperties(_props, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '5.2rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 52 50',
          style: mergedStyle
        }, otherProps),
        _ref,
        _ref2,
        _ref3
      );
    }
  }]);

  return Brandmark;
}(Icon);

var _ref4 = _jsx('path', {
  d: 'M.378 8.024c.354 2.004 1.99 3.168 4.3 3.168 2.193 0 3.846-1.233 3.846-3.27 0-1.593-1.03-2.57-2.715-2.963l-1.89-.446c-.776-.19-1.164-.548-1.164-1.147 0-.754.658-1.233 1.636-1.233 1.08 0 1.67.548 1.906 1.25H8.44C8.103 1.604 6.737.336 4.375.336 2.2.336.648 1.67.648 3.572c0 1.73 1.147 2.534 2.63 2.877l1.856.427c.894.205 1.265.548 1.265 1.18 0 .84-.692 1.32-1.738 1.32-1.012 0-1.77-.428-2.058-1.353H.378zm9.95.685c0 1.694.962 2.465 2.497 2.465.557 0 1.063-.086 1.35-.24V9.052c-.237.154-.59.256-.91.256-.54 0-.86-.274-.86-.873V5.08h1.652V3.366h-1.653V1.295H10.33v2.072H9.18V5.08h1.147v3.63zM22.54 7.2c0 2.346-1.5 3.99-3.693 3.99s-3.694-1.644-3.694-3.99c0-2.363 1.5-4.007 3.694-4.007 2.192 0 3.693 1.644 3.693 4.007zm-2.074 0c0-1.284-.574-2.21-1.62-2.21-1.045 0-1.62.926-1.62 2.21 0 1.267.575 2.192 1.62 2.192 1.046 0 1.62-.925 1.62-2.192zm7.978-3.87c-.12-.068-.44-.137-.793-.137-.74 0-1.365.377-1.686.925v-.753h-2.09v7.654h2.09V6.28c.152-.703.725-1.08 1.434-1.08.388 0 .76.086 1.046.258V3.332zm4.503 10.514l3.93-10.48h-2.11l-1.72 5.086-1.736-5.085H29.1l2.885 7.688-1.096 2.79h2.057zm5.515-5.137c0 1.694.962 2.465 2.496 2.465.557 0 1.063-.086 1.35-.24V9.052c-.236.154-.59.256-.91.256-.54 0-.86-.274-.86-.873V5.08h1.652V3.366h-1.653V1.295h-2.075v2.072h-1.147V5.08h1.147v3.63zm11.436 2.31H47.89v-.41c-.253.257-1.012.548-1.838.548-1.518 0-2.8-.89-2.8-2.483 0-1.456 1.282-2.45 2.918-2.45.658 0 1.417.224 1.72.446v-.564c0-.65-.388-1.18-1.23-1.18-.59 0-.945.273-1.114.718h-1.99c.22-1.387 1.45-2.45 3.17-2.45 2.008 0 3.172 1.114 3.172 2.947v4.88zM47.89 8.933v-.548c-.185-.41-.76-.668-1.366-.668-.658 0-1.332.29-1.332.942 0 .668.674.942 1.332.942.607 0 1.18-.257 1.366-.668zm5.802 1.455v3.46h-2.09V3.366h2.09V4c.338-.41 1.08-.805 1.89-.805 2.192 0 3.44 1.85 3.44 4.007 0 2.158-1.248 3.99-3.44 3.99-.81 0-1.552-.394-1.89-.805zm0-4.452v2.517c.253.53.81.89 1.417.89 1.13 0 1.804-.924 1.804-2.14 0-1.233-.675-2.157-1.805-2.157-.625 0-1.165.376-1.418.89zM65.01 8.52h1.94c-.27 1.627-1.45 2.672-3.34 2.672-2.193 0-3.66-1.627-3.66-3.99 0-2.31 1.518-4.007 3.626-4.007 2.21 0 3.424 1.56 3.424 3.802v.65h-5.026c.067 1.148.708 1.833 1.636 1.833.708 0 1.23-.31 1.4-.96zm-1.417-3.595c-.81 0-1.383.496-1.57 1.438h2.92c-.018-.805-.49-1.438-1.35-1.438z'
});

var Wordmark = function (_Icon2) {
  _inherits(Wordmark, _Icon2);

  function Wordmark() {
    _classCallCheck(this, Wordmark);

    return _possibleConstructorReturn(this, (Wordmark.__proto__ || Object.getPrototypeOf(Wordmark)).apply(this, arguments));
  }

  _createClass(Wordmark, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          color = _props2.color,
          style = _props2.style,
          otherProps = _objectWithoutProperties(_props2, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '6.7rem',
        fillRule: 'evenodd',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 67 14',
          style: mergedStyle
        }, otherProps),
        _ref4
      );
    }
  }]);

  return Wordmark;
}(Icon);

var _ref5 = _jsx('path', {
  d: 'M2.5 2.5l21 21M23.5 2.5l-21 21'
});

var X = function (_Icon3) {
  _inherits(X, _Icon3);

  function X() {
    _classCallCheck(this, X);

    return _possibleConstructorReturn(this, (X.__proto__ || Object.getPrototypeOf(X)).apply(this, arguments));
  }

  _createClass(X, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          color = _props3.color,
          style = _props3.style,
          otherProps = _objectWithoutProperties(_props3, ['color', 'style']);

      var mergedStyle = _extends({
        stroke: color,
        strokeWidth: 3,
        strokeLinecap: 'square',
        maxWidth: '2.6rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 26 26',
          style: mergedStyle
        }, otherProps),
        _ref5
      );
    }
  }]);

  return X;
}(Icon);

var _ref6 = _jsx('path', {
  id: 'Line',
  d: 'M14.77 1.27L8.37 8.6M8 8L1 1'
});

var Caret = function (_Icon4) {
  _inherits(Caret, _Icon4);

  function Caret() {
    _classCallCheck(this, Caret);

    return _possibleConstructorReturn(this, (Caret.__proto__ || Object.getPrototypeOf(Caret)).apply(this, arguments));
  }

  _createClass(Caret, [{
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          color = _props4.color,
          style = _props4.style,
          otherProps = _objectWithoutProperties(_props4, ['color', 'style']);

      var mergedStyle = _extends({
        stroke: color,
        strokeWidth: 1.5,
        strokeLinecap: 'square',
        maxWidth: '1.6rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 16 10',
          style: mergedStyle
        }, otherProps),
        _ref6
      );
    }
  }]);

  return Caret;
}(Icon);

var _ref7 = _jsx('path', {
  d: 'M47.43.55H4.57c-1.72 0-3.12 1.4-3.12 3.15v22.6c0 1.74 1.4 3.15 3.12 3.15h42.86c1.72 0 3.12-1.4 3.12-3.15V3.7c0-1.74-1.4-3.15-3.12-3.15zM49.1 26.3c0 .93-.75 1.68-1.67 1.68H4.57c-.92 0-1.66-.75-1.66-1.68V3.7c0-.93.78-1.68 1.7-1.68h42.86c.92 0 1.66.75 1.66 1.68v22.6z'
});

var _ref8 = _jsx('path', {
  d: 'M6.45 22.67h15.3V7.24H6.45v15.43zM7.9 8.72h12.4V21.2H7.9V8.7zm17.74-1.44h18.48v1.48H25.64zm0 6.98h16.82v1.48H25.64zm0 6.98h18.48v1.48H25.64z'
});

var Details = function (_Icon5) {
  _inherits(Details, _Icon5);

  function Details() {
    _classCallCheck(this, Details);

    return _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).apply(this, arguments));
  }

  _createClass(Details, [{
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          color = _props5.color,
          style = _props5.style,
          otherProps = _objectWithoutProperties(_props5, ['color', 'style']);

      var mergedStyle = _extends({
        stroke: color,
        strokeWidth: 1.5,
        strokeLinecap: 'square',
        maxWidth: '5.2rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 52 30',
          style: mergedStyle
        }, otherProps),
        _ref7,
        _ref8
      );
    }
  }]);

  return Details;
}(Icon);

var _ref9 = _jsx('path', {
  id: 'Shape',
  d: 'M14.628.405C6.555.405 0 6.962 0 15c-.006.44.227.847.61 1.068.385.22.86.22 1.244 0s.618-.63.612-1.068c0-6.74 5.44-12.162 12.162-12.162 4.516 0 8.464 2.445 10.57 6.08H21.78c-.444-.005-.857.225-1.082.604-.224.38-.224.847 0 1.226.225.38.638.61 1.083.603h5.76c.68 0 1.236-.54 1.236-1.21V4.46c.007-.33-.122-.648-.356-.88-.235-.235-.556-.366-.89-.362-.33.003-.643.136-.87.37-.23.233-.357.547-.35.87v1.7C23.62 2.66 19.373.404 14.63.404zm13.715 13.353c-.33.004-.643.137-.872.37-.23.233-.35.547-.34.872 0 6.74-5.44 12.162-12.16 12.162-4.527 0-8.494-2.45-10.594-6.106h3.44c.446.006.86-.224 1.083-.603.224-.38.224-.848 0-1.227-.225-.378-.638-.61-1.083-.603h-5.76c-.68 0-1.232.545-1.232 1.217v5.675c-.007.325.118.64.347.872.225.233.54.366.87.37.333.003.653-.127.89-.36.233-.235.36-.553.355-.882v-1.672c2.683 3.5 6.928 5.752 11.673 5.752 8.072 0 14.63-6.557 14.63-14.595.005-.33-.124-.647-.358-.88-.24-.235-.56-.365-.89-.362z'
});

var Refresh = function (_Icon6) {
  _inherits(Refresh, _Icon6);

  function Refresh() {
    _classCallCheck(this, Refresh);

    return _possibleConstructorReturn(this, (Refresh.__proto__ || Object.getPrototypeOf(Refresh)).apply(this, arguments));
  }

  _createClass(Refresh, [{
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          color = _props6.color,
          style = _props6.style,
          otherProps = _objectWithoutProperties(_props6, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        fillRule: 'nonzero',
        maxWidth: '3rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 30 30',
          style: mergedStyle
        }, otherProps),
        _ref9
      );
    }
  }]);

  return Refresh;
}(Icon);

var _ref10 = _jsx('path', {
  d: 'M3.5.39C1.574.39 0 1.962 0 3.89v27.22c0 1.927 1.574 3.5 3.5 3.5h27.222c1.926 0 3.5-1.573 3.5-3.5V3.89c0-1.927-1.574-3.5-3.5-3.5H3.5zm0 1.554h27.222c1.09 0 1.945.854 1.945 1.945v27.22c0 1.092-.854 1.946-1.945 1.946H3.5c-1.09 0-1.944-.854-1.944-1.945V3.89c0-1.092.853-1.946 1.944-1.946zm.705 1.945c-.4.037-.707.374-.705.777v10.89c0 .428.348.776.778.776h10.89c.428 0 .776-.348.776-.777V4.666c0-.43-.348-.777-.777-.777H4.277c-.024-.002-.048-.002-.072 0zm14.85 0c-.43 0-.777.347-.777.777v10.89c0 .428.348.776.778.776h10.888c.43 0 .778-.348.778-.777V4.666c.002-.402-.304-.74-.705-.777-.024-.002-.048-.002-.073 0H19.056zm-14 1.554h9.334v9.334H5.055V5.444zm14.778 0h9.334v9.334h-9.334V5.444zM9.637 18.654c-.4.045-.7.387-.693.79v4.667H4.205c-.278.014-.528.174-.656.422-.128.247-.114.543.036.777.15.234.414.37.692.357h4.666v4.666c-.004.28.144.542.386.683.242.142.542.142.784 0 .243-.14.39-.402.386-.683v-4.666h4.667c.28.004.54-.144.682-.386.14-.24.14-.54 0-.783-.142-.242-.403-.39-.683-.386H10.5v-4.666c.005-.224-.087-.44-.252-.59-.166-.15-.388-.224-.61-.2zm9.42.013c-.43 0-.78.348-.78.777v10.89c0 .43.35.777.78.777h10.887c.43 0 .778-.347.778-.777v-10.89c0-.428-.348-.776-.778-.776H19.056zm.776 1.555h9.334v9.334h-9.334v-9.334z'
});

var Grid = function (_Icon7) {
  _inherits(Grid, _Icon7);

  function Grid() {
    _classCallCheck(this, Grid);

    return _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).apply(this, arguments));
  }

  _createClass(Grid, [{
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          color = _props7.color,
          style = _props7.style,
          otherProps = _objectWithoutProperties(_props7, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        fillRule: 'nonzero',
        maxWidth: '3.5rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 35 35',
          style: mergedStyle
        }, otherProps),
        _ref10
      );
    }
  }]);

  return Grid;
}(Icon);

var _ref11 = _jsx('path', {
  d: 'M-881.6 574.9c7.3 1.2 14.8 1.8 22.1 1.8h1.2c7.8-.1 15.6-.8 23.4-2.2 5.7-1.1 11.3-6.6 12.5-12.3 1.4-7 2.1-14.2 2.1-21.2s-.7-14.2-2.1-21.2c-1.2-5.6-6.8-11.1-12.5-12.2-7.7-1.4-15.6-2.2-23.4-2.2-7.8-.1-15.6.5-23.4 1.8-5.7 1-11.4 6.5-12.6 12.3-1.4 7.2-2.1 14.4-2.1 21.6s.7 14.4 2.1 21.7c1.3 5.6 6.9 11.1 12.7 12.1zm-5.7-54.1c.6-2.9 4-6.3 6.9-6.8 7-1.1 14-1.7 21-1.7h1.2c7.4.1 14.8.8 22.1 2.1 2.9.6 6.4 3.9 6.9 6.7 1.3 6.6 1.9 13.3 1.9 19.9 0 6.6-.6 13.3-1.9 19.8-.6 2.8-4 6.2-6.9 6.8-7.3 1.3-14.8 2.1-22.1 2.1-7.4.1-14.8-.5-22.1-1.7-2.9-.5-6.3-3.9-6.9-6.7-1.3-6.7-2-13.6-2-20.3s.6-13.5 1.9-20.2z'
});

var _ref12 = _jsx('path', {
  d: 'M-875.7 551.6c-1.1 1.6-.8 3.8.8 4.9 4.3 3.1 10.2 4.8 16.6 4.8s12.3-1.7 16.6-4.8c1.6-1.1 1.9-3.3.8-4.9-1.1-1.6-3.3-1.9-4.9-.8-3.1 2.2-7.7 3.5-12.5 3.5-4.9 0-9.4-1.3-12.5-3.5-1.6-1.1-3.7-.8-4.9.8z'
});

var _ref13 = _jsx('circle', {
  cx: '-872.8',
  cy: '533.8',
  r: '4.7'
});

var _ref14 = _jsx('circle', {
  cx: '-843.7',
  cy: '533.8',
  r: '4.7'
});

var EmotionHappy = function (_Icon8) {
  _inherits(EmotionHappy, _Icon8);

  function EmotionHappy() {
    _classCallCheck(this, EmotionHappy);

    return _possibleConstructorReturn(this, (EmotionHappy.__proto__ || Object.getPrototypeOf(EmotionHappy)).apply(this, arguments));
  }

  _createClass(EmotionHappy, [{
    key: 'render',
    value: function render() {
      var _props8 = this.props,
          color = _props8.color,
          style = _props8.style,
          otherProps = _objectWithoutProperties(_props8, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '3.5rem',

        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '-909 491 100 100',
          style: mergedStyle
        }, otherProps),
        _ref11,
        _ref12,
        _ref13,
        _ref14
      );
    }
  }]);

  return EmotionHappy;
}(Icon);

var _ref15 = _jsx('path', {
  d: 'M-835.9 507.5c-7.7-1.4-15.6-2.2-23.4-2.2-7.8-.1-15.6.5-23.4 1.8-5.7 1-11.4 6.5-12.6 12.3-1.4 7.2-2.1 14.4-2.1 21.6s.7 14.4 2.1 21.7c1.2 5.7 6.8 11.2 12.6 12.3 7.3 1.2 14.8 1.8 22.1 1.8h1.2c7.8-.1 15.6-.8 23.4-2.2 5.7-1.1 11.3-6.6 12.5-12.3 1.4-7 2.1-14.2 2.1-21.2s-.7-14.2-2.1-21.2c-1-5.8-6.6-11.3-12.4-12.4zm5.7 53.3c-.6 2.8-4 6.2-6.9 6.8-7.3 1.3-14.8 2.1-22.1 2.1-7.4.1-14.8-.5-22.1-1.7-2.9-.5-6.3-3.9-6.9-6.7-1.3-6.7-2-13.6-2-20.3 0-6.7.7-13.5 2-20.2.6-2.9 4-6.3 6.9-6.8 7-1.1 14-1.7 21-1.7h1.2c7.4.1 14.8.8 22.1 2.1 2.9.6 6.4 3.9 6.9 6.7 1.3 6.6 1.9 13.3 1.9 19.9-.1 6.6-.7 13.3-2 19.8z'
});

var _ref16 = _jsx('path', {
  d: 'M-850.8 554.2c-.2 0-3.9-1.1-8.5-1.1s-8.3 1-8.5 1.1c-1.9.5-2.9 2.4-2.4 4.3s2.4 3 4.3 2.4c0 0 3-.8 6.6-.8s6.6.8 6.6.8c.3.1.6.1.9.1 1.5 0 2.9-1 3.4-2.6.6-1.7-.5-3.6-2.4-4.2zm-26-18.9h.4c2.7-.3 5.2-1.4 7.3-3l.6-.5c1.5-1.2 1.8-3.4.6-4.9-1.2-1.5-3.4-1.8-4.9-.6l-.6.5c-1.1.9-2.5 1.4-3.9 1.6-1.9.2-3.3 2-3 3.9.2 1.7 1.7 3 3.5 3zm35.6-7c-1.4-.2-2.8-.7-3.9-1.6l-.6-.5c-1.5-1.2-3.7-.9-4.9.6-1.2 1.5-.9 3.7.6 4.9l.6.5c2.1 1.6 4.7 2.7 7.3 3h.4c1.7 0 3.3-1.3 3.5-3.1.3-1.8-1.1-3.6-3-3.8zm-41.6 18.6c0 2.3 1.8 4.1 4.1 4.1s4.1-1.8 4.1-4.1-4.1-7.6-4.1-7.6-4.1 5.3-4.1 7.6z'
});

var EmotionSad = function (_Icon9) {
  _inherits(EmotionSad, _Icon9);

  function EmotionSad() {
    _classCallCheck(this, EmotionSad);

    return _possibleConstructorReturn(this, (EmotionSad.__proto__ || Object.getPrototypeOf(EmotionSad)).apply(this, arguments));
  }

  _createClass(EmotionSad, [{
    key: 'render',
    value: function render() {
      var _props9 = this.props,
          color = _props9.color,
          style = _props9.style,
          otherProps = _objectWithoutProperties(_props9, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '3.5rem',

        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '-909 491 100 100',
          style: mergedStyle
        }, otherProps),
        _ref15,
        _ref16
      );
    }
  }]);

  return EmotionSad;
}(Icon);

var _ref17 = _jsx('path', {
  d: 'M-835.5 507.5c-7.7-1.4-15.6-2.2-23.4-2.2-7.8-.1-15.6.5-23.4 1.8-5.7 1-11.4 6.5-12.6 12.3-1.4 7.2-2.1 14.4-2.1 21.6s.7 14.4 2.1 21.7c1.2 5.7 6.8 11.2 12.6 12.3 7.3 1.2 14.8 1.8 22.1 1.8h1.2c7.8-.1 15.6-.8 23.4-2.2 5.7-1.1 11.3-6.6 12.5-12.3 1.4-7 2.1-14.2 2.1-21.2s-.7-14.2-2.1-21.2c-1-5.8-6.6-11.3-12.4-12.4zm5.7 53.3c-.6 2.8-4 6.2-6.9 6.8-7.3 1.3-14.8 2.1-22.1 2.1-7.3.1-14.8-.5-22.1-1.7-2.9-.5-6.3-3.9-6.9-6.7-1.3-6.7-2-13.6-2-20.3 0-6.7.7-13.6 2-20.2.6-2.9 4-6.3 6.9-6.8 7-1.1 14-1.7 21-1.7h1.2c7.4.1 14.8.8 22.1 2.1 2.9.6 6.4 3.9 6.9 6.7 1.3 6.6 1.9 13.3 1.9 19.9-.1 6.6-.8 13.3-2 19.8z'
});

var _ref18 = _jsx('path', {
  d: 'M-845 544.3c-9.2 1.9-18.6 1.9-27.8 0-1.1-.2-2.2.1-3 .8-.8.7-1.3 1.8-1.2 2.9.5 5.9 5 17.2 18.1 17.2s17.6-11.3 18.1-17.2c.1-1.1-.3-2.2-1.2-2.9-.8-.7-1.9-1-3-.8zm4.4-20.8c-1.4-.2-2.8.2-3.8 1-.7-1.1-1.8-1.9-3.2-2.2-2.6-.4-5 1.3-5.4 3.9-.9 5.6 6.5 11.4 6.5 11.4s8.9-3.6 9.8-8.7c.4-2.6-1.3-5-3.9-5.4zm-24.7 2.8c-.4-2.6-2.8-4.3-5.4-3.9-1.4.2-2.6 1.1-3.2 2.2-1-.8-2.4-1.3-3.8-1-2.6.4-4.3 2.8-3.9 5.4.8 5.1 9.8 8.7 9.8 8.7s7.4-5.8 6.5-11.4z'
});

var EmotionExciting = function (_Icon10) {
  _inherits(EmotionExciting, _Icon10);

  function EmotionExciting() {
    _classCallCheck(this, EmotionExciting);

    return _possibleConstructorReturn(this, (EmotionExciting.__proto__ || Object.getPrototypeOf(EmotionExciting)).apply(this, arguments));
  }

  _createClass(EmotionExciting, [{
    key: 'render',
    value: function render() {
      var _props10 = this.props,
          color = _props10.color,
          style = _props10.style,
          otherProps = _objectWithoutProperties(_props10, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '3.5rem',

        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '-909 491 100 100',
          style: mergedStyle
        }, otherProps),
        _ref17,
        _ref18
      );
    }
  }]);

  return EmotionExciting;
}(Icon);

var _ref19 = _jsx('path', {
  d: 'M-882.3 574.9c7.3 1.2 14.8 1.8 22.1 1.8h1.2c7.8-.1 15.6-.8 23.4-2.2 5.7-1.1 11.3-6.6 12.5-12.3 1.4-7 2.1-14.2 2.1-21.2s-.7-14.2-2.1-21.2c-1.2-5.6-6.8-11.1-12.5-12.2-7.7-1.4-15.6-2.2-23.4-2.2-7.8-.1-15.6.5-23.4 1.8-5.7 1-11.4 6.5-12.6 12.3-1.4 7.2-2.1 14.4-2.1 21.6s.7 14.4 2.1 21.7c1.3 5.6 6.9 11.1 12.7 12.1zm-5.8-54.1c.6-2.9 4-6.3 6.9-6.8 7-1.1 14-1.7 21-1.7h1.2c7.4.1 14.8.8 22.1 2.1 2.9.6 6.4 3.9 6.9 6.7 1.3 6.6 1.9 13.3 1.9 19.9 0 6.6-.6 13.3-1.9 19.8-.6 2.8-4 6.2-6.9 6.8-7.3 1.3-14.8 2.1-22.1 2.1-7.4.1-14.8-.5-22.1-1.7-2.9-.5-6.3-3.9-6.9-6.7-1.3-6.7-2-13.6-2-20.3s.6-13.5 1.9-20.2z'
});

var _ref20 = _jsx('path', {
  d: 'M-868.5 553.8h-.6c-1.9-.1-3.6 1.4-3.7 3.3-.1 1.9 1.4 3.6 3.3 3.7h.6c.8 0 1.6.1 2.4.1 6.3 0 12.6-1.2 18.4-3.6 1.8-.7 2.7-2.8 1.9-4.6-.7-1.8-2.8-2.7-4.6-1.9-5.5 2.2-11.7 3.3-17.7 3zm-6.3-8.1c7.9 0 14.7-9.5 14.7-13.8 0-4.3-5.5-5.8-12.3-5.8s-12.3.6-12.3 5.8 2 13.8 9.9 13.8zm31.6 0c7.9 0 9.9-8.6 9.9-13.8s-5.5-5.8-12.3-5.8-12.3 1.6-12.3 5.8 6.8 13.8 14.7 13.8z'
});

var EmotionChill = function (_Icon11) {
  _inherits(EmotionChill, _Icon11);

  function EmotionChill() {
    _classCallCheck(this, EmotionChill);

    return _possibleConstructorReturn(this, (EmotionChill.__proto__ || Object.getPrototypeOf(EmotionChill)).apply(this, arguments));
  }

  _createClass(EmotionChill, [{
    key: 'render',
    value: function render() {
      var _props11 = this.props,
          color = _props11.color,
          style = _props11.style,
          otherProps = _objectWithoutProperties(_props11, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '3.5rem',

        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '-909 491 100 100',
          style: mergedStyle
        }, otherProps),
        _ref19,
        _ref20
      );
    }
  }]);

  return EmotionChill;
}(Icon);

var _ref21 = _jsx('path', {
  d: 'M-845.7 533.5c2.6-.4 4.3-2.9 3.9-5.4s-2.9-4.3-5.4-3.9c-2.6.4-7 3.3-6.6 5.9s5.5 3.8 8.1 3.4zm-27.3 0c2.6.4 7.7-.8 8.1-3.4.4-2.6-4-5.5-6.6-5.9-2.6-.4-5 1.3-5.4 3.9-.4 2.5 1.3 4.9 3.9 5.4z'
});

var _ref22 = _jsx('path', {
  d: 'M-882.3 574.9c7.3 1.2 14.8 1.8 22.1 1.8h1.2c7.8-.1 15.6-.8 23.4-2.2 5.7-1.1 11.3-6.6 12.5-12.3 1.4-7 2.1-14.2 2.1-21.2s-.7-14.2-2.1-21.2c-1.2-5.6-6.8-11.1-12.5-12.2-7.7-1.4-15.6-2.2-23.4-2.2-7.8-.1-15.6.5-23.4 1.8-5.7 1-11.4 6.5-12.6 12.3-1.4 7.2-2.1 14.4-2.1 21.6s.7 14.4 2.1 21.7c1.3 5.6 6.9 11.1 12.7 12.1zm-5.8-54.1c.6-2.9 4-6.3 6.9-6.8 7-1.1 14-1.7 21-1.7h1.2c7.4.1 14.8.8 22.1 2.1 2.9.6 6.4 3.9 6.9 6.7 1.3 6.6 1.9 13.3 1.9 19.9 0 6.6-.6 13.3-1.9 19.8-.6 2.8-4 6.2-6.9 6.8-7.3 1.3-14.8 2.1-22.1 2.1-7.4.1-14.8-.5-22.1-1.7-2.9-.5-6.3-3.9-6.9-6.7-1.3-6.7-2-13.5-2-20.3 0-6.7.6-13.6 1.9-20.2z'
});

var _ref23 = _jsx('path', {
  d: 'M-872.9 560.3l2-.3 1.6-3.1 1.4 2.6 3-.3 2.1-4.1 2 3.9h3.6l2-3.9 2.1 4.1 2.6.3 1.3-2.6 1.6 3c.8.1 1.6.3 2.4.4.2 0 .5.1.7.1.9 0 1.7-.3 2.3-.9.8-.7 1.3-1.8 1.2-2.9-.3-3.6-2.1-9.2-6.4-13.1l-2.1 1.6-.2-3.3c-1.1-.7-2.4-1.3-3.8-1.7l-1.8 3.4-2.2-4.1c-.5 0-1.1-.1-1.6-.1s-1.1 0-1.6.1l-2.2 4.1-1.8-3.4c-1.1.3-2.2.8-3.1 1.3l-.2 3.7-2.4-1.9c-4.6 3.8-6.4 9.6-6.7 13.3-.1 1.1.3 2.2 1.2 2.9.8.8 1.9 1.1 3 .9z'
});

var EmotionDark = function (_Icon12) {
  _inherits(EmotionDark, _Icon12);

  function EmotionDark() {
    _classCallCheck(this, EmotionDark);

    return _possibleConstructorReturn(this, (EmotionDark.__proto__ || Object.getPrototypeOf(EmotionDark)).apply(this, arguments));
  }

  _createClass(EmotionDark, [{
    key: 'render',
    value: function render() {
      var _props12 = this.props,
          color = _props12.color,
          style = _props12.style,
          otherProps = _objectWithoutProperties(_props12, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '3.5rem',

        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '-909 491 100 100',
          style: mergedStyle
        }, otherProps),
        _ref21,
        _ref22,
        _ref23
      );
    }
  }]);

  return EmotionDark;
}(Icon);

var _ref24 = _jsx('path', {
  d: 'M56.67 76.56H43.33v-33h13.34v33zM50 38.06a7.3 7.3 0 1 1 7.3-7.32 7.3 7.3 0 0 1-7.3 7.3z'
});

var _ref25 = _jsx('path', {
  d: 'M85.36 14.64a50 50 0 1 0 0 70.7 49.84 49.84 0 0 0 0-70.7zm-5.53 65.2a42.2 42.2 0 0 1-59.66-59.67 42.2 42.2 0 0 1 59.67 0 42.2 42.2 0 0 1 0 59.66z'
});

var _ref26 = _jsx('circle', {
  cx: '50',
  cy: '30.74',
  r: '7.31'
});

var _ref27 = _jsx('path', {
  d: 'M43.33 43.57h13.35v33H43.33z'
});

var Info = function (_Icon13) {
  _inherits(Info, _Icon13);

  function Info() {
    _classCallCheck(this, Info);

    return _possibleConstructorReturn(this, (Info.__proto__ || Object.getPrototypeOf(Info)).apply(this, arguments));
  }

  _createClass(Info, [{
    key: 'render',
    value: function render() {
      var _props13 = this.props,
          color = _props13.color,
          style = _props13.style,
          otherProps = _objectWithoutProperties(_props13, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '3.5rem',

        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 100 100',
          style: mergedStyle
        }, otherProps),
        _ref24,
        _ref25,
        _ref26,
        _ref27
      );
    }
  }]);

  return Info;
}(Icon);

var _ref28 = _jsx('g', {
  transform: 'translate(0,-952.36218)'
}, void 0, _jsx('path', {
  d: 'm 49.994505,969.36239 c -0.6142,0.011 -1.2381,0.22983 -1.8438,0.625 l -38,30 c -0.9762002,0.96921 -1.6623002,3.05621 -0.6562002,4.34371 1.0061002,1.2876 3.1221002,1.4603 4.3438002,0.375 l 36.1562,-28.53121 36.1562,28.53121 c 1.2216,1.0853 3.3823,0.9462 4.3438,-0.375 0.8437,-1.1592 0.636,-3.3774 -0.6562,-4.34371 l -13.8438,-10.9375 0,-16.6875 a 3.0003,3.0003 0 0 0 -3,-3 l -8,0 a 3.0003,3.0003 0 0 0 -3,3 l 0,5.65625 -10.1562,-8.03125 c -0.625,-0.43912 -1.2296,-0.63599 -1.8438,-0.625 z m 18,6 2,0 0,8.96875 -2,-1.59375 0,-7.375 z m -42,23.28125 -6,4.74996 0,28.9688 a 3.0003,3.0003 0 0 0 3,3 l 17,0 a 3.0003,3.0003 0 0 0 3,-3 l 0,-10 c 0,-3.9299 3.0701,-7 7,-7 3.9299,0 7,3.0701 7,7 l 0,10 a 3.0003,3.0003 0 0 0 3,3 l 17,0 a 3.0003,3.0003 0 0 0 3,-3 l 0,-28.9688 -6,-4.74996 0,30.71876 -11,0 0,-7 c 0,-7.1501 -5.8499,-13 -13,-13 -7.1501,0 -13,5.8499 -13,13 l 0,7 -11,0 0,-30.71876 z'
}));

var Inside = function (_Icon14) {
  _inherits(Inside, _Icon14);

  function Inside() {
    _classCallCheck(this, Inside);

    return _possibleConstructorReturn(this, (Inside.__proto__ || Object.getPrototypeOf(Inside)).apply(this, arguments));
  }

  _createClass(Inside, [{
    key: 'render',
    value: function render() {
      var _props14 = this.props,
          color = _props14.color,
          style = _props14.style,
          otherProps = _objectWithoutProperties(_props14, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '3.5rem',

        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 100 100',
          style: mergedStyle
        }, otherProps),
        _ref28
      );
    }
  }]);

  return Inside;
}(Icon);

var _ref29 = _jsx('g', {
  transform: 'translate(0,8)'
}, void 0, _jsx('polygon', {
  points: '83.424,74.68 68.32,55.111 77.764,55.111 62.055,34.757 69.364,34.757 50,9.667 30.635,34.757 37.944,34.757 22.236,55.111 31.68,55.111 16.576,74.68'
}));

var Outside = function (_Icon15) {
  _inherits(Outside, _Icon15);

  function Outside() {
    _classCallCheck(this, Outside);

    return _possibleConstructorReturn(this, (Outside.__proto__ || Object.getPrototypeOf(Outside)).apply(this, arguments));
  }

  _createClass(Outside, [{
    key: 'render',
    value: function render() {
      var _props15 = this.props,
          color = _props15.color,
          style = _props15.style,
          otherProps = _objectWithoutProperties(_props15, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '3.5rem',

        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 100 100',
          style: mergedStyle
        }, otherProps),
        _ref29
      );
    }
  }]);

  return Outside;
}(Icon);

var _ref30 = _jsx('path', {
  d: 'M15 28c1.786 0 3.488-.36 5.037-1.012C24.715 25.02 28 20.394 28 15c0-7.18-5.82-13-13-13S2 7.82 2 15c0 3.23 1.178 6.184 3.127 8.457'
});

var Working = function (_Icon16) {
  _inherits(Working, _Icon16);

  function Working() {
    _classCallCheck(this, Working);

    return _possibleConstructorReturn(this, (Working.__proto__ || Object.getPrototypeOf(Working)).apply(this, arguments));
  }

  _createClass(Working, [{
    key: 'render',
    value: function render() {
      var _props16 = this.props,
          color = _props16.color,
          style = _props16.style,
          otherProps = _objectWithoutProperties(_props16, ['color', 'style']);

      var mergedStyle = _extends({
        stroke: color,
        strokeWidth: 3,
        strokeLinecap: 'round',
        fill: 'none',
        maxWidth: '3.5rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 30 30',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref30,
        ' '
      );
    }
  }]);

  return Working;
}(Icon);

var _ref31 = _jsx('path', {
  id: 'Path',
  d: 'M24.5 0C30.8 0 36 5.2 36 11.5S30.8 23 24.5 23 13 17.8 13 11.5 18.2 0 24.5 0zm.5 54c-9.5 0-18.2-3.5-25-9.3C7 36.5 16 32 25 32c9.2 0 16.7 4.5 23.8 12.7C42 50.5 34.5 54 25 54z'
});

var Profile = function (_Icon17) {
  _inherits(Profile, _Icon17);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  _createClass(Profile, [{
    key: 'render',
    value: function render() {
      var _props17 = this.props,
          color = _props17.color,
          style = _props17.style,
          otherProps = _objectWithoutProperties(_props17, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        maxWidth: '3.5rem',
        fillRule: 'evenodd',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 49 54',
          style: mergedStyle
        }, otherProps),
        _ref31
      );
    }
  }]);

  return Profile;
}(Icon);

var _ref32 = _jsx('path', {
  d: 'M1.8 10h22.6M17.5 18l8.8-8-8.8-8'
});

var Arrow = function (_Icon18) {
  _inherits(Arrow, _Icon18);

  function Arrow() {
    _classCallCheck(this, Arrow);

    return _possibleConstructorReturn(this, (Arrow.__proto__ || Object.getPrototypeOf(Arrow)).apply(this, arguments));
  }

  _createClass(Arrow, [{
    key: 'render',
    value: function render() {
      var _props18 = this.props,
          color = _props18.color,
          style = _props18.style,
          otherProps = _objectWithoutProperties(_props18, ['color', 'style']);

      var mergedStyle = _extends({
        fill: 'none',
        fillRule: 'evenodd',
        stroke: color,
        strokeWidth: 3,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        maxWidth: '2.6rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 28 20',
          style: mergedStyle
        }, otherProps),
        _ref32
      );
    }
  }]);

  return Arrow;
}(Icon);

var _ref33 = _jsx('path', {
  id: 'Shape',
  d: 'M16.557 2.828c1.886.576 3.257 2.32 3.257 4.38s-1.372 3.805-3.257 4.382v11.793c0 .744-.607 1.347-1.357 1.347s-1.357-.603-1.357-1.347V11.59c-1.886-.577-3.257-2.322-3.257-4.38 0-2.062 1.372-3.806 3.257-4.382v-1.01c0-.745.607-1.348 1.357-1.348s1.357.603 1.357 1.347v1.01zM13.3 7.208c0 1.04.852 1.888 1.9 1.888 1.047 0 1.9-.847 1.9-1.887s-.852-1.89-1.9-1.89c-1.047 0-1.9.84-1.9 1.88zM5.97 14.69c1.887.575 3.26 2.32 3.26 4.38s-1.375 3.805-3.26 4.38c-.036.714-.63 1.28-1.356 1.28-.726 0-1.32-.566-1.355-1.28C1.37 22.876 0 21.13 0 19.07s1.372-3.805 3.257-4.38V1.816c0-.744.608-1.347 1.357-1.347.75 0 1.357.6 1.357 1.34v12.88zm-3.256 4.38c0 1.04.852 1.887 1.9 1.887 1.047 0 1.9-.847 1.9-1.887s-.852-1.887-1.9-1.887c-1.047 0-1.9.846-1.9 1.887zm24.43-8.155c1.884.576 3.256 2.32 3.256 4.38s-1.372 3.805-3.257 4.38v3.708c0 .744-.608 1.347-1.357 1.347-.75 0-1.357-.603-1.357-1.347v-3.706c-1.89-.577-3.26-2.322-3.26-4.38 0-2.062 1.37-3.806 3.26-4.382V1.817c0-.744.6-1.347 1.35-1.347s1.354.603 1.354 1.347v9.098zm-3.258 4.38c0 1.04.852 1.888 1.9 1.888 1.047 0 1.9-.847 1.9-1.887s-.852-1.887-1.9-1.887c-1.047 0-1.9.84-1.9 1.88z'
});

var Filters = function (_Icon19) {
  _inherits(Filters, _Icon19);

  function Filters() {
    _classCallCheck(this, Filters);

    return _possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).apply(this, arguments));
  }

  _createClass(Filters, [{
    key: 'render',
    value: function render() {
      var _props19 = this.props,
          color = _props19.color,
          style = _props19.style,
          otherProps = _objectWithoutProperties(_props19, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        fillRule: 'nonzero',
        stroke: 'none',
        maxWidth: '3.1rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 31 25',
          style: mergedStyle
        }, otherProps),
        _ref33
      );
    }
  }]);

  return Filters;
}(Icon);

var _ref34 = _jsx('g', {
  transform: 'translate(2 2)'
}, void 0, _jsx('ellipse', {
  cx: '8.19',
  cy: '8',
  rx: '8.19',
  ry: '8'
}), _jsx('path', {
  d: 'M13.87 14l5.24 5.12'
}));

var Search = function (_Icon20) {
  _inherits(Search, _Icon20);

  function Search() {
    _classCallCheck(this, Search);

    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
  }

  _createClass(Search, [{
    key: 'render',
    value: function render() {
      var _props20 = this.props,
          color = _props20.color,
          style = _props20.style,
          otherProps = _objectWithoutProperties(_props20, ['color', 'style']);

      var mergedStyle = _extends({
        fill: 'none',
        stroke: color,
        strokeWidth: 3,
        maxWidth: '2rem',
        width: '100vw',
        strokeLinecap: 'round'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 23 23',
          style: mergedStyle
        }, otherProps),
        _ref34
      );
    }
  }]);

  return Search;
}(Icon);

var _ref35 = _jsx('path', {
  d: 'M26.77 5.7C24.02 2.23 19.77 0 15 0 6.72 0 0 6.72 0 15c0 8.28 6.72 15 15 15 8.28 0 15-6.72 15-15 0-2.3-.5-4.46-1.43-6.4-.02 0-.03.02-.05.04l-12.57 12.4c-.36.35-.72.52-1.26.52-.56 0-.9-.17-1.28-.53l-5.4-5.3c-.7-.72-.7-1.78 0-2.5.73-.7 1.8-.7 2.52 0l4.14 4.08L26 6.18c.23-.23.5-.38.77-.46z'
});

var Check = function (_Icon21) {
  _inherits(Check, _Icon21);

  function Check() {
    _classCallCheck(this, Check);

    return _possibleConstructorReturn(this, (Check.__proto__ || Object.getPrototypeOf(Check)).apply(this, arguments));
  }

  _createClass(Check, [{
    key: 'render',
    value: function render() {
      var _props21 = this.props,
          color = _props21.color,
          style = _props21.style,
          otherProps = _objectWithoutProperties(_props21, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '3rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 30 30',
          style: mergedStyle
        }, otherProps),
        _ref35
      );
    }
  }]);

  return Check;
}(Icon);

var _ref36 = _jsx('path', {
  d: 'M51 5.118C51 2.292 48.687 0 45.83 0H5.17C2.312 0 0 2.292 0 5.118v18.764C0 26.708 2.313 29 5.17 29h40.66c2.857 0 5.17-2.292 5.17-5.118V5.118zm-2.297 0v3.354h-.23c-1.64.015-3.216-.618-4.38-1.762-1.167-1.14-1.823-2.7-1.823-4.322v-.114h3.56c.764 0 1.493.3 2.03.833.542.533.843 1.258.843 2.01zm-8.73 21.607H11.027v-.113c-.015-2.223-.917-4.35-2.51-5.915-1.593-1.566-3.747-2.443-5.99-2.443h-.23v-7.508h.23c2.243 0 4.397-.877 5.99-2.443s2.495-3.692 2.51-5.915v-.113h28.946v.113c.016 2.224.918 4.35 2.51 5.915 1.594 1.566 3.747 2.443 5.99 2.443h.288v7.508h-.28c-2.24 0-4.39.877-5.99 2.443S40 24.39 39.98 26.612v.113zM5.17 2.275h3.56v.113c0 1.624-.656 3.18-1.822 4.322-1.165 1.144-2.742 1.777-4.382 1.762h-.23V5.118c0-1.57 1.287-2.843 2.873-2.843zM2.296 23.94v-3.41h.23c1.64-.017 3.216.616 4.38 1.76 1.167 1.142 1.823 2.7 1.823 4.323v.113H5.17c-1.587 0-2.873-1.273-2.873-2.843v.057zm43.592 2.843h-3.62v-.115c-.016-1.633.633-3.203 1.8-4.358 1.166-1.155 2.754-1.797 4.403-1.78h.29v3.353c0 .764-.31 1.494-.86 2.03-.55.535-1.3.828-2.07.813l.06.057z'
});

var _ref37 = _jsx('path', {
  d: 'M30.367 16.434l.23-.116v-.003c-.252-.495-.604-.932-1.035-1.28-.435-.34-.92-.616-1.436-.814l-.4-.17-.69-.29v-2.91c.14.06.258.17.343.29.23.32.35.71.34 1.11v.47h2.93v-.462c0-.6-.11-1.193-.35-1.746-.2-.483-.49-.92-.86-1.28-.41-.343-.88-.6-1.38-.756l-.98-.23V7h-2.01v1.224l-1.036.232h.002c-.52.163-1.01.418-1.44.757-.434.343-.79.78-1.033 1.28-.264.544-.4 1.142-.4 1.747-.023.664.114 1.323.4 1.922.25.498.6.934 1.035 1.28.42.337.88.612 1.38.816l.343.116.63.232V20.1c-.28-.062-.522-.228-.69-.464-.3-.464-.44-1.02-.4-1.574v-.523H21V18c-.033.67.064 1.344.286 1.98.21.57.544 1.088.975 1.513.43.412.94.728 1.5.93.41.153.83.25 1.267.292V24h2.01v-1.28l1.15-.29c.55-.188 1.056-.486 1.49-.875.423-.39.755-.864.98-1.396.246-.63.363-1.31.343-1.98.014-.65-.12-1.29-.403-1.87l-.23.12zm-5.34-3.203l-.403-.23-.345-.4c-.09-.16-.13-.34-.12-.52-.05-.29.02-.58.19-.81.17-.23.43-.38.72-.406l-.06 2.387zm2.583 6.47l-.574.35v-2.91l.516.29c.14.11.26.25.345.41.09.2.128.42.115.65.067.44-.06.884-.346 1.22l-.056.003z'
});

var Money = function (_Icon22) {
  _inherits(Money, _Icon22);

  function Money() {
    _classCallCheck(this, Money);

    return _possibleConstructorReturn(this, (Money.__proto__ || Object.getPrototypeOf(Money)).apply(this, arguments));
  }

  _createClass(Money, [{
    key: 'render',
    value: function render() {
      var _props22 = this.props,
          color = _props22.color,
          style = _props22.style,
          otherProps = _objectWithoutProperties(_props22, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '5.1rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 51 29',
          style: mergedStyle
        }, otherProps),
        _ref36,
        _ref37
      );
    }
  }]);

  return Money;
}(Icon);

var _ref38 = _jsx('path', {
  d: 'M0 24.8c0 1.55 1.24 2.8 2.77 2.8h24.47l9 7c.32.25.7.4 1.14.4.33 0 .62-.1.9-.24.63-.34.96-.97.86-1.7l-.47-5.5h1.24c1.6 0 2.8-1.26 2.8-2.8V2.8c0-1.54-1.2-2.8-2.73-2.8H2.77C1.25 0 0 1.26 0 2.8v22zm2.15-22c0-.33.3-.67.67-.67h37.14c.33 0 .67.3.67.67v22c0 .34-.3.68-.67.68h-3.6l.6 7-9-7H2.76c-.32 0-.66-.3-.66-.68v-22h.05z'
});

var _ref39 = _jsx('path', {
  d: 'M18.2 19.54l-4.1-4.23c-.73-.7-.73-1.82 0-2.6.68-.7 1.8-.7 2.52 0l.03.05 2.84 2.9 6.4-8.32c.6-.77 1.7-.9 2.5-.3.8.65.92 1.8.3 2.6l-7.53 9.8c-.67.88-1.93 1.05-2.8.37-.08-.07-.15-.13-.2-.2z'
});

var TakeAction = function (_Icon23) {
  _inherits(TakeAction, _Icon23);

  function TakeAction() {
    _classCallCheck(this, TakeAction);

    return _possibleConstructorReturn(this, (TakeAction.__proto__ || Object.getPrototypeOf(TakeAction)).apply(this, arguments));
  }

  _createClass(TakeAction, [{
    key: 'render',
    value: function render() {
      var _props23 = this.props,
          color = _props23.color,
          style = _props23.style,
          otherProps = _objectWithoutProperties(_props23, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '4.3rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 43 35',
          style: mergedStyle
        }, otherProps),
        _ref38,
        _ref39
      );
    }
  }]);

  return TakeAction;
}(Icon);

var _ref40 = _jsx('path', {
  d: 'M45.47 26.44L34.7 19.67c-.75-.6-.92-.7-.4-1.48.53-.8 1.58-1.1 2.44-.7l10.46 6.6V3.86l-10.46 6.6c-.86.42-1.9.14-2.43-.65-.5-.78-.3-.88.4-1.48l10.8-6.77c1.1-.7 2.5-.77 3.65-.17.9.63.9 1.4.9 2.2v20.8c0 1.1-.3 1.8-.9 2.14-.53.3-1.12.43-1.7.43-.7 0-1.36-.2-1.93-.57z'
});

var _ref41 = _jsx('path', {
  d: 'M30.2 28H5.8C2.06 28 0 25.9 0 22.1V5.9C0 2.1 2.07 0 5.8 0h24.4C33.94 0 36 2.1 36 5.9v16.2c0 3.8-2.07 5.9-5.8 5.9zM5.8 2.78c-1.7 0-3.07 1.4-3.07 3.13v16.2c0 .87.32 1.6.9 2.2.57.6 1.35.97 2.16.97h24.4c.8 0 1.6-.33 2.12-.92.58-.6.9-1.37.9-2.2V5.9c0-.82-.32-1.6-.9-2.2-.57-.6-1.35-.92-2.16-.92H5.8z'
});

var _ref42 = _jsx('path', {
  d: 'M22.18 11H8.82C7.82 11 7 10.1 7 9s.8-2 1.82-2h13.36c1 0 1.82.9 1.82 2s-.82 2-1.82 2z'
});

var VideoCamera = function (_Icon24) {
  _inherits(VideoCamera, _Icon24);

  function VideoCamera() {
    _classCallCheck(this, VideoCamera);

    return _possibleConstructorReturn(this, (VideoCamera.__proto__ || Object.getPrototypeOf(VideoCamera)).apply(this, arguments));
  }

  _createClass(VideoCamera, [{
    key: 'render',
    value: function render() {
      var _props24 = this.props,
          color = _props24.color,
          style = _props24.style,
          otherProps = _objectWithoutProperties(_props24, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '5rem',
        width: '100vw'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 50 28',
          style: mergedStyle
        }, otherProps),
        _ref40,
        _ref41,
        _ref42
      );
    }
  }]);

  return VideoCamera;
}(Icon);

var _ref43 = _jsx('defs', {});

var _ref44 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Email-Lead-Capture',
  transform: 'translate(-862.000000, -388.000000)',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'Group-8',
  transform: 'translate(817.000000, 206.000000)'
}, void 0, _jsx('g', {
  id: 'Group-6',
  transform: 'translate(45.000000, 182.000000)'
}, void 0, _jsx('g', {
  id: 'np_checkbox_483467_000000',
  transform: 'translate(0.000000, 0.500000)'
}, void 0, _jsx('path', {
  d: 'M10.326087,14.8 C9.54196522,15.5804533 9.54196522,16.8973244 10.326087,17.6777778 L17.5543478,24.8722222 C17.8851048,25.2014318 18.4224,25.2014318 18.7934783,24.8722222 L37.3804348,6.37222222 C38.1645565,5.59176889 38.1645565,4.27489778 37.3804348,3.49444444 C36.596313,2.71399111 35.2732522,2.71399111 34.4891304,3.49444444 L18.7934783,19.1166667 C18.4627213,19.4458762 17.9254261,19.4458762 17.5543478,19.1166667 L13.2173913,14.8 C12.4332696,14.0195467 11.1102087,14.0195467 10.326087,14.8 Z M30.647413,32.8888889 L6.5265,32.8888889 C5.2050913,32.8888889 4.13051739,31.8193422 4.13051739,30.5041156 L4.13051739,6.49604889 C4.13051739,5.18082222 5.2050913,4.11127556 6.5265,4.11127556 L22.7173913,4.11127556 C23.8742435,4.11127556 24.7826087,3.20716 24.7826087,2.05572 C24.7826087,0.90428 23.8742435,0.000164444444 22.7173913,0.000164444444 L4.13043478,0.000164444444 C1.85869565,0.000164444444 0,1.85016444 0,4.11127556 L0,32.8890533 C0,35.1501644 1.85869565,37.0001644 4.13043478,37.0001644 L33.0434783,37.0001644 C35.3152174,37.0001644 37.173913,35.1501644 37.173913,32.8890533 L37.173913,18.5001644 C37.173913,17.3487244 36.2655478,16.4446089 35.1086957,16.4446089 C33.9518435,16.4446089 33.0434783,17.3487244 33.0434783,18.5001644 L33.0434783,30.5041978 C33.0434783,31.8194244 31.9689043,32.8889711 30.6474957,32.8889711 L30.647413,32.8888889 Z',
  id: 'Shape'
}))))));

var CheckedBox = function (_Icon25) {
  _inherits(CheckedBox, _Icon25);

  function CheckedBox() {
    _classCallCheck(this, CheckedBox);

    return _possibleConstructorReturn(this, (CheckedBox.__proto__ || Object.getPrototypeOf(CheckedBox)).apply(this, arguments));
  }

  _createClass(CheckedBox, [{
    key: 'render',
    value: function render() {
      var _props25 = this.props,
          color = _props25.color,
          style = _props25.style,
          otherProps = _objectWithoutProperties(_props25, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '5rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 38 38',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref43,
        _ref44
      );
    }
  }]);

  return CheckedBox;
}(Icon);

var _ref45 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Video-Course-Page(s)',
  transform: 'translate(-274.000000, -1357.000000)',
  fill: '#C58D5D',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'np_boxes_816634_000000',
  transform: 'translate(274.000000, 1357.000000)'
}, void 0, _jsx('path', {
  d: 'M31.2510321,23.3406491 L31.2510321,14.8710474 L20.1637355,14.8710474 L20.1637355,23.460676 L23.9535334,20.8963865 C24.295229,20.6666143 24.6731356,20.5185115 25.0615118,20.4520781 C25.8706506,20.2100669 26.7623643,20.3318356 27.4884076,20.817384 L31.2510321,23.3406491 Z M20.1119073,9.01408451 L34.7233271,9.01408451 C36.2220877,9.01408451 37.4575926,10.1519801 37.6185972,11.6162248 L40.3248832,11.6162248 C45.1080875,11.6162248 48.9872209,15.5182513 48.9872209,20.3270514 L48.9873595,46.4708243 L57.6496971,46.4708243 C59.2441217,46.4708243 60.5353644,45.171938 60.5353644,43.5707938 L60.5353644,8.71075696 C60.5353644,7.10689412 59.2441217,5.80800781 57.6496971,5.80800781 L22.9975745,5.80800781 C21.40315,5.80800781 20.1119073,7.10689412 20.1119073,8.71075696 L20.1119073,9.01408451 Z M65.6670369,46.8732394 L66.12408,46.8732394 C67.711632,46.8732394 69,48.1523978 69,49.7286015 L69,61.1473097 C69,62.7235134 67.711632,64 66.12408,64 L2.87592,64 C1.288368,64 0,62.7235134 0,61.1473097 L0,49.7286015 C0,48.1523978 1.288368,46.8732394 2.87592,46.8732394 L3.32015833,46.8732394 C2.91279715,45.860891 2.68831169,44.7532777 2.68831169,43.5927159 L2.68831169,20.4072841 C2.68831169,15.6106171 6.52304964,11.7183099 11.2548929,11.7183099 L14.3376623,11.7183099 L14.3376623,8.71082667 C14.3376623,3.89937758 18.2140238,-7.10542736e-15 22.9972281,-7.10542736e-15 L57.6493506,-7.10542736e-15 C62.4325549,-7.10542736e-15 66.3116883,3.89930787 66.3116883,8.71082667 L66.3116883,43.5708635 C66.3116883,44.7395382 66.0825693,45.854663 65.6670369,46.8732394 Z M14.580905,30.7009802 C14.2875201,30.2532897 14.1119054,29.7097695 14.1119054,29.1017515 L14.1119054,17.5145983 L11.2545502,17.5145983 C9.67724621,17.5145983 8.39986858,18.8102261 8.39986858,20.4073536 L8.39986858,43.5927855 C8.39986858,45.1899129 9.67724621,46.4855408 11.2545502,46.4855408 L42.6772308,46.4855408 L42.6772308,20.4074927 C42.6772308,18.8103652 41.3998532,17.5147374 39.8225493,17.5147374 L37.6363636,17.5146309 L37.6363636,29.5161612 C37.6363636,31.8558391 35.0427267,33.2508669 33.107109,31.9546936 L25.9873624,27.1792811 L18.866917,31.9546936 C17.2874525,33.0122757 15.2699665,32.2780901 14.580905,30.7009802 Z M5.749149,52.5840321 L5.749149,58.2920161 L63.250989,58.2920161 L63.250989,52.5840321 L5.749149,52.5840321 Z',
  id: 'Combined-Shape'
}))));

var Bundle = function (_Icon26) {
  _inherits(Bundle, _Icon26);

  function Bundle() {
    _classCallCheck(this, Bundle);

    return _possibleConstructorReturn(this, (Bundle.__proto__ || Object.getPrototypeOf(Bundle)).apply(this, arguments));
  }

  _createClass(Bundle, [{
    key: 'render',
    value: function render() {
      var _props26 = this.props,
          color = _props26.color,
          style = _props26.style,
          otherProps = _objectWithoutProperties(_props26, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '5rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 69 64',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref45
      );
    }
  }]);

  return Bundle;
}(Icon);

var _ref46 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd',
  fillOpacity: '0.53331635'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-425.000000, -2143.000000)',
  fill: '#727981'
}, void 0, _jsx('g', {
  id: 'Group-28',
  transform: 'translate(424.000000, 2130.000000)'
}, void 0, _jsx('path', {
  d: 'M395.352,84.504 L393.56,84.504 L393.56,91 L388.472,91 L388.472,71.352 L397.304,71.352 C401.528,71.352 404.44,73.752 404.44,78.04 C404.44,81.016 402.936,83.064 400.536,83.96 L405.144,91 L399.448,91 L395.352,84.504 Z M393.56,75.672 L393.56,80.408 L396.76,80.408 C398.584,80.408 399.416,79.48 399.416,78.04 C399.416,76.6 398.584,75.672 396.76,75.672 L393.56,75.672 Z M406.04,71.352 L420.088,71.352 L420.088,75.768 L411.096,75.768 L411.096,78.84 L419.32,78.84 L419.32,83.16 L411.096,83.16 L411.096,86.552 L420.088,86.552 L420.088,91 L406.04,91 L406.04,71.352 Z M434.52,84.344 L431.48,84.344 L431.48,80.504 L439.608,80.504 L439.608,82.456 C439.608,87.896 436.024,91.32 430.808,91.32 C425.112,91.32 421.08,87.16 421.08,81.176 C421.08,75.192 425.112,71.032 430.744,71.032 C435.8,71.032 438.712,73.944 439.448,77.944 L434.2,77.944 C433.656,76.44 432.6,75.544 430.744,75.544 C427.896,75.544 426.264,77.912 426.264,81.176 C426.264,84.536 427.992,86.808 430.808,86.808 C432.76,86.808 434.04,85.848 434.52,84.344 Z M446.136,71.352 L446.136,91 L440.984,91 L440.984,71.352 L446.136,71.352 Z M447.192,85.176 L452.536,85.176 C452.952,86.52 454.104,87.192 455.704,87.192 C457.272,87.192 458.36,86.52 458.36,85.304 C458.36,84.376 457.752,83.96 456.504,83.672 L452.728,82.872 C449.848,82.232 447.672,80.728 447.672,77.4 C447.672,73.56 450.872,71.032 455.224,71.032 C460.024,71.032 462.744,73.656 463.288,77.048 L458.264,77.048 C457.848,75.96 456.952,75.128 455.256,75.128 C453.784,75.128 452.792,75.768 452.792,76.856 C452.792,77.72 453.4,78.2 454.424,78.424 L458.264,79.32 C461.624,80.12 463.48,81.944 463.48,84.984 C463.48,89.016 460.088,91.32 455.8,91.32 C451.096,91.32 447.896,89.048 447.192,85.176 Z M463.736,75.768 L463.736,71.352 L481.016,71.352 L481.016,75.768 L474.936,75.768 L474.936,91 L469.784,91 L469.784,75.768 L463.736,75.768 Z M482.328,71.352 L496.376,71.352 L496.376,75.768 L487.384,75.768 L487.384,78.84 L495.608,78.84 L495.608,83.16 L487.384,83.16 L487.384,86.552 L496.376,86.552 L496.376,91 L482.328,91 L482.328,71.352 Z M505.016,84.504 L503.224,84.504 L503.224,91 L498.136,91 L498.136,71.352 L506.968,71.352 C511.192,71.352 514.104,73.752 514.104,78.04 C514.104,81.016 512.6,83.064 510.2,83.96 L514.808,91 L509.112,91 L505.016,84.504 Z M503.224,75.672 L503.224,80.408 L506.424,80.408 C508.248,80.408 509.08,79.48 509.08,78.04 C509.08,76.6 508.248,75.672 506.424,75.672 L503.224,75.672 Z M515.064,88.376 C515.064,86.776 516.408,85.56 518.072,85.56 C519.704,85.56 521.048,86.776 521.048,88.376 C521.048,90.008 519.704,91.224 518.072,91.224 C516.408,91.224 515.064,90.008 515.064,88.376 Z M516.12,84.408 L515,71.352 L521.112,71.352 L519.992,84.408 L516.12,84.408 Z',
  id: 'REGISTER!'
}), _jsx('path', {
  d: 'M106.384,62.176 L111.728,62.176 C112.144,63.52 113.296,64.192 114.896,64.192 C116.464,64.192 117.552,63.52 117.552,62.304 C117.552,61.376 116.944,60.96 115.696,60.672 L111.92,59.872 C109.04,59.232 106.864,57.728 106.864,54.4 C106.864,50.56 110.064,48.032 114.416,48.032 C119.216,48.032 121.936,50.656 122.48,54.048 L117.456,54.048 C117.04,52.96 116.144,52.128 114.448,52.128 C112.976,52.128 111.984,52.768 111.984,53.856 C111.984,54.72 112.592,55.2 113.616,55.424 L117.456,56.32 C120.816,57.12 122.672,58.944 122.672,61.984 C122.672,66.016 119.28,68.32 114.992,68.32 C110.288,68.32 107.088,66.048 106.384,62.176 Z M129.232,48.352 L129.232,68 L124.08,68 L124.08,48.352 L129.232,48.352 Z M144.048,61.344 L141.008,61.344 L141.008,57.504 L149.136,57.504 L149.136,59.456 C149.136,64.896 145.552,68.32 140.336,68.32 C134.64,68.32 130.608,64.16 130.608,58.176 C130.608,52.192 134.64,48.032 140.272,48.032 C145.328,48.032 148.24,50.944 148.976,54.944 L143.728,54.944 C143.184,53.44 142.128,52.544 140.272,52.544 C137.424,52.544 135.792,54.912 135.792,58.176 C135.792,61.536 137.52,63.808 140.336,63.808 C142.288,63.808 143.568,62.848 144.048,61.344 Z M167.856,48.352 L167.856,68 L163.696,68 L155.472,56.512 L155.472,68 L150.512,68 L150.512,48.352 L155.312,48.352 L162.896,59.168 L162.896,48.352 L167.856,48.352 Z M183.952,68.32 C178.768,68.32 175.376,65.376 175.376,59.968 L175.376,48.352 L180.496,48.352 L180.496,59.52 C180.496,62.304 181.808,63.744 183.952,63.744 C186.064,63.744 187.376,62.304 187.376,59.52 L187.376,48.352 L192.496,48.352 L192.496,60 C192.496,65.376 189.136,68.32 183.952,68.32 Z M203.024,61.888 L199.504,61.888 L199.504,68 L194.416,68 L194.416,48.352 L203.024,48.352 C207.28,48.352 210.16,50.752 210.16,55.136 C210.16,59.488 207.28,61.888 203.024,61.888 Z M205.168,55.136 C205.168,53.632 204.336,52.672 202.48,52.672 L199.504,52.672 L199.504,57.6 L202.48,57.6 C204.336,57.6 205.168,56.608 205.168,55.136 Z M210.928,65.376 C210.928,63.776 212.272,62.56 213.936,62.56 C215.568,62.56 216.912,63.776 216.912,65.376 C216.912,67.008 215.568,68.224 213.936,68.224 C212.272,68.224 210.928,67.008 210.928,65.376 Z M211.984,61.408 L210.864,48.352 L216.976,48.352 L215.856,61.408 L211.984,61.408 Z',
  id: 'SIGN-UP!'
}), _jsx('path', {
  d: 'M359.384,154.176 L364.728,154.176 C365.144,155.52 366.296,156.192 367.896,156.192 C369.464,156.192 370.552,155.52 370.552,154.304 C370.552,153.376 369.944,152.96 368.696,152.672 L364.92,151.872 C362.04,151.232 359.864,149.728 359.864,146.4 C359.864,142.56 363.064,140.032 367.416,140.032 C372.216,140.032 374.936,142.656 375.48,146.048 L370.456,146.048 C370.04,144.96 369.144,144.128 367.448,144.128 C365.976,144.128 364.984,144.768 364.984,145.856 C364.984,146.72 365.592,147.2 366.616,147.424 L370.456,148.32 C373.816,149.12 375.672,150.944 375.672,153.984 C375.672,158.016 372.28,160.32 367.992,160.32 C363.288,160.32 360.088,158.048 359.384,154.176 Z M389.816,140.352 L394.968,140.352 L394.968,160 L389.816,160 L389.816,152.224 L382.232,152.224 L382.232,160 L377.08,160 L377.08,140.352 L382.232,140.352 L382.232,147.808 L389.816,147.808 L389.816,140.352 Z M403.32,140.352 L408.568,140.352 L416.056,160 L410.84,160 L409.432,156.192 L402.296,156.192 L400.92,160 L395.832,160 L403.32,140.352 Z M405.88,146.432 L403.864,151.968 L407.896,151.968 L405.88,146.432 Z M423.832,153.504 L422.04,153.504 L422.04,160 L416.952,160 L416.952,140.352 L425.784,140.352 C430.008,140.352 432.92,142.752 432.92,147.04 C432.92,150.016 431.416,152.064 429.016,152.96 L433.624,160 L427.928,160 L423.832,153.504 Z M422.04,144.672 L422.04,149.408 L425.24,149.408 C427.064,149.408 427.896,148.48 427.896,147.04 C427.896,145.6 427.064,144.672 425.24,144.672 L422.04,144.672 Z M434.52,140.352 L448.568,140.352 L448.568,144.768 L439.576,144.768 L439.576,147.84 L447.8,147.84 L447.8,152.16 L439.576,152.16 L439.576,155.552 L448.568,155.552 L448.568,160 L434.52,160 L434.52,140.352 Z M449.688,157.376 C449.688,155.776 451.032,154.56 452.696,154.56 C454.328,154.56 455.672,155.776 455.672,157.376 C455.672,159.008 454.328,160.224 452.696,160.224 C451.032,160.224 449.688,159.008 449.688,157.376 Z M450.744,153.408 L449.624,140.352 L455.736,140.352 L454.616,153.408 L450.744,153.408 Z',
  id: 'SHARE!'
}), _jsx('path', {
  d: 'M203.576,114 L198.552,114 L191.224,94.352 L196.728,94.352 L201.176,107.056 L205.624,94.352 L210.904,94.352 L203.576,114 Z M229.144,104.176 C229.144,110.032 225.208,114.32 219.512,114.32 C213.848,114.32 209.944,110.032 209.944,104.176 C209.944,98.288 213.848,94.032 219.512,94.032 C225.208,94.032 229.144,98.288 229.144,104.176 Z M223.96,104.176 C223.96,100.784 222.168,98.544 219.512,98.544 C216.856,98.544 215.128,100.784 215.128,104.176 C215.128,107.568 216.856,109.808 219.512,109.808 C222.168,109.808 223.96,107.568 223.96,104.176 Z M230.488,114 L230.488,94.352 L235.64,94.352 L235.64,109.552 L244.44,109.552 L244.44,114 L230.488,114 Z M253.752,114.32 C248.568,114.32 245.176,111.376 245.176,105.968 L245.176,94.352 L250.296,94.352 L250.296,105.52 C250.296,108.304 251.608,109.744 253.752,109.744 C255.864,109.744 257.176,108.304 257.176,105.52 L257.176,94.352 L262.296,94.352 L262.296,106 C262.296,111.376 258.936,114.32 253.752,114.32 Z M281.56,94.352 L281.56,114 L277.4,114 L269.176,102.512 L269.176,114 L264.216,114 L264.216,94.352 L269.016,94.352 L276.6,105.168 L276.6,94.352 L281.56,94.352 Z M282.872,98.768 L282.872,94.352 L300.152,94.352 L300.152,98.768 L294.072,98.768 L294.072,114 L288.92,114 L288.92,98.768 L282.872,98.768 Z M301.464,94.352 L315.512,94.352 L315.512,98.768 L306.52,98.768 L306.52,101.84 L314.744,101.84 L314.744,106.16 L306.52,106.16 L306.52,109.552 L315.512,109.552 L315.512,114 L301.464,114 L301.464,94.352 Z M317.272,94.352 L331.32,94.352 L331.32,98.768 L322.328,98.768 L322.328,101.84 L330.552,101.84 L330.552,106.16 L322.328,106.16 L322.328,109.552 L331.32,109.552 L331.32,114 L317.272,114 L317.272,94.352 Z M339.96,107.504 L338.168,107.504 L338.168,114 L333.08,114 L333.08,94.352 L341.912,94.352 C346.136,94.352 349.048,96.752 349.048,101.04 C349.048,104.016 347.544,106.064 345.144,106.96 L349.752,114 L344.056,114 L339.96,107.504 Z M338.168,98.672 L338.168,103.408 L341.368,103.408 C343.192,103.408 344.024,102.48 344.024,101.04 C344.024,99.6 343.192,98.672 341.368,98.672 L338.168,98.672 Z M350.008,111.376 C350.008,109.776 351.352,108.56 353.016,108.56 C354.648,108.56 355.992,109.776 355.992,111.376 C355.992,113.008 354.648,114.224 353.016,114.224 C351.352,114.224 350.008,113.008 350.008,111.376 Z M351.064,107.408 L349.944,94.352 L356.056,94.352 L354.936,107.408 L351.064,107.408 Z',
  id: 'VOLUNTEER!'
}), _jsx('path', {
  d: 'M300.8,18.96 L300.8,13.44 L322.4,13.44 L322.4,18.96 L314.8,18.96 L314.8,38 L308.36,38 L308.36,18.96 L300.8,18.96 Z M339.96,13.44 L346.4,13.44 L346.4,38 L339.96,38 L339.96,28.28 L330.48,28.28 L330.48,38 L324.04,38 L324.04,13.44 L330.48,13.44 L330.48,22.76 L339.96,22.76 L339.96,13.44 Z M355.48,13.44 L355.48,38 L349.04,38 L349.04,13.44 L355.48,13.44 Z M356.8,30.72 L363.48,30.72 C364,32.4 365.44,33.24 367.44,33.24 C369.4,33.24 370.76,32.4 370.76,30.88 C370.76,29.72 370,29.2 368.44,28.84 L363.72,27.84 C360.12,27.04 357.4,25.16 357.4,21 C357.4,16.2 361.4,13.04 366.84,13.04 C372.84,13.04 376.24,16.32 376.92,20.56 L370.64,20.56 C370.12,19.2 369,18.16 366.88,18.16 C365.04,18.16 363.8,18.96 363.8,20.32 C363.8,21.4 364.56,22 365.84,22.28 L370.64,23.4 C374.84,24.4 377.16,26.68 377.16,30.48 C377.16,35.52 372.92,38.4 367.56,38.4 C361.68,38.4 357.68,35.56 356.8,30.72 Z M384.56,30.72 L391.24,30.72 C391.76,32.4 393.2,33.24 395.2,33.24 C397.16,33.24 398.52,32.4 398.52,30.88 C398.52,29.72 397.76,29.2 396.2,28.84 L391.48,27.84 C387.88,27.04 385.16,25.16 385.16,21 C385.16,16.2 389.16,13.04 394.6,13.04 C400.6,13.04 404,16.32 404.68,20.56 L398.4,20.56 C397.88,19.2 396.76,18.16 394.64,18.16 C392.8,18.16 391.56,18.96 391.56,20.32 C391.56,21.4 392.32,22 393.6,22.28 L398.4,23.4 C402.6,24.4 404.92,26.68 404.92,30.48 C404.92,35.52 400.68,38.4 395.32,38.4 C389.44,38.4 385.44,35.56 384.56,30.72 Z M417.12,38.4 C410.64,38.4 406.4,34.72 406.4,27.96 L406.4,13.44 L412.8,13.44 L412.8,27.4 C412.8,30.88 414.44,32.68 417.12,32.68 C419.76,32.68 421.4,30.88 421.4,27.4 L421.4,13.44 L427.8,13.44 L427.8,28 C427.8,34.72 423.6,38.4 417.12,38.4 Z M451.88,13.44 L451.88,38 L446.68,38 L436.4,23.64 L436.4,38 L430.2,38 L430.2,13.44 L436.2,13.44 L445.68,26.96 L445.68,13.44 L451.88,13.44 Z M460.88,32.44 L463.52,32.44 C467.6,32.44 469.88,29.84 469.88,25.72 C469.88,21.56 467.6,18.96 463.52,18.96 L460.88,18.96 L460.88,32.44 Z M454.56,38 L454.56,13.44 L463.84,13.44 C471.56,13.44 476.24,18.24 476.24,25.72 C476.24,33.2 471.56,38 463.84,38 L454.56,38 Z M484.36,13.44 L490.92,13.44 L500.28,38 L493.76,38 L492,33.24 L483.08,33.24 L481.36,38 L475,38 L484.36,13.44 Z M487.56,21.04 L485.04,27.96 L490.08,27.96 L487.56,21.04 Z M508.8,23.04 L513.96,13.44 L520.72,13.44 L511.84,29.28 L511.84,38 L505.4,38 L505.4,29.28 L496.68,13.44 L503.64,13.44 L508.8,23.04 Z M520.96,34.72 C520.96,32.72 522.64,31.2 524.72,31.2 C526.76,31.2 528.44,32.72 528.44,34.72 C528.44,36.76 526.76,38.28 524.72,38.28 C522.64,38.28 520.96,36.76 520.96,34.72 Z M522.28,29.76 L520.88,13.44 L528.52,13.44 L527.12,29.76 L522.28,29.76 Z',
  id: 'THIS-SUNDAY!'
}), _jsx('path', {
  d: 'M8.16,185.44 L10.8,185.44 C14.88,185.44 17.16,182.84 17.16,178.72 C17.16,174.56 14.88,171.96 10.8,171.96 L8.16,171.96 L8.16,185.44 Z M1.84,191 L1.84,166.44 L11.12,166.44 C18.84,166.44 23.52,171.24 23.52,178.72 C23.52,186.2 18.84,191 11.12,191 L1.84,191 Z M48.44,178.72 C48.44,186.04 43.52,191.4 36.4,191.4 C29.32,191.4 24.44,186.04 24.44,178.72 C24.44,171.36 29.32,166.04 36.4,166.04 C43.52,166.04 48.44,171.36 48.44,178.72 Z M41.96,178.72 C41.96,174.48 39.72,171.68 36.4,171.68 C33.08,171.68 30.92,174.48 30.92,178.72 C30.92,182.96 33.08,185.76 36.4,185.76 C39.72,185.76 41.96,182.96 41.96,178.72 Z M71.8,166.44 L71.8,191 L66.6,191 L56.32,176.64 L56.32,191 L50.12,191 L50.12,166.44 L56.12,166.44 L65.6,179.96 L65.6,166.44 L71.8,166.44 Z M73.24,177.36 L76.16,172.8 C74.72,172.52 73.48,171.4 73.48,169.56 C73.48,167.52 75.08,166.04 77.16,166.04 C79.16,166.04 80.84,167.4 80.84,169.96 C80.84,171.4 80.16,172.8 79.32,174.08 L77.2,177.36 L73.24,177.36 Z M81.64,171.96 L81.64,166.44 L103.24,166.44 L103.24,171.96 L95.64,171.96 L95.64,191 L89.2,191 L89.2,171.96 L81.64,171.96 Z M127.16,191 L123,191 L117.88,176.4 L117.88,191 L111.88,191 L111.88,166.44 L119.72,166.44 L125.12,181.72 L130.48,166.44 L138.28,166.44 L138.28,191 L132.24,191 L132.24,176.4 L127.16,191 Z M147.4,166.44 L147.4,191 L140.96,191 L140.96,166.44 L147.4,166.44 Z M148.72,183.72 L155.4,183.72 C155.92,185.4 157.36,186.24 159.36,186.24 C161.32,186.24 162.68,185.4 162.68,183.88 C162.68,182.72 161.92,182.2 160.36,181.84 L155.64,180.84 C152.04,180.04 149.32,178.16 149.32,174 C149.32,169.2 153.32,166.04 158.76,166.04 C164.76,166.04 168.16,169.32 168.84,173.56 L162.56,173.56 C162.04,172.2 160.92,171.16 158.8,171.16 C156.96,171.16 155.72,171.96 155.72,173.32 C155.72,174.4 156.48,175 157.76,175.28 L162.56,176.4 C166.76,177.4 169.08,179.68 169.08,183.48 C169.08,188.52 164.84,191.4 159.48,191.4 C153.6,191.4 149.6,188.56 148.72,183.72 Z M169.48,183.72 L176.16,183.72 C176.68,185.4 178.12,186.24 180.12,186.24 C182.08,186.24 183.44,185.4 183.44,183.88 C183.44,182.72 182.68,182.2 181.12,181.84 L176.4,180.84 C172.8,180.04 170.08,178.16 170.08,174 C170.08,169.2 174.08,166.04 179.52,166.04 C185.52,166.04 188.92,169.32 189.6,173.56 L183.32,173.56 C182.8,172.2 181.68,171.16 179.56,171.16 C177.72,171.16 176.48,171.96 176.48,173.32 C176.48,174.4 177.24,175 178.52,175.28 L183.32,176.4 C187.52,177.4 189.84,179.68 189.84,183.48 C189.84,188.52 185.6,191.4 180.24,191.4 C174.36,191.4 170.36,188.56 169.48,183.72 Z M221.64,178.72 C221.64,186.04 216.72,191.4 209.6,191.4 C202.52,191.4 197.64,186.04 197.64,178.72 C197.64,171.36 202.52,166.04 209.6,166.04 C216.72,166.04 221.64,171.36 221.64,178.72 Z M215.16,178.72 C215.16,174.48 212.92,171.68 209.6,171.68 C206.28,171.68 204.12,174.48 204.12,178.72 C204.12,182.96 206.28,185.76 209.6,185.76 C212.92,185.76 215.16,182.96 215.16,178.72 Z M233.76,191.4 C227.28,191.4 223.04,187.72 223.04,180.96 L223.04,166.44 L229.44,166.44 L229.44,180.4 C229.44,183.88 231.08,185.68 233.76,185.68 C236.4,185.68 238.04,183.88 238.04,180.4 L238.04,166.44 L244.44,166.44 L244.44,181 C244.44,187.72 240.24,191.4 233.76,191.4 Z M245.8,171.96 L245.8,166.44 L267.4,166.44 L267.4,171.96 L259.8,171.96 L259.8,191 L253.36,191 L253.36,171.96 L245.8,171.96 Z M268.24,187.72 C268.24,185.72 269.92,184.2 272,184.2 C274.04,184.2 275.72,185.72 275.72,187.72 C275.72,189.76 274.04,191.28 272,191.28 C269.92,191.28 268.24,189.76 268.24,187.72 Z M269.56,182.76 L268.16,166.44 L275.8,166.44 L274.4,182.76 L269.56,182.76 Z',
  id: 'DON\u2019T-MISS-OUT!'
}))));

var WordCloud = function (_Icon27) {
  _inherits(WordCloud, _Icon27);

  function WordCloud() {
    _classCallCheck(this, WordCloud);

    return _possibleConstructorReturn(this, (WordCloud.__proto__ || Object.getPrototypeOf(WordCloud)).apply(this, arguments));
  }

  _createClass(WordCloud, [{
    key: 'render',
    value: function render() {
      var _props27 = this.props,
          color = _props27.color,
          style = _props27.style,
          otherProps = _objectWithoutProperties(_props27, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 527 179',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref46
      );
    }
  }]);

  return WordCloud;
}(Icon);

var _ref47 = _jsx('defs', {}, void 0, _jsx('filter', {
  x: '-1.7%',
  y: '-17.2%',
  width: '103.5%',
  height: '134.5%',
  filterUnits: 'objectBoundingBox',
  id: 'filter-1'
}, void 0, _jsx('feGaussianBlur', {
  stdDeviation: '3.62165179',
  'in': 'SourceGraphic'
})));

var _ref48 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-473.000000, -2080.000000)',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'Group-38',
  transform: 'translate(473.000000, 2080.000000)'
}, void 0, _jsx('g', {
  id: 'np_megaphone_39209_000000'
}, void 0, _jsx('path', {
  d: 'M279.571188,94.921721 C269.704347,92.5096507 259.794862,94.962991 252.355651,100.746827 C251.424791,101.470552 250.532607,102.246424 249.684025,103.071436 C245.517321,107.122402 242.401837,112.358117 240.920413,118.422577 C239.924766,122.498332 249.128031,129.710185 249.684025,133.623249 C249.910551,135.217526 240.888225,133.654766 241.346846,135.180629 C244.504637,145.686825 252.989356,154.287202 264.394389,157.068984 C281.594855,161.28329 298.887627,150.793672 303.063531,133.623249 C307.294724,116.453297 296.790492,99.154259 279.571188,94.921721 Z',
  id: 'Shape',
  fill: '#454E57'
}), _jsx('ellipse', {
  id: 'Oval-4',
  fill: '#C5CCD3',
  cx: '346.5',
  cy: '420.5',
  rx: '314.5',
  ry: '31.5'
}), _jsx('path', {
  d: 'M248.048734,164.692558 L196.818449,172.490086 L164.789269,145.516102 C167.493346,144.00745 169.795451,141.699057 170.983033,138.936049 L174.12566,131.719906 L218.048907,136.918432 C218.048907,136.918432 220.405878,135.118957 222.433935,129.647848 C224.461993,124.158499 223.658095,121.631825 223.658095,121.631825 L111.20025,48 C103.745469,58.0331738 97.5517043,69.3026958 93.0207425,81.6447745 C88.233929,94.6773842 85.6211538,107.98267 85,121.160459 L128.15616,126.286395 L129.435138,133.902245 C130.257325,138.773653 134.148985,143.154151 138.84459,144.862796 C139.758125,145.18997 140.708238,145.426249 141.676593,145.53532 L144.636475,145.898849 L140.817829,149.788623 L182.768164,196.229626 C185.289544,198.683431 188.687835,200.046671 192.159374,200.046671 C192.798863,200.046671 193.438353,199.992141 194.059553,199.919435 L245.346841,192.594408 L219.493651,199.483432 L194.480516,259.355822 C194.334348,259.737531 194.279539,260.119222 194.151641,260.482774 L149.040811,330.09891 C146.848297,333.461573 145.916473,337.478379 146.446325,341.441022 L156.221078,408.239929 L192.159374,408.239929 L180.576109,343.171444 L206.941002,307.089337 L202.976189,344.296582 C202.830021,346.714045 203.17717,349.16799 204.05418,351.421522 L230.547234,420 L262.409643,420 L236.777481,342.914589 L243.464708,281.153011 C243.665689,280.6986 243.939741,280.298735 244.122439,279.862499 L276.95519,201.302963 C282.619009,187.634264 276.114715,171.984244 262.411397,166.331569 C257.677554,164.383541 252.762581,163.965499 248.048734,164.692558 Z M114.997862,67.811428 L118.25008,62.5221652 L209.715918,121.975769 L114.997862,67.811428 Z M142.422646,139.391203 C139.298308,139.009499 136.100722,135.974052 135.571245,132.884205 L134.584602,127.031443 L167.691446,130.957558 L165.279704,136.465055 C164.34788,138.64623 161.91785,140.427512 159.451242,140.991011 L153.96984,136.392372 L150.114664,140.318488 L142.422646,139.391203 Z',
  id: 'Shape',
  fill: '#454E57'
}), _jsx('path', {
  d: 'M108.471485,47.3527175 C109.347652,46.1470267 109.115164,44.4298023 107.917203,43.5346419 C106.737095,42.6394816 105.056306,42.8952484 104.180139,44.1009392 C96.5449768,54.6051952 90.4299807,66.2239003 86.0132132,78.6095783 C81.3286657,91.7079801 78.6284365,105.33578 78.0027011,119.128667 C77.9490581,120.370882 78.7000276,121.430474 79.7549892,121.83234 C80.0231994,121.92368 80.2914188,121.978486 80.5596108,121.996753 C82.0437069,122.069826 83.2953609,120.900636 83.3668604,119.402654 C83.9926874,106.15834 86.5674949,93.0781773 91.0555788,80.5096416 C95.2932771,68.598645 101.157979,57.43685 108.471348,47.3530262 L108.471485,47.3527175 Z',
  id: 'Shape',
  fill: '#454E57'
}), _jsx('path', {
  d: 'M221.040927,135.110182 C219.846673,136.068665 219.631308,137.782959 220.649361,138.962659 C221.001768,139.368179 221.452079,139.663118 221.941499,139.828984 C222.822505,140.142345 223.879731,140.031746 224.701996,139.441896 C225.015245,139.20227 227.951963,136.953483 230.340471,130.833858 C232.709433,124.732448 231.906714,121.543482 231.710946,120.972507 C231.26065,119.516333 229.61609,118.686814 228.069444,119.110799 C226.542344,119.534755 225.680936,121.027812 226.092068,122.447133 C226.131222,122.613027 226.44447,124.695925 224.819477,128.917081 C223.018272,133.48842 221.060494,135.092105 221.040897,135.110508 L221.040927,135.110182 Z',
  id: 'Shape',
  fill: '#454E57'
}), _jsx('path', {
  d: 'M76.3666619,48.5934816 C75.5126447,48.832665 74.4984823,49.1270414 73.3064109,49.4766248 C72.096576,49.8078059 70.7087867,50.1573751 69.4633336,51.0589348 C68.1467351,51.813304 66.687755,52.6780307 65.1932477,53.6531621 C63.5741677,54.481103 62.3999055,56.0082107 60.9587344,57.351342 C59.642136,58.8048309 57.9518652,60.0743434 57.0088936,61.969451 C55.9057766,63.7541539 54.7848962,65.5572262 53.6817792,67.3785265 C52.9700983,69.4024082 52.2406082,71.4262898 51.5467363,73.413103 C50.67491,75.3449965 50.7105282,77.4976522 50.4080467,79.4665199 C50.2301242,81.471985 49.7853202,83.3302597 50.1233743,85.2255557 C50.2835014,87.0838303 50.5147966,88.8317002 50.7282918,90.4141987 C50.8172508,92.0332946 51.386591,93.2843906 51.8491722,94.4435455 C52.2939717,95.5842839 52.6853803,96.5962012 53.0056709,97.4241421 C53.6639701,99.0800238 54.1265514,100 54.1265514,100 C54.1265514,100 54.1443423,98.9696662 54.0375879,97.1849633 C54.0553833,95.4370934 53.4682431,92.7876637 53.8240881,89.8989141 C53.9664243,88.4454252 54.1265514,86.9183175 54.2155104,85.3360074 C54.1265514,83.7536974 54.9093823,82.0610298 55.1762911,80.3498986 C55.6032997,78.6388145 55.7990177,76.7989093 56.6174622,75.1428862 C57.2757614,73.4318021 57.9518697,71.683885 58.627978,69.9358738 C59.5531406,68.3351944 60.4961577,66.7160985 61.4035567,65.1522991 C62.2041921,63.4780009 63.4674088,62.1900719 64.534953,60.8101548 C65.7092152,59.5406423 66.5098507,57.9031299 67.8086855,56.9647844 C69.0185204,55.9160341 70.1394465,54.8489145 71.1713725,53.8369972 C73.217461,51.7763297 75.3880767,50.745996 76.7760026,49.6604599 C78.1815555,48.666912 79,48.0045781 79,48.0045781 C78.9822091,47.9677829 78.0392193,48.1517687 76.3668031,48.5933403 L76.3666619,48.5934816 Z',
  id: 'Shape',
  fill: '#454E57'
}), _jsx('path', {
  d: 'M57.6369697,32.2921859 C61.3488942,29.5220211 64.662361,27.3132498 67.1432197,26.1183422 C69.5876442,24.8328663 71,24 71,24 C71,24 69.4427884,24.3440064 66.7267302,25.104432 C65.3505768,25.4484384 63.7209604,25.9916208 61.9281784,26.7701647 C60.0812552,27.4762633 57.9627446,28.2729302 55.8803901,29.5765289 C53.6894285,30.680961 51.4441865,32.1113275 49.2170225,33.8494591 C46.8450027,35.406547 44.7626945,37.5610887 42.4632649,39.6251548 C40.4534078,41.9607866 38.1175903,44.1877736 36.3793205,46.9577529 C34.3875415,49.5468275 32.8665785,52.4979897 31.2187451,55.3767992 C29.9331671,58.4366526 28.5208113,61.4421835 27.6698008,64.5926051 C26.5471566,67.6524585 26.1850402,70.8753717 25.5331659,73.8807173 C25.2796659,76.9586472 24.8632135,79.928025 25.0442717,82.7526048 C25.0261659,85.5770919 25.2796612,88.2205353 25.714224,90.628427 C25.9496182,93.0545807 26.6014833,95.2453219 27.1446579,97.146189 C27.633552,99.0834874 28.1767729,100.676775 28.7380719,101.944359 C29.7701869,104.533434 30.4401393,106 30.4401393,106 C30.4401393,106 30.2409614,104.406713 29.7701869,101.654671 C29.4804753,100.278627 29.2632148,98.6129404 29.1726393,96.7118879 C29.0277835,94.810789 28.8286102,92.7105697 28.9010335,90.3748915 C28.8286102,88.0392597 28.9553556,85.540568 29.2088556,82.9152939 C29.2631777,80.2718969 30.0417881,77.5562864 30.3858265,74.7136299 C31.1282299,71.9434652 31.7257312,69.0644703 32.812173,66.2403539 C33.6631836,63.3615907 35.039337,60.6278109 36.2343859,57.8574608 C37.7191465,55.2140638 39.0409732,52.4618366 40.8154454,50.0358683 C42.4088593,47.5010697 44.3281873,45.2562379 46.0844888,42.9748822 C48.1305946,40.9832614 49.8326157,38.7381978 51.8967995,37.0726505 C53.8342519,35.2621199 55.7535799,33.6325867 57.6367982,32.2930202 L57.6369697,32.2921859 Z',
  id: 'Shape',
  fill: '#454E57'
}), _jsx('path', {
  d: 'M36.5017708,17.650073 C37.9199398,16.4050755 39.3012848,15.2149644 40.6273704,14.0431799 C42.0639749,13.0178686 43.4637083,12.0108839 44.7897939,11.0587857 C47.4419651,9.06309621 50.0389711,7.54343244 52.3596797,6.13354144 C54.6250818,4.65048422 56.7063172,3.53363307 58.4929139,2.76466126 C61.9738827,1.00698465 64,0 64,0 C64,0 61.8266813,0.640825458 58.0511212,1.73934991 C56.1356642,2.25202902 53.8886977,3.07593408 51.3836808,4.24771848 C48.823593,5.30963639 45.9133715,6.49974751 43.0405397,8.36729063 C41.5671113,9.24612893 40.0384234,10.1432939 38.4544761,11.0770186 C36.9626121,12.1572632 35.4155358,13.2924411 33.8315885,14.4458988 C30.5347865,16.6246679 27.6431891,19.6275295 24.4568118,22.5387107 C21.6757333,25.7977243 18.4527678,28.9286854 16.0396457,32.7735444 C13.2769556,36.3804374 11.1775676,40.4632624 8.89363571,44.4548288 C7.08869768,48.6842206 5.09954574,52.8223069 3.88397908,57.1982186 C2.30003175,61.4459371 1.76591984,65.8952025 0.826603328,70.0695673 C0.439824832,74.3356125 -0.186361028,78.4370454 0.053065196,82.3915834 C0.0899032639,84.3323397 0.126736617,86.2364893 0.163574685,88.0855183 C0.366172271,89.916408 0.587181819,91.6740846 0.771381589,93.3768279 C1.01081253,96.7640348 1.8396054,99.8033623 2.53949569,102.476437 C3.14730259,105.186165 3.82875734,107.456521 4.56547155,109.250757 C5.98364051,112.894257 6.77561418,115 6.77561418,115 C6.77561418,115 6.35200705,112.802904 5.63369537,108.957811 C5.15484292,107.053661 4.80489778,104.710092 4.60229548,102.036783 C4.32602647,99.363662 3.97610019,96.415968 3.95766465,93.1021617 C3.90241462,91.4726314 3.86557655,89.769888 3.81032181,87.9941191 C3.93924797,86.2364425 4.06817414,84.4238326 4.17867891,82.5378221 C4.25235033,78.8027359 5.30216219,74.9395033 5.76262625,70.9296571 C6.79402614,66.9932114 7.58599981,62.8734049 9.11468769,58.900587 C10.2934304,54.7993416 12.2457113,50.9362028 13.9767657,46.981196 C16.094825,43.2095032 17.9918464,39.3280377 20.5517927,35.9040836 C22.8171948,32.2971906 25.5982261,29.1480434 28.1400669,25.962196 C31.1053593,23.1242748 33.5547395,19.9753151 36.5015964,17.6500261 L36.5017708,17.650073 Z',
  id: 'Shape',
  fill: '#454E57'
})), _jsx('g', {
  id: 'Group-25',
  opacity: '0.744419643',
  transform: 'translate(51.000000, 86.000000)',
  stroke: '#EB3248'
}, void 0, _jsx('circle', {
  id: 'Oval-3',
  strokeWidth: '12.8',
  fill: '#F0F1F2',
  cx: '153.5',
  cy: '153.5',
  r: '153.5'
}), _jsx('path', {
  d: 'M53.5651042,82.3463542 L244.640625,231.848958',
  id: 'Line-5',
  strokeWidth: '57.6',
  strokeLinecap: 'square'
})))));

var MegaPhone = function (_Icon28) {
  _inherits(MegaPhone, _Icon28);

  function MegaPhone() {
    _classCallCheck(this, MegaPhone);

    return _possibleConstructorReturn(this, (MegaPhone.__proto__ || Object.getPrototypeOf(MegaPhone)).apply(this, arguments));
  }

  _createClass(MegaPhone, [{
    key: 'render',
    value: function render() {
      var _props28 = this.props,
          color = _props28.color,
          style = _props28.style,
          otherProps = _objectWithoutProperties(_props28, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 669 461',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref47,
        _ref48
      );
    }
  }]);

  return MegaPhone;
}(Icon);

var _ref49 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-666.000000, -6184.000000)',
  fill: '#000000',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'np_calendar_888685_000000',
  transform: 'translate(666.000000, 6184.000000)'
}, void 0, _jsx('path', {
  d: 'M17.332,0.668 C15.039,0.668 13.164,2.543 13.164,4.836 L13.164,11.086 L21.4960061,11.086 L21.496,4.836 C21.499906,2.543 19.6249,0.668 17.3319,0.668 L17.332,0.668 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M54.832,11.082 L54.832,15.25 C54.832,17.543 52.957,19.418 50.664,19.418 C48.371,19.418 46.496,17.543 46.496,15.25 L46.496,11.082 L21.5,11.082 L21.5,15.25 C21.5,17.543 19.625,19.418 17.332,19.418 C15.039,19.418 13.164,17.543 13.164,15.25 L13.164,11.082 L5.468,11.082 C2.8170332,11.082 0.668,13.2310332 0.668,15.882 L0.668,62.532 C0.668,65.1829668 2.8170332,67.332 5.468,67.332 L62.536,67.3323334 C65.1869668,67.3323334 67.336,65.1833002 67.336,62.5323334 C67.336,62.5322223 67.336,62.5321111 67.336,62.532 L67.332093,15.882 C67.3319089,13.2311634 65.1829296,11.0823334 62.532093,11.0823334 L54.832,11.082 Z M59,59 L9,59 L9,23.582 L59,23.582 L59,59 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M50.668,0.668 C48.375,0.668 46.5,2.543 46.5,4.836 L46.5,11.086 L54.832,11.086 L54.832,4.836 C54.832,2.543 52.957,0.668 50.6679,0.668 L50.668,0.668 Z',
  id: 'Shape'
}), _jsx('polygon', {
  id: 'Shape',
  points: '29.832 54.418 18.582 43.168 24.4179 37.3321 29.832 42.7501 43.582 29.0001 49.4179 34.8321'
}))));

var Calendar = function (_Icon29) {
  _inherits(Calendar, _Icon29);

  function Calendar() {
    _classCallCheck(this, Calendar);

    return _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).apply(this, arguments));
  }

  _createClass(Calendar, [{
    key: 'render',
    value: function render() {
      var _props29 = this.props,
          color = _props29.color,
          style = _props29.style,
          otherProps = _objectWithoutProperties(_props29, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '6.8rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 68 68',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref49
      );
    }
  }]);

  return Calendar;
}(Icon);

var _ref50 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-855.000000, -2878.000000)',
  fillRule: 'nonzero',
  stroke: '#6191A4',
  strokeWidth: '8'
}, void 0, _jsx('g', {
  id: 'Arrow',
  transform: 'translate(913.500000, 2943.500000) scale(-1, 1) translate(-913.500000, -2943.500000) translate(859.000000, 2879.000000)'
}, void 0, _jsx('path', {
  d: 'M4.01010529,8.52651283e-14 C3.90119877,28.94281 11.5974366,54.9384417 27.0988187,77.986895 C51.2770966,106.719369 78.5774904,119.375881 109,115.956431',
  id: 'Path-3',
  transform: 'translate(56.504483, 58.250967) scale(-1, 1) translate(-56.504483, -58.250967) '
}), _jsx('polyline', {
  id: 'Path-4',
  points: '19.1281474 100.786856 0 118.886267 19.1281474 128.227729'
}))));

var LineArrow = function (_Icon30) {
  _inherits(LineArrow, _Icon30);

  function LineArrow() {
    _classCallCheck(this, LineArrow);

    return _possibleConstructorReturn(this, (LineArrow.__proto__ || Object.getPrototypeOf(LineArrow)).apply(this, arguments));
  }

  _createClass(LineArrow, [{
    key: 'render',
    value: function render() {
      var _props30 = this.props,
          color = _props30.color,
          style = _props30.style,
          otherProps = _objectWithoutProperties(_props30, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '10.9rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 120 133',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref50
      );
    }
  }]);

  return LineArrow;
}(Icon);

var _ref51 = _jsx('defs', {}, void 0, _jsx('circle', {
  id: 'path-1',
  cx: '136.5',
  cy: '136.5',
  r: '136.5'
}));

var _ref52 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-132.000000, -9256.000000)'
}, void 0, _jsx('g', {
  id: 'Screen-Shot-2018-09-18-at-9.07.43-AM',
  transform: 'translate(141.000000, 9265.000000)'
}, void 0, _jsx('mask', {
  id: 'mask-2',
  fill: 'white'
}, void 0, _jsx('use', {
  xlinkHref: '#path-1'
})), _jsx('use', {
  id: 'Mask',
  stroke: '#454E57',
  strokeWidth: '18',
  fillRule: 'nonzero',
  xlinkHref: '#path-1'
}), _jsx('g', {
  id: 'np_installment_1628844_000000',
  mask: 'url(#mask-2)',
  fill: '#454E57',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  transform: 'translate(62.500000, 52.500000)',
  id: 'Shape'
}, void 0, _jsx('path', {
  d: 'M48.5523314,34.92056 L52.8447091,42.6407741 C53.6486709,43.966535 55.3055244,44.3913606 56.6059087,43.6076197 C57.8992416,42.8165471 58.3746175,41.1026566 57.6825109,39.7109479 L51.9918532,29.4563315 C51.2158642,28.0646416 49.5240581,27.5885504 48.188775,28.3869359 L38.4013519,34.2466632 C37.059089,35.0523804 36.6046883,36.846882 37.3736796,38.2532166 C38.1426889,39.6595511 39.8554342,40.1356422 41.1976971,39.3299438 L48.5523314,34.92056 Z'
}), _jsx('path', {
  d: 'M62.0080702,139.543657 C62.7840632,140.935358 64.4758779,141.411453 65.8111678,140.613061 L75.5986409,134.753286 C76.9409107,133.947562 77.3953137,132.153045 76.6263184,130.746699 C75.8573053,129.340353 74.1445512,128.864258 72.8022814,129.669963 L65.4477169,134.079515 L61.1553172,126.359237 C60.3513513,125.033465 58.6944894,124.608636 57.3940984,125.392384 C56.1007589,126.183444 55.6253806,127.897367 56.3174907,129.289087 L62.0080702,139.543657 Z'
}), _jsx('path', {
  d: 'M23.6559535,43.3202602 L13.4593513,48.9597101 C12.7892856,49.3333214 12.3013262,49.9536609 12.0973867,50.6797513 C11.9007374,51.4058237 12.0027053,52.1741965 12.3960057,52.8227423 L18.3245707,62.6918698 C19.1621434,63.967793 20.8882644,64.3766486 22.2430133,63.62237 C23.5904162,62.8610533 24.0856659,61.2115728 23.3646247,59.8721809 L18.8344381,52.4986679 L26.5400623,48.2689903 C27.9384407,47.4935614 28.4118384,45.7665182 27.6106981,44.4130503 C26.8095391,43.0595823 25.0251897,42.6013883 23.6268113,43.3767991 L23.6559535,43.3202602 Z'
}), _jsx('path', {
  d: 'M68.1048656,71.8630908 C63.6366408,68.8626838 57.9793512,68.171931 52.9060561,70.0210834 C47.8397863,71.8702359 43.9768119,76.028864 42.5342985,81.1853056 C41.4717959,85.0299064 42.0065599,89.1397691 44.0260425,92.5867451 C45.2081722,94.6032715 46.8476621,96.3057707 48.8249934,97.5688462 C50.1267501,98.3852277 51.8577301,98.0084307 52.6949931,96.7245452 C53.5323282,95.4406596 53.1664399,93.7241381 51.8787517,92.8799443 C50.6473735,92.0984488 49.620051,91.037937 48.8811412,89.781828 C47.621608,87.618827 47.2908999,85.0440894 47.9664026,82.6367259 C48.9304079,79.2386939 51.4775752,76.4964037 54.8129371,75.2683393 C58.1553241,74.0332905 61.8846391,74.4589243 64.8539686,76.4126631 C65.3183721,76.7406054 65.7546388,77.1174024 66.148682,77.5290853 C67.225271,78.6455075 69.0054277,78.6803935 70.1312654,77.6128188 C71.2571031,76.5452333 71.2922833,74.7799644 70.2157032,73.6635422 C69.5683375,73.0006732 68.8646979,72.4005918 68.1047124,71.8633337 L68.1048656,71.8630908 Z'
}), _jsx('path', {
  d: 'M67.3828101,28 C68.2395061,28 69.0504141,27.5220559 69.5344276,26.7279545 C70.0249033,25.9338342 70.1360836,24.9191418 69.8287097,24.0147543 L66.0618722,12.897297 C65.5517755,11.3752583 64.0411732,10.6179754 62.6874556,11.1914293 C61.3337547,11.7649585 60.6602274,13.4634097 61.1702572,14.9854672 L64.9370946,26.0882423 C65.31639,27.2353007 66.2907955,27.9999435 67.3828603,27.9999435 L67.3828101,28 Z'
}), _jsx('path', {
  d: 'M181.55175,154.713504 C177.641892,148.551644 143.233903,94.353918 138.456684,89.6490764 L137.461421,88.6626151 C132.954274,84.2020739 127.864397,79.141121 120.968641,79.141121 L120.854897,79.141121 C115.97813,79.141121 106.011486,79.8702525 101.645927,80.1990607 L71.9871305,1.83993277 C71.4326273,0.374532901 69.7976172,-0.368835734 68.3331493,0.181526427 L13.2104102,20.9827456 C12.4995236,21.2472306 11.9308071,21.7905108 11.6180039,22.4767479 C11.3052189,23.1701402 11.2767739,23.9635949 11.5469152,24.6712427 L13.4235889,29.6320965 C13.9780921,31.1117884 15.6201997,31.8480018 17.0917652,31.2905028 C18.5633125,30.7329306 19.2954736,29.0817343 18.7410432,27.6020241 L17.873755,25.3288408 L67.6369092,6.52960397 L101.759903,96.7688687 L101.64616,96.7688687 C101.596398,96.3828558 101.468436,96.01829 101.276503,95.6823266 L56.3051271,17.8520588 C55.5160396,16.4938766 53.7956766,16.0292483 52.4378544,16.8084111 L1.42443377,46.2598778 C0.77040062,46.6387356 0.294116424,47.2677862 0.0950565273,48.0040546 C-0.0968875874,48.740323 0.00264054088,49.5194857 0.38653059,50.1771388 L58.4665958,150.409846 C58.5519033,150.538516 58.6443192,150.667194 58.750954,150.781567 C58.8078257,150.860197 58.8718059,150.938828 58.9357824,151.010312 C59.0353087,151.10324 59.1490556,151.18902 59.262799,151.267642 C59.4405224,151.439201 59.6609005,151.553574 59.9026005,151.610761 C60.2225013,151.768024 60.570847,151.839506 60.9262903,151.825214 C61.1679903,151.825214 61.4168061,151.789473 61.6514085,151.725137 L61.8646818,151.639359 C62.0281864,151.589321 62.1845826,151.517837 62.3338684,151.439198 L74.5897558,144.290986 C73.736681,148.372724 75.5068181,152.554379 79.025745,154.756193 C81.1299053,156.185854 98.4185248,165.378595 103.381373,165.378595 C106.466638,165.378595 112.523423,162.748019 116.049466,161.089521 C122.141922,172.455255 132.968829,180.490817 145.566311,182.99238 L145.978626,182.99238 C147.549703,183.106753 148.914659,181.92013 149.028402,180.340394 C149.142146,178.760658 147.962054,177.38811 146.391013,177.273737 C135.414875,175.057832 126.017311,167.988126 120.799678,158.029819 C119.690672,155.770909 118.709713,153.454905 117.870742,151.081623 C115.851753,145.77765 113.775983,140.302027 110.192978,137.170956 C108.301927,135.512549 101.34939,130.022744 93.316382,123.617864 L81.8283074,114.468036 C77.8756818,111.322691 65.8616582,101.729829 63.5438424,99.4423716 C61.8661377,97.9984189 60.8423933,95.9396344 60.7002596,93.7237291 C60.8779849,91.5220974 61.9016802,89.470523 63.5438424,88.0050865 C65.9466472,85.5604354 69.6859813,85.7033557 74.6339064,88.4053915 L122.278705,114.368944 C122.69102,114.590534 123.145993,114.712062 123.615198,114.712062 C124.930362,114.747803 126.096258,113.868558 126.437488,112.588936 C126.771602,111.309388 126.195788,109.965497 125.037026,109.336538 L109.482582,100.901495 C109.454147,100.744233 109.411494,100.594115 109.354622,100.444003 L103.795395,85.7757309 C108.6152,85.4326123 116.818913,84.8893321 120.92805,84.8607481 C125.477782,84.8607481 129.345055,88.6923301 133.425619,92.7382011 L134.435095,93.7389544 C137.705261,96.9556679 161.449587,133.769452 176.70575,157.787751 C177.096736,158.459696 177.743653,158.938635 178.490101,159.117331 C179.243645,159.296038 180.032751,159.16737 180.686711,158.745628 C181.333629,158.331031 181.788602,157.666241 181.945004,156.901389 C182.094293,156.143673 181.937895,155.3502 181.497146,154.714031 L181.55175,154.713504 Z M110.97448,148.994861 C111.543196,150.424522 112.0977,151.854183 112.623758,153.169379 C112.993433,154.141548 113.348876,155.070896 113.718533,156.0287 C109.524225,157.987313 104.917712,159.788731 103.382086,159.803004 C100.652247,159.73152 85.6097393,152.383043 82.1402953,150.10986 C80.1711711,148.944684 79.4672365,146.421381 80.5478889,144.391217 C81.0597338,143.04019 82.1474111,141.996524 83.5052151,141.531896 C85.410461,142.961556 87.6283646,144.391217 89.6757443,145.649318 C91.3392357,146.692966 92.9031425,147.679482 93.7705035,148.351446 C95.3060382,149.566653 98.1353349,149.952665 101.106856,149.952665 C104.419607,149.916924 107.718163,149.5881 110.974134,148.966204 L110.97448,148.994861 Z M108.329993,143.719437 C104.931889,144.262717 98.6476166,144.705898 97.2685016,143.919598 C96.1595134,143.04751 94.5528573,142.046811 92.6903788,140.860079 C90.8279003,139.673456 88.808911,138.415428 87.1169565,137.157326 L95.2638895,132.439492 C100.808921,136.842755 105.21652,140.316945 106.524477,141.532225 C107.228266,142.168431 107.839641,142.904699 108.34437,143.705309 L108.329993,143.719437 Z M59.4913448,84.0314479 C56.7402125,86.5690612 55.1265134,90.1146196 55.0127701,93.8675131 C55.169168,97.598996 56.8397607,101.10155 59.6336604,103.560658 C61.3824684,105.276251 67.1549142,110.037089 78.3585395,118.972445 L89.8608092,128.122274 L90.4863974,128.608349 L61.9504752,145.092313 L6.74220115,49.7913637 L52.8218919,23.1854936 L92.5046587,91.6811068 L77.3342127,83.417714 C68.0640417,78.3710348 62.5617772,80.9586062 59.4907078,84.0324727 L59.4913448,84.0314479 Z'
}))))));

var MoneyCircle = function (_Icon31) {
  _inherits(MoneyCircle, _Icon31);

  function MoneyCircle() {
    _classCallCheck(this, MoneyCircle);

    return _possibleConstructorReturn(this, (MoneyCircle.__proto__ || Object.getPrototypeOf(MoneyCircle)).apply(this, arguments));
  }

  _createClass(MoneyCircle, [{
    key: 'render',
    value: function render() {
      var _props31 = this.props,
          color = _props31.color,
          style = _props31.style,
          otherProps = _objectWithoutProperties(_props31, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '27.3rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 291 291',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref51,
        _ref52
      );
    }
  }]);

  return MoneyCircle;
}(Icon);

var _ref53 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-251.000000, -11223.000000)',
  fill: '#000000',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'Group-36',
  transform: 'translate(251.000000, 11223.000000)'
}, void 0, _jsx('g', {
  id: 'np_animation_200269_000000',
  transform: 'translate(0.000000, 0.500000)'
}, void 0, _jsx('path', {
  d: 'M40.7158837,21.66966 C37.9871209,21.66966 35.7682093,19.429524 35.7682093,16.67466 C35.7682093,13.919796 37.9871209,11.67966 40.7158837,11.67966 C43.4446465,11.67966 45.6635581,13.919796 45.6635581,16.67466 C45.6635581,19.429524 43.4446465,21.66966 40.7158837,21.66966 Z M40.7158837,13.29966 C38.8730488,13.29966 37.3728605,14.814198 37.3728605,16.67466 C37.3728605,18.535122 38.8730488,20.04966 40.7158837,20.04966 C42.5587186,20.04966 44.058907,18.535122 44.058907,16.67466 C44.058907,14.814198 42.5587186,13.29966 40.7158837,13.29966 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M14.7761425,26.1330808 C14.7740532,25.9137058 14.3499043,4.21664076 0.990584326,1.67270076 C0.555991302,1.59043716 0.267635488,1.16645076 0.351237814,0.72559476 C0.432722,0.28684476 0.852691302,-0.00426924 1.28937037,0.08013276 C11.3039983,1.98698076 14.6737657,13.0066528 15.808789,20.0936128 C16.8848146,15.1872268 18.8405099,9.25797276 21.9952541,9.24501276 C25.3779791,9.24501276 26.9032535,16.6889128 27.5530303,21.8124328 C28.5789372,19.3086148 30.4050303,16.5411148 33.5308907,16.1381128 C33.9738386,16.0790476 34.3729047,16.3954552 34.4293349,16.8384388 C34.4857491,17.2814062 34.1744307,17.6885068 33.7356442,17.7454768 C29.1766163,18.3318628 27.9712023,26.1575968 27.9583651,26.2380568 C27.8977735,26.6472742 27.5404872,26.9489128 27.1330396,26.9277988 C26.7235219,26.9109238 26.3913163,26.58397 26.3641442,26.1726628 C25.8814972,18.8086828 24.0783721,10.8647428 22.0036117,10.8647428 C19.4587349,10.8731803 17.181307,19.8530428 16.3724559,26.2250428 C16.3223105,26.6321542 15.979648,26.9337928 15.5784745,26.9337928 C15.1125522,26.9072383 14.7824541,26.5591894 14.7761425,26.1330808 Z',
  id: 'Shape'
})), _jsx('path', {
  d: 'M46.4821429,0.592 L3.625,0.592 C1.89911016,0.592 0.5,2.00230304 0.5,3.742 L0.5,26.35 C0.5,28.089697 1.89911016,29.5 3.625,29.5 L46.4821429,29.5 C48.2080327,29.5 49.6071429,28.089697 49.6071429,26.35 L49.6071429,3.742 C49.6071429,2.00230304 48.2080327,0.592 46.4821429,0.592 Z M48.1428571,26.35 C48.1428571,27.2745247 47.39933,28.024 46.4821429,28.024 L3.625,28.024 C2.70781283,28.024 1.96428571,27.2745247 1.96428571,26.35 L1.96428571,3.742 C1.96428571,2.81747533 2.70781283,2.068 3.625,2.068 L46.4821429,2.068 C47.39933,2.068 48.1428571,2.81747533 48.1428571,3.742 L48.1428571,26.35 Z',
  id: 'Shape',
  stroke: '#000000'
}))));

var MotionDesigner = function (_Icon32) {
  _inherits(MotionDesigner, _Icon32);

  function MotionDesigner() {
    _classCallCheck(this, MotionDesigner);

    return _possibleConstructorReturn(this, (MotionDesigner.__proto__ || Object.getPrototypeOf(MotionDesigner)).apply(this, arguments));
  }

  _createClass(MotionDesigner, [{
    key: 'render',
    value: function render() {
      var _props32 = this.props,
          color = _props32.color,
          style = _props32.style,
          otherProps = _objectWithoutProperties(_props32, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '5rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 51 30',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref53
      );
    }
  }]);

  return MotionDesigner;
}(Icon);

var _ref54 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-767.000000, -11020.000000)',
  fill: '#000000',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'np_designer_693491_000000',
  transform: 'translate(767.000000, 11020.000000)'
}, void 0, _jsx('path', {
  d: 'M41.3870976,31.874807 L4.30156098,31.874807 C2.11902927,31.874807 0.249802439,30.1072842 0.249802439,27.8199579 L0.249802439,4.2213614 C0.249802439,2.03716491 2.01597805,0.166512281 4.30156098,0.166512281 L41.3870976,0.166512281 C43.5696293,0.166512281 45.4388561,1.93403509 45.4388561,4.2213614 L45.4388561,27.8199579 C45.4388561,30.0041544 43.5696854,31.874807 41.3870976,31.874807 Z M4.30156098,1.62245614 C2.84650244,1.62245614 1.70486098,2.76502456 1.70486098,4.22113684 L1.70486098,27.8197333 C1.70486098,29.2759018 2.84655854,30.418414 4.30156098,30.418414 L41.3870976,30.418414 C42.8421561,30.418414 43.9837976,29.2758456 43.9837976,27.8197333 L43.9837976,4.22113684 C43.9837976,2.76496842 42.8421,1.62245614 41.3870976,1.62245614 L4.30156098,1.62245614 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M41.284439,31.874807 L4.40478049,31.874807 C2.11925366,31.874807 0.250082927,30.0042105 0.250082927,27.7169404 L0.250082927,25.2213333 C0.250082927,24.8046653 0.561250488,24.4932491 0.977612195,24.4932491 L44.7140756,24.4932491 C45.1304261,24.4932491 45.4416049,24.804654 45.4416049,25.2213333 L45.4416049,27.7169404 C45.4394137,30.0042105 43.5702463,31.874807 41.2846634,31.874807 L41.284439,31.874807 Z M1.70256098,25.949193 L1.70256098,27.7167158 C1.70256098,29.1728842 2.94944146,30.4206596 4.4044439,30.4206596 L41.2841024,30.4206596 C42.739161,30.4206596 43.9859854,29.1728281 43.9859854,27.7167158 L43.9859854,25.949193 L1.70256098,25.949193 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M20.4032439,28.2369123 C20.4032439,27.8202442 20.8195944,27.4057544 21.2337683,27.4057544 L24.3498195,27.4057544 C24.8691595,27.4057544 25.1803439,27.7171593 25.1803439,28.2369123 C25.1803439,28.6535804 24.7639934,29.0680702 24.3498195,29.0680702 L21.2337683,29.0680702 C20.8174178,29.0680702 20.4032439,28.6514021 20.4032439,28.2369123 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M17.8064878,3.70189474 C18.5340171,3.70189474 19.3644854,3.70189474 19.9890195,4.11856281 C20.8195439,4.53523088 21.338839,5.15805754 21.5470171,5.88608561 C21.6500066,6.50890667 21.5470171,7.55053474 20.3001366,8.79617684 C19.6777902,9.41899789 19.6777902,10.3553628 20.3001366,10.9803733 C20.9224829,11.6031944 21.8581341,11.6031944 22.4826683,10.9803733 C24.351839,9.10977684 25.7039024,9.73254175 26.2232537,10.0439523 C27.3649512,10.8751102 27.3649512,12.3312225 27.3649512,13.3707172 C27.3649512,18.6733418 23.1050146,22.934226 17.8087317,22.934226 C12.5101488,22.934226 8.2525122,18.67104 8.2525122,13.3707172 C8.24812929,7.96282947 12.5080171,3.70166456 17.8064878,3.70166456 L17.8064878,3.70189474 Z M17.8064878,5.05274386 C13.2354341,5.05274386 9.59997561,8.6909193 9.59997561,13.2655158 C9.59997561,17.8400561 13.235378,21.4782877 17.8064878,21.4782877 C22.3775415,21.4782877 26.013,17.8401123 26.013,13.2655158 C26.013,12.3290947 26.013,11.497993 25.3906537,11.0813193 C24.7683073,10.6646512 23.9355951,11.3927242 23.4163,11.8094035 C22.2746024,12.9519719 20.4032439,12.9519719 19.2616024,11.8094035 C18.1199049,10.6668351 18.1199049,8.79404912 19.2616024,7.65153684 C19.8839488,7.02871579 20.1973098,6.40370526 20.0921268,5.98708772 C19.9891373,5.57041965 19.6757763,5.36426667 19.3645976,5.25900351 C19.05343,5.15593544 18.5318854,5.05286175 17.8066,5.05286175 L17.8064878,5.05274386 Z M15.6239,16.1779649 C16.3514293,15.4498807 17.7012488,15.4498807 18.428778,16.1779649 C19.1563073,16.9060491 19.1563073,18.2568982 18.428778,18.9849825 C17.7012488,19.7130667 16.3514293,19.7130667 15.6239,18.9849825 C15.2075495,18.5683144 15.0015537,18.1538246 15.0015537,17.528814 C15.1045432,17.0090779 15.3127212,16.4893193 15.6239,16.1779649 Z M17.4930707,17.1121965 C17.2848983,16.9038653 16.8707244,16.9038653 16.6625463,17.1121965 C16.5595568,17.2152646 16.4543739,17.4236014 16.4543739,17.5288646 C16.4543739,17.7371958 16.5573634,17.8402695 16.6625463,17.9455326 C16.8707188,18.1538639 17.2848927,18.1538639 17.4930707,17.9455326 C17.5960602,17.8424646 17.7012432,17.6341277 17.7012432,17.5288646 C17.7012432,17.4236014 17.5982537,17.2174596 17.4930707,17.1121965 Z M15.0015537,12.6429193 C15.7290829,13.3710035 15.7290829,14.7218526 15.0015537,15.4499368 C14.5852032,15.8666049 14.1710293,16.0727579 13.5464951,16.0727579 C13.0271551,16.0727579 12.5077927,15.8644267 12.0914366,15.4499368 C11.6750861,15.0332688 11.4690902,14.5135158 11.4690902,13.9937684 C11.4690902,13.4740211 11.6772627,12.9542737 12.0914366,12.5376 C12.921961,11.9147789 14.1687854,11.9147789 15.0014976,12.6428632 L15.0015537,12.6429193 Z M13.9628512,13.682414 C13.7546788,13.4740828 13.3405049,13.4740828 13.1323268,13.682414 C12.9241488,13.8907453 12.9241544,14.3052351 13.1323268,14.5135719 C13.2353163,14.61664 13.4434944,14.7219032 13.5486773,14.7219032 C13.7568498,14.7219032 13.8598449,14.6188351 13.9650278,14.5135719 C14.168819,14.202167 14.168819,13.8907509 13.9628366,13.682414 L13.9628512,13.682414 Z M20.5060707,17.5289263 C20.0897202,17.1122582 19.8837244,16.6977684 19.8837244,16.0727579 C19.8837244,15.5530218 20.0918968,15.0332632 20.5060707,14.6165895 C20.9224212,14.1999214 21.3365951,13.9937684 21.9611293,13.9937684 C22.4804693,13.9937684 22.9998317,14.2020996 23.4161878,14.6165895 C24.1437171,15.3446737 24.1437171,16.6955228 23.4161878,17.423607 C22.9998373,17.8402751 22.5856634,18.0464281 21.9611293,18.0464281 C21.3365951,18.1516912 20.9224268,17.9455495 20.5060707,17.5288814 L20.5060707,17.5289263 Z M21.8581341,16.6977684 C22.0663066,16.6977684 22.1693017,16.5947004 22.2744846,16.4894372 C22.3774741,16.3863691 22.4826571,16.1780323 22.4826571,16.0727691 C22.4826571,15.9697011 22.3796676,15.7613642 22.2744846,15.6561011 C22.1714951,15.553033 21.9633171,15.4477698 21.8581341,15.4477698 C21.6499617,15.4477698 21.5469666,15.5508379 21.4417837,15.6561011 C21.3387941,15.7591691 21.2336112,15.967506 21.2336112,16.0727691 C21.2336112,16.2811004 21.3366007,16.384174 21.4417837,16.4894372 C21.5447732,16.6977684 21.7529512,16.6977684 21.8581341,16.6977684 Z M16.5595512,7.96289123 C16.9759017,8.3795593 17.1818976,8.79404912 17.1818976,9.41905965 C17.1818976,9.93879579 16.9737251,10.4585544 16.5595512,10.8752281 C15.832022,11.6033123 14.4822024,11.6033123 13.7546732,10.8752281 C13.3383227,10.45856 13.1323268,10.0440702 13.1323268,9.41905965 C13.1323268,8.89932351 13.3404993,8.37956491 13.7546732,7.96289123 C14.4822024,7.23699649 15.726839,7.23699649 16.5595512,7.96289123 Z M15.1044927,8.7962386 C14.8963202,8.7962386 14.7933251,8.89930667 14.6881422,9.00456982 C14.5851527,9.10763789 14.4799698,9.31597474 14.4799698,9.42123789 C14.4799698,9.62956912 14.5829593,9.73264281 14.6881422,9.83790596 C14.8963146,10.0462372 15.3104885,10.0462372 15.5186666,9.83790596 C15.6216561,9.73483789 15.726839,9.52650105 15.726839,9.42123789 C15.726839,9.21290667 15.6238495,9.10983298 15.5186666,9.00456982 C15.4156771,8.7962386 15.312682,8.7962386 15.1045095,8.7962386 L15.1044927,8.7962386 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M34.9470976,3.70189474 C34.844108,3.39048982 34.5307471,3.28522667 34.2195683,3.28522667 C29.3373415,3.59663158 29.0261683,6.40365474 29.0261683,8.89926175 C29.0261683,10.0418302 29.8566927,10.9781951 30.895339,11.2896056 L30.895339,19.60736 C30.895339,20.0240281 31.2065066,20.3354442 31.6228683,20.3354442 C32.0392188,20.3354442 32.3503976,20.0240393 32.3503976,19.60736 L32.3503976,11.2896056 C33.3891,10.9782007 34.013578,10.041774 34.013578,8.89926175 C34.013578,8.58785684 33.9105885,8.2764407 33.9105885,7.9628407 C33.9105885,5.88390737 33.9105885,5.25889684 34.7411129,4.53300211 C35.0500871,4.32467088 35.0500871,3.91018105 34.9470976,3.70184421 L34.9470976,3.70189474 Z M32.5563878,7.96283509 L32.5563878,8.89925614 C32.5563878,9.52207719 32.0370478,10.0418246 31.4146902,10.0418246 C30.7923327,10.0418246 30.3759878,9.52208842 30.2729927,8.89925614 C30.2729927,7.23480702 30.3759822,5.57249123 32.7666976,4.94967018 C32.5563317,5.67556491 32.5563317,6.61192982 32.5563317,7.96283509 L32.5563878,7.96283509 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M29.9594634,19.8158596 C29.9594634,20.2325277 30.270631,20.5439439 30.6869927,20.5439439 L32.2449902,20.5439439 C32.6613407,20.5439439 32.9725195,20.2325389 32.9725195,19.8158596 C32.9725195,19.3991804 32.661352,19.0877754 32.2449902,19.0877754 L30.6869927,19.0877754 C30.2728356,19.0877754 29.9594634,19.3991804 29.9594634,19.8158596 Z',
  id: 'Shape'
}))));

var GraphicDesigner = function (_Icon33) {
  _inherits(GraphicDesigner, _Icon33);

  function GraphicDesigner() {
    _classCallCheck(this, GraphicDesigner);

    return _possibleConstructorReturn(this, (GraphicDesigner.__proto__ || Object.getPrototypeOf(GraphicDesigner)).apply(this, arguments));
  }

  _createClass(GraphicDesigner, [{
    key: 'render',
    value: function render() {
      var _props33 = this.props,
          color = _props33.color,
          style = _props33.style,
          otherProps = _objectWithoutProperties(_props33, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '5rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 46 32',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref54
      );
    }
  }]);

  return GraphicDesigner;
}(Icon);

var _ref55 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-248.000000, -11448.000000)',
  fill: '#000000',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'np_writer_67421_000000',
  transform: 'translate(248.000000, 11448.000000)'
}, void 0, _jsx('path', {
  d: 'M6.7,10.2837778 L29.7896341,10.2837778 C30.4994512,10.2837778 31.0710976,9.71086111 31.0710976,8.99708333 C31.0710976,8.28568889 30.4994512,7.71038889 29.7896341,7.71038889 L6.7,7.71277589 C5.99018293,7.71277589 5.41615854,8.288082 5.41615854,8.99947033 C5.41854085,9.71086478 5.99018902,10.2837814 6.7,10.2837814 L6.7,10.2837778 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M6.7,17.9990556 L29.7896341,17.9990556 C30.4994512,17.9990556 31.0710976,17.4237494 31.0710976,16.7123611 C31.0710976,16.0009667 30.4994512,15.4256667 29.7896341,15.4256667 L6.7,15.4280537 C5.99018293,15.4280537 5.41615854,16.0033598 5.41615854,16.7147481 C5.41854085,17.4237592 5.99018902,17.9990592 6.7,17.9990592 L6.7,17.9990556 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M31.0737805,24.4255 C31.0737805,23.7141056 30.5021341,23.1411889 29.7923171,23.1411889 L6.7002439,23.1411889 C5.99042683,23.1411889 5.41640244,23.7141056 5.41640244,24.4255 C5.41640244,25.1392778 5.99043293,25.7121944 6.7002439,25.7121944 L29.789878,25.7121944 C30.4996951,25.7121944 31.0737195,25.1392778 31.0737195,24.4255 L31.0737805,24.4255 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M36.2042683,30.8537778 L36.2042683,2.57094444 C36.2042683,1.1506 35.0562195,0 33.6390244,0 L2.85365854,0 C1.43646341,0 0.286036585,1.1506 0.286036585,2.57094444 L0.286036585,38.5690556 C0.286036585,39.9894 1.43646341,41.14 2.85365854,41.14 L25.9432927,41.14 L36.2042683,30.8537778 Z M25.9432927,37.5020556 L25.9432927,30.8537778 L32.5768293,30.8537778 L25.9432927,37.5020556 Z M23.3780488,30.8537778 L23.3780488,38.5690556 L2.85365854,38.5690556 L2.85365854,2.57094444 L33.6390244,2.57094444 L33.6390244,28.2828333 L25.9432927,28.2828333 C24.5237195,28.2828333 23.3780488,29.4358167 23.3780488,30.8537778 Z',
  id: 'Shape'
}))));

var CopyWriter = function (_Icon34) {
  _inherits(CopyWriter, _Icon34);

  function CopyWriter() {
    _classCallCheck(this, CopyWriter);

    return _possibleConstructorReturn(this, (CopyWriter.__proto__ || Object.getPrototypeOf(CopyWriter)).apply(this, arguments));
  }

  _createClass(CopyWriter, [{
    key: 'render',
    value: function render() {
      var _props34 = this.props,
          color = _props34.color,
          style = _props34.style,
          otherProps = _objectWithoutProperties(_props34, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '5rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 37 42',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref55
      );
    }
  }]);

  return CopyWriter;
}(Icon);

var _ref56 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-769.000000, -11223.000000)',
  fill: '#000000',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'noun_984148_cc',
  transform: 'translate(770.000000, 11223.000000)'
}, void 0, _jsx('path', {
  d: 'M46.4285714,0.546 L3.57142857,0.546 C1.84553873,0.546 0.446428571,1.95630304 0.446428571,3.696 L0.446428571,26.304 C0.446428571,28.043697 1.84553873,29.454 3.57142857,29.454 L46.4285714,29.454 C48.1544613,29.454 49.5535714,28.043697 49.5535714,26.304 L49.5535714,3.696 C49.5535714,1.95630304 48.1544613,0.546 46.4285714,0.546 Z M48.0892857,26.304 C48.0892857,27.2285247 47.3457586,27.978 46.4285714,27.978 L3.57142857,27.978 C2.6542414,27.978 1.91071429,27.2285247 1.91071429,26.304 L1.91071429,3.696 C1.91071429,2.77147533 2.6542414,2.022 3.57142857,2.022 L46.4285714,2.022 C47.3457586,2.022 48.0892857,2.77147533 48.0892857,3.696 L48.0892857,26.304 Z',
  id: 'Shape',
  stroke: '#000000'
}), _jsx('path', {
  d: 'M28.4274351,4.411328 L6.12613636,4.411328 C5.22804605,4.411328 4.5,5.14519842 4.5,6.05047345 L4.5,17.8148545 C4.5,18.7201296 5.22804605,19.454 6.12613636,19.454 L28.4274351,19.454 C29.3255254,19.454 30.0535714,18.7201296 30.0535714,17.8148545 L30.0535714,6.05047345 C30.0535714,5.14519842 29.3255254,4.411328 28.4274351,4.411328 Z M29.2916104,17.8148545 C29.2916104,18.2959436 28.9047059,18.6859433 28.4274351,18.6859433 L6.12613636,18.6859433 C5.64886551,18.6859433 5.26196104,18.2959436 5.26196104,17.8148545 L5.26196104,6.05047345 C5.26196104,5.56938443 5.64886551,5.17938473 6.12613636,5.17938473 L28.4274351,5.17938473 C28.9047059,5.17938473 29.2916104,5.56938443 29.2916104,6.05047345 L29.2916104,17.8148545 Z',
  id: 'Shape',
  stroke: '#000000'
}), _jsx('path', {
  d: 'M47.9928325,4.411328 L33.5529109,4.411328 C32.9714043,4.411328 32.5,5.14519842 32.5,6.05047345 L32.5,17.8148545 C32.5,18.7201296 32.9714043,19.454 33.5529109,19.454 L47.9928325,19.454 C48.5743391,19.454 49.0457434,18.7201296 49.0457434,17.8148545 L49.0457434,6.05047345 C49.0457434,5.14519842 48.5743391,4.411328 47.9928325,4.411328 Z M48.5523794,17.8148545 C48.5523794,18.2959436 48.3018617,18.6859433 47.9928325,18.6859433 L33.5529109,18.6859433 C33.2438817,18.6859433 32.993364,18.2959436 32.993364,17.8148545 L32.993364,6.05047345 C32.993364,5.56938443 33.2438817,5.17938473 33.5529109,5.17938473 L47.9928325,5.17938473 C48.3018617,5.17938473 48.5523794,5.56938443 48.5523794,6.05047345 L48.5523794,17.8148545 Z',
  id: 'Shape',
  stroke: '#000000'
}), _jsx('polygon', {
  id: 'Rectangle-path',
  points: '4.02048564 21.762 49.0457434 21.762 49.0457434 23.238 4.02048564 23.238'
}), _jsx('polygon', {
  id: 'Rectangle-path',
  points: '4.02048564 24.24 49.0457434 24.24 49.0457434 25.716 4.02048564 25.716'
}), _jsx('polygon', {
  id: 'Rectangle-path',
  transform: 'translate(4.738000, 23.512000) rotate(90.000000) translate(-4.738000, -23.512000) ',
  points: '3.238 22.762 6.238 22.762 6.238 24.262 3.238 24.262'
}), _jsx('polygon', {
  id: 'Rectangle-path',
  transform: 'translate(21.510243, 23.500000) rotate(90.000000) translate(-21.510243, -23.500000) ',
  points: '20.0102428 22.762 23.0102428 22.762 23.0102428 24.238 20.0102428 24.238'
}), _jsx('polygon', {
  id: 'Rectangle-path',
  transform: 'translate(31.510243, 23.500000) rotate(90.000000) translate(-31.510243, -23.500000) ',
  points: '30.0102428 22.762 33.0102428 22.762 33.0102428 24.238 30.0102428 24.238'
}))));

var VideoEditor = function (_Icon35) {
  _inherits(VideoEditor, _Icon35);

  function VideoEditor() {
    _classCallCheck(this, VideoEditor);

    return _possibleConstructorReturn(this, (VideoEditor.__proto__ || Object.getPrototypeOf(VideoEditor)).apply(this, arguments));
  }

  _createClass(VideoEditor, [{
    key: 'render',
    value: function render() {
      var _props35 = this.props,
          color = _props35.color,
          style = _props35.style,
          otherProps = _objectWithoutProperties(_props35, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '5rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 52 30',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref56
      );
    }
  }]);

  return VideoEditor;
}(Icon);

var _ref57 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-251.000000, -11020.000000)',
  fill: '#000000',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'np_video_1146306_000000',
  transform: 'translate(251.000000, 11020.000000)'
}, void 0, _jsx('path', {
  d: 'M45.4772316,26.6210897 L34.8452003,19.7618943 C34.1101923,19.1578174 33.9476783,19.061313 34.4643574,18.2624038 C34.9810365,17.4634946 36.0144195,17.1808957 36.8634419,17.6095955 L47.1899443,24.2399432 L47.1899443,3.75963282 L36.8634419,10.4461012 C36.0144195,10.8748009 34.9810861,10.592252 34.4643574,9.79329287 C33.9476286,8.99433379 34.1101985,8.89784805 34.8452003,8.29380236 L45.4772316,1.43460695 C46.5421114,0.718506954 47.9127063,0.647857241 49.0479447,1.24705161 C49.949387,1.91325364 49.949387,2.68535156 49.949387,3.46270448 C49.949387,10.387687 49.949387,17.4125423 49.949387,24.5372706 C49.949387,25.6567079 49.6489063,26.3952589 49.0479447,26.7529234 C48.5402508,27.0550794 47.9612059,27.1816232 47.3766026,27.1840613 C46.7022656,27.1837557 46.0424599,26.9888922 45.4772316,26.6210897 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M30.8886018,27.9563506 L6.15566907,27.9563506 C2.38362981,27.9563506 0.286278045,25.8503201 0.286278045,22.0626724 L0.286278045,5.93795115 C0.286278045,2.15030345 2.38362981,0.0442729885 6.15566907,0.0442729885 L30.8886018,0.0442729885 C34.660641,0.0442729885 36.7579928,2.15030345 36.7579928,5.93795115 L36.7579928,22.0626724 C36.7579928,25.8503201 34.660641,27.9563506 30.8886018,27.9563506 Z M6.15566907,2.82013506 C4.44067107,2.82013506 3.05070112,4.21585661 3.05070112,5.93795115 L3.05070112,22.0626724 C3.05070112,22.8908267 3.37817588,23.6825026 3.96033253,24.2670931 C4.54248918,24.8516836 5.33086538,25.1804885 6.15566907,25.1804885 L30.8886018,25.1804885 C31.7133433,25.1804885 32.5017568,24.8516587 33.0839383,24.2670931 C33.6661198,23.6825275 33.9935697,22.8908891 33.9935697,22.0626724 L33.9935697,5.93795115 C33.9935697,5.10979684 33.666095,4.31812098 33.0839383,3.73353046 C32.5017817,3.14893994 31.7134054,2.82013506 30.8886018,2.82013506 L6.15566907,2.82013506 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M22.2338141,10.8821839 L8.57195513,10.8821839 C7.54098157,10.8821839 6.70897436,10.0442397 6.70897436,9.01149425 C6.70897436,7.97874885 7.54098157,7.1408046 8.57195513,7.1408046 L22.2338141,7.1408046 C23.2623037,7.1408046 24.0967949,7.97874885 24.0967949,9.01149425 C24.0967949,10.0442397 23.2623037,10.8821839 22.2338141,10.8821839 Z',
  id: 'Shape'
}))));

var Videographer = function (_Icon36) {
  _inherits(Videographer, _Icon36);

  function Videographer() {
    _classCallCheck(this, Videographer);

    return _possibleConstructorReturn(this, (Videographer.__proto__ || Object.getPrototypeOf(Videographer)).apply(this, arguments));
  }

  _createClass(Videographer, [{
    key: 'render',
    value: function render() {
      var _props36 = this.props,
          color = _props36.color,
          style = _props36.style,
          otherProps = _objectWithoutProperties(_props36, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '5rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 50 28',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref57
      );
    }
  }]);

  return Videographer;
}(Icon);

var _ref58 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-766.000000, -11453.000000)',
  fill: '#000000',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'Group-7',
  transform: 'translate(766.000000, 11453.000000)'
}, void 0, _jsx('g', {
  id: 'np_take-action_638677_000000'
}, void 0, _jsx('path', {
  d: 'M0,24.7991854 C0,26.3457258 1.24348161,27.6033775 2.77259691,27.6033775 L27.2440817,27.6033775 L36.2303585,34.6128912 C36.5645633,34.8545985 36.9473106,35 37.376717,35 C37.7109218,35 37.9984578,34.9036941 38.2840915,34.7582926 C38.9058323,34.4202794 39.2400276,33.7914632 39.1448163,33.0663411 L38.6668483,27.55638 L39.9103299,27.55638 C41.4394452,27.55638 42.6829268,26.2987282 42.6829268,24.7521878 L42.6829268,2.80419217 C42.6829268,1.25765176 41.4394452,0 39.9103299,0 L2.7726925,0 C1.2435772,0 9.55936048e-05,1.25765176 9.55936048e-05,2.80419217 L0,24.7991854 Z M2.1508561,2.80381511 C2.1508561,2.46580186 2.43838255,2.12780795 2.81924659,2.12780795 L39.956884,2.12780795 C40.2910888,2.12780795 40.6252745,2.41861091 40.6252745,2.80381511 L40.6252745,24.7991854 C40.6252745,25.1371986 40.337748,25.4751925 39.956884,25.4751925 L36.3739879,25.4751925 L36.9471672,32.4847061 L27.9608904,25.4751925 L2.77245352,25.4751925 C2.43824872,25.4751925 2.10406303,25.1843896 2.10406303,24.7991854 L2.10406303,2.80381511 L2.1508561,2.80381511 Z',
  id: 'Shape'
}), _jsx('path', {
  d: 'M18.2132665,19.5433177 L14.0854552,15.3113583 C13.3731824,14.5811142 13.3733927,13.4160331 14.085929,12.6860462 L14.085929,12.6860462 C14.7762716,11.9787967 15.9092438,11.9650909 16.6164933,12.6554335 C16.6269747,12.6656643 16.6373301,12.6760235 16.6475572,12.6865086 L19.4926742,15.6034103 L25.9176157,7.27451086 C26.5212124,6.49204518 27.644838,6.34704322 28.4273037,6.95063993 C28.4366968,6.95788581 28.4460176,6.96522493 28.4552648,6.9726562 L28.4552648,6.9726562 C29.2459689,7.6080875 29.3838619,8.7589471 28.765656,9.56319041 L21.2306573,19.3657041 C20.5574923,20.2414454 19.3018558,20.4056659 18.4261145,19.7325009 C18.3507601,19.6745774 18.2796305,19.6113561 18.2132665,19.5433177 Z',
  id: 'Shape'
})))));

var ContentStrategist = function (_Icon37) {
  _inherits(ContentStrategist, _Icon37);

  function ContentStrategist() {
    _classCallCheck(this, ContentStrategist);

    return _possibleConstructorReturn(this, (ContentStrategist.__proto__ || Object.getPrototypeOf(ContentStrategist)).apply(this, arguments));
  }

  _createClass(ContentStrategist, [{
    key: 'render',
    value: function render() {
      var _props37 = this.props,
          color = _props37.color,
          style = _props37.style,
          otherProps = _objectWithoutProperties(_props37, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '5rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 43 35',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref58
      );
    }
  }]);

  return ContentStrategist;
}(Icon);

var _ref59 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-253.000000, -10681.000000)',
  fillRule: 'nonzero',
  stroke: '#6191A4',
  strokeWidth: '8'
}, void 0, _jsx('g', {
  id: 'Arrow',
  transform: 'translate(323.500000, 10784.000000) scale(-1, 1) translate(-323.500000, -10784.000000) translate(257.000000, 10682.000000)'
}, void 0, _jsx('path', {
  d: 'M6.00190449,8.52651283e-14 C5.81991596,48.803849 18.6807344,92.6381167 44.5843598,131.502803 C61.0134329,156.152278 90.485313,175.832172 133,190.542485',
  id: 'Path-3',
  transform: 'translate(69.500000, 95.271242) scale(-1, 1) translate(-69.500000, -95.271242) '
}), _jsx('polyline', {
  id: 'Path-4',
  points: '22.6788079 167.07836 0 191 36.4437576 203.660198'
}))));

var LongLineArrow = function (_Icon38) {
  _inherits(LongLineArrow, _Icon38);

  function LongLineArrow() {
    _classCallCheck(this, LongLineArrow);

    return _possibleConstructorReturn(this, (LongLineArrow.__proto__ || Object.getPrototypeOf(LongLineArrow)).apply(this, arguments));
  }

  _createClass(LongLineArrow, [{
    key: 'render',
    value: function render() {
      var _props38 = this.props,
          color = _props38.color,
          style = _props38.style,
          otherProps = _objectWithoutProperties(_props38, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '13.3rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 145 209',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref59
      );
    }
  }]);

  return LongLineArrow;
}(Icon);

var _ref60 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-597.000000, -13067.000000)',
  fill: '#454E57',
  fillRule: 'nonzero'
}, void 0, _jsx('g', {
  id: 'np_debt_89577_000000',
  transform: 'translate(597.000000, 13067.000000)'
}, void 0, _jsx('path', {
  d: 'M202.164759,32.0415812 L174.251995,22.9529312 C171.27561,22.0476108 168.299225,23.6363522 167.155165,26.361175 C166.243487,29.0859522 167.843386,32.2724329 170.587344,33.1776625 L186.148384,38.1746023 L135.809765,63.6205502 C143.818182,51.8071229 145.418035,36.3546001 138.553678,22.7216251 C131.456848,8.40518354 117.04902,0 101.943773,0 C95.7676823,0 89.5915914,1.36684208 83.8712939,4.3134733 C63.734016,14.3073529 55.5031942,38.6276715 65.5663417,58.8453735 C72.4306988,72.4783485 86.1594129,80.661769 100.576851,81.1143837 L79.072193,92.0225815 L39.4762933,72.4872099 C37.1881743,71.5818895 35.5883215,71.8037889 34.444262,72.4872099 L29.4122306,74.9902241 C29.4122306,74.9902241 3.55419754,87.9397327 3.09886186,88.1705844 C0.354949525,89.5374265 -0.789109986,92.7149094 0.578269942,95.4396867 C1.95471082,98.164464 5.15450799,99.3005452 7.89842032,97.9427009 C8.13080169,97.7119401 36.7332963,83.4044963 36.7332963,83.4044963 L76.3200435,103.401344 C77.9199421,104.084765 79.2964287,104.306665 81.1287544,103.401344 L190.958468,48.1855231 C190.958468,48.1855231 185.926436,63.1854311 185.926436,63.6380458 C185.014758,66.5936748 186.614657,69.7710669 189.358615,70.4545333 C192.102527,71.3598538 195.534706,69.7711123 196.222972,67.0462896 C196.455353,66.3628686 205.375448,38.8760188 205.375448,38.8760188 C206.287126,37.722192 206.054745,36.1335187 205.598896,34.7665857 C204.908717,33.3995164 203.764658,32.494196 202.164759,32.0415812 Z M117.04902,61.8096367 C117.960698,63.8510383 117.281401,66.3539617 114.993282,67.4900429 C112.705163,68.3953634 110.417044,67.7208038 109.505457,65.4486412 L107.43185,61.1263065 C101.479079,62.4931486 94.8471949,60.6736463 92.1032826,55.2150485 C91.1916044,53.1736468 91.8709012,50.6707235 94.1590202,49.5346423 C96.2147579,48.6293218 98.7352583,49.3038814 99.6468449,51.3541446 C101.023286,54.3097735 105.599615,53.1736468 107.655261,52.259465 C109.710999,51.1233837 113.375559,48.1677547 111.999027,45.4429775 C110.622586,42.7182002 106.046256,43.854236 103.99061,44.7595564 C99.6468449,46.8009581 95.2939273,47.2625706 91.4059554,45.8956377 C88.2062498,44.9903173 85.9181307,42.9400087 84.7740712,40.2152314 C82.2534793,34.9874399 84.3182322,28.6235672 89.5827822,24.5409456 L87.5270445,20.4492353 C86.6153664,18.4078337 87.2946632,15.9049103 89.3593245,14.7688291 C91.8799164,13.8635086 93.9355625,14.7688291 95.079622,16.8102308 L97.1353597,20.901941 C99.4234787,20.4492808 101.711598,20.21852 103.999717,20.6711802 C107.887689,21.5765006 110.864074,23.6268092 112.463927,26.8042012 C113.375605,28.8456029 112.696308,31.3485262 110.408189,32.4846075 C108.352451,33.3899279 105.831951,32.7153683 104.920364,30.4432058 C103.543923,27.7184285 98.7442735,28.8544643 96.9119477,29.7597848 C93.2472963,31.3485262 91.6474435,34.7567245 92.5681826,36.3454206 C93.9446235,39.0701978 98.7442735,37.934162 100.576599,37.0288416 C107.208483,33.6205978 116.593432,34.7566791 120.025611,41.5731666 C122.546203,46.8009581 120.48145,53.1648309 115.2169,57.2474525 L117.04902,61.8096367 Z',
  id: 'Shape'
}))));

var CostArrow = function (_Icon39) {
  _inherits(CostArrow, _Icon39);

  function CostArrow() {
    _classCallCheck(this, CostArrow);

    return _possibleConstructorReturn(this, (CostArrow.__proto__ || Object.getPrototypeOf(CostArrow)).apply(this, arguments));
  }

  _createClass(CostArrow, [{
    key: 'render',
    value: function render() {
      var _props39 = this.props,
          color = _props39.color,
          style = _props39.style,
          otherProps = _objectWithoutProperties(_props39, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '20.6rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 206 104',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref60
      );
    }
  }]);

  return CostArrow;
}(Icon);

var _ref61 = _jsx('defs', {}, void 0, _jsx('circle', {
  id: 'path-12',
  cx: '59.5',
  cy: '59.5',
  r: '59.5'
}), _jsx('filter', {
  x: '-7.1%',
  y: '-5.5%',
  width: '114.3%',
  height: '114.3%',
  filterUnits: 'objectBoundingBox',
  id: 'filter-2'
}, void 0, _jsx('feOffset', {
  dx: '0',
  dy: '2',
  'in': 'SourceAlpha',
  result: 'shadowOffsetOuter1'
}), _jsx('feGaussianBlur', {
  stdDeviation: '2.5',
  'in': 'shadowOffsetOuter1',
  result: 'shadowBlurOuter1'
}), _jsx('feColorMatrix', {
  values: '0 0 0 0 0.751233939   0 0 0 0 0.768341247   0 0 0 0 0.785448554  0 0 0 1 0',
  type: 'matrix',
  'in': 'shadowBlurOuter1'
})));

var _ref62 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-525.000000, -6771.000000)'
}, void 0, _jsx('g', {
  id: 'Group-24',
  transform: 'translate(97.000000, 6517.000000)'
}, void 0, _jsx('g', {
  id: 'Group-11',
  transform: 'translate(433.000000, 257.000000)'
}, void 0, _jsx('g', {
  id: 'Oval',
  fillRule: 'nonzero'
}, void 0, _jsx('use', {
  fill: 'black',
  fillOpacity: '1',
  filter: 'url(#filter-2)',
  xlinkHref: '#path-12'
}), _jsx('use', {
  fill: '#FFFFFF',
  xlinkHref: '#path-12'
})), _jsx('polygon', {
  id: '+',
  fill: '#AB5C47',
  points: '53.0464892 33.9086022 66.1825538 33.9086022 66.1825538 53.0464892 85.3204409 53.0464892 85.3204409 66.1825538 66.1825538 66.1825538 66.1825538 85.2071989 53.0464892 85.2071989 53.0464892 66.1825538 33.9086022 66.1825538 33.9086022 53.0464892 53.0464892 53.0464892'
})))));

var CirclePlus = function (_Icon40) {
  _inherits(CirclePlus, _Icon40);

  function CirclePlus() {
    _classCallCheck(this, CirclePlus);

    return _possibleConstructorReturn(this, (CirclePlus.__proto__ || Object.getPrototypeOf(CirclePlus)).apply(this, arguments));
  }

  _createClass(CirclePlus, [{
    key: 'render',
    value: function render() {
      var _props40 = this.props,
          color = _props40.color,
          style = _props40.style,
          otherProps = _objectWithoutProperties(_props40, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '11.9rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 129 129',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref61,
        _ref62
      );
    }
  }]);

  return CirclePlus;
}(Icon);

var _ref63 = _jsx('g', {
  id: 'Storytape-Social',
  stroke: 'none',
  strokeWidth: '1',
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('g', {
  id: 'Social-Landing-+-Purchase-Page',
  transform: 'translate(-929.000000, -6572.000000)',
  fill: '#AB5C47',
  fillRule: 'nonzero',
  stroke: '#AB5C47',
  strokeWidth: '1.04545455'
}, void 0, _jsx('g', {
  id: 'Group-24',
  transform: 'translate(97.000000, 6517.000000)'
}, void 0, _jsx('g', {
  id: 'Group-22',
  transform: 'translate(690.000000, 56.000000)'
}, void 0, _jsx('g', {
  id: 'np_like_947382_000000',
  transform: 'translate(143.000000, 0.000000)'
}, void 0, _jsx('path', {
  d: 'M22.8693182,0.507466667 C23.0980114,0.51565119 23.3328309,0.540204762 23.5553977,0.589311905 C25.3400409,0.980120952 26.7223932,2.60273095 26.8224432,4.63249286 C27.0490925,10.637969 27.8250341,14.1983024 31.5432977,19.5610643 C32.0088491,18.8203452 32.8215227,18.3170167 33.7485795,18.3170167 L43.1576705,18.3170167 C44.5870159,18.3170167 45.7713068,19.5037595 45.7713068,20.9360643 L45.7713068,39.7932071 C45.7713068,41.2255119 44.5870159,42.4122548 43.1576705,42.4122548 L33.7485795,42.4122548 C32.8460386,42.4122548 32.0476773,41.9416433 31.5760205,41.2336833 C31.0328545,41.6735995 30.5285273,42.0664357 30.0078386,42.3795167 C29.146175,42.8971871 28.1721773,43.2061405 26.8388045,43.3453167 C24.1740977,43.6215424 19.7981909,43.4169319 9.70328182,43.4599 C9.46642364,43.4537615 9.23160409,43.3678248 9.04987273,43.2143643 C7.01818864,41.5528929 6.13608636,39.9630786 5.73379545,38.1726976 C5.53572886,38.1113124 5.35808523,37.99059 5.22740341,37.8289476 C3.70825341,35.9260524 3.15897159,33.7305571 3.51223068,31.8376143 C3.3672575,31.77009 3.23657568,31.6677848 3.13652045,31.5429714 C1.36212273,29.4559048 1.00274773,26.7857333 1.63367955,24.7659238 C0.549438636,23.4809667 0.102245455,21.9729714 0.261520455,20.5754476 C0.516757727,18.8055476 1.79907045,17.0274762 3.43055455,16.7450905 L16.8907818,16.7450905 C16.0862523,11.4394238 16.6192093,6.56328095 18.4099318,3.40418571 C19.375775,1.69771905 20.7867205,0.744228571 22.1833955,0.53957619 C22.4161711,0.504792095 22.6407818,0.498653571 22.869475,0.506838095 L22.8693182,0.507466667 Z M20.2230114,4.4360381 C18.6936159,7.1348619 18.0586068,12.1805619 19.0959068,17.5967524 C19.2102534,18.2003381 18.6813998,18.8428429 18.0667614,18.8408 L3.72417045,18.8408 C2.94007955,19.2438871 2.43575227,19.9395952 2.33570227,20.8050857 C2.23973477,21.644019 2.58073068,22.6302476 3.43018864,23.5550857 L9.18018864,23.5550857 C9.73354773,23.5550857 10.2399136,24.0482052 10.2399136,24.6027048 C10.2399136,25.1572043 9.73147773,25.6584952 9.18018864,25.6503238 L3.56087045,25.6503238 C3.24641864,26.8084143 3.48736455,28.3471048 4.524675,29.8408 L9.18018864,29.8408 C9.73354773,29.8408 10.2399136,30.3339195 10.2399136,30.888419 C10.2399136,31.4429186 9.73147773,31.9442095 9.18018864,31.9360381 L5.65177955,31.9360381 C5.33732773,33.0941286 5.57827364,34.632819 6.61558409,36.1265143 L9.18018864,36.1265143 C9.73354773,36.1265143 10.2399136,36.6196338 10.2399136,37.1741333 C10.2399136,37.7286329 9.73147773,38.2299238 9.18018864,38.2217524 L7.87337045,38.2217524 C8.1959925,39.343019 8.78610455,40.202381 10.1439932,41.3646095 C19.8594023,41.3318714 24.3658341,41.4853319 26.6261068,41.2500262 C27.7777273,41.1313519 28.3208932,40.9615224 28.9293477,40.5952643 C29.4786295,40.2658352 30.1503864,39.6847262 31.1346295,38.8928833 L31.1346295,22.5563119 C26.276925,16.3648833 24.9721977,11.1592643 24.7312205,4.7143119 C24.0308705,1.50393571 21.2089273,2.38990714 20.2226977,4.4360381 L20.2230114,4.4360381 Z M43.1576705,20.4122286 L33.7485795,20.4122286 C33.4402541,20.4122286 33.2258523,20.6270743 33.2258523,20.9360381 L33.2258523,39.793181 C33.2258523,40.1021448 33.4402541,40.3169905 33.7485795,40.3169905 L43.1576705,40.3169905 C43.4659959,40.3169905 43.6803977,40.1021448 43.6803977,39.793181 L43.6803977,20.9360381 C43.6803977,20.6270743 43.4659959,20.4122286 43.1576705,20.4122286 Z',
  id: 'Shape'
}))))));

var ThumbsUp = function (_Icon41) {
  _inherits(ThumbsUp, _Icon41);

  function ThumbsUp() {
    _classCallCheck(this, ThumbsUp);

    return _possibleConstructorReturn(this, (ThumbsUp.__proto__ || Object.getPrototypeOf(ThumbsUp)).apply(this, arguments));
  }

  _createClass(ThumbsUp, [{
    key: 'render',
    value: function render() {
      var _props41 = this.props,
          color = _props41.color,
          style = _props41.style,
          otherProps = _objectWithoutProperties(_props41, ['color', 'style']);

      var mergedStyle = _extends({
        fill: color,
        stroke: 'none',
        maxWidth: '4.1rem',
        width: '100%'
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, function (v) {
        return v !== undefined;
      }));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        _extends({
          viewBox: '0 0 48 46',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          style: mergedStyle
        }, otherProps),
        _ref63
      );
    }
  }]);

  return ThumbsUp;
}(Icon);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_pickBy__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_motion__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_Motion__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_Color__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Hoverable__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icons__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WorkingSpinner__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Typography__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Style__ = __webpack_require__(350);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var SIZES = {
  small: {
    height: 3,
    borderWidth: 0.2,
    fontSize: '1.8rem',
    letterSpacing: 0,
    labelTop: 0
  },
  large: {
    height: 5,
    borderWidth: 0.4,
    fontSize: '2.2rem',
    letterSpacing: '-0.15px',
    labelTop: '-0.1rem'
  }
};

var Button = function (_React$PureComponent) {
  _inherits(Button, _React$PureComponent);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.aniamtionResting = function () {
      if (!_this.props.checked && _this.state.checked) {
        _this.setState({ checked: false });
      }
    };

    _this.getMaxWidth = function () {
      var width = 0;
      if (_this.labelEl) {
        width = _this.labelEl.getBoundingClientRect().width;
      }
      _this.setState({ labelMaxWidth: width });
    };

    _this.state = {
      checked: props.checked,
      labelMaxWidth: 0
    };

    _this.animatedDefault = {
      border: props.border ? 1 : 0,
      hover: props.hover && props.enabled ? 1 : 0,
      working: props.working ? 1 : 0,
      arrow: props.arrow ? 1 : 0,
      checked: props.checked ? 1 : 0
    };
    return _this;
  }

  _createClass(Button, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getMaxWidth();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.checked && nextProps.checked) {
        this.getMaxWidth();
        this.setState({ checked: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          lightColor = _props.lightColor,
          darkColor = _props.darkColor,
          baseColor = _props.baseColor,
          hover = _props.hover,
          checked = _props.checked,
          enabled = _props.enabled,
          onClick = _props.onClick,
          border = _props.border,
          size = _props.size,
          style = _props.style,
          arrow = _props.arrow,
          type = _props.type,
          working = _props.working,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['lightColor', 'darkColor', 'baseColor', 'hover', 'checked', 'enabled', 'onClick', 'border', 'size', 'style', 'arrow', 'type', 'working', 'children']);

      var sizeParams = SIZES[size];
      if (arrow) {
        sizeParams = SIZES['large'];
      }

      var _sortByContrast = Object(__WEBPACK_IMPORTED_MODULE_6__lib_Color__["b" /* sortByContrast */])([lightColor, darkColor], baseColor),
          _sortByContrast2 = _slicedToArray(_sortByContrast, 2),
          colorB = _sortByContrast2[0],
          colorA = _sortByContrast2[1];

      var fontWeight = style.fontWeight,
          fontStyle = style.fontStyle,
          letterSpacing = style.letterSpacing,
          lineHeight = style.lineHeight,
          fontSize = style.fontSize,
          otherStyles = _objectWithoutProperties(style, ['fontWeight', 'fontStyle', 'letterSpacing', 'lineHeight', 'fontSize']);

      var hoverFillColor = colorA;
      var workingFillColor = colorA;

      var hoverColor = colorB;
      var workingColor = colorB;
      var forgroundFillMulitplier = 1;

      var arrowPadding = 0;
      var arrowMultiplier = 0;
      if (arrow) {
        arrowPadding = 1;
        arrowMultiplier = 1;
        hoverFillColor = __WEBPACK_IMPORTED_MODULE_2_color___default()(colorB).alpha(0.1);
        forgroundFillMulitplier = 0;
      }

      if (!border) {
        hoverFillColor = 'transparent';
      }

      var buttonStyle = _extends(_defineProperty({
        overflow: 'hidden',
        position: 'relative',
        height: sizeParams.height + 'rem',
        minWidth: sizeParams.height + 'rem',
        borderRadius: '99999rem',
        borderStyle: 'solid',
        cursor: enabled ? 'pointer' : 'not-allowed'
      }, 'overflow', checked ? 'visible' : 'hidden'), otherStyles, {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      });

      var labelStyle = __WEBPACK_IMPORTED_MODULE_3_lodash_pickBy___default()({
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        letterSpacing: letterSpacing,
        lineHeight: lineHeight,
        fontSize: fontSize,
        margin: 0,
        position: 'relative',
        top: sizeParams.labelTop
      }, function (value) {
        return value !== undefined;
      });

      var workingStyle = {
        maxWidth: sizeParams.height * 0.6 + 'rem'
      };

      var arrowStyle = {
        display: arrow ? 'block' : 'none',
        position: 'relative',
        top: '0.2rem'
      };

      var hovering = hover && enabled;
      var animatedCurrent = {
        border: border ? 1 : 0,
        hover: hovering ? 1 : 0,
        working: working ? 1 : 0
      };
      var animatedCurrentChecked = {
        checked: this.props.checked ? 1 : 0
      };
      var arrowOn = arrow && hovering && !this.state.checked && !working;
      var animatedCurrentArrow = {
        arrow: arrowOn ? 0.3 : 0
      };

      return _jsx(__WEBPACK_IMPORTED_MODULE_4_react_motion__["Motion"], {
        defaultStyle: this.animatedDefault,
        style: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5__lib_Motion__["d" /* springify */])(animatedCurrent, {
          stiffness: hovering || working ? 180 : 100,
          damping: hovering || working ? 25 : 35
        }), Object(__WEBPACK_IMPORTED_MODULE_5__lib_Motion__["d" /* springify */])(animatedCurrentArrow, {
          stiffness: arrowOn ? 80 : 75,
          damping: arrowOn ? 0 : 20
        }), Object(__WEBPACK_IMPORTED_MODULE_5__lib_Motion__["d" /* springify */])(animatedCurrentChecked, {
          stiffness: this.props.checked ? 180 : 180,
          damping: this.props.checked ? 15 : 15
        })),
        onRest: this.aniamtionResting
      }, void 0, function (tween) {
        var tweenCheckedInverse = Object(__WEBPACK_IMPORTED_MODULE_5__lib_Motion__["a" /* invertRange */])(tween.checked);
        var tweenWorkingInverse = Object(__WEBPACK_IMPORTED_MODULE_5__lib_Motion__["a" /* invertRange */])(tween.working);
        var borderWidth = sizeParams.borderWidth * tween.border;

        // Animated properties.
        var buttonStyleMerged = _extends({}, buttonStyle, {
          borderWidth: borderWidth * tweenCheckedInverse + 'rem',
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: (sizeParams.height - borderWidth - arrowPadding) * tweenCheckedInverse * tween.border + 'rem',
          paddingRight: (sizeParams.height - borderWidth) * tweenCheckedInverse + 'rem',
          borderColor: __WEBPACK_IMPORTED_MODULE_2_color___default()(colorA).alpha(tweenCheckedInverse).string(),
          color: __WEBPACK_IMPORTED_MODULE_2_color___default()(colorA).mix(__WEBPACK_IMPORTED_MODULE_2_color___default()(hoverColor), tween.hover * forgroundFillMulitplier).mix(__WEBPACK_IMPORTED_MODULE_2_color___default()(workingColor), tween.working).string(),
          backgroundColor: __WEBPACK_IMPORTED_MODULE_2_color___default()('transparent').mix(__WEBPACK_IMPORTED_MODULE_2_color___default()(hoverFillColor), tween.hover).mix(__WEBPACK_IMPORTED_MODULE_2_color___default()(workingFillColor), tween.working).mix(__WEBPACK_IMPORTED_MODULE_2_color___default()('transparent'), tween.checked).string(),
          maxWidth: undefined
        });
        if (_this2.state.checked) {
          buttonStyleMerged.maxWidth = 'calc((' + _this2.state.labelMaxWidth + 'px + ' + buttonStyleMerged.paddingLeft + ' + ' + buttonStyleMerged.paddingRight + ') * ' + tweenCheckedInverse + ')';
        }
        var labelStyleMerged = _extends({
          fontFamily: 'Calibre',
          fontSize: sizeParams.fontSize,
          letterSpacing: sizeParams.letterSpacing,
          fontWeight: 600
        }, labelStyle, {
          opacity: tweenWorkingInverse * tweenCheckedInverse,
          whiteSpace: 'nowrap',
          display: 'flex',
          alignItems: 'center'
        });
        var workingContainerStyle = _extends({}, __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* FULL_STYLE */], {
          pointerEvents: 'none',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transformOrigin: '50% 50%',
          transform: 'scale(' + (0.8 + tweenWorkingInverse * 1) + ')'
        });
        var workingStyleMerged = _extends({}, workingStyle, {
          opacity: tween.working > 0.5 ? tween.working : 0
        });
        var checkContainerStyle = _extends({}, __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* FULL_STYLE */], {
          pointerEvents: 'none',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        });
        var arrowStyleMerged = _extends({}, arrowStyle, {
          opacity: labelStyleMerged.opacity,
          left: arrowPadding + tween.arrow + 'rem'
        });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            disabled: !enabled,
            style: buttonStyleMerged,
            onClick: onClick,
            type: type,
            ref: function ref(el) {
              return _this2.buttonEl = el;
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { ref: function ref(el) {
                return _this2.labelEl = el;
              }, style: labelStyleMerged },
            children
          ),
          _jsx(__WEBPACK_IMPORTED_MODULE_9__Icons__["a" /* Arrow */], {
            style: arrowStyleMerged,
            color: buttonStyleMerged.color
          }),
          _jsx('div', {
            style: workingContainerStyle
          }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__WorkingSpinner__["a" /* default */], {
            color: buttonStyleMerged.color,
            style: workingStyleMerged,
            active: working
          })),
          _jsx('div', {
            style: checkContainerStyle
          }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icons__["f" /* Check */], {
            color: __WEBPACK_IMPORTED_MODULE_2_color___default()(colorA).alpha(tween.checked).string(),
            style: {
              maxWidth: buttonStyleMerged.maxWidth,
              minWidth: buttonStyleMerged.minWidth
            }
          }))
        );
      });
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Button.defaultProps = {
  baseColor: __WEBPACK_IMPORTED_MODULE_12__Style__["a" /* default */].Colors.white,
  lightColor: __WEBPACK_IMPORTED_MODULE_12__Style__["a" /* default */].Colors.white,
  darkColor: __WEBPACK_IMPORTED_MODULE_12__Style__["a" /* default */].Colors.black,
  hover: false,
  checked: false,
  enabled: true,
  onClick: function onClick() {},
  border: true,
  size: 'small',
  style: __WEBPACK_IMPORTED_MODULE_7__constants__["l" /* EMPTY_OBJECT */],
  arrow: false,
  type: undefined,
  working: false,
  children: ' '
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__Hoverable__["c" /* withHover */])({ wrapper: 'span' })(Button));

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__history__ = __webpack_require__(357);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Link = function (_React$PureComponent) {
  _inherits(Link, _React$PureComponent);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      _this.props.onClick(event);

      if (_this.props.to === undefined) {
        event.preventDefault();
        return;
      }

      if (event.defaultPrevented === true) {
        return;
      }

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      if (isAbsoluteURL(_this.props.to)) {
        return;
      }

      if (_this.props.target === '_blank') {
        return;
      }

      event.preventDefault();
      __WEBPACK_IMPORTED_MODULE_3__history__["a" /* default */].push(_this.props.to);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      // NOTE: target omitted on purpose.
      var _props = this.props,
          to = _props.to,
          onClick = _props.onClick,
          children = _props.children,
          style = _props.style,
          underline = _props.underline,
          otherProps = _objectWithoutProperties(_props, ['to', 'onClick', 'children', 'style', 'underline']);

      var composedStyle = _extends({
        cursor: 'pointer',
        textDecoration: 'none',
        color: 'inherit'
      }, style);
      if (underline) {
        composedStyle['textDecoration'] = 'underline';
      }
      if (onClick && composedStyle.cursor === undefined) {
        composedStyle.cursor = 'pointer';
      }

      if (otherProps.target === undefined && isAbsoluteURL(to)) {
        otherProps.target = '_blank';
        otherProps.rel = 'noopener';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({}, otherProps, {
          style: composedStyle,
          href: to,
          onClick: this.handleClick
        }),
        children
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Link.defaultProps = {
  onClick: function onClick() {},
  style: __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* EMPTY_OBJECT */],
  underline: false
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function isAbsoluteURL(url) {
  if (url === undefined) {
    return false;
  }

  if (url.indexOf('://') > -1) {
    return true;
  }

  return false;
}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(919)('wks');
var uid = __webpack_require__(912);
var Symbol = __webpack_require__(893).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 893 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return withHover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_react__ = __webpack_require__(221);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Hoverable = function (_MyPureComponent) {
  _inherits(Hoverable, _MyPureComponent);

  function Hoverable(props) {
    _classCallCheck(this, Hoverable);

    var _this = _possibleConstructorReturn(this, (Hoverable.__proto__ || Object.getPrototypeOf(Hoverable)).call(this, props));

    _this.onMouseEnter = function (e) {
      if (_this.state.hover === undefined) {
        _this.setState({ hover: true });
        _this.props.onHover(e);
        _this.props.onChange(true, e);
      }
    };

    _this.onMouseOver = function (e) {
      if (_this.state.hover === undefined) {
        _this.setState({ hover: true });
        _this.props.onHover(e);
        _this.props.onChange(true, e);
      }
    };

    _this.onMouseLeave = function (e) {
      if (_this.state.hover === true) {
        _this.setState({ hover: undefined });
        _this.props.onLeave(e);
        _this.props.onChange(false, e);
      }
    };

    _this.state = { hover: undefined };
    return _this;
  }

  _createClass(Hoverable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          hover = _props.hover,
          wrapWith = _props.wrapWith,
          onHover = _props.onHover,
          onLeave = _props.onLeave,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['hover', 'wrapWith', 'onHover', 'onLeave', 'children']);

      var Wrap = wrapWith;

      var childrenWithProps = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          hover: hover || _this2.state.hover
        });
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Wrap,
        _extends({
          onMouseEnter: this.onMouseEnter,
          onMouseOver: this.onMouseOver,
          onMouseLeave: this.onMouseLeave
        }, otherProps),
        childrenWithProps
      );
    }
  }]);

  return Hoverable;
}(__WEBPACK_IMPORTED_MODULE_3__lib_react__["a" /* MyPureComponent */]);

Hoverable.propTypes = {
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  wrapWith: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  onHover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Hoverable.defaultProps = {
  hover: undefined,
  wrapWith: 'div',
  onHover: function onHover() {},
  onLeave: function onLeave() {},
  onChange: function onChange(hovering, event) {}
};

var Hover = function (_MyPureComponent2) {
  _inherits(Hover, _MyPureComponent2);

  function Hover(props) {
    _classCallCheck(this, Hover);

    var _this3 = _possibleConstructorReturn(this, (Hover.__proto__ || Object.getPrototypeOf(Hover)).call(this, props));

    _this3.callChildProp = function (e, propName) {
      var func = _this3.childProps[propName];
      if (typeof func === 'function') {
        func(e);
      }
    };

    _this3.onMouseEnter = function (e) {
      if (_this3.state.hover === undefined) {
        _this3.setState({ hover: true });
        _this3.props.onHover(e);
        _this3.props.onChange(true, e);
      }
      _this3.callChildProp(e, 'onMouseEnter');
    };

    _this3.onMouseOver = function (e) {
      if (_this3.state.hover === undefined) {
        _this3.setState({ hover: true });
        _this3.props.onHover(e);
        _this3.props.onChange(true, e);
      }
      _this3.callChildProp(e, 'onMouseOver');
    };

    _this3.onMouseLeave = function (e) {
      if (_this3.state.hover === true) {
        _this3.setState({ hover: undefined });
        _this3.props.onLeave(e);
        _this3.props.onChange(false, e);
      }
      _this3.callChildProp(e, 'onMouseLeave');
    };

    _this3.state = { hover: undefined };
    return _this3;
  }

  _createClass(Hover, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          hover = _props2.hover,
          onHover = _props2.onHover,
          onLeave = _props2.onLeave,
          children = _props2.children,
          otherProps = _objectWithoutProperties(_props2, ['hover', 'onHover', 'onLeave', 'children']);

      var additionalProps = _extends({
        onMouseEnter: this.onMouseEnter,
        onMouseOver: this.onMouseOver,
        onMouseLeave: this.onMouseLeave,
        hover: hover || this.state.hover
      }, otherProps);

      var child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);
      this.childProps = child.props;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, additionalProps);
    }
  }]);

  return Hover;
}(__WEBPACK_IMPORTED_MODULE_3__lib_react__["a" /* MyPureComponent */]);

Hover.propTypes = {
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onHover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Hover.defaultProps = {
  hover: undefined,
  onHover: function onHover() {},
  onLeave: function onLeave() {},
  onChange: function onChange(hovering, event) {}
};


function withHover() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* EMPTY_OBJECT */];

  return function (WrappedComponent) {
    var WithHoverable = function (_MyPureComponent3) {
      _inherits(WithHoverable, _MyPureComponent3);

      function WithHoverable() {
        _classCallCheck(this, WithHoverable);

        return _possibleConstructorReturn(this, (WithHoverable.__proto__ || Object.getPrototypeOf(WithHoverable)).apply(this, arguments));
      }

      _createClass(WithHoverable, [{
        key: 'render',
        value: function render() {
          var _props3 = this.props,
              hover = _props3.hover,
              otherProps = _objectWithoutProperties(_props3, ['hover']);

          return _jsx(Hoverable, {
            hover: hover,
            wrapWith: options.wrapper
          }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, this.props));
        }
      }]);

      return WithHoverable;
    }(__WEBPACK_IMPORTED_MODULE_3__lib_react__["a" /* MyPureComponent */]);

    WithHoverable.displayName = 'WithHoverable(' + Object(__WEBPACK_IMPORTED_MODULE_3__lib_react__["c" /* getDisplayName */])(WrappedComponent) + ')';

    return WithHoverable;
  };
}

/* harmony default export */ __webpack_exports__["b"] = (Hoverable);


/***/ }),
/* 895 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(902);
var IE8_DOM_DEFINE = __webpack_require__(942);
var toPrimitive = __webpack_require__(920);
var dP = Object.defineProperty;

exports.f = __webpack_require__(897) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(908)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Typography__ = __webpack_require__(887);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var BASE_STYLE = {
  border: 'none',
  width: '100%'
};

var _ref2 = _jsx('button', {
  hidden: true,
  type: 'submit'
});

var Form = function (_React$PureComponent) {
  _inherits(Form, _React$PureComponent);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmitForm = function (e) {
      e.preventDefault();
      _this.props.onSubmit();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: 'render',
    value: function render() {
      return _jsx('form', {
        style: _extends({}, BASE_STYLE, {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }, this.props.style),
        onSubmit: this.onSubmitForm
      }, void 0, this.props.children, _ref2);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Form.defaultProps = {
  onSubmit: function onSubmit() {},
  style: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */]
};
var Input = function (_React$PureComponent2) {
  _inherits(Input, _React$PureComponent2);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this2 = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this2.changeInput = function (e) {
      _this2.props.onChange(e.target.value, e.target.name);
    };

    _this2.onFocus = function (e) {
      _this2.setState({ focused: true });
      _this2.props.onFocus(e);
    };

    _this2.onBlur = function (e) {
      _this2.setState({ focused: false });
      _this2.props.onBlur(e);
    };

    _this2.focus = function () {
      _this2.formFieldRef.focus();
    };

    _this2.state = {
      focused: false
    };
    return _this2;
  }

  _createClass(Input, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          name = _props.name,
          type = _props.type,
          value = _props.value,
          onChange = _props.onChange,
          labelStyle = _props.labelStyle,
          style = _props.style,
          inputStyle = _props.inputStyle,
          children = _props.children,
          textColor = _props.textColor,
          placeHolder = _props.placeHolder,
          otherProps = _objectWithoutProperties(_props, ['name', 'type', 'value', 'onChange', 'labelStyle', 'style', 'inputStyle', 'children', 'textColor', 'placeHolder']);

      var labelStyleMerged = _extends({}, BASE_STYLE, {
        color: textColor.alpha(0.5).string(),
        fontStyle: 'italic',
        fontWeight: 'light',
        fontSize: '2.6rem',
        letterSpacing: -0.18,
        marginTop: '2.5rem',
        display: 'block'
      }, labelStyle);
      if (this.props.value && this.state.focused) {
        labelStyleMerged.color = textColor.string();
      }

      var inputStyleMerged = _extends({}, BASE_STYLE, {
        color: textColor.alpha(0.5).string(),
        borderBottom: '0.1rem solid ' + __WEBPACK_IMPORTED_MODULE_4__Style__["a" /* default */].Colors.shadow3,
        backgroundColor: 'transparent',
        fontSize: '2rem',
        lineHeight: '1.6em',
        marginTop: '0.7rem'
      }, inputStyle);
      if (this.props.value) {
        inputStyleMerged.color = textColor.string();
      }

      return _jsx('label', {
        style: labelStyleMerged
      }, void 0, _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Typography__["h" /* L2 */], {
        style: { color: 'inherit' }
      }, void 0, children)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, otherProps, {
        style: inputStyleMerged,
        name: name,
        type: type,
        value: value,
        onChange: this.changeInput,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        placeholder: placeHolder,
        ref: function ref(_ref3) {
          return _this3.formFieldRef = _ref3;
        }
      })));
    }
  }]);

  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Input.defaultProps = {
  onChange: function onChange(value) {},
  labelStyle: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */],
  inputStyle: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */],
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  textColor: __WEBPACK_IMPORTED_MODULE_2_color___default()(__WEBPACK_IMPORTED_MODULE_4__Style__["a" /* default */].Colors.shadow3)
};
var Checkbox = function (_React$PureComponent3) {
  _inherits(Checkbox, _React$PureComponent3);

  function Checkbox() {
    var _ref4;

    var _temp2, _this4, _ret2;

    _classCallCheck(this, Checkbox);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref4 = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref4, [this].concat(args))), _this4), _this4.changeInput = function (e) {
      _this4.props.onChange(!_this4.props.checked, _this4.props.name);
    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
  }

  _createClass(Checkbox, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          name = _props2.name,
          checked = _props2.checked,
          onChange = _props2.onChange,
          labelStyle = _props2.labelStyle,
          inputStyle = _props2.inputStyle,
          children = _props2.children,
          otherProps = _objectWithoutProperties(_props2, ['name', 'checked', 'onChange', 'labelStyle', 'inputStyle', 'children']);

      return _jsx('label', {
        style: {
          display: 'block'
        }
      }, void 0, _jsx('input', {
        name: name,
        type: 'checkbox',
        checked: checked,
        onChange: this.changeInput,
        style: inputStyle
      }), _jsx(__WEBPACK_IMPORTED_MODULE_5__Typography__["o" /* P2 */], {
        style: _extends({
          marginLeft: '0.5rem',
          display: 'inline'
        }, labelStyle)
      }, void 0, children));
    }
  }]);

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);
Checkbox.defaultProps = {
  onChange: function onChange(value) {},
  labelStyle: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */],
  inputStyle: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */]
};

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sortByContrast;
/* harmony export (immutable) */ __webpack_exports__["c"] = textColor;
/* harmony export (immutable) */ __webpack_exports__["d"] = themeColors;
/* harmony export (immutable) */ __webpack_exports__["a"] = imageColors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_color__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Style__ = __webpack_require__(350);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





function sortByContrast(colors, control) {
  var base = __WEBPACK_IMPORTED_MODULE_0_color___default()(control);

  var contrasts = colors.map(function (color) {
    return { color: color, contrast: base.contrast(__WEBPACK_IMPORTED_MODULE_0_color___default()(color)) };
  });

  var sorted = __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default()(contrasts, 'contrast');

  return sorted.map(function (s) {
    return s.color;
  });
}

function textColor(background, colors) {
  var choices = void 0;
  if (colors === undefined) {
    choices = [__WEBPACK_IMPORTED_MODULE_2__components_Style__["a" /* default */].Colors.black, __WEBPACK_IMPORTED_MODULE_2__components_Style__["a" /* default */].Colors.white];
  } else {
    choices = [].concat(_toConsumableArray(colors));
  }
  return sortByContrast(choices, background).pop();
}

function themeColors(colors) {
  var sortedColors = imageColors(colors);
  var colorLight = __WEBPACK_IMPORTED_MODULE_0_color___default()(colors.light || sortedColors.light).white(80).wblack(0).hex();

  var colorDark = __WEBPACK_IMPORTED_MODULE_0_color___default()(colors.dark || sortedColors.dark).white(20).wblack(60).hex();

  var colorHighlight = __WEBPACK_IMPORTED_MODULE_0_color___default()(colors.highlight || sortedColors.highlight).white(15).wblack(30).hex();

  return { light: colorLight, dark: colorDark, highlight: colorHighlight };
}

function imageColors(colors) {
  var colorLight = colors.LightVibrant || colors.Vibrant || colors.DarkVibrant || colors.LightMuted || colors.Muted || colors.DarkMuted;

  var colorDark = colors.DarkVibrant || colors.Vibrant || colors.LightVibrant || colors.DarkMuted || colors.Muted || colors.LightMuted;

  var colorHighlight = colors.Vibrant || colors.LightVibrant || colors.DarkVibrant || colors.LightMuted || colors.Muted || colors.DarkMuted;

  return { light: colorLight, dark: colorDark, highlight: colorHighlight };
}

// Light Color
// Light Vibrant (setting white and black points - 0 tinting + shaded towards white)
// Vibrant (setting white and black points - 0 tinting + shaded towards white)
// Dark Vibrant (lightened a ton)
// Light Muted (lightened up a lot)
// Muted (lightened)
// Dark Muted (lightened)
//
// Dark Color
// Dark Vibrant (lightened slightly)
// Dark Muted (no effect or just slightly lightened)
// Muted (no effect or just slightly lightened)
// Light Muted (darkened a bit)
// Light Vibrant (darkened a bit)
// Vibrant (darkened / muted a bit)
//
// Highlight Color
// Vibrant (no effect)
// Light Vibrant (no effect currently)
// Dark Vibrant (lighten up)
// Light Muted (no effect? Or just slightly pushed towards white)
// Muted (lightened up)
// Dark Muted (lightened up)

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(893);
var core = __webpack_require__(891);
var ctx = __webpack_require__(941);
var hide = __webpack_require__(901);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(896);
var createDesc = __webpack_require__(913);
module.exports = __webpack_require__(897) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(903);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(1097);
var defined = __webpack_require__(917);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 905 */,
/* 906 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(1128);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(1130);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1081);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1086);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1087);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1091);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(1115);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(19);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(33);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(365);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var _context;

          this.removeCss = (_context = this.context).insertCss.apply(_context, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.removeCss) {
            setTimeout(this.removeCss, 0);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_motion__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_Motion__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_react__ = __webpack_require__(221);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var optionsShape = {
  precision: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  stiffness: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  damping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var ElementTransition = function (_MyPureComponent) {
  _inherits(ElementTransition, _MyPureComponent);

  function ElementTransition(props) {
    _classCallCheck(this, ElementTransition);

    var _this = _possibleConstructorReturn(this, (ElementTransition.__proto__ || Object.getPrototypeOf(ElementTransition)).call(this, props));

    _initialiseProps.call(_this);

    _this.entering = undefined;
    _this.leaving = undefined;

    _this.state = _extends({
      styleLeave: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */],
      currentElementData: __WEBPACK_IMPORTED_MODULE_3__constants__["k" /* EMPTY_ARRAY */]
    }, _this.processNewProps(__WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */], props));
    return _this;
  }

  _createClass(ElementTransition, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(this.processNewProps(this.props, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          element = _props.element,
          id = _props.id,
          baseStyle = _props.baseStyle,
          styleEnter = _props.styleEnter,
          styleShown = _props.styleShown,
          styleLeave = _props.styleLeave,
          options = _props.options,
          optionsShown = _props.optionsShown,
          optionsLeave = _props.optionsLeave,
          onStartLeave = _props.onStartLeave,
          onEndLeave = _props.onEndLeave,
          onStartEnter = _props.onStartEnter,
          otherProps = _objectWithoutProperties(_props, ['element', 'id', 'baseStyle', 'styleEnter', 'styleShown', 'styleLeave', 'options', 'optionsShown', 'optionsLeave', 'onStartLeave', 'onEndLeave', 'onStartEnter']);

      return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_motion__["TransitionMotion"], {
        willEnter: this.getEnterStyle,
        willLeave: this.getLeaveStyle,
        styles: this.getStyles
      }, void 0, function (tweens) {
        return _jsx('div', {}, void 0, tweens.map(function (tween) {
          if (tween.key === id) {
            if (_this2.leaving) {
              _this2.triggerEndLeave();
            } else {
              _this2.triggerStartEnter();
            }
          }

          if (tween.key === undefined) {
            return null;
          } else {
            return _jsx('div', {
              style: _extends({}, baseStyle, tween.style, {
                pointerEvents: tween.style.opacity < 0.5 ? 'none' : undefined
              })
            }, tween.key, tween.data);
          }
        }));
      });
    }
  }]);

  return ElementTransition;
}(__WEBPACK_IMPORTED_MODULE_5__lib_react__["a" /* MyPureComponent */]);

ElementTransition.propTypes = {
  element: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  baseStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  styleEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  styleShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  styleLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(optionsShape),
  optionsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(optionsShape),
  optionsLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(optionsShape),
  onStartLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEndLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onStartEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
ElementTransition.defaultProps = {
  element: null,
  styleEnter: { opacity: 0 },
  styleShown: { opacity: 1 },
  styleLeave: { opacity: 0 },
  options: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */],
  optionsShown: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */],
  optionsLeave: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */],
  onStartLeave: function onStartLeave() {},
  onEndLeave: function onEndLeave() {},
  onStartEnter: function onStartEnter() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.processNewProps = function (props, nextProps) {
    var stateUpdate = {};

    if (!Object(__WEBPACK_IMPORTED_MODULE_5__lib_react__["f" /* propsEqual */])(props, nextProps, ['id'])) {
      if (props.element) {
        _this3.triggerStartLeave();
      } else if (nextProps.element) {
        _this3.triggerStartEnter();
      }
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_5__lib_react__["f" /* propsEqual */])(props, nextProps, ['styleLeave', 'options', 'optionsLeave'])) {
      stateUpdate['styleLeave'] = _extends({}, nextProps.styleLeave, Object(__WEBPACK_IMPORTED_MODULE_4__lib_Motion__["d" /* springify */])(nextProps.styleLeave, _extends({}, nextProps.options, nextProps.optionsLeave)));
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_5__lib_react__["f" /* propsEqual */])(props, nextProps, ['id', 'element', 'styleShown', 'options', 'optionsShown'])) {
      stateUpdate['currentElementData'] = [{
        key: nextProps.id,
        data: nextProps.element,
        style: _extends({}, nextProps.styleShown, Object(__WEBPACK_IMPORTED_MODULE_4__lib_Motion__["d" /* springify */])(nextProps.styleShown, _extends({}, nextProps.options, nextProps.optionsShown)))
      }];
    }

    return stateUpdate;
  };

  this.triggerStartEnter = function () {
    if (!_this3.entering) {
      _this3.entering = true;
      setTimeout(_this3.props.onStartEnter, 0);
    }
  };

  this.triggerStartLeave = function () {
    if (!_this3.leaving) {
      _this3.leaving = true;
      _this3.entering = false;
      setTimeout(_this3.props.onStartLeave, 0);
    }
  };

  this.triggerEndLeave = function () {
    if (_this3.leaving) {
      _this3.leaving = false;
      setTimeout(_this3.props.onEndLeave, 0);
    }
  };

  this.getEnterStyle = function () {
    return _this3.props.styleEnter;
  };

  this.getLeaveStyle = function () {
    return _this3.state.styleLeave;
  };

  this.getStyles = function (tweeningStyles) {
    if (tweeningStyles === undefined || tweeningStyles.length < 1 || tweeningStyles[0].key === _this3.props.id) {
      return _this3.state.currentElementData;
    }
    return __WEBPACK_IMPORTED_MODULE_3__constants__["k" /* EMPTY_ARRAY */];
  };
};

/* harmony default export */ __webpack_exports__["a"] = (ElementTransition);

/***/ }),
/* 912 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 914 */,
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/crypto-js/sha3.js
var sha3 = __webpack_require__(1145);
var sha3_default = /*#__PURE__*/__webpack_require__.n(sha3);

// EXTERNAL MODULE: ./node_modules/crypto-js/enc-base64.js
var enc_base64 = __webpack_require__(1147);
var enc_base64_default = /*#__PURE__*/__webpack_require__.n(enc_base64);

// EXTERNAL MODULE: ./node_modules/lodash/chunk.js
var chunk = __webpack_require__(1148);
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);

// EXTERNAL MODULE: ./node_modules/lodash/difference.js
var difference = __webpack_require__(1074);
var difference_default = /*#__PURE__*/__webpack_require__.n(difference);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(138);
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(225);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);

// EXTERNAL MODULE: ./node_modules/lodash/intersection.js
var intersection = __webpack_require__(1080);
var intersection_default = /*#__PURE__*/__webpack_require__.n(intersection);

// EXTERNAL MODULE: ./node_modules/lodash/keyBy.js
var keyBy = __webpack_require__(356);
var keyBy_default = /*#__PURE__*/__webpack_require__.n(keyBy);

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(139);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(142);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// EXTERNAL MODULE: ./node_modules/lodash/values.js
var values = __webpack_require__(83);
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(70);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(17);

// CONCATENATED MODULE: ./src/lib/clips.js


function clipsBySceneIds(clips, sceneIds) {
  var result = {};

  clips.map(function (clip) {
    if (!sceneIds.includes(clip.scene_id)) {
      return;
    }
    var res = result[clip.scene_id] || [];
    res.push(clip);
    result[clip.scene_id] = res;
  });

  return result;
}

function clipsByClipIds(clips, clipIds) {
  var indexed = keyBy_default()(clips, 'clip_id');
  return clipIds.map(function (id) {
    return clips[id];
  });
}

function clipsIdsToX(clips, clipIds, x) {
  var filterToIds = clipsByClipIds(clips, clipIds);
  return filterToIds.map(function (clip) {
    return clip && clip[x];
  });
}
// EXTERNAL MODULE: ./src/lib/tags.js
var lib_tags = __webpack_require__(1070);

// EXTERNAL MODULE: ./src/actions/helpers.js
var helpers = __webpack_require__(101);

// CONCATENATED MODULE: ./src/actions/search.js
/* harmony export (immutable) */ __webpack_exports__["m"] = setSearchText;
/* harmony export (immutable) */ __webpack_exports__["l"] = setSearchSource;
/* harmony export (immutable) */ __webpack_exports__["n"] = toggleTag;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearTags;
/* unused harmony export toggleFilterFavorites */
/* unused harmony export toggleFilterLicensed */
/* harmony export (immutable) */ __webpack_exports__["i"] = getLibraryClipCount;
/* harmony export (immutable) */ __webpack_exports__["h"] = getLatestScenes;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildSearchParams;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildGlobalSearchParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = clipsFromClipIds;
/* harmony export (immutable) */ __webpack_exports__["e"] = clipsFromClipSlug;
/* harmony export (immutable) */ __webpack_exports__["f"] = clipsFromSceneId;
/* harmony export (immutable) */ __webpack_exports__["g"] = clipsFromSceneSlug;
/* harmony export (immutable) */ __webpack_exports__["j"] = search;
/* harmony export (immutable) */ __webpack_exports__["k"] = searchNext;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }


















var MAX_CLIPID_SEARCH = 50;

function setSearchText(text) {
  return Object(helpers["a" /* buildAction */])(constants["Q" /* SET_SEARCH_TEXT */], text);
}

function setSearchSource(source) {
  return Object(helpers["a" /* buildAction */])(constants["P" /* SET_SEARCH_SOURCE */], source);
}

function toggleTag(tagId, state) {
  return Object(helpers["a" /* buildAction */])(constants["W" /* TOGGLE_SEARCH_TAG */], { tagId: tagId, state: state });
}

function clearTags() {
  return function (dispatch, getState) {
    getState().search.tags.map(function (tagId) {
      return dispatch(toggleTag(tagId, false));
    });
  };
}

function toggleFilterFavorites(state) {
  return Object(helpers["a" /* buildAction */])(constants["U" /* TOGGLE_FILTER_FAVORITES */], state);
}

function toggleFilterLicensed(state) {
  return Object(helpers["a" /* buildAction */])(constants["V" /* TOGGLE_FILTER_LICENSED */], state);
}

function getLibraryClipCount() {
  return function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
      var results;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(search(buildSearchParams()));

            case 2:
              results = _context.sent;
              return _context.abrupt('return', results.found);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function getLatestScenes() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  return function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch) {
      var lastLength, more, clips, sceneIds, func, results, scenePromises, scenes;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              lastLength = 0;
              more = false;
              clips = void 0;
              sceneIds = void 0;

            case 4:
              if (false) {
                _context2.next = 20;
                break;
              }

              func = more ? searchNext : search;
              _context2.next = 8;
              return dispatch(func(buildSearchParams()));

            case 8:
              results = _context2.sent;


              clips = results.clips;
              if (results.nextClips) {
                clips = clips.concat(results.nextClips);
              }

              sceneIds = uniq_default()(clips.map(function (clip) {
                return clip.scene_id;
              }));

              if (!(sceneIds.length === lastLength)) {
                _context2.next = 14;
                break;
              }

              return _context2.abrupt('break', 20);

            case 14:
              lastLength = sceneIds.length;

              if (!(sceneIds.length >= min)) {
                _context2.next = 17;
                break;
              }

              return _context2.abrupt('break', 20);

            case 17:

              more = true;
              _context2.next = 4;
              break;

            case 20:

              sceneIds = sceneIds.slice(0, max);

              scenePromises = sceneIds.map(function (sceneId) {
                return dispatch(clipsFromSceneId(sceneId));
              });
              _context2.next = 24;
              return Promise.all(scenePromises);

            case 24:
              scenes = _context2.sent;


              scenes = sortBy_default()(scenes, function (sceneClips) {
                return get_default()(sceneClips, '[0].published_at', '0');
              }
              // timestamp is a string '2017-12-19T19:59:23.051Z' so compare to a string: '0'.
              );
              scenes.reverse();

              return _context2.abrupt('return', scenes);

            case 28:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function buildSearchParams() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants["k" /* EMPTY_ARRAY */];
  var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : constants["D" /* SEARCH_SOURCE */].ALL_SCENES;
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var filterToFavorites = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var filterToLicensed = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  var tagQuery = buildTagQuery(tags);
  var textQuery = text ? '\'' + text.replace(/\\/g, '\\\\').replace(/'/g, "\\'") + '\'' : '';
  var query = [textQuery, tagQuery];
  var filter = [];
  var textAndTags = groupTerms('and', query);

  // Source impacts the fallback query and sorting.
  var searchSource = source;
  if (filterToFavorites || filterToLicensed) {
    searchSource = constants["D" /* SEARCH_SOURCE */].ALL_SCENES;

    var favoriteSceneIds = uniq_default()(clipsIdsToX(values_default()(state.clips.clips), state.user.favorites.map(function (fav) {
      return fav.clipId;
    }), 'scene_id'));
    var licensedSceneIds = uniq_default()(clipsIdsToX(values_default()(state.clips.clips), state.user.licenses.map(function (license) {
      return license.clipId;
    }), 'scene_id'));
    var filterToSceneIds = favoriteSceneIds.concat(licensedSceneIds);
    if (filterToFavorites && filterToLicensed) {
      filterToSceneIds = intersection_default()(favoriteSceneIds, licensedSceneIds);
    }
    if (filterToSceneIds.length < 1) {
      filterToSceneIds = ['matchnone'];
    }

    filter.push(groupTerms('or', filterToSceneIds.map(function (sceneId) {
      return 'scene_id:\'' + sceneId + '\'';
    })));
  }

  var sort = void 0; // Sort by score (natural sort).
  switch (searchSource) {
    case constants["D" /* SEARCH_SOURCE */].ALL_SCENES:
      if (!textAndTags) {
        query.push('matchall');
      }
      sort = '_score ' + constants["T" /* SORT_DIRECTION */].DESC + ', published_at ' + constants["T" /* SORT_DIRECTION */].DESC;
      break;
    case constants["D" /* SEARCH_SOURCE */].FEATURED:
      // Featured_at is anything in this millennium. :P
      query.push("featured_at:['2000-01-01T00:00:00Z','3000-01-01T00:00:00Z']");
      sort = 'featured_at ' + constants["T" /* SORT_DIRECTION */].DESC;
      break;
  }

  return {
    query: groupTerms('and', query),
    filter: groupTerms('and', filter),
    sorting: sort
  };
}

function buildGlobalSearchParams(state) {
  return buildSearchParams(state.search.text, state.search.tags, state.search.source, state, state.search.filterToFavorites, state.search.filterToLicensed);
}

function clipsFromClipIds(clipIds) {
  return function () {
    var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var beforeState, clipIdsToLoad, loadChunks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, loadChunk, query, afterState;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              beforeState = getState();
              clipIdsToLoad = difference_default()(clipIds, Object.keys(beforeState.clips.clips));

              if (!clipIdsToLoad.length) {
                _context3.next = 31;
                break;
              }

              loadChunks = chunk_default()(clipIdsToLoad, MAX_CLIPID_SEARCH);
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context3.prev = 7;
              _iterator = loadChunks[Symbol.iterator]();

            case 9:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context3.next = 17;
                break;
              }

              loadChunk = _step.value;
              query = '(or ' + loadChunk.map(function (clipId) {
                return 'clip_id:\'' + clipId + '\'';
              }).join(' ') + ')';
              _context3.next = 14;
              return dispatch(searchNext({ query: query }, { iterations: -1 }));

            case 14:
              _iteratorNormalCompletion = true;
              _context3.next = 9;
              break;

            case 17:
              _context3.next = 23;
              break;

            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3['catch'](7);
              _didIteratorError = true;
              _iteratorError = _context3.t0;

            case 23:
              _context3.prev = 23;
              _context3.prev = 24;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 26:
              _context3.prev = 26;

              if (!_didIteratorError) {
                _context3.next = 29;
                break;
              }

              throw _iteratorError;

            case 29:
              return _context3.finish(26);

            case 30:
              return _context3.finish(23);

            case 31:
              afterState = getState();
              return _context3.abrupt('return', clipIds.map(function (clipId) {
                return afterState.clips.clips[clipId];
              }));

            case 33:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[7, 19, 23, 31], [24,, 26, 30]]);
    }));

    return function (_x11, _x12) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function clipsFromClipSlug(clipSlug) {
  return function () {
    var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var beforeState, beforeClipIds, results, allClips, clipIds;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              beforeState = getState();
              beforeClipIds = get_default()(beforeState, ['clips', 'indexByClipSlug', clipSlug]);

              if (!(beforeClipIds !== undefined)) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt('return', beforeClipIds.map(function (id) {
                return beforeState.clips.clips[id];
              }));

            case 4:
              _context4.next = 6;
              return dispatch(searchNext({
                query: 'clip_slug:\'' + clipSlug.replace(/\\/g, '\\\\').replace(/'/g, "\\'") + '\''
              }));

            case 6:
              results = _context4.sent;
              allClips = results.clips.concat(results.nextClips);
              clipIds = allClips.map(function (clip) {
                return clip.clip_id;
              });

              dispatch(Object(helpers["a" /* buildAction */])(constants["o" /* INDEX_BY_CLIP_SLUG */], { key: clipSlug, value: clipIds }));

              return _context4.abrupt('return', allClips);

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    return function (_x13, _x14) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function clipsFromSceneId(sceneId) {
  return function () {
    var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var beforeState, beforeClipIds, alreadyLoaded, results, allClips, clipIds, sceneSlug;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              beforeState = getState();

              // Try to take the shortest path to get the clips. The indexBySceneId.

              beforeClipIds = get_default()(beforeState, ['clips', 'indexBySceneId', sceneId]);

              if (!(beforeClipIds !== undefined)) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt('return', beforeClipIds.map(function (clipId) {
                return beforeState.clips.clips[clipId];
              }));

            case 4:

              // If that fails we can still run through the whole list of clips and see if all the clips for a
              // given id are loaded. This should still be faster than making a network request and then doing
              // all the parsing and organizing of data we might already have.
              alreadyLoaded = checkLoadedClipsForScene(dispatch, beforeState.clips.clips, 'scene_id', sceneId);

              if (!(alreadyLoaded !== undefined)) {
                _context5.next = 7;
                break;
              }

              return _context5.abrupt('return', alreadyLoaded);

            case 7:
              _context5.next = 9;
              return dispatch(searchNext({ query: 'scene_id:\'' + sceneId + '\'' }, { iterations: -1 }));

            case 9:
              results = _context5.sent;
              allClips = results.clips.concat(results.nextClips);
              clipIds = allClips.map(function (clip) {
                return clip.clip_id;
              });

              dispatch(Object(helpers["a" /* buildAction */])(constants["p" /* INDEX_BY_SCENE_ID */], { key: sceneId, value: clipIds }));
              sceneSlug = get_default()(allClips[0], 'scene_slug');

              if (sceneSlug !== undefined) {
                dispatch(Object(helpers["a" /* buildAction */])(constants["q" /* INDEX_BY_SCENE_SLUG */], { key: sceneSlug, value: clipIds }));
              }

              return _context5.abrupt('return', allClips);

            case 16:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    return function (_x15, _x16) {
      return _ref5.apply(this, arguments);
    };
  }();
}

function clipsFromSceneSlug(sceneSlug) {
  return function () {
    var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      var beforeState, beforeClipIds, alreadyLoaded, results, allClips, clipIds, sceneId;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              beforeState = getState();

              // Try to take the shortest path to get the clips. The indexBySceneSlug.

              beforeClipIds = get_default()(beforeState, ['clips', 'indexBySceneSlug', sceneSlug]);

              if (!(beforeClipIds !== undefined)) {
                _context6.next = 4;
                break;
              }

              return _context6.abrupt('return', beforeClipIds.map(function (clipId) {
                return beforeState.clips.clips[clipId];
              }));

            case 4:

              // If that fails we can still run through the whole list of clips and see if all the clips for a
              // given slug are loaded. This should still be faster than making a network request and then
              // doing all the parsing and organizing of data we might already have.
              alreadyLoaded = checkLoadedClipsForScene(dispatch, beforeState.clips.clips, 'scene_slug', sceneSlug);

              if (!(alreadyLoaded !== undefined)) {
                _context6.next = 7;
                break;
              }

              return _context6.abrupt('return', alreadyLoaded);

            case 7:
              _context6.next = 9;
              return dispatch(searchNext({
                query: 'scene_slug:\'' + sceneSlug.replace(/\\/g, '\\\\').replace(/'/g, "\\'") + '\''
              }, { iterations: -1 }));

            case 9:
              results = _context6.sent;

              if (!(results.clips === undefined)) {
                _context6.next = 12;
                break;
              }

              throw new Error(JSON.stringify(results, null, 2));

            case 12:
              allClips = results.clips.concat(results.nextClips);
              clipIds = allClips.map(function (clip) {
                return clip.clip_id;
              });

              dispatch(Object(helpers["a" /* buildAction */])(constants["q" /* INDEX_BY_SCENE_SLUG */], { key: sceneSlug, value: clipIds }));
              sceneId = get_default()(allClips[0], 'scene_id');

              if (sceneId) {
                dispatch(Object(helpers["a" /* buildAction */])(constants["p" /* INDEX_BY_SCENE_ID */], { key: sceneId, value: clipIds }));
              }

              return _context6.abrupt('return', allClips);

            case 18:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    return function (_x17, _x18) {
      return _ref6.apply(this, arguments);
    };
  }();
}

function search(params) {
  return function () {
    var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      var results, _results, clips, nextClips, others;

      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return dispatch(searchNext(params, { iterations: 0 }));

            case 2:
              results = _context7.sent;

              if (!(results.found === undefined)) {
                _context7.next = 7;
                break;
              }

              _context7.next = 6;
              return dispatch(searchNext(params));

            case 6:
              results = _context7.sent;

            case 7:

              // Break down the results.
              _results = results, clips = _results.clips, nextClips = _results.nextClips, others = _objectWithoutProperties(_results, ['clips', 'nextClips']);
              return _context7.abrupt('return', _extends({
                clips: clips.concat(nextClips)
              }, others));

            case 9:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    return function (_x19, _x20) {
      return _ref7.apply(this, arguments);
    };
  }();
}

function searchNext(params, options) {
  return function (dispatch, getState) {
    var mergedOptions = _extends({
      iterations: constants["i" /* DEFAULT_ITERATION_COUNT */]
    }, options);
    var query = params.query,
        filter = params.filter,
        sorting = params.sorting,
        size = params.size;

    var sizeParam = size !== undefined ? size : constants["j" /* DEFAULT_SEARCH_SIZE */];

    var key = queryHash({ query: query, filter: filter, sorting: sorting });
    var beforeState = getState();
    var cachedQuery = get_default()(beforeState, ['search', 'queries', key], {
      hit: constants["k" /* EMPTY_ARRAY */]
    });
    var cachedClips = constants["k" /* EMPTY_ARRAY */];

    // Already found some, maybe we're done?
    if (cachedQuery.found !== undefined) {
      // If we've found some, there will be at minimum an empty list here.
      cachedClips = cachedQuery.hit.map(function (clipId) {
        return beforeState.clips.clips[clipId];
      });
    }

    // Possible reasons to exit before doing any more searching.
    //  All clips found.
    //  We're told not to do any iterations.
    //  Size of search is less than 1 so even if we tried to search nothing would come back.
    if (cachedQuery.found <= cachedClips.length || mergedOptions.iterations === 0 || sizeParam < 1) {
      return Promise.resolve({
        clips: cachedClips,
        nextClips: constants["k" /* EMPTY_ARRAY */],
        found: cachedQuery.found,
        loaded: cachedClips.length,
        done: cachedQuery.found <= cachedClips.length
      });
    }

    // Already running? Tag along. The options might be different (iterations and size) but this is
    //  better than just throwing an error. You'll get mostly what you're looking for.
    if (cachedQuery.fetching !== undefined && cachedQuery.fetching.then !== undefined) {
      return cachedQuery.fetching;
    }

    var trigger = void 0;
    // Construct a new promise so we can save it to the app state and use it again if needed.
    var searchPromise = new Promise(function (resolve, reject) {
      trigger = function () {
        var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8() {
          var found, iterationsCompleted, nextClips, nextCursor, iterationResults, loaded, beDone;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.prev = 0;
                  found = cachedQuery.found;
                  iterationsCompleted = 0;
                  nextClips = constants["k" /* EMPTY_ARRAY */];
                  nextCursor = cachedQuery.cursor;

                case 5:
                  if (false) {
                    _context8.next = 24;
                    break;
                  }

                  _context8.next = 8;
                  return dispatch(runSearch({
                    query: query,
                    filter: filter,
                    sorting: sorting,
                    size: sizeParam,
                    cursor: nextCursor
                  }));

                case 8:
                  iterationResults = _context8.sent;

                  iterationsCompleted += 1;
                  nextClips = nextClips.concat(iterationResults.clips);
                  found = iterationResults.found;
                  nextCursor = iterationResults.cursor;
                  loaded = cachedClips.length + nextClips.length;
                  beDone = false;
                  // Out of iterations...

                  if (mergedOptions.iterations > -1 && iterationsCompleted >= mergedOptions.iterations) {
                    beDone = true;
                  }
                  // All clips loaded?
                  if (loaded >= found) {
                    beDone = true;
                  }
                  // Didn't find any more?
                  if (iterationResults.clips.length < 1) {
                    beDone = true;
                  }

                  dispatch(Object(helpers["a" /* buildAction */])(constants["X" /* UPDATE_SEARCH_REQUEST */], {
                    key: key,
                    found: found,
                    cursor: nextCursor,
                    hit: iterationResults.clipIds
                  }));

                  if (!beDone) {
                    _context8.next = 22;
                    break;
                  }

                  resolve({
                    clips: cachedClips,
                    nextClips: nextClips,
                    found: found,
                    loaded: loaded,
                    done: loaded >= found
                  });
                  return _context8.abrupt('return');

                case 22:
                  _context8.next = 5;
                  break;

                case 24:
                  _context8.next = 29;
                  break;

                case 26:
                  _context8.prev = 26;
                  _context8.t0 = _context8['catch'](0);

                  reject(_context8.t0);

                case 29:
                  _context8.prev = 29;

                  // No matter what, close the loop on using this query.
                  dispatch(Object(helpers["a" /* buildAction */])(constants["m" /* END_SEARCH_REQUEST */], { key: key }));
                  return _context8.finish(29);

                case 32:
                case 'end':
                  return _context8.stop();
              }
            }
          }, _callee8, this, [[0, 26, 29, 32]]);
        }));

        return function trigger() {
          return _ref8.apply(this, arguments);
        };
      }();
    });

    // Note that we're using this query. There is a race condition where the
    dispatch(Object(helpers["a" /* buildAction */])(constants["a" /* BEGIN_SEARCH_REQUEST */], { key: key, fetching: searchPromise }));
    // Fix the race condition where the search starts before we have noted that the search has begun.
    trigger();

    return searchPromise;
  };
}

// Private functions below here.

function queryHash(params) {
  return enc_base64_default.a.stringify(sha3_default()(JSON.stringify(params)));
}

function runSearch(params) {
  return function () {
    var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState, _ref10) {
      var fetch = _ref10.fetch;
      var results, state, clipIds, clips;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return sendSearchToServer(params, fetch).then(function (results) {
                return results.json();
              }).then(function (results) {
                return checkForError(params, results);
              });

            case 2:
              results = _context9.sent;


              // Save the clips in the app state.
              dispatch(Object(helpers["a" /* buildAction */])(constants["s" /* LOAD_CLIPS */], results.hits.hit));

              // Return the clips in the order we found them.
              state = getState();
              clipIds = results.hits.hit.map(function (hit) {
                return hit.fields.clip_id;
              });
              clips = clipIds.map(function (clipId) {
                return state.clips.clips[clipId];
              });
              return _context9.abrupt('return', {
                found: results.hits.found,
                clipIds: clipIds,
                clips: clips,
                cursor: results.hits.cursor
              });

            case 8:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    return function (_x21, _x22, _x23) {
      return _ref9.apply(this, arguments);
    };
  }();
}

function sendSearchToServer(params, fetch) {
  var queryParams = {
    q: params.query,
    'q.parser': constants["B" /* QUERY_PARSER */].STRUCTURED,
    'q.options': '{"defaultOperator":"and"}',
    sort: params.sorting || '_score desc',
    cursor: params.cursor || 'initial',
    partial: 'true',
    size: params.size || constants["j" /* DEFAULT_SEARCH_SIZE */],
    return: '_all_fields,_score'
  };
  if (params.filter !== undefined) {
    queryParams.fq = params.filter;
  }

  var queryString = Object.keys(queryParams).map(function (key) {
    return key + '=' + encodeURIComponent(queryParams[key]);
  }).join('&');

  var url = config_default.a.search.endpoint + '?' + queryString;

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json'
    }
  });
}

function checkForError(params, results) {
  if (results.message) {
    console.error(params);
    throw new Error(results.message);
  }

  if (results.hits === undefined) {
    console.error(results);
    throw new Error('Did not get a hits object back from cloudsearch.');
  }

  return results;
}

function buildTagQuery(tagIds) {
  if (!tagIds.length) {
    return;
  }

  var defaultOp = 'or';
  var ops = {
    Category: {
      undefined: 'and'
    }
  };

  // Sort everything. The results of this are used in a hash based on string conversion so keep it as uniform as possible.

  var tags = tagIds.map(lib_tags["b" /* getTag */]);
  var grouped = Object(lib_tags["d" /* groupTags */])(tags);
  var terms = [];
  sortBy_default()(Object.keys(grouped)).map(function (typeKey) {
    var type = grouped[typeKey];
    sortBy_default()(Object.keys(type)).map(function (groupKey) {
      var group = type[groupKey];
      var queryItems = sortBy_default()(group).map(function (tag) {
        return 'tags:\'' + tag.id + '\'';
      });
      terms.push(groupTerms(get_default()(ops, [typeKey, groupKey], defaultOp), queryItems));
    });
  });

  return groupTerms('and', sortBy_default()(terms));
}

function groupTerms(op, terms) {
  var filteredTerms = sortBy_default()(terms.filter(Boolean));
  switch (filteredTerms.length) {
    case 0:
      return;
    case 1:
      return filteredTerms[0];
    default:
      return '(' + op + ' ' + filteredTerms.join(' ') + ')';
  }
}

function checkLoadedClipsForScene(dispatch, clips, attribute, value) {
  var sceneClips = [];
  var sceneClipCount = void 0;

  Object.keys(clips).map(function (clipId) {
    var clip = clips[clipId];
    if (clip[attribute] === value) {
      sceneClips.push(clip);
      sceneClipCount = clip.scene_clip_count;
    }
  });

  if (sceneClips.length === sceneClipCount) {
    var anyClip = sceneClips[0];
    var clipIds = sceneClips.map(function (clip) {
      return clip.clip_id;
    });
    dispatch(Object(helpers["a" /* buildAction */])(constants["p" /* INDEX_BY_SCENE_ID */], {
      key: anyClip.scene_id,
      value: clipIds
    }));
    dispatch(Object(helpers["a" /* buildAction */])(constants["q" /* INDEX_BY_SCENE_SLUG */], {
      key: anyClip.scene_slug,
      value: clipIds
    }));

    return sceneClips;
  }
}

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Typography__ = __webpack_require__(887);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SecondaryAction = function (_React$PureComponent) {
  _inherits(SecondaryAction, _React$PureComponent);

  function SecondaryAction() {
    _classCallCheck(this, SecondaryAction);

    return _possibleConstructorReturn(this, (SecondaryAction.__proto__ || Object.getPrototypeOf(SecondaryAction)).apply(this, arguments));
  }

  _createClass(SecondaryAction, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefix = _props.prefix,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['prefix', 'children']);

      return _jsx(__WEBPACK_IMPORTED_MODULE_4__Typography__["o" /* P2 */], {
        style: {
          marginTop: '1rem',
          textAlign: 'center',
          color: __WEBPACK_IMPORTED_MODULE_3__Style__["a" /* default */].Colors.shadow2,
          fontStyle: 'italic'
        }
      }, void 0, prefix, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */],
        otherProps,
        children
      ));
    }
  }]);

  return SecondaryAction;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

SecondaryAction.defaultProps = {
  prefix: 'or, '
};


/* harmony default export */ __webpack_exports__["a"] = (SecondaryAction);

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(919)('keys');
var uid = __webpack_require__(912);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(893);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(903);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1094)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(945)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 922 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(902);
var dPs = __webpack_require__(1096);
var enumBugKeys = __webpack_require__(927);
var IE_PROTO = __webpack_require__(918)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(943)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1101).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(947);
var enumBugKeys = __webpack_require__(927);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 926 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 927 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(896).f;
var has = __webpack_require__(895);
var TAG = __webpack_require__(892)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1102);
var global = __webpack_require__(893);
var hide = __webpack_require__(901);
var Iterators = __webpack_require__(909);
var TO_STRING_TAG = __webpack_require__(892)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(892);


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(893);
var core = __webpack_require__(891);
var LIBRARY = __webpack_require__(923);
var wksExt = __webpack_require__(930);
var defineProperty = __webpack_require__(896).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 932 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(17);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SIDES = ['top', 'right', 'bottom', 'left'];

function nextSide(side) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var index = SIDES.indexOf(side);
  if (index < 0) {
    throw new Error(side + ' is not a valid side');
  }

  var next = (index + SIDES.length + step) % SIDES.length;
  return SIDES[next];
}

function capitalize(str) {
  switch ((str || '').length) {
    case 0:
      return str;
    case 1:
      return str.toUpperCase();
    default:
      return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
  }
}

var Section = function (_React$PureComponent) {
  _inherits(Section, _React$PureComponent);

  function Section() {
    _classCallCheck(this, Section);

    return _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).apply(this, arguments));
  }

  _createClass(Section, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          angle = _props.angle,
          topAngle = _props.topAngle,
          topMargin = _props.topMargin,
          bottomAngle = _props.bottomAngle,
          bottomMargin = _props.bottomMargin,
          style = _props.style,
          contentStyle = _props.contentStyle,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['backgroundColor', 'angle', 'topAngle', 'topMargin', 'bottomAngle', 'bottomMargin', 'style', 'contentStyle', 'children']);

      var containerStyle = _extends({ pointerEvents: 'none' }, style);
      var contentStyleMerged = _extends({
        paddingTop: angle || topAngle ? '1px' : undefined,
        paddingBottom: angle || bottomAngle ? '1px' : undefined,
        backgroundColor: backgroundColor,
        pointerEvents: 'auto'
      }, contentStyle);

      return _jsx('div', {
        style: containerStyle
      }, void 0, _jsx(Triangle, {
        side: 'top',
        angle: angle || topAngle,
        color: backgroundColor,
        margin: topMargin
      }), _jsx('div', {
        style: contentStyleMerged
      }, void 0, children), _jsx(Triangle, {
        side: 'bottom',
        angle: angle || bottomAngle,
        color: backgroundColor,
        margin: bottomMargin
      }));
    }
  }]);

  return Section;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Section.defaultProps = {
  backgroundColor: undefined,
  angle: 0,
  topAngle: 0,
  topMargin: 1,
  bottomAngle: 0,
  bottomMargin: 1,
  style: __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* EMPTY_OBJECT */],
  contentStyle: __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* EMPTY_OBJECT */]
};


/* harmony default export */ __webpack_exports__["a"] = (Section);

function Triangle(_ref) {
  var side = _ref.side,
      angle = _ref.angle,
      color = _ref.color,
      margin = _ref.margin,
      children = _ref.children;

  var slope = Math.tan(Math.abs(angle) * Math.PI / 180);

  var step = -1;
  if (angle < 0) {
    step = 1;
  }

  var realSide = nextSide(side, 2);
  var adjacent = nextSide(realSide, step);
  var oppositeA = nextSide(realSide, 2);
  var oppositeB = nextSide(adjacent, 2);

  var style = {
    borderWidth: slope * 50 + 'vw 50vw',
    borderStyle: 'solid',
    pointerEvents: 'none'
  };

  style['margin' + capitalize(side)] = margin * slope * -100 + 'vw';

  [[realSide, color], [adjacent, color], [oppositeA, 'transparent'], [oppositeB, 'transparent']].map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        postfix = _ref3[0],
        value = _ref3[1];

    return style['border' + capitalize(postfix) + 'Color'] = value;
  });

  return _jsx('div', {
    style: style
  }, void 0, children);
}

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Video = function (_React$PureComponent) {
  _inherits(Video, _React$PureComponent);

  function Video() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Video);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Video.__proto__ || Object.getPrototypeOf(Video)).call.apply(_ref, [this].concat(args))), _this), _this.onRef = function (el) {
      _this.props.refCallback(el);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Video, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          refCallback = _props.refCallback,
          otherProps = _objectWithoutProperties(_props, ['refCallback']);

      var mergedProps = _extends({
        muted: true,
        autoPlay: true,
        preload: true,
        playsInline: true,
        loop: true
      }, otherProps, {
        ref: this.onRef
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', mergedProps);
    }
  }]);

  return Video;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Video.defaultProps = { refCallback: function refCallback(el) {} };


/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Style__ = __webpack_require__(350);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Toggle = function (_React$PureComponent) {
  _inherits(Toggle, _React$PureComponent);

  function Toggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Toggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      e.preventDefault();
      _this.props.onToggle(!_this.props.checked, _this.props.name);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Toggle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          onToggle = _props.onToggle,
          name = _props.name,
          style = _props.style,
          otherProps = _objectWithoutProperties(_props, ['checked', 'onToggle', 'name', 'style']);

      var colors = __WEBPACK_IMPORTED_MODULE_3__Style__["a" /* default */].Colors;

      var composedStyle = {
        backgroundColor: checked ? colors.white : colors.shadow5,
        borderRadius: '999999px',
        border: '0.1em solid ' + (checked ? colors.black : colors.shadow3),
        height: '1.8em',
        width: '3.2em',
        padding: '0.2em',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: checked ? 'flex-end' : 'flex-start'
      };

      var composedInnerStyle = {
        backgroundColor: checked ? colors.black : colors.shadow1,
        borderRadius: '999999px',
        height: '1.2em',
        width: '1.2em'
      };

      return _jsx('div', {
        style: _extends({ fontSize: '10px' }, style, { boxSizing: 'border-box' })
      }, void 0, _jsx('div', {
        style: composedStyle,
        onClick: this.handleClick
      }, void 0, _jsx('div', {
        style: composedInnerStyle
      })));
    }
  }]);

  return Toggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Toggle.defaultProps = {
  checked: false,
  onToggle: function onToggle(checked, name) {},
  style: __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* EMPTY_OBJECT */]
};


/* harmony default export */ __webpack_exports__["a"] = (Toggle);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);


function startConversation(message) {
  var link = ['mailto:', __WEBPACK_IMPORTED_MODULE_0__config___default.a.url.supportEmailAddress];

  if (message !== undefined) {
    link.push('?subject=');
    link.push(message);
  }

  window.location = link.join('');
}

/* harmony default export */ __webpack_exports__["a"] = ({ startConversation: startConversation });

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ElementTransition__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Link__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Typography__ = __webpack_require__(887);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MAX_STRIPE_HEIGHT = '3rem';

var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["c" /* H3 */], {}, void 0, 'Confirm your subscription change');

var _ref2 = _jsx('span', {}, void 0, 'Enter your payment information');

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["m" /* P1 */], {}, void 0, 'Fetching pricing...');

var Payment = function (_React$PureComponent) {
  _inherits(Payment, _React$PureComponent);

  function Payment(props) {
    _classCallCheck(this, Payment);

    var _this = _possibleConstructorReturn(this, (Payment.__proto__ || Object.getPrototypeOf(Payment)).call(this, props));

    _this.completeSubscription = function (token) {
      var tokenId = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(token, 'id');
      if (tokenId === undefined && !_this.props.paymentOnFile) {
        return;
      }

      var couponCode = void 0;
      if (_this.props.allowCoupon) {
        couponCode = _this.props.couponCode;
      }

      if (!_this.state.formEnabled) {
        return;
      }
      _this.setState({ formEnabled: false, fetching: true });
      _this.props.onCreateSubscription(tokenId, _this.props.chosenPlan, couponCode).then(function () {
        return _this.setState({ formEnabled: true, fetching: false });
      }).catch(function () {
        return _this.setState({ formEnabled: true, fetching: false });
      });
    };

    _this.doSubmit = function (e) {
      if (_this.state.showCC) {
        var fakeEvent = { preventDefault: function preventDefault() {} };
        // HACK: To make sure that any error from stripe propogates to state. Users wont notice.
        setTimeout(function () {
          return _this.cardSubmit(fakeEvent);
        }, 100);
      } else {
        _this.completeSubscription();
      }
    };

    _this.headline = function () {
      if (_this.props.paymentOnFile) {
        return _jsx('div', {}, void 0, _ref, _this.state.showCC && _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["m" /* P1 */], {
          style: { color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.shadow4 }
        }, void 0, 'Enter your new card details to change your payment method.', ' ', _jsx(__WEBPACK_IMPORTED_MODULE_7__Link__["a" /* default */], {
          underline: true,
          onClick: function onClick(e) {
            return _this.setState({ showCC: false });
          }
        }, void 0, 'Cancel.')), !_this.state.showCC && _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["m" /* P1 */], {
          style: { color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.shadow4 }
        }, void 0, 'We\'ll use the card you have on file unless you', ' ', _jsx(__WEBPACK_IMPORTED_MODULE_7__Link__["a" /* default */], {
          underline: true,
          onClick: function onClick(e) {
            return _this.setState({ showCC: true });
          }
        }, void 0, 'change it here.')));
      } else {
        return _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["c" /* H3 */], {}, void 0, _this.props.paymentInfoHeadline || _ref2), _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["m" /* P1 */], {
          style: { color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.shadow4 }
        }, void 0, 'Everything is encrypted and no billing information is ever stored on our\xA0servers.'));
      }
    };

    _this.state = {
      showCC: !props.paymentOnFile,
      formEnabled: true,
      fetching: false
    };
    return _this;
  }

  _createClass(Payment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.createSubscriptionRef(this.doSubmit);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.fetching !== this.state.fetching) {
        this.props.fetchingUpdated(this.state.fetching);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          style = _props.style,
          allowCoupon = _props.allowCoupon,
          paymentOnFile = _props.paymentOnFile,
          paymentInfoHeadline = _props.paymentInfoHeadline,
          chosenPlan = _props.chosenPlan,
          couponCode = _props.couponCode,
          couponError = _props.couponError,
          paymentError = _props.paymentError,
          planSummary = _props.planSummary,
          onGoToPlan = _props.onGoToPlan,
          onChangeCoupon = _props.onChangeCoupon,
          onCreateSubscription = _props.onCreateSubscription,
          onCardFocus = _props.onCardFocus,
          showCreateButton = _props.showCreateButton,
          otherProps = _objectWithoutProperties(_props, ['style', 'allowCoupon', 'paymentOnFile', 'paymentInfoHeadline', 'chosenPlan', 'couponCode', 'couponError', 'paymentError', 'planSummary', 'onGoToPlan', 'onChangeCoupon', 'onCreateSubscription', 'onCardFocus', 'showCreateButton']);

      var paymentMethod = {
        id: 'editPayment',
        element: _jsx('div', {
          style: { height: MAX_STRIPE_HEIGHT }
        })
      };
      if (this.state.showCC) {
        paymentMethod = {
          id: 'cc',
          element: _jsx('div', {
            style: { maxHeight: MAX_STRIPE_HEIGHT }
          }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__["Elements"], {}, void 0, _jsx(CardForm, {
            allowEmpty: paymentOnFile,
            onFocus: onCardFocus,
            onSubmit: this.completeSubscription,
            submitRef: function submitRef(func) {
              return _this2.cardSubmit = func;
            }
          })))
        };
      }

      return _jsx('div', {
        style: _extends({ padding: '7rem 5rem 5rem' }, style)
      }, void 0, _jsx('div', {
        style: { maxWidth: '55rem' }
      }, void 0, this.headline(), _jsx('div', {
        style: { maxHeight: MAX_STRIPE_HEIGHT, margin: '3rem 0 -2rem' }
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ElementTransition__["a" /* default */], paymentMethod), paymentError && _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["m" /* P1 */], {}, void 0, paymentError)), _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["e" /* H5 */], {
        style: { color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.shadow2, margin: '9rem 0 0' }
      }, void 0, 'Summary'), _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["m" /* P1 */], {
        style: { color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.shadow4 }
      }, void 0, 'Here\u2019s what you\u2019re subscribing to, and paying today'), _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["j" /* L3 */], {
        style: {
          color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.shadow3,
          display: 'block',
          margin: '2rem 0 0.5rem'
        }
      }, void 0, 'YOUR', paymentOnFile ? ' ' : ' NEW ', 'PLAN'), _jsx('div', {
        style: { color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.shadow2 }
      }, void 0, planSummary === undefined && _ref3, planSummary !== undefined && _jsx('div', {}, void 0, _jsx('div', {}, void 0, _jsx(SummaryText, {}, void 0, planSummary.name, ' - $', simpleRound(planSummary.monthly, 2), '/mo,', chosenPlan.annual && ' paying annually'), onGoToPlan && _jsx(Action, {
        onClick: onGoToPlan
      }, void 0, 'Change this plan')), _jsx('div', {
        style: { margin: '0 0 0.75rem' }
      }, void 0, _jsx(SummaryText, {}, void 0, 'Amount due today = $', simpleRound(planSummary.total, 2))), allowCoupon && _jsx('div', {
        style: { minHeight: '5.7rem' }
      }, void 0, _jsx(CouponCode, {
        summary: planSummary,
        code: couponCode,
        error: couponError,
        onSubmit: onChangeCoupon
      })))))), showCreateButton && _jsx('div', {
        style: { margin: '1rem 0 0', textAlign: 'center' }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], {
        size: 'large',
        onClick: this.doSubmit,
        working: this.state.fetching
      }, void 0, paymentOnFile ? 'Update' : 'Create', '\xA0subscription')));
    }
  }]);

  return Payment;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Payment.defaultProps = {
  style: __WEBPACK_IMPORTED_MODULE_4__constants__["l" /* EMPTY_OBJECT */],
  allowCoupon: true,
  paymentOnFile: false,
  onCardFocus: function onCardFocus() {},
  showCreateButton: true,
  createSubscriptionRef: function createSubscriptionRef(subFunc) {},
  fetchingUpdated: function fetchingUpdated(fetching) {}
};


/* harmony default export */ __webpack_exports__["b"] = (Payment);

var CardBase = function (_React$PureComponent2) {
  _inherits(CardBase, _React$PureComponent2);

  function CardBase(props) {
    _classCallCheck(this, CardBase);

    var _this3 = _possibleConstructorReturn(this, (CardBase.__proto__ || Object.getPrototypeOf(CardBase)).call(this, props));

    _this3.handleSubmit = function (e) {
      // We don't want to let default form submission happen here, which would refresh the page.
      e.preventDefault();

      // Errors always block submit.
      if (_this3.state.error !== undefined) {
        console.error('Stripe submit error', _this3.state.error);
        return;
      }

      if (_this3.state.empty) {
        if (_this3.props.allowEmpty) {
          // If empty is allowed and the form is empty we can submit without any token creation.
          _this3.props.onSubmit();
        } else {
          // If payment info is required and the form is empty, tell them.
          _this3.setState({ error: 'A valid credit card is required' });
        }

        // Empty forms cannot generate tokens.
        return;
      } else {
        if (!_this3.state.complete) {
          _this3.setState({
            error: 'You have not entered all the information yet'
          });
          return;
        }
      }

      // Within the context of `Elements`, this call to createToken knows which Element to
      // tokenize, since there's only one in this group.
      _this3.props.stripe.createToken().then(function (result) {
        if (result.token) {
          _this3.props.onSubmit(result.token);
          return;
        }

        if (result.error) {
          _this3.setState({ error: result.error.message || result.error });
          return;
        }

        _this3.setState({
          error: 'Something went wrong billing your card. You have not been charged.'
        });
      }).catch(function (err) {
        _this3.setState({
          error: 'Something went wrong billing your card. You have not been charged.'
        });
      });
    };

    _this3.handleChange = function (e) {
      var message = void 0;
      if (e.error) {
        message = e.error.message;
      }

      var stateUpdate = { error: undefined };

      if (_this3.state.error !== message) {
        stateUpdate['error'] = message;
      }
      if (_this3.state.empty !== e.empty) {
        stateUpdate['empty'] = e.empty;
        stateUpdate['error'] = undefined;
      }
      if (_this3.state.complete !== e.complete) {
        stateUpdate['complete'] = e.complete;
      }

      _this3.setState(stateUpdate);
    };

    _this3.state = {
      error: undefined,
      empty: true,
      complete: false
    };
    return _this3;
  }

  _createClass(CardBase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.submitRef(this.handleSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          allowEmpty = _props2.allowEmpty,
          onFocus = _props2.onFocus,
          onSubmit = _props2.onSubmit,
          submitRef = _props2.submitRef,
          otherProps = _objectWithoutProperties(_props2, ['allowEmpty', 'onFocus', 'onSubmit', 'submitRef']);

      return _jsx('div', {
        style: { maxHeight: MAX_STRIPE_HEIGHT }
      }, void 0, _jsx('form', {
        style: { maxHeight: MAX_STRIPE_HEIGHT },
        onSubmit: this.handleSubmit
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__["CardElement"], {
        onFocus: onFocus,
        onChange: this.handleChange,
        hidePostalCode: true,
        style: {
          base: {
            fontSize: '22px',
            color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.shadow3,
            letterSpacing: '0.025em',
            fontFamily: 'Calibre, Source Code Pro, monospace',
            '::placeholder': {
              color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.shadow4
            }
          },
          invalid: {
            color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.error
          }
        }
      })), _jsx('div', {}, void 0, _jsx('span', {
        style: { color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.error }
      }, void 0, this.state.error)));
    }
  }]);

  return CardBase;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var CardForm = Object(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__["injectStripe"])(CardBase);

var _ref6 = _jsx('span', {}, void 0, '\xA0');

var CouponCode = function (_React$PureComponent3) {
  _inherits(CouponCode, _React$PureComponent3);

  function CouponCode(props) {
    _classCallCheck(this, CouponCode);

    var _this4 = _possibleConstructorReturn(this, (CouponCode.__proto__ || Object.getPrototypeOf(CouponCode)).call(this, props));

    _this4.addCode = function (e) {
      _this4.setState({ code: '' });
    };

    _this4.removeCode = function (e) {
      _this4.setState({ code: undefined });
      _this4.props.onSubmit(undefined);
    };

    _this4.applyCode = function () {
      if (!_this4.state.formEnabled) {
        return;
      }

      if (_this4.state.code === '') {
        _this4.setState({ code: undefined });
        _this4.props.onSubmit(undefined);
      } else {
        _this4.setState({ formEnabled: false, fetching: true });
        _this4.props.onSubmit(_this4.state.code).then(function () {
          return _this4.setState({ formEnabled: true, fetching: false });
        }).catch(function () {
          return _this4.setState({ formEnabled: true, fetching: false });
        });
      }
    };

    _this4.updateCode = function (value) {
      _this4.setState({ code: value });
    };

    _this4.state = {
      formEnabled: true,
      fetching: false,
      code: props.code
    };
    return _this4;
  }

  _createClass(CouponCode, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          summary = _props3.summary,
          code = _props3.code,
          error = _props3.error,
          onSubmit = _props3.onSubmit,
          otherProps = _objectWithoutProperties(_props3, ['summary', 'code', 'error', 'onSubmit']);

      if (this.state.code === undefined) {
        return _jsx('div', {}, void 0, _ref4, _jsx(Action, {
          onClick: this.addCode
        }, void 0, 'Add it'));
      } else if (this.state.code === code && !this.state.fetching) {
        var amtPrefix = summary.amount_off ? '$' + summary.amount_off : '';
        var pctPrefix = summary.percent_off ? summary.percent_off + '%' : '';
        var regularPostfix = summary.regularMonthly ? '($' + simpleRound(summary.regularMonthly) + '/mo after that)' : '';
        return _jsx('div', {}, void 0, _jsx(SummaryText, {}, void 0, amtPrefix, pctPrefix, ' off ', summary.discountPostfix, ' ', regularPostfix), _jsx(Action, {
          onClick: this.removeCode
        }, void 0, 'Remove'));
      } else {
        return _jsx('div', {}, void 0, _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Form__["b" /* Form */], {
          onSubmit: this.applyCode,
          style: { flexDirection: 'row', alignItems: 'flex-end' }
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Form__["c" /* Input */], {
          name: 'coupon-code',
          type: 'text',
          value: this.state.code,
          onChange: this.updateCode,
          labelStyle: {
            margin: 0,
            display: 'inline',
            maxWidth: '80%',
            width: '25rem'
          },
          inputStyle: {
            margin: 0,
            fontWeight: 300,
            fontStyle: 'normal'
          }
        }), this.state.fetching ? _ref5 : _jsx(Action, {
          onClick: this.applyCode
        }, void 0, this.state.code.length ? 'Apply' : 'Cancel'))), _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["m" /* P1 */], {}, void 0, error || _ref6));
      }
    }
  }]);

  return CouponCode;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

CouponCode.defaultProps = {};


function simpleRound(number) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
  var factor = Math.pow(10, precision);
  var tempNumber = number * factor;
  var roundedTempNumber = Math.round(tempNumber);
  return roundedTempNumber / factor;
}

function Action(_ref7) {
  var onClick = _ref7.onClick,
      children = _ref7.children;

  return _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["o" /* P2 */], {
    style: {
      display: 'inline-block',
      fontWeight: 500,
      marginLeft: '2rem'
    }
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Link__["a" /* default */], {
    onClick: onClick
  }, void 0, children));
}

var _ref5 = _jsx(Action, {}, void 0, 'Checking...');

function SummaryText(_ref8) {
  var style = _ref8.style,
      children = _ref8.children;

  return _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["m" /* P1 */], {
    style: _extends({
      margin: 0,
      display: 'inline-block'
    }, style || __WEBPACK_IMPORTED_MODULE_4__constants__["l" /* EMPTY_OBJECT */])
  }, void 0, children);
}

var _ref4 = _jsx(SummaryText, {}, void 0, 'Have a coupon code?');

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(917);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(895);
var toObject = __webpack_require__(939);
var IE_PROTO = __webpack_require__(918)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1085);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(897) && !__webpack_require__(908)(function () {
  return Object.defineProperty(__webpack_require__(943)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(903);
var document = __webpack_require__(893).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1092);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1105);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(923);
var $export = __webpack_require__(900);
var redefine = __webpack_require__(946);
var hide = __webpack_require__(901);
var has = __webpack_require__(895);
var Iterators = __webpack_require__(909);
var $iterCreate = __webpack_require__(1095);
var setToStringTag = __webpack_require__(928);
var getPrototypeOf = __webpack_require__(940);
var ITERATOR = __webpack_require__(892)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(901);


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(895);
var toIObject = __webpack_require__(904);
var arrayIndexOf = __webpack_require__(1098)(false);
var IE_PROTO = __webpack_require__(918)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 948 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(947);
var hiddenKeys = __webpack_require__(927).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(932);
var createDesc = __webpack_require__(913);
var toIObject = __webpack_require__(904);
var toPrimitive = __webpack_require__(920);
var has = __webpack_require__(895);
var IE8_DOM_DEFINE = __webpack_require__(942);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(897) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'كانون الثاني يناير',
    'شباط فبراير',
    'آذار مارس',
    'نيسان أبريل',
    'أيار مايو',
    'حزيران يونيو',
    'تموز يوليو',
    'آب أغسطس',
    'أيلول سبتمبر',
    'تشرين الأول أكتوبر',
    'تشرين الثاني نوفمبر',
    'كانون الأول ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

// Language contact person : Abdoufata Kane : https://github.com/abdoufata

var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH.mm',
        LLLL : 'dddd, D. MMMM YYYY HH.mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish(United State) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY H:mm',
        LLLL : 'dddd, MMMM [de] D [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    };
var numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number,
        suffix;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日Ah点mm分',
        LLLL : 'YYYY年MMMD日ddddAh点mm分',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(886)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(926);
var TAG = __webpack_require__(892)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTag;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTagName;
/* harmony export (immutable) */ __webpack_exports__["a"] = allTags;
/* harmony export (immutable) */ __webpack_exports__["d"] = groupTags;
/* unused harmony export compareTags */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_tags_json__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_tags_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_tags_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var TAGS = __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default()(__WEBPACK_IMPORTED_MODULE_2__assets_tags_json___default.a, 'id');

function getTag(id) {
  return TAGS[id];
}

function getTagName(id) {
  var tag = getTag(id);

  if (tag.type === 'Camera') {
    if (['Framing', 'Movement'].includes(tag.group)) {
      return tag.name + ' ' + tag.group.toLowerCase();
    }
  }

  if (tag.type === 'Energy') {
    return tag.name + ' energy';
  }

  return tag.name;
}

function allTags() {
  return _extends({}, TAGS);
}

function groupTags(tags) {
  var types = {};

  tags.map(function (tag) {
    var typeContainer = types[tag.type] || {};
    var groupContainer = typeContainer[tag.group] || [];
    groupContainer.push(tag);
    groupContainer.sort(compareTags);
    typeContainer[tag.group] = groupContainer;
    types[tag.type] = typeContainer;
  });

  return types;
}

function compareTags(a, b) {
  // Ordered tags sort by order.
  if (a.order !== undefined && b.order !== undefined) {
    return a.order - b.order;
  }

  // Other tags sort by name.
  if (a.name > b.name) {
    return 1;
  }
  if (a.name < b.name) {
    return -1;
  }

  return 0;
}

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_react__ = __webpack_require__(221);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Aspect = function (_MyPureComponent) {
  _inherits(Aspect, _MyPureComponent);

  function Aspect() {
    _classCallCheck(this, Aspect);

    return _possibleConstructorReturn(this, (Aspect.__proto__ || Object.getPrototypeOf(Aspect)).apply(this, arguments));
  }

  _createClass(Aspect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ratio = _props.ratio,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['ratio', 'children']);

      var outerStyle = {
        position: 'relative',
        width: '100%',
        paddingTop: ratio * 100 + '%',
        height: 0,
        maxHeight: 0
      };
      var innerStyle = {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };

      var childrenWithProps = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, otherProps);
      });

      return _jsx('div', {
        style: outerStyle
      }, void 0, _jsx('div', {
        style: innerStyle
      }, void 0, childrenWithProps));
    }
  }]);

  return Aspect;
}(__WEBPACK_IMPORTED_MODULE_2__lib_react__["a" /* MyPureComponent */]);

Aspect.propTypes = {
  ratio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
Aspect.defaultProps = {
  ratio: 1
};


/* harmony default export */ __webpack_exports__["a"] = (Aspect);

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports = [
	{
		"group": "Movement",
		"order": 30000,
		"id": 4200,
		"name": "Smooth",
		"type": "Camera"
	},
	{
		"group": "Framing",
		"order": 20000,
		"id": 3700,
		"name": "Medium",
		"type": "Camera"
	},
	{
		"order": 50000,
		"id": 2200,
		"name": "Dark",
		"type": "Emotion"
	},
	{
		"group": "Time of day",
		"order": 40000,
		"id": 3500,
		"name": "Night",
		"type": "Setting"
	},
	{
		"order": 30000,
		"id": 300,
		"name": "Animals",
		"type": "Category"
	},
	{
		"order": 20000,
		"id": 200,
		"name": "Aerial",
		"type": "Category"
	},
	{
		"group": "Speed",
		"order": 10000,
		"id": 4300,
		"name": "Slow Motion",
		"type": "Camera"
	},
	{
		"group": "Movement",
		"order": 20000,
		"id": 4100,
		"name": "Shakey",
		"type": "Camera"
	},
	{
		"order": 150000,
		"id": 1500,
		"name": "Technology",
		"type": "Category"
	},
	{
		"order": 90000,
		"id": 900,
		"name": "Landscape",
		"type": "Category"
	},
	{
		"order": 100000,
		"id": 1000,
		"name": "Lifestyle",
		"type": "Category"
	},
	{
		"group": "Season",
		"order": 20000,
		"id": 2900,
		"name": "Summer",
		"type": "Setting"
	},
	{
		"order": 70000,
		"id": 700,
		"name": "Fitness",
		"type": "Category"
	},
	{
		"group": "Season",
		"order": 40000,
		"id": 3100,
		"name": "Winter",
		"type": "Setting"
	},
	{
		"order": 20000,
		"id": 1900,
		"name": "Sad",
		"type": "Emotion"
	},
	{
		"order": 10000,
		"id": 1800,
		"name": "Happy",
		"type": "Emotion"
	},
	{
		"order": 140000,
		"id": 1400,
		"name": "Sports",
		"type": "Category"
	},
	{
		"order": 120000,
		"id": 1200,
		"name": "People",
		"type": "Category"
	},
	{
		"order": 10000,
		"id": 100,
		"name": "Abstract",
		"type": "Category"
	},
	{
		"order": 110000,
		"id": 1100,
		"name": "Nature",
		"type": "Category"
	},
	{
		"group": "Location",
		"order": 20000,
		"id": 2700,
		"name": "Outside",
		"type": "Setting"
	},
	{
		"order": 30000,
		"id": 2000,
		"name": "Exciting",
		"type": "Emotion"
	},
	{
		"order": 160000,
		"id": 1600,
		"name": "Travel",
		"type": "Category"
	},
	{
		"group": "Movement",
		"order": 10000,
		"id": 4000,
		"name": "Static",
		"type": "Camera"
	},
	{
		"order": 105000,
		"id": 4600,
		"name": "Music",
		"type": "Category"
	},
	{
		"group": "Framing",
		"order": 10000,
		"id": 3600,
		"name": "Wide",
		"type": "Camera"
	},
	{
		"order": 40000,
		"id": 400,
		"name": "Business",
		"type": "Category"
	},
	{
		"order": 80000,
		"id": 800,
		"name": "Holidays",
		"type": "Category"
	},
	{
		"group": "Time of day",
		"order": 20000,
		"id": 3300,
		"name": "Day",
		"type": "Setting"
	},
	{
		"order": 50000,
		"id": 500,
		"name": "City & Urban",
		"type": "Category"
	},
	{
		"group": "Season",
		"order": 30000,
		"id": 3000,
		"name": "Fall",
		"type": "Setting"
	},
	{
		"order": 130000,
		"id": 1300,
		"name": "Religion",
		"type": "Category"
	},
	{
		"group": "Framing",
		"order": 40000,
		"id": 3900,
		"name": "Macro",
		"type": "Camera"
	},
	{
		"group": " ",
		"order": 30000,
		"id": 2500,
		"name": "High",
		"type": "Energy"
	},
	{
		"group": " ",
		"order": 20000,
		"id": 2400,
		"name": "Medium",
		"type": "Energy"
	},
	{
		"group": " ",
		"order": 10000,
		"id": 2300,
		"name": "Low",
		"type": "Energy"
	},
	{
		"group": "Time of day",
		"order": 30000,
		"id": 3400,
		"name": "Dusk",
		"type": "Setting"
	},
	{
		"group": "Season",
		"order": 10000,
		"id": 2800,
		"name": "Spring",
		"type": "Setting"
	},
	{
		"group": "Speed",
		"order": 20000,
		"id": 4400,
		"name": "Real Time",
		"type": "Camera"
	},
	{
		"group": "Speed",
		"order": 30000,
		"id": 4500,
		"name": "Timelapse",
		"type": "Camera"
	},
	{
		"order": 40000,
		"id": 2100,
		"name": "Chill",
		"type": "Emotion"
	},
	{
		"group": "Framing",
		"order": 30000,
		"id": 3800,
		"name": "Close-up",
		"type": "Camera"
	},
	{
		"order": 170000,
		"id": 1700,
		"name": "Worship",
		"type": "Category"
	},
	{
		"group": "Location",
		"order": 10000,
		"id": 2600,
		"name": "Inside",
		"type": "Setting"
	},
	{
		"group": "Time of day",
		"order": 10000,
		"id": 3200,
		"name": "Dawn",
		"type": "Setting"
	},
	{
		"order": 60000,
		"id": 600,
		"name": "Food & Drink",
		"type": "Category"
	}
];

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(19);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(33);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(220);

// EXTERNAL MODULE: ./node_modules/react-cognito/dist/react-cognito.js
var react_cognito = __webpack_require__(55);
var react_cognito_default = /*#__PURE__*/__webpack_require__.n(react_cognito);

// EXTERNAL MODULE: ./node_modules/react-motion/lib/react-motion.js
var react_motion = __webpack_require__(353);
var react_motion_default = /*#__PURE__*/__webpack_require__.n(react_motion);

// EXTERNAL MODULE: ./node_modules/color/index.js
var node_modules_color = __webpack_require__(351);
var color_default = /*#__PURE__*/__webpack_require__.n(node_modules_color);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(138);
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(357);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(17);

// EXTERNAL MODULE: ./src/actions/search.js + 1 modules
var search = __webpack_require__(915);

// EXTERNAL MODULE: ./src/actions/user.js
var user = __webpack_require__(222);

// EXTERNAL MODULE: ./src/lib/Motion.js
var Motion = __webpack_require__(352);

// EXTERNAL MODULE: ./src/lib/react.js
var lib_react = __webpack_require__(221);

// EXTERNAL MODULE: ./src/components/Button/Button.js
var Button = __webpack_require__(889);

// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__(355);
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);

// EXTERNAL MODULE: ./src/lib/Color.js
var Color = __webpack_require__(899);

// EXTERNAL MODULE: ./src/components/Hoverable/Hoverable.js
var Hoverable = __webpack_require__(894);

// EXTERNAL MODULE: ./src/components/Icons/Icons.js
var Icons = __webpack_require__(888);

// EXTERNAL MODULE: ./src/components/Typography/Typography.js
var Typography = __webpack_require__(887);

// EXTERNAL MODULE: ./src/components/Style/Style.js
var Style = __webpack_require__(350);

// CONCATENATED MODULE: ./src/components/FilterButton/FilterButton.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var SIZES = {
  small: {
    height: 3,
    borderWidth: 0.2,
    fontSize: '1.8rem',
    letterSpacing: 0
  },
  large: {
    height: 5,
    borderWidth: 0.4,
    fontSize: '2.2rem',
    letterSpacing: '-0.15px'
  }
};

var FilterButton_FilterButton = function (_React$PureComponent) {
  _inherits(FilterButton, _React$PureComponent);

  function FilterButton() {
    _classCallCheck(this, FilterButton);

    return _possibleConstructorReturn(this, (FilterButton.__proto__ || Object.getPrototypeOf(FilterButton)).apply(this, arguments));
  }

  _createClass(FilterButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          count = _props.count,
          lightColor = _props.lightColor,
          darkColor = _props.darkColor,
          baseColor = _props.baseColor,
          hover = _props.hover,
          checked = _props.checked,
          enabled = _props.enabled,
          onClick = _props.onClick,
          border = _props.border,
          size = _props.size,
          style = _props.style,
          arrow = _props.arrow,
          type = _props.type,
          working = _props.working,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['count', 'lightColor', 'darkColor', 'baseColor', 'hover', 'checked', 'enabled', 'onClick', 'border', 'size', 'style', 'arrow', 'type', 'working', 'children']);

      var sizeParams = SIZES['large'];

      var _sortByContrast = Object(Color["b" /* sortByContrast */])([lightColor, darkColor], baseColor),
          _sortByContrast2 = _slicedToArray(_sortByContrast, 2),
          colorB = _sortByContrast2[0],
          colorA = _sortByContrast2[1];

      var fontWeight = style.fontWeight,
          fontStyle = style.fontStyle,
          letterSpacing = style.letterSpacing,
          lineHeight = style.lineHeight,
          fontSize = style.fontSize,
          otherStyles = _objectWithoutProperties(style, ['fontWeight', 'fontStyle', 'letterSpacing', 'lineHeight', 'fontSize']);

      var arrowPaddingFactor = 1;
      if (arrow) {
        arrowPaddingFactor = 0.7;
      }

      var rightPaddingShift = -2;
      if (count > 0) {
        rightPaddingShift = 0;
      }

      var buttonStyle = _extends({
        height: sizeParams.height + 'rem',
        paddingLeft: (sizeParams.height - sizeParams.borderWidth) * arrowPaddingFactor + 'rem',
        paddingRight: sizeParams.height - sizeParams.borderWidth + rightPaddingShift + 'rem',
        borderRadius: '99999rem',
        borderStyle: 'solid',
        borderWidth: border ? sizeParams.borderWidth + 'rem' : 0,
        borderColor: colorA,
        cursor: enabled ? 'pointer' : 'not-allowed'
      }, otherStyles, {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      });

      var labelStyle = pickBy_default()({
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        letterSpacing: letterSpacing,
        lineHeight: lineHeight,
        fontSize: fontSize,
        margin: 0,
        position: 'relative',
        top: '-0.1rem'
      }, function (value) {
        return value !== undefined;
      });

      var workingStyle = {
        maxWidth: sizeParams.height * 0.7 + 'rem'
      };

      var arrowStyle = {
        display: arrow ? 'block' : 'none',
        position: 'relative',
        top: '0.2rem'
      };

      var hovering = hover && enabled;

      var animatedDefault = {
        hover: 0,
        working: 0,
        arrow: 0
      };
      var animatedCurrent = {
        hover: hovering ? 1 : animatedDefault.hover,
        working: working ? 1 : animatedDefault.working
      };
      var animatedCurrentArrow = {
        arrow: hovering ? 0.7 : animatedDefault.arrow
      };

      return _jsx(react_motion["Motion"], {
        defaultStyle: animatedDefault,
        style: _extends({}, Object(Motion["d" /* springify */])(animatedCurrent, {
          stiffness: hovering || working ? 180 : 100,
          damping: hovering || working ? 25 : 35
        }), Object(Motion["d" /* springify */])(animatedCurrentArrow, {
          stiffness: hovering ? 75 : 75,
          damping: hovering ? 0 : 20
        }))
      }, void 0, function (tween) {
        var colorChange = Math.max(tween.hover * Number(!arrow), tween.working);
        // Animated properties.
        var buttonStyleMerged = _extends({}, buttonStyle, {
          color: color_default()(colorA).mix(color_default()(colorB), colorChange).string(),
          backgroundColor: color_default()('transparent').mix(color_default()(colorA), colorChange).string()
        });
        var labelStyleMerged = _extends({
          fontFamily: 'Calibre',
          fontSize: sizeParams.fontSize,
          letterSpacing: sizeParams.letterSpacing,
          fontWeight: 600
        }, labelStyle, {
          opacity: tween.working * -1 + 1,
          whiteSpace: 'nowrap',
          display: 'flex',
          alignItems: 'center'
        });
        var workingContainerStyle = {
          position: 'absolute',
          transformOrigin: '50% 50%',
          transform: 'scale(' + (0.8 + (tween.working * -1 + 1) * 1) + ')'
        };
        var workingStyleMerged = _extends({}, workingStyle, {
          opacity: tween.working > 0.5 ? tween.working : 0
        });
        var arrowStyleMerged = _extends({}, arrowStyle, {
          opacity: labelStyleMerged.opacity,
          left: (sizeParams.height - sizeParams.borderWidth) * 0.4 + tween.arrow + 'rem'
        });

        return _jsx('button', {
          disabled: !enabled,
          style: buttonStyleMerged,
          onClick: onClick,
          type: type
        }, void 0, _jsx('span', {
          style: labelStyleMerged
        }, void 0, ' ', _jsx('span', {}, void 0, _jsx(Icons["r" /* Filters */], {
          color: buttonStyleMerged.color,
          style: {
            position: 'relative',
            left: '-2rem',
            top: '0.25rem'
          }
        })), _jsx('span', {
          style: { position: 'relative', left: '-1rem' }
        }, void 0, 'All Filters'), _jsx('div', {
          style: {
            position: 'absolute',
            top: '0',
            right: '-1.8rem',
            display: count ? 'block' : 'none',
            marginLeft: '2rem',
            marginRight: '-2rem',
            borderRadius: '99999rem',
            width: '3rem',
            height: '3rem',
            lineHeight: '1.3em',
            color: colorA,
            backgroundColor: Style["a" /* default */].Colors.shadow5
          }
        }, void 0, count)));
      });
    }
  }]);

  return FilterButton;
}(react_default.a.PureComponent);

FilterButton_FilterButton.defaultProps = {
  count: 0,
  baseColor: Style["a" /* default */].Colors.white,
  lightColor: Style["a" /* default */].Colors.white,
  darkColor: Style["a" /* default */].Colors.black,
  hover: false,
  checked: false,
  enabled: true,
  onClick: function onClick() {},
  border: true,
  size: 'small',
  style: constants["l" /* EMPTY_OBJECT */],
  arrow: false,
  type: undefined,
  working: false,
  children: ' '
};


/* harmony default export */ var components_FilterButton_FilterButton = (Object(Hoverable["c" /* withHover */])({ wrapper: 'span' })(FilterButton_FilterButton));
// CONCATENATED MODULE: ./src/components/SearchButton/SearchButton.js
var SearchButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SearchButton__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SearchButton__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var SearchButton__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SearchButton__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function SearchButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchButton__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SearchButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SearchButton_animatedDefault = {
  hover: 0,
  iconOnly: 0
};

var SearchButton_SearchButton = function (_React$PureComponent) {
  SearchButton__inherits(SearchButton, _React$PureComponent);

  function SearchButton() {
    SearchButton__classCallCheck(this, SearchButton);

    return SearchButton__possibleConstructorReturn(this, (SearchButton.__proto__ || Object.getPrototypeOf(SearchButton)).apply(this, arguments));
  }

  SearchButton__createClass(SearchButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          iconOnly = _props.iconOnly,
          lightColor = _props.lightColor,
          darkColor = _props.darkColor,
          baseColor = _props.baseColor,
          hover = _props.hover,
          enabled = _props.enabled,
          onClick = _props.onClick,
          border = _props.border,
          style = _props.style,
          children = _props.children,
          otherProps = SearchButton__objectWithoutProperties(_props, ['iconOnly', 'lightColor', 'darkColor', 'baseColor', 'hover', 'enabled', 'onClick', 'border', 'style', 'children']);

      var sizeParams = {
        height: 5,
        borderWidth: 0.4,
        fontSize: '2.2rem',
        letterSpacing: '-0.15px'
      };

      var _sortByContrast = Object(Color["b" /* sortByContrast */])([lightColor, darkColor], baseColor),
          _sortByContrast2 = SearchButton__slicedToArray(_sortByContrast, 2),
          colorB = _sortByContrast2[0],
          colorA = _sortByContrast2[1];

      var fontWeight = style.fontWeight,
          fontStyle = style.fontStyle,
          letterSpacing = style.letterSpacing,
          lineHeight = style.lineHeight,
          fontSize = style.fontSize,
          otherStyles = SearchButton__objectWithoutProperties(style, ['fontWeight', 'fontStyle', 'letterSpacing', 'lineHeight', 'fontSize']);

      var buttonStyle = SearchButton__extends({
        height: sizeParams.height + 'rem',
        borderRadius: '99999rem',
        borderStyle: 'solid',
        borderWidth: border ? sizeParams.borderWidth + 'rem' : 0,
        borderColor: colorA,
        cursor: enabled ? 'pointer' : 'not-allowed'
      }, otherStyles, {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      });

      var labelStyle = pickBy_default()({
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        letterSpacing: letterSpacing,
        lineHeight: lineHeight,
        fontSize: fontSize,
        margin: 0,
        position: 'relative',
        top: '-0.1rem'
      }, function (value) {
        return value !== undefined;
      });

      var workingStyle = {
        maxWidth: sizeParams.height * 0.7 + 'rem'
      };

      var hovering = hover && enabled;
      var animatedCurrent = {
        hover: hovering ? 1 : SearchButton_animatedDefault.hover
      };
      var animatedCurrentIconOnly = {
        iconOnly: iconOnly ? 1 : SearchButton_animatedDefault.iconOnly
      };

      return SearchButton__jsx(react_motion["Motion"], {
        defaultStyle: SearchButton_animatedDefault,
        style: SearchButton__extends({}, Object(Motion["d" /* springify */])(animatedCurrent, {
          stiffness: hovering ? 180 : 100,
          damping: hovering ? 25 : 35
        }), Object(Motion["d" /* springify */])(animatedCurrentIconOnly, {
          stiffness: iconOnly ? 200 : 200,
          damping: iconOnly ? 70 : 30
        }))
      }, void 0, function (tween) {
        var iconOnlyInverted = tween.iconOnly * -1 + 1;

        // Animated properties.
        var buttonStyleMerged = SearchButton__extends({}, buttonStyle, {
          paddingLeft: (sizeParams.height * 0.5 - sizeParams.borderWidth) * iconOnlyInverted + 'rem',
          paddingRight: (sizeParams.height * 0.5 - sizeParams.borderWidth) * iconOnlyInverted + 'rem',
          minWidth: '5.2rem',
          color: color_default()(colorA).mix(color_default()(colorB), tween.hover).string(),
          backgroundColor: color_default()('transparent').mix(color_default()(colorA), tween.hover).string()
        });
        var labelStyleMerged = SearchButton__extends({
          fontFamily: 'Calibre',
          fontSize: sizeParams.fontSize,
          letterSpacing: sizeParams.letterSpacing,
          fontWeight: 600
        }, labelStyle, {
          pointerEvents: 'none',
          opacity: 1,
          whiteSpace: 'nowrap',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center'
        });
        var textStyle = {
          maxWidth: 9 * Math.max(iconOnlyInverted * 3 - 2, 0) + 'rem',
          opacity: Math.max(iconOnlyInverted * 3 - 2, 0)
        };

        return SearchButton__jsx('button', {
          disabled: !enabled,
          style: buttonStyleMerged,
          onClick: onClick
        }, void 0, SearchButton__jsx('span', {
          style: labelStyleMerged
        }, void 0, SearchButton__jsx('span', {}, void 0, SearchButton__jsx(Icons["F" /* Search */], {
          color: buttonStyleMerged.color,
          style: {
            position: 'relative',
            // left: `${-2 * iconOnlyInverted}rem`,
            top: '0.25rem'
            // paddingRight: '2rem',
          }
        })), SearchButton__jsx('span', {
          style: textStyle
        }, void 0, SearchButton__jsx('span', {
          style: { paddingLeft: '1rem' }
        }), 'Search')));
      });
    }
  }]);

  return SearchButton;
}(react_default.a.PureComponent);

SearchButton_SearchButton.defaultProps = {
  iconOnly: false,
  baseColor: Style["a" /* default */].Colors.white,
  lightColor: Style["a" /* default */].Colors.white,
  darkColor: Style["a" /* default */].Colors.black,
  hover: false,
  enabled: true,
  onClick: function onClick() {},
  border: true,
  style: constants["l" /* EMPTY_OBJECT */],
  children: ' '
};


/* harmony default export */ var components_SearchButton_SearchButton = (Object(Hoverable["c" /* withHover */])({ wrapper: 'span' })(SearchButton_SearchButton));
// EXTERNAL MODULE: ./src/components/Link/Link.js
var Link = __webpack_require__(890);

// EXTERNAL MODULE: ./src/lib/intercom.js
var intercom = __webpack_require__(936);

// EXTERNAL MODULE: ./src/actions/runtime.js
var runtime = __webpack_require__(354);

// CONCATENATED MODULE: ./src/components/MobileNav/MobileNav.js
var MobileNav__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MobileNav__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var MobileNav__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MobileNav__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function MobileNav__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MobileNav__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MobileNav__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var MobileNav_MobileNav = function (_React$PureComponent) {
  MobileNav__inherits(MobileNav, _React$PureComponent);

  function MobileNav() {
    var _ref;

    var _temp, _this, _ret;

    MobileNav__classCallCheck(this, MobileNav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = MobileNav__possibleConstructorReturn(this, (_ref = MobileNav.__proto__ || Object.getPrototypeOf(MobileNav)).call.apply(_ref, [this].concat(args))), _this), _this.checkForClose = function (e) {
      if (e.target.tagName === 'A') {
        _this.props.close();
      }
    }, _this.doAndClose = function (func) {
      return function (e) {
        _this.props.close();
        func();
      };
    }, _temp), MobileNav__possibleConstructorReturn(_this, _ret);
  }

  MobileNav__createClass(MobileNav, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.setScrollPrison(true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.setScrollPrison(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          responsive = _props.responsive,
          loggedIn = _props.loggedIn,
          logout = _props.logout,
          showSignup = _props.showSignup,
          close = _props.close,
          otherProps = MobileNav__objectWithoutProperties(_props, ['responsive', 'loggedIn', 'logout', 'showSignup', 'close']);

      var containerStyle = {
        backgroundColor: Style["a" /* default */].Colors.black,
        color: Style["a" /* default */].Colors.white,
        position: 'relative',
        padding: '0rem 8vw 4rem'
      };

      var brandmarkStyle = {
        display: 'block',
        fill: Style["a" /* default */].Colors.white,
        maxWidth: '6.6rem',
        width: '100vw'
      };
      var navBrandmarkStyle = MobileNav__extends({}, brandmarkStyle, {
        opacity: 1
      });
      var centerBrandmarkStyle = MobileNav__extends({}, brandmarkStyle, {
        opacity: 0
      });

      var labelStyle = {
        opacity: 0.5,
        display: 'block',
        padding: '5rem 0 2rem'
      };

      var bottomRowStyle = {
        paddingTop: '4rem',
        display: 'flex',
        flexDirection: 'column'
      };

      var bottomCellStyle = {
        paddingTop: '1rem'
      };

      var navLinkStyle = {
        margin: '1rem 0'
      };

      var subLinkStyle = {
        margin: '0.5rem 0'
      };

      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE) {
        containerStyle.padding = '0rem 8vw 7rem';
        labelStyle.padding = '8rem 0 2rem';
        delete navLinkStyle.margin;
        delete subLinkStyle.margin;
      }

      return MobileNav__jsx('div', {
        style: {
          position: 'fixed',
          zIndex: 500,
          top: 0,
          left: 0,
          minHeight: '100vh',
          width: '100vw',
          backgroundColor: Style["a" /* default */].Colors.black,
          opacity: 1,
          pointerEvents: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }
      }, void 0, MobileNav__jsx('div', {
        style: MobileNav__extends({}, containerStyle),
        onClick: this.checkForClose
      }, void 0, MobileNav__jsx('div', {}, void 0, MobileNav__jsx(Icons["b" /* Brandmark */], {
        style: MobileNav__extends({}, navBrandmarkStyle)
      }), MobileNav__jsx(Typography["k" /* L4 */], {
        style: labelStyle
      }, void 0, 'STORYTAPE NAVIGATION'), MobileNav__jsx(NavLink, {
        style: navLinkStyle,
        to: '/'
      }, void 0, 'Home'), MobileNav__jsx(NavLink, {
        style: navLinkStyle,
        to: '/how-it-works'
      }, void 0, 'How it Works'), MobileNav__jsx(NavLink, {
        style: navLinkStyle,
        to: '/pricing'
      }, void 0, 'Pricing Plans'), MobileNav__jsx(NavLink, {
        style: navLinkStyle,
        to: '/browse'
      }, void 0, 'Browse Scenes'), MobileNav__jsx(NavLink, {
        style: navLinkStyle,
        to: '/legal'
      }, void 0, 'Privacy & Terms'), MobileNav__jsx(NavLink, {
        style: navLinkStyle,
        onClick: this.doAndClose(function () {
          return intercom["a" /* default */].startConversation();
        })
      }, void 0, 'Get Support'), !loggedIn && MobileNav__jsx(Button["a" /* default */], {
        size: 'large',
        style: { marginTop: '5rem' },
        baseColor: Style["a" /* default */].Colors.black,
        onClick: this.doAndClose(showSignup)
      }, void 0, 'Sign Up'), loggedIn && MobileNav__jsx('div', {}, void 0, MobileNav__jsx(NavLink, {
        style: navLinkStyle,
        to: '/dashboard'
      }, void 0, 'Dashboard'), MobileNav__jsx('div', {
        style: { paddingLeft: '2rem' }
      }, void 0, MobileNav__jsx(SubLink, {
        style: subLinkStyle,
        to: '/dashboard/licenses'
      }, void 0, 'Licensed Clips'), MobileNav__jsx(SubLink, {
        style: subLinkStyle,
        to: '/dashboard/subscription'
      }, void 0, 'My Subscription'), MobileNav__jsx(SubLink, {
        style: subLinkStyle,
        onClick: this.doAndClose(logout)
      }, void 0, 'Sign Out'))))));
    }
  }]);

  return MobileNav;
}(react_default.a.PureComponent);

MobileNav_MobileNav.defaultProps = {};


function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
    loggedIn: state.cognito.state === react_cognito["CognitoState"].LOGGED_IN
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: function logout() {
      return dispatch(Object(user["e" /* logout */])());
    },
    showSignup: function showSignup() {
      return dispatch(Object(user["h" /* showSignup */])());
    },
    setScrollPrison: function setScrollPrison(locked) {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('scrollPrison', locked));
    }
  };
}

/* harmony default export */ var components_MobileNav_MobileNav = (Object(es["connect"])(mapStateToProps, mapDispatchToProps)(MobileNav_MobileNav));

function NavLink(props) {
  var style = props.style,
      otherProps = MobileNav__objectWithoutProperties(props, ['style']);

  return MobileNav__jsx(Typography["e" /* H5 */], {
    style: style
  }, void 0, react_default.a.createElement(
    Link["a" /* default */],
    otherProps,
    otherProps.children
  ));
}

function SubLink(props) {
  var style = props.style,
      otherProps = MobileNav__objectWithoutProperties(props, ['style']);

  var merged = style || constants["l" /* EMPTY_OBJECT */];
  return MobileNav__jsx(Typography["f" /* H6 */], {
    style: MobileNav__extends({ fontWeight: 400 }, merged)
  }, void 0, react_default.a.createElement(
    Link["a" /* default */],
    otherProps,
    otherProps.children
  ));
}
// EXTERNAL MODULE: ./src/components/LicenseMeter/LicenseMeter.js
var LicenseMeter = __webpack_require__(1144);

// EXTERNAL MODULE: ./src/components/Toggle/Toggle.js
var Toggle = __webpack_require__(935);

// EXTERNAL MODULE: ./src/lib/tags.js
var tags = __webpack_require__(1070);

// EXTERNAL MODULE: ./src/assets/tags.json
var assets_tags = __webpack_require__(1072);
var tags_default = /*#__PURE__*/__webpack_require__.n(assets_tags);

// CONCATENATED MODULE: ./src/components/TagToggles/TagToggles.js
var TagToggles__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TagToggles__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var TagToggles__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ICON_MAP;

function TagToggles__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TagToggles__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TagToggles__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TagToggles__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















var ICON_MAP = (_ICON_MAP = {}, _defineProperty(_ICON_MAP, 1800, Icons["p" /* EmotionHappy */]), _defineProperty(_ICON_MAP, 1900, Icons["q" /* EmotionSad */]), _defineProperty(_ICON_MAP, 2000, Icons["o" /* EmotionExciting */]), _defineProperty(_ICON_MAP, 2100, Icons["m" /* EmotionChill */]), _defineProperty(_ICON_MAP, 2200, Icons["n" /* EmotionDark */]), _defineProperty(_ICON_MAP, 2600, Icons["v" /* Inside */]), _defineProperty(_ICON_MAP, 2700, Icons["C" /* Outside */]), _ICON_MAP);

var TagToggles_TagToggles = function (_React$PureComponent) {
  TagToggles__inherits(TagToggles, _React$PureComponent);

  function TagToggles(props) {
    TagToggles__classCallCheck(this, TagToggles);

    var _this = TagToggles__possibleConstructorReturn(this, (TagToggles.__proto__ || Object.getPrototypeOf(TagToggles)).call(this, props));

    _this.state = {
      allTags: Object(tags["d" /* groupTags */])(tags_default.a)
    };
    return _this;
  }

  TagToggles__createClass(TagToggles, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var minButtonWidth = '5rem';
      if (this.props.responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT) {
        minButtonWidth = '10rem';
      }
      if (this.props.responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE) {
        minButtonWidth = '13rem';
      }

      var _props = this.props,
          activeTagIds = _props.activeTagIds,
          toggleTag = _props.toggleTag,
          ref = _props.ref,
          otherProps = TagToggles__objectWithoutProperties(_props, ['activeTagIds', 'toggleTag', 'ref']);

      var typeStyle = {
        marginTop: '3rem',
        marginBottom: '2rem'
      };

      var groupStyle = {
        display: 'block',
        marginBottom: '0.5rem',
        fontWeight: 400,
        letterSpacing: '0.07rem',
        textTransform: 'uppercase',
        color: Style["a" /* default */].Colors.shadow2,
        opacity: 0.5
      };

      return react_default.a.createElement(
        'div',
        { ref: ref },
        TagToggles__jsx('div', {}, void 0, TagToggles__jsx(Typography["e" /* H5 */], {
          style: typeStyle
        }, void 0, 'Category'), TagToggles__jsx('div', {
          style: { margin: '0 -0.5rem 2rem', maxWidth: '75rem' }
        }, void 0, this.state.allTags['Category']['undefined'].map(function (tag) {
          return TagToggles__jsx(Hoverable["a" /* Hover */], {}, tag.id, TagToggles__jsx(TagToggles_RoundedButton, {
            style: { minWidth: minButtonWidth },
            checked: activeTagIds.includes(tag.id) ? true : undefined,
            onClick: function onClick(e) {
              return toggleTag(tag.id);
            }
          }, void 0, tag.name));
        }))),
        TagToggles__jsx('div', {
          style: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            maxWidth: '80rem'
          }
        }, void 0, TagToggles__jsx('div', {}, void 0, TagToggles__jsx(Typography["e" /* H5 */], {
          style: TagToggles__extends({}, typeStyle, { marginBottom: '1rem' })
        }, void 0, 'Emotion'), TagToggles__jsx('div', {
          style: { margin: '0 2rem 0 -0.5rem' }
        }, void 0, this.state.allTags['Emotion']['undefined'].map(function (tag) {
          return TagToggles__jsx(Hoverable["a" /* Hover */], {}, tag.id, TagToggles__jsx(TagToggles_IconButton, {
            icon: ICON_MAP[tag.id],
            checked: activeTagIds.includes(tag.id) ? true : undefined,
            onClick: function onClick(e) {
              return toggleTag(tag.id);
            }
          }, void 0, tag.name));
        }))), TagToggles__jsx('div', {}, void 0, TagToggles__jsx(Typography["e" /* H5 */], {
          style: typeStyle
        }, void 0, 'Energy'), TagToggles__jsx(TagToggles_ButtonGroup, {}, void 0, this.state.allTags['Energy'][' '].map(function (tag) {
          return TagToggles__jsx(Hoverable["a" /* Hover */], {
            style: { minWidth: minButtonWidth }
          }, tag.id, TagToggles__jsx(TagToggles_RoundedButton, {
            checked: activeTagIds.includes(tag.id) ? true : undefined,
            onClick: function onClick(e) {
              return toggleTag(tag.id);
            }
          }, void 0, tag.name));
        })))),
        TagToggles__jsx('div', {}, void 0, TagToggles__jsx(Typography["e" /* H5 */], {
          style: typeStyle
        }, void 0, 'Setting'), ['Location', 'Season', 'Time of day'].map(function (groupKey) {
          return TagToggles__jsx('div', {}, groupKey, TagToggles__jsx(Typography["j" /* L3 */], {
            style: groupStyle
          }, void 0, groupKey.toUpperCase()), TagToggles__jsx(TagToggles_ButtonGroup, {}, void 0, _this2.state.allTags['Setting'][groupKey].map(function (tag) {
            return TagToggles__jsx(Hoverable["a" /* Hover */], {
              style: { minWidth: minButtonWidth }
            }, tag.id, TagToggles__jsx(TagToggles_RoundedButton, {
              checked: activeTagIds.includes(tag.id) ? true : undefined,
              onClick: function onClick(e) {
                return toggleTag(tag.id);
              },
              icon: ICON_MAP[tag.id]
            }, void 0, tag.name));
          })));
        })),
        TagToggles__jsx('div', {}, void 0, TagToggles__jsx(Typography["e" /* H5 */], {
          style: typeStyle
        }, void 0, 'Camera'), ['Framing', 'Movement', 'Speed'].map(function (groupKey) {
          return TagToggles__jsx('div', {}, groupKey, TagToggles__jsx(Typography["j" /* L3 */], {
            style: groupStyle
          }, void 0, groupKey.toUpperCase()), TagToggles__jsx(TagToggles_ButtonGroup, {}, void 0, _this2.state.allTags['Camera'][groupKey].map(function (tag) {
            return TagToggles__jsx(Hoverable["a" /* Hover */], {
              style: { minWidth: minButtonWidth }
            }, tag.id, TagToggles__jsx(TagToggles_RoundedButton, {
              checked: activeTagIds.includes(tag.id) ? true : undefined,
              onClick: function onClick(e) {
                return toggleTag(tag.id);
              }
            }, void 0, tag.name));
          })));
        }))
      );
    }
  }]);

  return TagToggles;
}(react_default.a.PureComponent);

TagToggles_TagToggles.defaultProps = {
  activeTagIds: constants["k" /* EMPTY_ARRAY */],
  toggleTag: function toggleTag() {},
  ref: function ref() {}
};


function TagToggles_mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
    activeTagIds: state.search.tags
  };
}

function TagToggles_mapDispatchToProps(dispatch) {
  return {
    toggleTag: function toggleTag(tagId) {
      return dispatch(Object(search["n" /* toggleTag */])(tagId));
    }
  };
}

/* harmony default export */ var components_TagToggles_TagToggles = (Object(es["connect"])(TagToggles_mapStateToProps, TagToggles_mapDispatchToProps)(TagToggles_TagToggles));

var TagToggles_ButtonGroup = function (_React$PureComponent2) {
  TagToggles__inherits(ButtonGroup, _React$PureComponent2);

  function ButtonGroup() {
    TagToggles__classCallCheck(this, ButtonGroup);

    return TagToggles__possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).apply(this, arguments));
  }

  TagToggles__createClass(ButtonGroup, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var childCount = react_default.a.Children.count(children);

      if (childCount > 1) {
        var firstStyle = {
          borderBottomRightRadius: 0,
          borderTopRightRadius: 0,
          marginRight: 0
        };

        var middleStyle = {
          borderRadius: 0,
          marginLeft: '-0.15rem',
          marginRight: 0
        };

        var lastStyle = {
          borderBottomLeftRadius: 0,
          borderTopLeftRadius: 0,
          marginLeft: '-0.15rem'
        };

        children = react_default.a.Children.map(children, function (child, index) {
          if (index === 0) {
            return react_default.a.cloneElement(child, {
              style: TagToggles__extends({}, child.props.style, firstStyle)
            });
          } else if (index + 1 === childCount) {
            return react_default.a.cloneElement(child, {
              style: TagToggles__extends({}, child.props.style, lastStyle)
            });
          } else {
            return react_default.a.cloneElement(child, {
              style: TagToggles__extends({}, child.props.style, middleStyle)
            });
          }
        });
      }

      return TagToggles__jsx('div', {
        style: TagToggles__extends({ margin: '0 -0.5rem 2rem' }, this.props.style)
      }, void 0, children);
    }
  }]);

  return ButtonGroup;
}(react_default.a.PureComponent);

TagToggles_ButtonGroup.defaultProps = {
  style: constants["l" /* EMPTY_OBJECT */]
};

var TagToggles_RoundedButton = function (_React$PureComponent3) {
  TagToggles__inherits(RoundedButton, _React$PureComponent3);

  function RoundedButton() {
    TagToggles__classCallCheck(this, RoundedButton);

    return TagToggles__possibleConstructorReturn(this, (RoundedButton.__proto__ || Object.getPrototypeOf(RoundedButton)).apply(this, arguments));
  }

  TagToggles__createClass(RoundedButton, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          hover = _props2.hover,
          checked = _props2.checked,
          icon = _props2.icon,
          style = _props2.style,
          children = _props2.children,
          otherProps = TagToggles__objectWithoutProperties(_props2, ['hover', 'checked', 'icon', 'style', 'children']);

      var borderColor = Style["a" /* default */].Colors.shadow3;
      var fillColor = Style["a" /* default */].Colors.white;
      var labelColor = Style["a" /* default */].Colors.shadow3;
      if (hover) {
        borderColor = Style["a" /* default */].Colors.black;
        labelColor = Style["a" /* default */].Colors.black;
      }
      if (checked) {
        borderColor = Style["a" /* default */].Colors.black;
        fillColor = Style["a" /* default */].Colors.black;
        labelColor = Style["a" /* default */].Colors.white;
      }

      var buttonStyle = TagToggles__extends({
        position: hover ? 'relative' : 'static',
        zIndex: 2,
        display: 'inline-flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        minWidth: '13rem',
        minHeight: '4rem',
        margin: '0.5rem',
        borderRadius: '0.7rem',
        border: borderColor + ' solid 0.15rem',
        backgroundColor: fillColor
      }, style);
      var labelStyle = {
        padding: 0,
        margin: 0,
        letterSpacing: 0,
        color: labelColor
      };

      var iconElement = null;
      if (icon) {
        var Icon = icon;
        iconElement = TagToggles__jsx(Icon, {
          color: labelColor
        });
      }

      return react_default.a.createElement(
        'button',
        TagToggles__extends({}, otherProps, { style: buttonStyle }),
        iconElement,
        TagToggles__jsx(Typography["g" /* L1 */], {
          style: labelStyle
        }, void 0, children)
      );
    }
  }]);

  return RoundedButton;
}(react_default.a.PureComponent);

TagToggles_RoundedButton.defaultProps = {
  hover: false,
  checked: false,
  icon: false,
  style: constants["l" /* EMPTY_OBJECT */]
};

var TagToggles_IconButton = function (_React$PureComponent4) {
  TagToggles__inherits(IconButton, _React$PureComponent4);

  function IconButton() {
    TagToggles__classCallCheck(this, IconButton);

    return TagToggles__possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).apply(this, arguments));
  }

  TagToggles__createClass(IconButton, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          hover = _props3.hover,
          checked = _props3.checked,
          icon = _props3.icon,
          style = _props3.style,
          children = _props3.children,
          otherProps = TagToggles__objectWithoutProperties(_props3, ['hover', 'checked', 'icon', 'style', 'children']);

      var fillColor = Style["a" /* default */].Colors.shadow4;
      if (hover) {
        fillColor = Style["a" /* default */].Colors.shadow3;
      }
      if (checked) {
        fillColor = Style["a" /* default */].Colors.black;
      }

      var buttonStyle = TagToggles__extends({
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        border: 0,
        padding: '0 0.35rem'
      }, style);
      var labelStyle = {
        fontWeight: 400,
        letterSpacing: '0.07rem',
        textTransform: 'uppercase',
        color: fillColor
      };
      var iconStyle = {
        maxWidth: '6.5rem',
        margin: '-0.5rem'
      };

      var Icon = icon;
      var iconElement = TagToggles__jsx(Icon, {
        color: fillColor,
        style: iconStyle
      });

      return react_default.a.createElement(
        'button',
        TagToggles__extends({}, otherProps, { style: buttonStyle }),
        iconElement,
        TagToggles__jsx(Typography["k" /* L4 */], {
          style: labelStyle
        }, void 0, children)
      );
    }
  }]);

  return IconButton;
}(react_default.a.PureComponent);

TagToggles_IconButton.defaultProps = {
  hover: false,
  checked: false,
  style: constants["l" /* EMPTY_OBJECT */]
};
// CONCATENATED MODULE: ./src/components/Header/Header.js
var Header__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Header__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Header__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var AUTOSEARCH_TIMEOUT = 750;

var LINK_SHAPE = prop_types_default.a.shape({
  text: prop_types_default.a.string.isRequired,
  href: prop_types_default.a.string,
  onClick: prop_types_default.a.func
});

var _ref2 = Header__jsx(Icons["O" /* X */], {});

var _ref4 = Header__jsx(components_TagToggles_TagToggles, {});

var Header_Header = function (_MyPureComponent) {
  Header__inherits(Header, _MyPureComponent);

  function Header(props) {
    Header__classCallCheck(this, Header);

    var _this = Header__possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.historyChanged = function (location, action) {
      if (action !== 'PUSH') {
        return;
      }

      if (!_this.state.searchText) {
        _this.searchInput.blur();
        _this.props.setSearchText(undefined);
      }
    };

    _this.toggleSearch = function (e) {
      if (_this.props.searchText === undefined) {
        _this.props.setSearchText('');
        _this.setState({ searchText: '' });
        setTimeout(function () {
          return clearTimeout(_this.autosearchTimeout);
        }, AUTOSEARCH_TIMEOUT * 0.7);
        _this.searchInput.focus();
      } else {
        _this.searchInput.blur();
        _this.props.setSearchText(undefined);
      }
    };

    _this.inputKeyDown = function (e) {
      if (e.key === 'Escape' && _this.props.searchText !== undefined) {
        _this.toggleSearch();
      }
    };

    _this.toggleFilters = function (e) {
      var showFilters = !_this.state.openFilters;
      _this.setState({ openFilters: showFilters });
      if (showFilters) {
        document.documentElement.style['maxHeight'] = '100vh';
        document.documentElement.style['overflowY'] = 'hidden';
      } else {
        _this.tagsContainer.scrollTop = 0;
        document.documentElement.style['maxHeight'] = '';
        document.documentElement.style['overflowY'] = '';
      }
    };

    _this.submitSearch = function (e) {
      clearTimeout(_this.autosearchTimeout);
      e && e.preventDefault && e.preventDefault();
      _this.props.setSearchText(_this.state.searchText);
    };

    _this.onSearchChange = function (e) {
      _this.setState({ searchText: e.target.value });
      clearTimeout(_this.autosearchTimeout);
      _this.autosearchTimeout = setTimeout(_this.submitSearch, AUTOSEARCH_TIMEOUT);
    };

    _this.onClickX = function (e) {
      if (_this.state.openFilters) {
        return _this.toggleFilters();
      } else if (_this.state.searchText !== undefined) {
        _this.toggleSearch();
      }
    };

    _this.toggleMobileNav = function () {
      _this.setState({ showMobileNav: !_this.state.showMobileNav });
    };

    _this.state = {
      searchText: props.searchText,
      openFilters: false,
      showMobileNav: false
    };
    _this.autosearchTimeout;
    _this.unlisten;
    _this.tagsContainer;
    return _this;
  }

  Header__createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.unlisten = src_history["a" /* default */].listen(this.historyChanged);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unlisten();
      document.documentElement.style['maxHeight'] = '';
      document.documentElement.style['overflow'] = '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          responsive = _props.responsive,
          activeTagIds = _props.activeTagIds,
          searchText = _props.searchText,
          brandmarkColor = _props.brandmarkColor,
          brandmarkLink = _props.brandmarkLink,
          crumbs = _props.crumbs,
          navLinks = _props.navLinks,
          showFilterBar = _props.showFilterBar,
          backgroundColor = _props.backgroundColor,
          setSearchText = _props.setSearchText,
          profile = _props.profile,
          loggedIn = _props.loggedIn,
          doSignup = _props.doSignup,
          doSignin = _props.doSignin,
          searchResultsMessage = _props.searchResultsMessage,
          clearTags = _props.clearTags,
          showSignin = _props.showSignin,
          showSignup = _props.showSignup,
          showNav = _props.showNav,
          otherProps = Header__objectWithoutProperties(_props, ['responsive', 'activeTagIds', 'searchText', 'brandmarkColor', 'brandmarkLink', 'crumbs', 'navLinks', 'showFilterBar', 'backgroundColor', 'setSearchText', 'profile', 'loggedIn', 'doSignup', 'doSignin', 'searchResultsMessage', 'clearTags', 'showSignin', 'showSignup', 'showNav']);

      var mobileNavMode = responsive < constants["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE;

      var showFilters = !!this.state.openFilters;
      var showSearchInput = searchText !== undefined && showFilterBar && !showFilters;

      var realCrumbs = crumbs.slice(0, 1);
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT) {
        realCrumbs = crumbs;
      }
      if (showSearchInput) {
        realCrumbs = [{ text: '' }];
        if (crumbs.length > 0 && responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE) {
          realCrumbs.unshift({
            text: crumbs[0].text,
            onClick: this.toggleSearch
          });
        }
      }
      if (showFilters) {
        realCrumbs = [{ text: 'Choose Filters', onClick: function onClick() {} }];
        if (crumbs.length > 0 && responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE) {
          realCrumbs.unshift({
            text: get_default()(crumbs[0], 'text'),
            onClick: this.toggleFilters
          });
        }
      }

      var showWordmark = responsive < constants["C" /* RESPONSIVE_SIZE */].TABLET_TABLET && (loggedIn || responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE);
      var showNavLinks = showNav && realCrumbs.length < 2 && !showSearchInput && !mobileNavMode;
      var showProfileCard = !showSearchInput && !showFilters && !mobileNavMode;
      var showMobileNav = showNav && !showSearchInput && !showFilters && mobileNavMode;

      var navHeight = mobileNavMode ? 8.5 : 9.3;
      var filterHeight = 9.8;

      var searchIconOnly = true;
      var sidePadding = 2;
      var filterBarIndent = 0;
      var closeShift = 3.9;
      var crumbShift = 1;
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE) {
        searchIconOnly = false;
      }
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT) {
        sidePadding = 4;
        filterBarIndent = 4;
        closeShift = 3.9;
        crumbShift = 0;
      }
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE) {
        sidePadding = 7.2;
        filterBarIndent = 7.8;
      }

      var motionStyleDefault = {
        filterTags: 0,
        navLinks: 1,
        xOpacity: 0,
        brandOpacity: 1,
        profileOpacity: 1
      };
      var motionStyleCurrent = {
        filterTags: showFilters ? 1 : 0,
        navLinks: showNavLinks ? 1 : 0,
        xOpacity: showSearchInput ? 1 : 0,
        brandOpacity: showSearchInput ? 0 : 1,
        profileOpacity: showProfileCard ? 1 : 0
      };

      var navbarStyle = {
        boxShadow: backgroundColor ? '0 0.1rem 0.5rem 0 rgba(0, 0, 0, 0.14)' : undefined,
        backgroundColor: backgroundColor,
        marginBottom: showFilterBar ? filterHeight + 'rem' : 0
      };

      var pageYOffset = 0;
      try {
        pageYOffset = window.pageYOffset;
      } catch (err) {}

      var _ref = Header__jsx(NavLinks, {
        navLinks: navLinks
      });

      var _ref3 = Header__jsx(UserWidget, {
        loggedIn: loggedIn,
        onSignup: doSignup,
        onSignin: doSignin,
        showSignin: showSignin,
        showSignup: showSignup
      });

      return Header__jsx(react_motion["Motion"], {
        defaultStyle: motionStyleDefault,
        style: Object(Motion["d" /* springify */])(motionStyleCurrent)
      }, void 0, function (tweens) {
        var _style;

        return Header__jsx('div', {}, void 0, Header__jsx('div', {
          style: Header__extends({
            position: 'relative',
            zIndex: 3,
            height: navHeight + 'rem'
          }, navbarStyle)
        }, void 0, !mobileNavMode && Header__jsx('div', {
          style: {
            opacity: tweens.navLinks,
            pointerEvents: tweens.navLinks < 0.75 ? 'none' : undefined,
            height: '100%'
          }
        }, void 0, _ref), Header__jsx('div', {
          style: {
            position: 'absolute',
            top: 0,
            left: sidePadding + 'rem',
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            pointerEvents: 'none'
          }
        }, void 0, Header__jsx('div', {
          style: {
            opacity: tweens.brandOpacity,
            pointerEvents: tweens.brandOpacity > 0.75 ? 'auto' : undefined
          }
        }, void 0, Header__jsx(Link["a" /* default */], {
          to: brandmarkLink
        }, void 0, Header__jsx('div', {
          style: { display: 'flex', alignItems: 'center' }
        }, void 0, Header__jsx(Icons["b" /* Brandmark */], {
          color: brandmarkColor,
          style: { marginBottom: '0.5rem' }
        }), showWordmark && Header__jsx(Icons["M" /* Wordmark */], {
          color: brandmarkColor,
          style: { margin: '0 1rem' }
        })))), Header__jsx('div', {
          style: {
            position: 'relative',
            top: '0.3rem',
            right: closeShift + 'rem',
            opacity: tweens.xOpacity,
            pointerEvents: tweens.xOpacity > 0.75 ? 'auto' : undefined
          }
        }, void 0, Header__jsx(Link["a" /* default */], {
          onClick: _this2.onClickX
        }, void 0, _ref2)), Header__jsx('div', {
          style: {
            position: 'relative',
            left: '-' + crumbShift + 'rem',
            top: '0rem',
            overflow: 'hidden',
            pointerEvents: showSearchInput || !showNavLinks ? 'auto' : undefined
          }
        }, void 0, Header__jsx(Crumbs, {
          crumbs: realCrumbs,
          colorOverride: showSearchInput ? Style["a" /* default */].Colors.black : undefined
        }), Header__jsx('form', {
          style: {
            position: showSearchInput ? 'static' : 'absolute',
            display: 'inline',
            opacity: showSearchInput ? 1 : 0,
            pointerEvents: showSearchInput ? 'auto' : undefined
          },
          onSubmit: _this2.submitSearch
        }, void 0, Header__jsx(Typography["c" /* H3 */], {
          style: { display: 'inline' }
        }, void 0, react_default.a.createElement('input', {
          onKeyDown: _this2.inputKeyDown,
          ref: function ref(el) {
            return _this2.searchInput = el;
          },
          style: {
            padding: 0,
            border: 'none',
            color: Style["a" /* default */].Colors.shadow3,
            backgroundColor: 'transparent',
            opacity: (_this2.state.searchText || '').length ? 1 : 0.4
          },
          type: 'search',
          onChange: _this2.onSearchChange,
          value: _this2.state.searchText || '',
          placeholder: 'Start Searching...'
        }))))), showMobileNav && Header__jsx('div', {}, void 0, _this2.state.showMobileNav && Header__jsx(components_MobileNav_MobileNav, {
          close: _this2.toggleMobileNav
        }), Header__jsx('div', {
          style: {
            height: '100%',
            position: 'absolute',
            zIndex: 1000,
            top: 0,
            right: sidePadding + 'rem',
            bottom: 0,
            display: 'flex',
            alignItems: 'center'
          }
        }, void 0, Header__jsx(Typography["j" /* L3 */], {
          onClick: _this2.toggleMobileNav,
          style: {
            marginRight: '1rem',
            letterSpacing: '0.3rem',
            color: _this2.state.showMobileNav ? Style["a" /* default */].Colors.white : Style["a" /* default */].Colors.black
          }
        }, void 0, 'MENU'), Header__jsx(Toggle["a" /* default */], {
          checked: _this2.state.showMobileNav,
          onToggle: _this2.toggleMobileNav
        }))), !showMobileNav && Header__jsx('div', {
          style: {
            opacity: tweens.profileOpacity,
            pointerEvents: tweens.profileOpacity < 0.75 ? 'none' : undefined
          }
        }, void 0, _ref3)), react_default.a.createElement(
          'div',
          {
            style: {
              position: 'absolute',
              top: navHeight + 'rem',
              width: '100vw',
              left: 0,
              zIndex: 2,
              display: showFilterBar ? 'block' : 'none',
              height: filterHeight + 'rem',
              backgroundColor: backgroundColor
            },
            ref: function ref(el) {
              return _this2.tagsContainer = el;
            }
          },
          Header__jsx('div', {
            style: (_style = {
              position: 'absolute',
              zIndex: 0,
              paddingLeft: sidePadding + filterBarIndent + 'rem',
              top: '-' + tweens.filterTags * filterHeight + 'rem'
            }, Header__defineProperty(_style, 'top', 0), Header__defineProperty(_style, 'display', 'flex'), Header__defineProperty(_style, 'flexDirection', 'row'), Header__defineProperty(_style, 'height', filterHeight + 'rem'), Header__defineProperty(_style, 'alignItems', 'center'), _style)
          }, void 0, Header__jsx(components_SearchButton_SearchButton, {
            hover: _this2.props.searchText !== undefined ? true : undefined,
            style: { marginRight: '1.5rem' },
            iconOnly: searchIconOnly || _this2.props.searchText !== undefined,
            onClick: _this2.toggleSearch
          }, void 0, 'Search'), Header__jsx(components_FilterButton_FilterButton, {
            hover: activeTagIds.length ? true : undefined,
            onClick: _this2.toggleFilters,
            checked: _this2.state.showFilters,
            count: activeTagIds.length
          })),
          Header__jsx('div', {
            style: {
              position: 'fixed',
              zIndex: 1,
              width: '100vw',
              left: 0,
              top: 'calc(' + navHeight + 'rem - ' + pageYOffset + 'px)',
              bottom: 0,
              opacity: tweens.filterTags,
              pointerEvents: tweens.filterTags < 0.75 ? 'none' : undefined
            }
          }, void 0, Header__jsx('div', {
            style: {
              paddingTop: '1rem',
              paddingLeft: sidePadding + filterBarIndent + 'rem',
              paddingRight: sidePadding + 'rem',
              paddingBottom: '10rem',
              opacity: 0.97,
              backgroundColor: backgroundColor,
              height: '100%',
              overflowY: 'scroll'
            }
          }, void 0, _ref4), Header__jsx(Header_SeeResults, {
            responsive: responsive,
            message: searchResultsMessage,
            clearTags: clearTags,
            onSeeClicked: function onSeeClicked(e) {
              return _this2.toggleFilters();
            }
          }))
        ));
      });
    }
  }]);

  return Header;
}(lib_react["a" /* MyPureComponent */]);

Header_Header.propTypes = {
  responsive: prop_types_default.a.number,
  activeTagIds: prop_types_default.a.arrayOf(prop_types_default.a.number),
  searchText: prop_types_default.a.string,
  brandmarkColor: prop_types_default.a.string,
  brandmarkLink: prop_types_default.a.string,
  crumbs: prop_types_default.a.arrayOf(LINK_SHAPE),
  navLinks: prop_types_default.a.arrayOf(LINK_SHAPE),
  showFilterBar: prop_types_default.a.bool,
  backgroundColor: prop_types_default.a.string,
  setSearchText: prop_types_default.a.func.isRequired,
  profile: prop_types_default.a.object,
  loggedIn: prop_types_default.a.bool,
  doSignup: prop_types_default.a.func,
  doSignin: prop_types_default.a.func,
  searchResultsMessage: prop_types_default.a.string,
  clearTags: prop_types_default.a.func,
  showSignin: prop_types_default.a.bool,
  showSignup: prop_types_default.a.bool,
  showNav: prop_types_default.a.bool
};
Header_Header.defaultProps = {
  activeTagIds: constants["k" /* EMPTY_ARRAY */],
  brandmarkColor: Style["a" /* default */].Colors.black,
  brandmarkLink: '/',
  crumbs: constants["k" /* EMPTY_ARRAY */],
  navLinks: constants["k" /* EMPTY_ARRAY */],
  showFilterBar: false,
  showSignin: true,
  showSignup: true,
  showNav: true
};
Header_Header.contextTypes = {
  store: prop_types_default.a.object
};


function Header_mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
    activeTagIds: state.search.tags,
    searchText: state.search.text,
    profile: state.user.profile,
    loggedIn: state.cognito.state === react_cognito["CognitoState"].LOGGED_IN
  };
}

function Header_mapDispatchToProps(dispatch) {
  return {
    setSearchText: function setSearchText(text) {
      return dispatch(Object(search["m" /* setSearchText */])(text));
    },
    doSignup: function doSignup() {
      return dispatch(Object(user["h" /* showSignup */])());
    },
    doSignin: function doSignin() {
      return dispatch(Object(user["g" /* showLogin */])());
    }
  };
}

/* harmony default export */ var components_Header_Header = __webpack_exports__["a"] = (Object(es["connect"])(Header_mapStateToProps, Header_mapDispatchToProps)(Header_Header));

function UserWidget(_ref5) {
  var loggedIn = _ref5.loggedIn,
      onSignup = _ref5.onSignup,
      onSignin = _ref5.onSignin,
      showSignin = _ref5.showSignin,
      showSignup = _ref5.showSignup;

  if (loggedIn) {
    return _ref6;
  } else {
    return Header__jsx('div', {
      style: {
        height: '100%',
        position: 'absolute',
        top: 0,
        right: '4rem',
        bottom: 0,
        display: 'flex',
        alignItems: 'center'
      }
    }, void 0, showSignin && Header__jsx(Hoverable["a" /* Hover */], {}, void 0, Header__jsx(Header_NavLink, {
      text: 'Sign In',
      onClick: onSignin
    })), showSignup && Header__jsx(Button["a" /* default */], {
      size: 'large',
      onClick: onSignup
    }, void 0, 'Sign Up'));
  }
}

var _ref7 = Header__jsx(Link["a" /* default */], {
  underline: true,
  to: '/dashboard/subscription#payment'
}, void 0, 'UPDATE HERE');

var _ref8 = Header__jsx('span', {}, void 0, 'LICENSES REMAINING');

var _ref9 = Header__jsx(Link["a" /* default */], {
  to: '/browse'
}, void 0, 'Browse');

var _ref10 = Header__jsx(Link["a" /* default */], {
  to: '/dashboard/licenses'
}, void 0, 'Licensed Clips');

var _ref11 = Header__jsx(Link["a" /* default */], {
  to: '/dashboard/subscription'
}, void 0, 'My Subscription');

var Header_ProfileWidgetComp = function (_MyPureComponent2) {
  Header__inherits(ProfileWidgetComp, _MyPureComponent2);

  function ProfileWidgetComp(props) {
    Header__classCallCheck(this, ProfileWidgetComp);

    var _this3 = Header__possibleConstructorReturn(this, (ProfileWidgetComp.__proto__ || Object.getPrototypeOf(ProfileWidgetComp)).call(this, props));

    _this3.toggleOpen = function (e) {
      _this3.setState({ open: !_this3.state.open });
    };

    _this3.checkForClose = function (e) {
      if (e.target.tagName === 'A') {
        _this3.close();
      }
    };

    _this3.close = function (e) {
      _this3.setState({ open: false });
    };

    _this3.doSignOut = function (e) {
      _this3.setState({ open: false });
      _this3.props.onSignOut();
      src_history["a" /* default */].push('/');
    };

    _this3.state = {
      open: false,
      widthClosed: 9,
      widthOpen: 27,
      heightClosed: 27,
      heightOpen: 53
    };
    return _this3;
  }

  Header__createClass(ProfileWidgetComp, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          subscription = _props2.subscription,
          pastDue = _props2.pastDue,
          profilePhotoUrl = _props2.profilePhotoUrl,
          otherProps = Header__objectWithoutProperties(_props2, ['subscription', 'pastDue', 'profilePhotoUrl']);

      var borderColor = Style["a" /* default */].Colors.black;
      var backgroundColor = Style["a" /* default */].Colors.shadow4;
      if (pastDue) {
        borderColor = Style["a" /* default */].Colors.error;
        backgroundColor = Style["a" /* default */].Colors.errorDark;
      }

      var animatedDefault = {
        open: 0,
        outerWidth: this.state.widthClosed,
        outerHeight: this.state.heightClosed
      };
      var animatedCurrent = {
        open: this.state.open ? 1 : animatedDefault.open,
        outerWidth: this.state.open ? this.state.widthOpen : animatedDefault.outerWidth,
        outerHeight: this.state.open ? this.state.heightOpen : animatedDefault.outerHeight
      };

      var remaining = 'Unlimited';
      return Header__jsx(react_motion["Motion"], {
        defaultStyle: animatedDefault,
        style: Object(Motion["d" /* springify */])(animatedCurrent)
      }, void 0, function (tween) {
        return Header__jsx('div', {}, void 0, Header__jsx('div', {
          style: Header__extends({}, constants["n" /* FULL_STYLE */], {
            position: 'fixed',
            display: _this4.state.open ? 'block' : 'none'
          }),
          onClick: _this4.close
        }), Header__jsx('div', {
          style: {
            position: 'absolute',
            top: '-20rem',
            right: 0,
            height: tween.outerHeight + 'rem',
            width: tween.outerWidth + 'rem',
            backgroundColor: color_default()(Style["a" /* default */].Colors.white).alpha(tween.open),
            boxShadow: '0 ' + 0.2 * tween.open + 'rem ' + 2.2 * tween.open + 'rem 0 ' + color_default()(Style["a" /* default */].Colors.shadow5).alpha(0.79).string(),
            borderBottomLeftRadius: '0.6rem',
            overflow: 'hidden'
          },
          onClick: _this4.checkForClose
        }, void 0, Header__jsx('div', {
          style: {
            position: 'absolute',
            width: _this4.state.widthOpen + 'rem',
            height: _this4.state.heightOpen + 'rem',
            top: 0,
            right: 0,
            padding: '22.5rem 2.5rem 0'
          }
        }, void 0, Header__jsx('div', {
          style: {
            display: 'flex'
          }
        }, void 0, Header__jsx('div', {
          style: {
            opacity: tween.open,
            flex: '1 1 auto',
            paddingTop: '0.3rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }
        }, void 0, Header__jsx(LicenseMeter["a" /* default */], {
          used: subscription.licensesUsed,
          max: subscription.licensesMax,
          style: { height: '3.9rem', borderColor: borderColor },
          textStyle: { fontWeight: 500, fontSize: '1.8rem' }
        }), Header__jsx(Typography["l" /* L4R */], {
          style: {
            opacity: pastDue ? 1 : 0.5,
            margin: '0.6rem auto'
          }
        }, void 0, pastDue && Header__jsx('span', {
          style: { color: Style["a" /* default */].Colors.error }
        }, void 0, 'PAST DUE -', ' ', _ref7), !pastDue && _ref8)), Header__jsx('div', {}, void 0, Header__jsx('div', {
          onClick: _this4.toggleOpen,
          style: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            cursor: 'pointer',
            borderRadius: '99999rem',
            backgroundColor: backgroundColor,
            width: '4.2rem',
            height: '4.2rem',
            margin: '0 1.5rem',
            border: '0.3rem solid ' + borderColor
          }
        }, void 0, Header__jsx(Icons["D" /* Profile */], {
          color: Style["a" /* default */].Colors.white,
          style: { maxWidth: '65%' }
        }), Header__jsx('div', {
          style: Header__extends({}, constants["n" /* FULL_STYLE */], {
            borderRadius: '99999rem',
            backgroundImage: 'url(' + profilePhotoUrl + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          })
        })))), Header__jsx('div', {
          style: {
            opacity: tween.open,
            padding: '5rem 0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }
        }, void 0, Header__jsx(Typography["m" /* P1 */], {
          style: { margin: '0.5rem 0' }
        }, void 0, _ref9), Header__jsx(Typography["m" /* P1 */], {
          style: { margin: '0.5rem 0' }
        }, void 0, _ref10), Header__jsx(Typography["m" /* P1 */], {
          style: { margin: '0.5rem 0' }
        }, void 0, _ref11), Header__jsx(Typography["o" /* P2 */], {
          style: { margin: '5rem 0', color: Style["a" /* default */].Colors.shadow2 }
        }, void 0, Header__jsx(Link["a" /* default */], {
          onClick: _this4.doSignOut
        }, void 0, 'Sign Out'))))));
      });
    }
  }]);

  return ProfileWidgetComp;
}(lib_react["a" /* MyPureComponent */]);

Header_ProfileWidgetComp.propTypes = {
  subscription: prop_types_default.a.object,
  pastDue: prop_types_default.a.bool,
  profilePhotoUrl: prop_types_default.a.string,
  onSignOut: prop_types_default.a.func
};


function mapStateToProfileProps(state) {
  return {
    subscription: state.user.subscription,
    pastDue: state.plan.activePlan.status === constants["A" /* PLAN_STATUS */].PAST_DUE,
    profilePhotoUrl: state.user.profileImageSrc
  };
}

function mapDispatchToProfileProps(dispatch) {
  return {
    onSignOut: function onSignOut() {
      return dispatch(Object(user["e" /* logout */])());
    }
  };
}

var ProfileWidget = Object(es["connect"])(mapStateToProfileProps, mapDispatchToProfileProps)(Header_ProfileWidgetComp),
    _ref6 = Header__jsx(ProfileWidget, {});

function NavLinks(_ref12) {
  var hover = _ref12.hover,
      navLinks = _ref12.navLinks,
      style = _ref12.style;

  return Header__jsx('div', {
    style: Header__extends({
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }, style)
  }, void 0, navLinks.map(function (navLink) {
    return Header__jsx(Hoverable["a" /* Hover */], {}, navLink.text, Header__jsx(Header_NavLink, {
      text: navLink.text,
      onClick: navLink.onClick,
      href: navLink.href
    }));
  }));
}

function Header_NavLink(_ref13) {
  var hover = _ref13.hover,
      text = _ref13.text,
      onClick = _ref13.onClick,
      href = _ref13.href,
      otherProps = Header__objectWithoutProperties(_ref13, ['hover', 'text', 'onClick', 'href']);

  var baseOpacity = 0.6;
  return Header__jsx(react_motion["Motion"], {
    defaultStyle: { opacity: baseOpacity },
    style: Object(Motion["d" /* springify */])({ opacity: hover ? 1 : baseOpacity })
  }, void 0, function (tween) {
    return react_default.a.createElement(
      Typography["h" /* L2 */],
      otherProps,
      Header__jsx(Link["a" /* default */], {
        style: {
          padding: '0 1.7rem',
          opacity: tween.opacity,
          color: Style["a" /* default */].Colors.shadow2
        },
        onClick: onClick,
        to: href
      }, void 0, text)
    );
  });
}

function Crumbs(_ref14) {
  var crumbs = _ref14.crumbs,
      colorOverride = _ref14.colorOverride;

  var lastIndex = crumbs.length - 1;
  return Header__jsx('div', {
    style: { display: 'inline' }
  }, void 0, crumbs.map(function (crumb, index) {
    var text = crumb.text,
        otherProps = Header__objectWithoutProperties(crumb, ['text']);

    var color = index < lastIndex ? Style["a" /* default */].Colors.shadow4 : Style["a" /* default */].Colors.black;
    var style = {
      color: colorOverride || color,
      display: 'inline',
      textDecoration: 'none'
    };
    return Header__jsx('span', {}, crumb.text, !!index && Header__jsx(Typography["c" /* H3 */], {
      style: style
    }, void 0, '\xA0/\xA0'), react_default.a.createElement(
      Link["a" /* default */],
      Header__extends({ style: style }, otherProps),
      Header__jsx(Typography["c" /* H3 */], {
        style: style
      }, void 0, text)
    ));
  }));
}

var Header_SeeResults = function (_MyPureComponent3) {
  Header__inherits(SeeResults, _MyPureComponent3);

  function SeeResults() {
    Header__classCallCheck(this, SeeResults);

    return Header__possibleConstructorReturn(this, (SeeResults.__proto__ || Object.getPrototypeOf(SeeResults)).apply(this, arguments));
  }

  Header__createClass(SeeResults, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          responsive = _props3.responsive,
          message = _props3.message,
          clearTags = _props3.clearTags,
          onSeeClicked = _props3.onSeeClicked,
          otherProps = Header__objectWithoutProperties(_props3, ['responsive', 'message', 'clearTags', 'onSeeClicked']);

      var showMessages = false;
      var padding = '0 1rem 0 1rem';
      var minButtonWidth = '22rem';
      var justify = 'flex-start';
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE) {
        showMessages = true;
        padding = '0 12rem 0 2rem';
        justify = 'flex-end';
      }

      return Header__jsx('div', {
        style: {
          boxShadow: '0 -0.2rem 2.2rem 0 ' + color_default()(Style["a" /* default */].Colors.shadow5).alpha(0.79).string(),
          zIndex: 9999,
          position: 'fixed',
          width: '100vw',
          height: '9.3rem',
          bottom: '0',
          left: '0',
          backgroundColor: Style["a" /* default */].Colors.white,
          display: 'flex',
          justifyContent: justify,
          alignItems: 'center',
          padding: padding
        }
      }, void 0, showMessages && Header__jsx(Typography["m" /* P1 */], {
        style: { fontWeight: 500, marginRight: '3rem', opacity: 0.5 }
      }, void 0, message, clearTags && Header__jsx('span', {}, void 0, ':', ' ', Header__jsx(Link["a" /* default */], {
        underline: true,
        onClick: clearTags
      }, void 0, 'Clear Filters'))), Header__jsx(Button["a" /* default */], {
        style: { minWidth: minButtonWidth },
        size: 'large',
        hover: true,
        onClick: onSeeClicked
      }, void 0, clearTags || !message ? 'Close' : 'See Results'));
    }
  }]);

  return SeeResults;
}(lib_react["a" /* MyPureComponent */]);

Header_SeeResults.propTypes = {
  responsive: prop_types_default.a.number,
  message: prop_types_default.a.string,
  clearTags: prop_types_default.a.func,
  onSeeClicked: prop_types_default.a.func
};
Header_SeeResults.defaultProps = {
  message: ''
};

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(370),
    baseFlatten = __webpack_require__(146),
    baseRest = __webpack_require__(140),
    isArrayLikeObject = __webpack_require__(360);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(22),
    now = __webpack_require__(1123),
    toNumber = __webpack_require__(367);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_color__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_motion__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_Color__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_Motion__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_plan__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Hoverable__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icons__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Button__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Typography__ = __webpack_require__(887);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var SubscriptionPlans = function (_React$PureComponent) {
  _inherits(SubscriptionPlans, _React$PureComponent);

  function SubscriptionPlans(props) {
    _classCallCheck(this, SubscriptionPlans);

    var _this = _possibleConstructorReturn(this, (SubscriptionPlans.__proto__ || Object.getPrototypeOf(SubscriptionPlans)).call(this, props));

    _this.toggleTooltip = function (show, el, title, text) {
      var triggerRect = el.getBoundingClientRect();
      var thisRect = _this.tooltipContainer.getBoundingClientRect();

      var triggerCenter = (triggerRect.right - triggerRect.left) / 2 + triggerRect.left;
      var xOffset = triggerCenter - thisRect.left;
      var yOffset = thisRect.height - (triggerRect.top - thisRect.top);

      _this.setState({
        tooltipVisible: show,
        tooltipTitle: title,
        tooltipText: text,
        tooltipPosition: [xOffset, yOffset]
      });
    };

    _this.state = {
      tooltipVisible: false,
      tooltipPosition: [0, 0],
      tooltipTitle: '',
      tooltipText: ''
    };
    return _this;
  }

  _createClass(SubscriptionPlans, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          responsive = _props.responsive,
          plan = _props.plan,
          onSelectPlan = _props.onSelectPlan,
          showUnlimited = _props.showUnlimited,
          bannerColor = _props.bannerColor,
          otherProps = _objectWithoutProperties(_props, ['responsive', 'plan', 'onSelectPlan', 'showUnlimited', 'bannerColor']);

      var planName = plan.name;
      var annual = plan.annual;

      var planStyle = {
        margin: '1rem',
        flex: '1 1 18rem',
        width: '18rem',
        height: '25rem'
      };
      var buttonSize = 'small';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            maxWidth: '75rem',
            margin: '-1rem auto'
          },
          ref: function ref(el) {
            return _this2.tooltipContainer = el;
          }
        },
        _jsx('div', {
          style: {
            pointerEvents: 'none',
            opacity: this.state.tooltipVisible ? 1 : 0,
            position: 'absolute',
            zIndex: 9,
            left: this.state.tooltipPosition[0],
            bottom: this.state.tooltipPosition[1]
          }
        }, void 0, _jsx('div', {
          style: {
            position: 'relative',
            bottom: '2rem',
            left: '-50%',
            width: '100vw',
            maxWidth: '21rem',
            boxShadow: '0 0.2rem 2.2rem 0 ' + __WEBPACK_IMPORTED_MODULE_4_color___default()('#E4E6E8').alpha(0.8).string()
          }
        }, void 0, _jsx('div', {
          style: {
            position: 'absolute',
            zIndex: 0,
            bottom: '-1rem',
            transformOrigin: '50%',
            transform: 'rotate(45deg)',
            left: 'calc(50% - 1.5rem)',
            width: '3rem',
            height: '3rem',
            backgroundColor: __WEBPACK_IMPORTED_MODULE_13__Style__["a" /* default */].Colors.white,
            boxShadow: '0 0.2rem 2.2rem 0 ' + __WEBPACK_IMPORTED_MODULE_4_color___default()('#E4E6E8').alpha(0.8).string()
          }
        }), _jsx('div', {
          style: {
            borderRadius: '0.6rem',
            position: 'relative',
            zIndex: 1,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_13__Style__["a" /* default */].Colors.white,
            padding: '4rem 2rem 5rem'
          }
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Typography__["j" /* L3 */], {
          style: { color: __WEBPACK_IMPORTED_MODULE_13__Style__["a" /* default */].Colors.gray }
        }, void 0, this.state.tooltipTitle), _jsx(__WEBPACK_IMPORTED_MODULE_14__Typography__["o" /* P2 */], {
          style: { color: '#454E57', marginTop: '1rem' }
        }, void 0, this.state.tooltipText)))),
        _jsx(__WEBPACK_IMPORTED_MODULE_10__Hoverable__["b" /* default */], {
          style: _extends({}, planStyle)
        }, void 0, _jsx(Plan, {
          title: Object(__WEBPACK_IMPORTED_MODULE_8__actions_plan__["e" /* getPlanTitle */])(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].BASIC),
          price: Object(__WEBPACK_IMPORTED_MODULE_8__actions_plan__["d" /* getPlanPrice */])(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].BASIC, annual),
          benefits: [{ text: '5 clips per month' }, { text: '1080p HD resolution' }],
          buttonSize: buttonSize,
          onButtonClick: function onButtonClick() {
            return onSelectPlan(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].BASIC);
          },
          selected: planName === __WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].BASIC,
          onTooltipHover: this.toggleTooltip
        })),
        _jsx(__WEBPACK_IMPORTED_MODULE_10__Hoverable__["b" /* default */], {
          style: _extends({}, planStyle)
        }, void 0, _jsx(Plan, {
          title: Object(__WEBPACK_IMPORTED_MODULE_8__actions_plan__["e" /* getPlanTitle */])(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].PRO),
          price: Object(__WEBPACK_IMPORTED_MODULE_8__actions_plan__["d" /* getPlanPrice */])(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].PRO, annual),
          benefits: [{ text: '20 clips per month' }, { text: '1080p HD resolution' }],
          buttonSize: buttonSize,
          onButtonClick: function onButtonClick() {
            return onSelectPlan(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].PRO);
          },
          selected: planName === __WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].PRO,
          onTooltipHover: this.toggleTooltip
        })),
        showUnlimited && _jsx(__WEBPACK_IMPORTED_MODULE_10__Hoverable__["b" /* default */], {
          style: _extends({}, planStyle, {
            flex: '5 5 18rem',
            width: '18rem',
            height: '30rem'
          })
        }, void 0, _jsx(Plan, {
          title: Object(__WEBPACK_IMPORTED_MODULE_8__actions_plan__["e" /* getPlanTitle */])(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].UNLIMITED),
          price: Object(__WEBPACK_IMPORTED_MODULE_8__actions_plan__["d" /* getPlanPrice */])(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].UNLIMITED, annual),
          benefits: [{ text: 'No download limit' }, { text: '4K UHD resolution' }, { text: '1080p HD resolution' }, { text: 'After Effects Templates (Bonus)' }],
          buttonSize: buttonSize,
          onButtonClick: function onButtonClick() {
            return onSelectPlan(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].UNLIMITED);
          },
          selected: planName === __WEBPACK_IMPORTED_MODULE_9__constants__["z" /* PLAN */].UNLIMITED,
          bannerColor: bannerColor,
          bannerText: 'BEST VALUE!',
          onTooltipHover: this.toggleTooltip
        }))
      );
    }
  }]);

  return SubscriptionPlans;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

SubscriptionPlans.defaultProps = {
  plan: __WEBPACK_IMPORTED_MODULE_9__constants__["l" /* EMPTY_OBJECT */],
  onSelectPlan: function onSelectPlan(name) {},
  showUnlimited: true
};


function mapStateToProps(state, ownProps) {
  return {
    responsive: state.runtime.responsive,
    bannerColor: ownProps.bannerColor || state.ui.colors.dark
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(SubscriptionPlans));

var Plan = function (_React$PureComponent2) {
  _inherits(Plan, _React$PureComponent2);

  function Plan(props) {
    _classCallCheck(this, Plan);

    var _this3 = _possibleConstructorReturn(this, (Plan.__proto__ || Object.getPrototypeOf(Plan)).call(this, props));

    _this3.state = {
      price: props.price
    };

    _this3.tooltipRefs = {};
    return _this3;
  }

  _createClass(Plan, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          hover = _props2.hover,
          title = _props2.title,
          price = _props2.price,
          benefits = _props2.benefits,
          buttonSize = _props2.buttonSize,
          onButtonClick = _props2.onButtonClick,
          selected = _props2.selected,
          bannerColor = _props2.bannerColor,
          bannerText = _props2.bannerText,
          onTooltipHover = _props2.onTooltipHover,
          otherProps = _objectWithoutProperties(_props2, ['hover', 'title', 'price', 'benefits', 'buttonSize', 'onButtonClick', 'selected', 'bannerColor', 'bannerText', 'onTooltipHover']);

      var boxStyle = {
        backgroundColor: '#F9F9FA'
      };

      var animatedDefault = {
        hover: 0,
        selected: 0,
        price: this.state.price
      };
      var animatedCurrent = {
        hover: hover ? 1 : 0,
        selected: selected ? 1 : 0,
        price: price
      };

      var textColorBase = __WEBPACK_IMPORTED_MODULE_4_color___default()(__WEBPACK_IMPORTED_MODULE_13__Style__["a" /* default */].Colors.shadow3);
      var textColorHover = __WEBPACK_IMPORTED_MODULE_4_color___default()(__WEBPACK_IMPORTED_MODULE_13__Style__["a" /* default */].Colors.black);

      var borderColorBase = __WEBPACK_IMPORTED_MODULE_4_color___default()('#979797');
      var borderColorHover = __WEBPACK_IMPORTED_MODULE_4_color___default()('#4A4A4A');
      var borderColorSelected = __WEBPACK_IMPORTED_MODULE_4_color___default()(__WEBPACK_IMPORTED_MODULE_13__Style__["a" /* default */].Colors.black);

      return _jsx(__WEBPACK_IMPORTED_MODULE_5_react_motion__["Motion"], {
        defaultStyle: animatedDefault,
        style: Object(__WEBPACK_IMPORTED_MODULE_7__lib_Motion__["d" /* springify */])(animatedCurrent)
      }, void 0, function (tweens) {
        var borderColor = borderColorBase.mix(borderColorSelected, tweens.selected).mix(borderColorHover, tweens.hover);

        var outerShadow = 0.5 * tweens.hover + 'rem ' + 0.6 * tweens.hover + 'rem ' + 1.6 * tweens.hover + 'rem ' + 0 * tweens.hover + 'rem rgba(0,0,0,0.09)';
        var innerShaddow = '0 0 0 ' + 0.1 * tweens.selected + 'rem ' + borderColor;

        var benefitColor = textColorBase.mix(textColorHover, tweens.hover);
        var buttonColor = benefitColor.mix(__WEBPACK_IMPORTED_MODULE_4_color___default()(__WEBPACK_IMPORTED_MODULE_13__Style__["a" /* default */].Colors.black), tweens.selected);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          _extends({
            style: {
              position: 'relative',
              height: '100%',
              textAlign: 'center',
              boxShadow: outerShadow + ', ' + innerShaddow,
              border: '0.1rem solid ' + borderColor,
              borderRadius: '0.5rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              padding: '4rem 1rem 2.5rem',
              backgroundColor: __WEBPACK_IMPORTED_MODULE_4_color___default()(__WEBPACK_IMPORTED_MODULE_13__Style__["a" /* default */].Colors.shadow5).alpha(0.3),
              overflow: 'hidden'
            }
          }, otherProps),
          _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Typography__["d" /* H4 */], {
            style: { fontSize: '3.2rem', marginBottom: 0 }
          }, void 0, title), _jsx(__WEBPACK_IMPORTED_MODULE_14__Typography__["m" /* P1 */], {
            style: { fontSize: '2.1rem', marginTop: 0 }
          }, void 0, '$', Math.round(tweens.price), '/mo.'), _jsx('div', {
            style: {
              display: bannerText && bannerColor ? 'flex' : 'none',
              position: 'absolute',
              right: 0,
              top: '22%',
              width: '100%',
              transformOrigin: '100% 100%',
              transform: 'rotate(43deg)',
              height: '3rem',
              justifyContent: 'flex-end',
              alignItems: 'center',
              backgroundColor: bannerColor,
              boxShadow: '0 0.2rem 0.3rem 0 ' + __WEBPACK_IMPORTED_MODULE_4_color___default()('#9B9B9B').alpha(0.4).string() + ', inset 0 -0.1rem 0.8rem 0 ' + __WEBPACK_IMPORTED_MODULE_4_color___default()(__WEBPACK_IMPORTED_MODULE_13__Style__["a" /* default */].Colors.black).alpha(0.2).string()
            }
          }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Typography__["g" /* L1 */], {
            style: {
              fontWeight: 500,
              marginRight: '3.2rem',
              letterSpacing: '0.3px',
              fontSize: '1.4rem',
              color: __WEBPACK_IMPORTED_MODULE_13__Style__["a" /* default */].Colors.white
            }
          }, void 0, bannerText))),
          _jsx('div', {
            style: { color: benefitColor.string() }
          }, void 0, benefits.map(function (benefit) {
            return _jsx('div', {}, benefit.text, _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Typography__["o" /* P2 */], {
              style: { display: 'inline-block', fontWeight: 400 }
            }, void 0, benefit.text, !!benefit.tooltip && _jsx(__WEBPACK_IMPORTED_MODULE_10__Hoverable__["b" /* default */], {
              wrapWith: 'span',
              onChange: function onChange(hovering) {
                return onTooltipHover(hovering, _this4.tooltipRefs[benefit.text], benefit.tooltip.title, benefit.tooltip.text);
              }
            }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                ref: function ref(el) {
                  return _this4.tooltipRefs[benefit.text] = el;
                }
              },
              _jsx(__WEBPACK_IMPORTED_MODULE_11__Icons__["u" /* Info */], {
                color: benefitColor.string(),
                style: {
                  margin: '0 0.5rem',
                  maxWidth: '1.4rem',
                  position: 'relative',
                  top: '0.2rem'
                }
              })
            )))));
          })),
          _jsx(__WEBPACK_IMPORTED_MODULE_12__Button__["a" /* default */], {
            hover: selected || undefined,
            darkColor: buttonColor.string(),
            size: buttonSize,
            checked: selected || undefined,
            onClick: onButtonClick,
            style: { fontSize: '1.4rem' }
          }, void 0, 'Choose\xA0this\xA0plan')
        );
      });
    }
  }]);

  return Plan;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Plan.defaultProps = {};


var PlanHoverable = Object(__WEBPACK_IMPORTED_MODULE_10__Hoverable__["c" /* withHover */])()(Plan);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withFooterDrawer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_intercom__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_react__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_user__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Link__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Typography__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__config__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_8__Link__["a" /* default */], {
  to: '/legal'
}, void 0, ' Terms of Service');

var _ref7 = _jsx(__WEBPACK_IMPORTED_MODULE_8__Link__["a" /* default */], {
  to: 'https://www.prochurchtools.com'
}, void 0, 'Pro Church Tools, Inc.');

var FooterComp = function (_React$PureComponent) {
  _inherits(FooterComp, _React$PureComponent);

  function FooterComp() {
    _classCallCheck(this, FooterComp);

    return _possibleConstructorReturn(this, (FooterComp.__proto__ || Object.getPrototypeOf(FooterComp)).apply(this, arguments));
  }

  _createClass(FooterComp, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          responsive = _props.responsive,
          showLogin = _props.showLogin,
          empty = _props.empty,
          collapse = _props.collapse,
          otherProps = _objectWithoutProperties(_props, ['responsive', 'showLogin', 'empty', 'collapse']);

      var containerStyle = {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.black,
        color: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.white,
        position: 'relative'
      };

      var brandmarkStyle = {
        display: 'block',
        fill: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.white,
        maxWidth: '6.6rem',
        width: '100vw'
      };
      var navBrandmarkStyle = _extends({}, brandmarkStyle);
      var centerBrandmarkStyle = _extends({}, brandmarkStyle);

      var labelStyle = { opacity: 0.5 };

      var bottomRowStyle = {
        display: 'flex',
        justifyContent: 'space-between'
      };

      var P = __WEBPACK_IMPORTED_MODULE_10__Typography__["o" /* P2 */];
      var containerPadding = '6.3rem 3.5rem 3.5rem';
      var bottomCellPaddingTop = '1rem';
      var bottomRowPaddingTop = '4rem';
      var bottomRowFlexDirection = 'column';

      var navBrandmarkOpacity = 1;
      var centerBrandmarkOpacity = 0;

      if (responsive >= __WEBPACK_IMPORTED_MODULE_3__constants__["C" /* RESPONSIVE_SIZE */].PHONE) {
        P = __WEBPACK_IMPORTED_MODULE_10__Typography__["m" /* P1 */];
        bottomCellPaddingTop = '2rem';
        containerPadding = '6.3rem 3.5rem 5rem';
      }
      if (responsive >= __WEBPACK_IMPORTED_MODULE_3__constants__["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT) {
        bottomCellPaddingTop = '3rem';
        bottomRowPaddingTop = '10rem';
      }
      if (responsive >= __WEBPACK_IMPORTED_MODULE_3__constants__["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE) {
        containerPadding = '9rem 12rem 9rem';
        navBrandmarkOpacity = 0;
        centerBrandmarkOpacity = 1;
        bottomRowFlexDirection = 'row';
      }

      return _jsx('div', {
        style: _extends({}, containerStyle, { padding: containerPadding })
      }, void 0, _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icons__["b" /* Brandmark */], {
        style: _extends({}, navBrandmarkStyle, { opacity: navBrandmarkOpacity })
      }), _jsx('div', {
        style: {
          pointerEvents: empty ? 'none' : undefined,
          opacity: empty ? 0 : 1,
          display: collapse ? 'none' : 'initial'
        }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["k" /* L4 */], {
        style: _extends({}, labelStyle, {
          display: 'block',
          padding: '8rem 0 2rem'
        })
      }, void 0, 'STORYTAPE NAVIGATION'), _ref, _ref2, _ref3, _ref4, _ref5, _jsx(NavLink, {
        onClick: function onClick(e) {
          return __WEBPACK_IMPORTED_MODULE_4__lib_intercom__["a" /* default */].startConversation();
        }
      }, void 0, 'Get Support'), _jsx(NavLink, {
        onClick: this.props.showLogin
      }, void 0, 'Sign In'))), _jsx('div', {
        style: _extends({}, bottomRowStyle, {
          paddingTop: bottomRowPaddingTop,
          flexDirection: bottomRowFlexDirection
        })
      }, void 0, _jsx('div', {
        style: { paddingTop: bottomCellPaddingTop }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["k" /* L4 */], {
        style: _extends({}, labelStyle)
      }, void 0, 'QUESTIONS? NEED HELP?'), !this.props.marketing && _jsx(P, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Link__["a" /* default */], {
        onClick: function onClick(e) {
          return __WEBPACK_IMPORTED_MODULE_4__lib_intercom__["a" /* default */].startConversation();
        }
      }, void 0, 'Contact our Support Team')), this.props.marketing && _jsx(P, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Link__["a" /* default */], {
        onClick: function onClick(e) {
          return __WEBPACK_IMPORTED_MODULE_4__lib_intercom__["a" /* default */].startConversation();
        }
      }, void 0, 'Contact Support'), ' \u2014', _ref6)), _jsx('div', {
        style: { paddingTop: bottomCellPaddingTop }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["k" /* L4 */], {
        style: _extends({}, labelStyle)
      }, void 0, 'COPYRIGHT ', new Date().getFullYear()), _jsx(P, {}, void 0, _ref7))), _jsx('div', {
        style: {
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icons__["b" /* Brandmark */], {
        style: _extends({}, centerBrandmarkStyle, { opacity: centerBrandmarkOpacity })
      })));
    }
  }]);

  return FooterComp;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

FooterComp.defaultProps = {
  empty: false,
  collapse: false,
  marketing: false
};


function mapStateToProps(state) {
  return { responsive: state.runtime.responsive };
}

function mapDispatchToProps(dispatch) {
  return {
    showLogin: function showLogin() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_user__["g" /* showLogin */])());
    }
  };
}

var Footer = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(FooterComp);
/* unused harmony default export */ var _unused_webpack_default_export = (Footer);

function withFooterDrawer() {
  var footerProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */];

  return function (WrappedComponent) {
    var FooterDrawer = function (_React$PureComponent2) {
      _inherits(FooterDrawer, _React$PureComponent2);

      function FooterDrawer() {
        _classCallCheck(this, FooterDrawer);

        return _possibleConstructorReturn(this, (FooterDrawer.__proto__ || Object.getPrototypeOf(FooterDrawer)).apply(this, arguments));
      }

      _createClass(FooterDrawer, [{
        key: 'render',
        value: function render() {
          return _jsx('div', {
            style: { position: 'relative' }
          }, void 0, _jsx('div', {
            style: {
              position: 'relative',
              zIndex: 1,
              pointerEvents: 'none'
            }
          }, void 0, _jsx('div', {
            style: {
              backgroundColor: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.white,
              pointerEvents: 'auto',
              overflow: 'hidden'
            }
          }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, this.props)), _jsx('div', {
            style: { opacity: 0, pointerEvents: 'none' }
          }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer, footerProps))), _jsx('div', {
            style: {
              position: 'fixed',
              right: 0,
              bottom: 0,
              left: 0,
              zIndex: 0,
              backgroundColor: __WEBPACK_IMPORTED_MODULE_9__Style__["a" /* default */].Colors.black,
              paddingTop: '10rem'
            }
          }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer, footerProps)));
        }
      }]);

      return FooterDrawer;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

    FooterDrawer.displayName = 'FooterDrawer(' + Object(__WEBPACK_IMPORTED_MODULE_5__lib_react__["c" /* getDisplayName */])(WrappedComponent) + ')';

    return FooterDrawer;
  };
}

function NavLink(props) {
  return _jsx(__WEBPACK_IMPORTED_MODULE_10__Typography__["e" /* H5 */], {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__Link__["a" /* default */],
    props,
    props.children
  ));
}

var _ref5 = _jsx(NavLink, {
  to: '/legal'
}, void 0, 'Privacy & Terms');

var _ref4 = _jsx(NavLink, {
  to: '/browse'
}, void 0, 'Browse Scenes');

var _ref3 = _jsx(NavLink, {
  to: '/pricing'
}, void 0, 'Pricing Plans');

var _ref2 = _jsx(NavLink, {
  to: '/how-it-works'
}, void 0, 'How it Works');

var _ref = _jsx(NavLink, {
  to: '/'
}, void 0, 'Home');

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icons__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WorkingSpinner_css__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WorkingSpinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__WorkingSpinner_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







function WorkingSpinner(props) {
  var active = props.active,
      otherProps = _objectWithoutProperties(props, ['active']);

  var classnames = [__WEBPACK_IMPORTED_MODULE_4__WorkingSpinner_css___default.a.WorkingSpinner];
  if (active) {
    classnames.push(__WEBPACK_IMPORTED_MODULE_4__WorkingSpinner_css___default.a.activeSpinner);
  }

  return _jsx('div', {
    className: classnames.join(' ')
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icons__["N" /* Working */], otherProps));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__WorkingSpinner_css___default.a)(WorkingSpinner));

/***/ }),
/* 1079 */,
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(71),
    baseIntersection = __webpack_require__(1150),
    baseRest = __webpack_require__(140),
    castArrayLikeObject = __webpack_require__(1151);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1082), __esModule: true };

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1083);
module.exports = __webpack_require__(891).Object.getPrototypeOf;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(939);
var $getPrototypeOf = __webpack_require__(940);

__webpack_require__(1084)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(900);
var core = __webpack_require__(891);
var fails = __webpack_require__(908);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1088);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1089), __esModule: true };

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1090);
var $Object = __webpack_require__(891).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(900);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(897), 'Object', { defineProperty: __webpack_require__(896).f });


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(944);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1093), __esModule: true };

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(921);
__webpack_require__(929);
module.exports = __webpack_require__(930).f('iterator');


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(922);
var defined = __webpack_require__(917);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(924);
var descriptor = __webpack_require__(913);
var setToStringTag = __webpack_require__(928);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(901)(IteratorPrototype, __webpack_require__(892)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(896);
var anObject = __webpack_require__(902);
var getKeys = __webpack_require__(925);

module.exports = __webpack_require__(897) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(926);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(904);
var toLength = __webpack_require__(1099);
var toAbsoluteIndex = __webpack_require__(1100);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(922);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(922);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(893).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1103);
var step = __webpack_require__(1104);
var Iterators = __webpack_require__(909);
var toIObject = __webpack_require__(904);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(945)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1106), __esModule: true };

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1107);
__webpack_require__(1112);
__webpack_require__(1113);
__webpack_require__(1114);
module.exports = __webpack_require__(891).Symbol;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(893);
var has = __webpack_require__(895);
var DESCRIPTORS = __webpack_require__(897);
var $export = __webpack_require__(900);
var redefine = __webpack_require__(946);
var META = __webpack_require__(1108).KEY;
var $fails = __webpack_require__(908);
var shared = __webpack_require__(919);
var setToStringTag = __webpack_require__(928);
var uid = __webpack_require__(912);
var wks = __webpack_require__(892);
var wksExt = __webpack_require__(930);
var wksDefine = __webpack_require__(931);
var enumKeys = __webpack_require__(1109);
var isArray = __webpack_require__(1110);
var anObject = __webpack_require__(902);
var isObject = __webpack_require__(903);
var toIObject = __webpack_require__(904);
var toPrimitive = __webpack_require__(920);
var createDesc = __webpack_require__(913);
var _create = __webpack_require__(924);
var gOPNExt = __webpack_require__(1111);
var $GOPD = __webpack_require__(950);
var $DP = __webpack_require__(896);
var $keys = __webpack_require__(925);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(949).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(932).f = $propertyIsEnumerable;
  __webpack_require__(948).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(923)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(901)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(912)('meta');
var isObject = __webpack_require__(903);
var has = __webpack_require__(895);
var setDesc = __webpack_require__(896).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(908)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(925);
var gOPS = __webpack_require__(948);
var pIE = __webpack_require__(932);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(926);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(904);
var gOPN = __webpack_require__(949).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1112 */
/***/ (function(module, exports) {



/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(931)('asyncIterator');


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(931)('observable');


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1116);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1120);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(944);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1117), __esModule: true };

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1118);
module.exports = __webpack_require__(891).Object.setPrototypeOf;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(900);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1119).set });


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(903);
var anObject = __webpack_require__(902);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(941)(Function.call, __webpack_require__(950).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1121), __esModule: true };

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1122);
var $Object = __webpack_require__(891).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(900);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(924) });


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(45);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(19);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(33);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(220);

// EXTERNAL MODULE: ./node_modules/lodash/values.js
var values = __webpack_require__(83);
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(886);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/actions/clips.js
var clips = __webpack_require__(363);

// EXTERNAL MODULE: ./src/actions/helpers.js
var helpers = __webpack_require__(101);

// EXTERNAL MODULE: ./src/actions/plan.js
var actions_plan = __webpack_require__(223);

// EXTERNAL MODULE: ./src/actions/modal.js
var modal = __webpack_require__(224);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(17);

// EXTERNAL MODULE: ./src/lib/Color.js
var Color = __webpack_require__(899);

// EXTERNAL MODULE: ./src/lib/facebook.js
var facebook = __webpack_require__(358);

// EXTERNAL MODULE: ./src/components/Icons/Icons.js
var Icons = __webpack_require__(888);

// EXTERNAL MODULE: ./node_modules/color/index.js
var node_modules_color = __webpack_require__(351);
var color_default = /*#__PURE__*/__webpack_require__.n(node_modules_color);

// EXTERNAL MODULE: ./src/components/Button/Button.js
var Button = __webpack_require__(889);

// EXTERNAL MODULE: ./src/components/Link/Link.js
var Link = __webpack_require__(890);

// EXTERNAL MODULE: ./src/components/Style/Style.js
var Style = __webpack_require__(350);

// EXTERNAL MODULE: ./src/components/Typography/Typography.js
var Typography = __webpack_require__(887);

// CONCATENATED MODULE: ./src/components/ClipDownloading/ClipDownloading.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ClipDownloading_ClipDownloading = function (_React$PureComponent) {
  _inherits(ClipDownloading, _React$PureComponent);

  function ClipDownloading() {
    _classCallCheck(this, ClipDownloading);

    return _possibleConstructorReturn(this, (ClipDownloading.__proto__ || Object.getPrototypeOf(ClipDownloading)).apply(this, arguments));
  }

  _createClass(ClipDownloading, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          downloadUrl = _props.downloadUrl,
          backTo = _props.backTo,
          onBackTo = _props.onBackTo,
          goTo = _props.goTo,
          onGoTo = _props.onGoTo,
          otherProps = _objectWithoutProperties(_props, ['downloadUrl', 'backTo', 'onBackTo', 'goTo', 'onGoTo']);

      return _jsx('div', {
        style: {
          width: '100%',
          height: '100%',
          color: Style["a" /* default */].Colors.white
        }
      }, void 0, _jsx('div', {
        style: { padding: '6rem 7rem 0' }
      }, void 0, _jsx(Icons["b" /* Brandmark */], {
        color: Style["a" /* default */].Colors.white
      })), _jsx('div', {
        style: {
          maxWidth: '55rem',
          margin: '10rem auto 0',
          opacity: downloadUrl ? 1 : 0
        }
      }, void 0, _jsx(Typography["j" /* L3 */], {
        style: { color: '#9B9B9B' }
      }, void 0, 'SUCCESS'), _jsx(Typography["c" /* H3 */], {
        style: { margin: '0.8rem 0' }
      }, void 0, 'Your clip is downloading now!'), _jsx(Typography["m" /* P1 */], {
        style: { opacity: 0.75 }
      }, void 0, 'If your download hasn\u2019t started after a few seconds, you can', ' ', _jsx(Link["a" /* default */], {
        target: '_self',
        underline: true,
        to: downloadUrl
      }, void 0, 'click here'), ' ', 'to restart!'), _jsx('div', {
        style: {
          marginTop: '4.5rem',
          display: 'flex',
          alignItems: 'center'
        }
      }, void 0, _jsx(Button["a" /* default */], {
        arrow: true,
        baseColor: Style["a" /* default */].Colors.black,
        onClick: onBackTo
      }, void 0, 'Back to ', backTo), _jsx('span', {
        style: { margin: '0 2rem' }
      }, void 0, 'or'), _jsx(Button["a" /* default */], {
        baseColor: Style["a" /* default */].Colors.black,
        onClick: onGoTo
      }, void 0, 'Go to ', goTo))));
    }
  }]);

  return ClipDownloading;
}(react_default.a.PureComponent);

ClipDownloading_ClipDownloading.defaultProps = {};


/* harmony default export */ var components_ClipDownloading_ClipDownloading = (ClipDownloading_ClipDownloading);
// EXTERNAL MODULE: ./src/components/ElementTransition/ElementTransition.js
var ElementTransition = __webpack_require__(911);

// EXTERNAL MODULE: ./src/components/Form/Form.js
var Form = __webpack_require__(898);

// CONCATENATED MODULE: ./src/components/DownloadVersionPicker/DownloadVersionPicker.js
var DownloadVersionPicker__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var DownloadVersionPicker__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function DownloadVersionPicker__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function DownloadVersionPicker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DownloadVersionPicker__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function DownloadVersionPicker__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var DownloadVersionPicker_DownloadVersionPicker = function (_React$PureComponent) {
  DownloadVersionPicker__inherits(DownloadVersionPicker, _React$PureComponent);

  function DownloadVersionPicker(props) {
    DownloadVersionPicker__classCallCheck(this, DownloadVersionPicker);

    var _this = DownloadVersionPicker__possibleConstructorReturn(this, (DownloadVersionPicker.__proto__ || Object.getPrototypeOf(DownloadVersionPicker)).call(this, props));

    _this.doPickVersion = function (e) {
      _this.props.onPickVersion(e.target.value);
    };

    _this.doDownload = function () {
      if (!_this.state.formEnabled) {
        return;
      }

      _this.setState({ formEnabled: false, fetching: true });
      _this.props.onDownloadClip().then(function () {
        return _this.setState({ fetching: false });
      }).catch(function () {
        return _this.setState({ fetching: false, formEnabled: true });
      });
    };

    _this.state = {
      formEnabled: true,
      fetching: false
    };
    return _this;
  }

  DownloadVersionPicker__createClass(DownloadVersionPicker, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          alreadyLicensed = _props.alreadyLicensed,
          pastDue = _props.pastDue,
          selectedVersion = _props.selectedVersion,
          onPickVersion = _props.onPickVersion,
          downloadablesFetching = _props.downloadablesFetching,
          downloadables = _props.downloadables,
          onDownloadClip = _props.onDownloadClip,
          otherProps = DownloadVersionPicker__objectWithoutProperties(_props, ['alreadyLicensed', 'pastDue', 'selectedVersion', 'onPickVersion', 'downloadablesFetching', 'downloadables', 'onDownloadClip']);

      var selectedAvailable = downloadables.allVersions.includes(selectedVersion);
      var selectedDownloadable = downloadables.downloadableVerions.includes(selectedVersion);
      var buttonText = 'Download Now';
      var buttonArrow = false;
      if (selectedAvailable && !selectedDownloadable) {
        buttonText = 'Continue';
        buttonArrow = true;
      }

      var unavailableText = 'AVAILABLE w/ UPGRADE';
      if (pastDue) {
        unavailableText = 'ACCOUNT PAST DUE!';
      }

      return DownloadVersionPicker__jsx('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '11rem 4rem 6rem'
        }
      }, void 0, DownloadVersionPicker__jsx(Typography["c" /* H3 */], {
        style: { marginBottom: '7rem' }
      }, void 0, 'Download this clip', alreadyLicensed ? ' again' : ''), DownloadVersionPicker__jsx(Typography["h" /* L2 */], {
        style: {
          color: Style["a" /* default */].Colors.shadow3,
          marginBottom: '1rem',
          display: 'block'
        }
      }, void 0, 'CHOOSE YOUR FORMAT'), DownloadVersionPicker__jsx(Form["b" /* Form */], {
        onSubmit: this.doDownload,
        style: { alignItems: 'flex-start', paddingLeft: '2rem' }
      }, void 0, constants["b" /* CLIP_MEDIA_VERSIONS_ORDER */].map(function (version) {
        var available = downloadables.allVersions.includes(version);
        if (!available) {
          return null;
        }

        var text = constants["d" /* CLIP_MEDIA_VERSION_LABELS */][version];
        var graded = constants["c" /* CLIP_MEDIA_VERSION_GRADED */][version];
        var canDownload = downloadables.downloadableVerions.includes(version);

        return DownloadVersionPicker__jsx('div', {
          style: { margin: '1rem 0' }
        }, version, DownloadVersionPicker__jsx('input', {
          type: 'radio',
          id: 'download_' + version,
          name: 'version',
          value: version,
          onChange: _this2.doPickVersion,
          checked: version === selectedVersion,
          style: { display: 'none' }
        }), DownloadVersionPicker__jsx('label', {
          htmlFor: 'download_' + version
        }, void 0, DownloadVersionPicker__jsx(Typography["m" /* P1 */], {
          style: { display: 'inline' }
        }, void 0, DownloadVersionPicker__jsx('span', {
          style: { marginRight: '1rem' }
        }, void 0, DownloadVersionPicker__jsx(Radio, {
          size: '1em',
          checked: version === selectedVersion
        })), text), DownloadVersionPicker__jsx(Icons["u" /* Info */], {
          color: Style["a" /* default */].Colors.black,
          style: {
            maxWidth: '1.6rem',
            opacity: 0.5,
            display: graded || true ? 'none' : 'inline'
          }
        }), DownloadVersionPicker__jsx(Typography["k" /* L4 */], {
          style: {
            marginLeft: '2rem',
            opacity: 0.5,
            fontWeight: 400,
            display: canDownload ? 'none' : 'inline',
            letterSpacing: '0.07rem'
          }
        }, void 0, unavailableText)));
      })), DownloadVersionPicker__jsx('div', {
        style: { alignSelf: 'center', marginTop: '8rem' }
      }, void 0, DownloadVersionPicker__jsx(Button["a" /* default */], {
        size: 'large',
        type: 'submit',
        arrow: buttonArrow,
        onClick: this.doDownload,
        working: this.state.fetching || downloadablesFetching
      }, void 0, buttonText)));
    }
  }]);

  return DownloadVersionPicker;
}(react_default.a.PureComponent);

DownloadVersionPicker_DownloadVersionPicker.defaultProps = {};


/* harmony default export */ var components_DownloadVersionPicker_DownloadVersionPicker = (DownloadVersionPicker_DownloadVersionPicker);

function Radio(_ref) {
  var size = _ref.size,
      checked = _ref.checked;

  var containerStyle = {
    fontSize: size,
    display: 'inline-block'
  };

  var borderStyle = {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '1em',
    height: '1em',
    borderRadius: '99999rem',
    border: '0.05em solid ' + Style["a" /* default */].Colors.black,
    backgroundColor: Style["a" /* default */].Colors.white
  };

  var checkStyle = {
    display: 'inline-block',
    width: 14 / 18 + 'em',
    height: 14 / 18 + 'em',
    borderRadius: '99999rem',
    backgroundColor: checked ? Style["a" /* default */].Colors.black : Style["a" /* default */].Colors.white,
    padding: '0.111em'
  };

  return DownloadVersionPicker__jsx('span', {
    style: containerStyle
  }, void 0, DownloadVersionPicker__jsx('span', {
    style: borderStyle
  }, void 0, DownloadVersionPicker__jsx('span', {
    style: checkStyle
  })));
}
// EXTERNAL MODULE: ./src/components/SecondaryAction/SecondaryAction.js
var SecondaryAction = __webpack_require__(916);

// CONCATENATED MODULE: ./src/components/LicenseInput/LicenseInput.js
var LicenseInput__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LicenseInput__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LicenseInput__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function LicenseInput__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LicenseInput__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LicenseInput__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var LicenseInput__ref = LicenseInput__jsx('span', {}, void 0, '\xA0');

var LicenseInput__ref2 = LicenseInput__jsx(Link["a" /* default */], {
  underline: true,
  to: '/legal',
  target: '_blank'
}, void 0, 'terms of use');

var LicenseInput_LicenseInput = function (_React$PureComponent) {
  LicenseInput__inherits(LicenseInput, _React$PureComponent);

  function LicenseInput(props) {
    LicenseInput__classCallCheck(this, LicenseInput);

    var _this = LicenseInput__possibleConstructorReturn(this, (LicenseInput.__proto__ || Object.getPrototypeOf(LicenseInput)).call(this, props));

    _this.onChange = function (value) {
      _this.setState({ error: '', description: value });
    };

    _this.onSubmit = function () {
      if (!_this.state.formEnabled) {
        return;
      }

      if (_this.state.description.length < constants["v" /* MINIMUM_DESCRIPTION_LENGTH */]) {
        _this.setState({ error: 'Description is too short.' });
        return;
      }

      _this.setState({ formEnabled: false, fetching: true });
      _this.props.onSubmit(_this.state.description).then(function () {
        return _this.setState({ fetching: false });
      }).catch(function () {
        return _this.setState({
          formEnabled: true,
          fetching: false,
          error: 'Uh oh. Something went wrong'
        });
      });
    };

    _this.state = {
      fetching: false,
      formEnabled: true,
      description: '',
      error: ''
    };
    return _this;
  }

  LicenseInput__createClass(LicenseInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onCancel = _props.onCancel,
          onSubmit = _props.onSubmit,
          licensingError = _props.licensingError,
          otherProps = LicenseInput__objectWithoutProperties(_props, ['onCancel', 'onSubmit', 'licensingError']);

      return LicenseInput__jsx('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '10rem 6rem 6rem'
        }
      }, void 0, LicenseInput__jsx(Typography["c" /* H3 */], {
        style: { marginBottom: '4rem' }
      }, void 0, 'License this clip'), LicenseInput__jsx(Form["b" /* Form */], {
        onSubmit: this.onSubmit
      }, void 0, LicenseInput__jsx(Form["c" /* Input */], {
        name: 'description',
        type: 'text',
        value: this.state.description,
        onChange: this.onChange,
        placeholder: 'Describe your video project here...'
      }, void 0, 'HOW WILL YOU USE THIS CLIP?')), LicenseInput__jsx('span', {
        style: {
          width: '100%',
          marginTop: '1rem',
          color: Style["a" /* default */].Colors.error
        }
      }, void 0, licensingError || this.state.error || LicenseInput__ref), LicenseInput__jsx(Typography["j" /* L3 */], {
        style: {
          display: 'block',
          width: '100%',
          marginTop: '4rem',
          color: Style["a" /* default */].Colors.shadow2
        }
      }, void 0, 'TERMS & CONDITIONS'), LicenseInput__jsx(Typography["m" /* P1 */], {
        style: {
          display: 'block',
          marginBottom: '6rem',
          color: Style["a" /* default */].Colors.shadow3
        }
      }, void 0, 'By licensing this clip, you agree to our', ' ', LicenseInput__ref2, ', and agree to only use it for your specified project.'), LicenseInput__jsx(Button["a" /* default */], {
        arrow: true,
        onClick: this.onSubmit,
        working: this.state.fetching
      }, void 0, 'Agree & Continue'), LicenseInput__jsx(SecondaryAction["a" /* default */], {
        onClick: onCancel
      }, void 0, 'Cancel'));
    }
  }]);

  return LicenseInput;
}(react_default.a.PureComponent);

LicenseInput_LicenseInput.defaultProps = {};


/* harmony default export */ var components_LicenseInput_LicenseInput = (LicenseInput_LicenseInput);
// CONCATENATED MODULE: ./src/components/NoMoreLicenses/NoMoreLicenses.js
var NoMoreLicenses__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var NoMoreLicenses__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NoMoreLicenses__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function NoMoreLicenses__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NoMoreLicenses__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NoMoreLicenses__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var NoMoreLicenses__ref = NoMoreLicenses__jsx(Typography["c" /* H3 */], {}, void 0, 'License this\xA0clip');

var NoMoreLicenses_NoMoreLicenses = function (_React$PureComponent) {
  NoMoreLicenses__inherits(NoMoreLicenses, _React$PureComponent);

  function NoMoreLicenses() {
    NoMoreLicenses__classCallCheck(this, NoMoreLicenses);

    return NoMoreLicenses__possibleConstructorReturn(this, (NoMoreLicenses.__proto__ || Object.getPrototypeOf(NoMoreLicenses)).apply(this, arguments));
  }

  NoMoreLicenses__createClass(NoMoreLicenses, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          licensesResetAt = _props.licensesResetAt,
          onGoToPlan = _props.onGoToPlan,
          onCancel = _props.onCancel,
          otherProps = NoMoreLicenses__objectWithoutProperties(_props, ['licensesResetAt', 'onGoToPlan', 'onCancel']);

      var atTime = ' ';
      if (licensesResetAt !== undefined) {
        atTime = ' ' + moment_default()(licensesResetAt).calendar().toLowerCase() + ' when ';
      }

      return NoMoreLicenses__jsx('div', {
        style: {
          padding: '12rem 3rem 3rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center'
        }
      }, void 0, NoMoreLicenses__ref, NoMoreLicenses__jsx(Typography["f" /* H6 */], {
        style: { margin: '4.5rem auto 0', maxWidth: '27rem' }
      }, void 0, 'Whoops! You don\u2019t have any more licenses available on your current subscription.'), NoMoreLicenses__jsx(Typography["m" /* P1 */], {
        style: { margin: '3rem auto 0', maxWidth: '32rem' }
      }, void 0, 'You can seamlessly upgrade to a new plan to continue licensing, or wait to license this clip until', atTime, 'your plan renews.', ' '), NoMoreLicenses__jsx('div', {
        style: { marginTop: '7rem' }
      }, void 0, NoMoreLicenses__jsx(Button["a" /* default */], {
        arrow: true,
        onClick: onGoToPlan
      }, void 0, 'Upgrade Subscription')), NoMoreLicenses__jsx(SecondaryAction["a" /* default */], {
        onClick: onCancel
      }, void 0, 'Cancel'));
    }
  }]);

  return NoMoreLicenses;
}(react_default.a.PureComponent);

NoMoreLicenses_NoMoreLicenses.defaultProps = {};


/* harmony default export */ var components_NoMoreLicenses_NoMoreLicenses = (NoMoreLicenses_NoMoreLicenses);
// EXTERNAL MODULE: ./src/components/Payment/Payment.js
var Payment = __webpack_require__(937);

// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__(355);
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);

// EXTERNAL MODULE: ./src/components/Toggle/Toggle.js
var Toggle = __webpack_require__(935);

// EXTERNAL MODULE: ./src/components/SubscriptionPlans/SubscriptionPlans.js
var SubscriptionPlans = __webpack_require__(1076);

// CONCATENATED MODULE: ./src/components/Plans/Plans.js
var Plans__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Plans__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Plans__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Plans__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Plans__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Plans__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Plans__ref = Plans__jsx(Typography["c" /* H3 */], {}, void 0, 'Now, choose your subscription');

var Plans_Plans = function (_React$PureComponent) {
  Plans__inherits(Plans, _React$PureComponent);

  function Plans(props) {
    Plans__classCallCheck(this, Plans);

    var _this = Plans__possibleConstructorReturn(this, (Plans.__proto__ || Object.getPrototypeOf(Plans)).call(this, props));

    _this.onToggleAnnual = function (newValue) {
      _this.setState({ fetching: true, formEnabled: false });
      _this.props.onChangePlan({
        name: _this.props.chosenPlan.name,
        annual: newValue
      }).then(function () {
        return _this.setState({ fetching: false, formEnabled: true });
      }).catch(function () {
        return _this.setState({ fetching: false, formEnabled: true });
      });
    };

    _this.onTogglePlan = function (name) {
      _this.setState({ fetching: true, formEnabled: false });
      _this.props.onChangePlan({
        name: name,
        annual: _this.props.chosenPlan.annual
      }).then(function () {
        return _this.setState({ fetching: false, formEnabled: true });
      }).catch(function () {
        return _this.setState({ fetching: false, formEnabled: true });
      });
    };

    _this.onDoConfirmPlan = function (plan) {
      if (!_this.state.formEnabled) {
        return;
      }

      if (_this.props.chosenPlan.name === undefined || _this.props.chosenPlan.annual === undefined) {
        return;
      }

      _this.setState({ fetching: true, formEnabled: false });
      _this.props.onConfirmPlan(plan).then(function () {
        return _this.setState({ fetching: false });
      }).catch(function () {
        return _this.setState({ fetching: false, formEnabled: true });
      });
    };

    _this.state = {
      fetching: false,
      formEnabled: true
    };
    return _this;
  }

  Plans__createClass(Plans, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          activePlan = _props.activePlan,
          chosenPlan = _props.chosenPlan,
          onChangePlan = _props.onChangePlan,
          onConfirmPlan = _props.onConfirmPlan,
          otherProps = Plans__objectWithoutProperties(_props, ['activePlan', 'chosenPlan', 'onChangePlan', 'onConfirmPlan']);

      var mergedPlans = _extends({}, activePlan, pickBy_default()(chosenPlan, function (v) {
        return v !== undefined;
      }));

      return Plans__jsx('div', {}, void 0, Plans__jsx('div', {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '3rem 3rem 0',
          alignItems: 'center'
        }
      }, void 0, Plans__jsx('span', {
        style: { minWidth: '12.5rem' }
      }, void 0, 'Paying ', mergedPlans.annual ? 'Annually' : 'Monthly', ' '), Plans__jsx(Toggle["a" /* default */], {
        checked: mergedPlans.annual,
        onToggle: this.onToggleAnnual
      })), Plans__jsx('div', {
        style: {
          padding: '2rem 6.5rem 6rem 5.5rem'
        }
      }, void 0, Plans__ref, Plans__jsx(Typography["m" /* P1 */], {
        style: { marginBottom: '2rem' }
      }, void 0, 'Upgrade, downgrade, or cancel anytime.'), Plans__jsx(SubscriptionPlans["a" /* default */], {
        plan: mergedPlans,
        onSelectPlan: this.onTogglePlan
      }), Plans__jsx('div', {
        style: {
          display: 'flex',
          justifyContent: 'center',
          marginTop: '5.5rem'
        }
      }, void 0, Plans__jsx(Button["a" /* default */], {
        arrow: true,
        onClick: this.onDoConfirmPlan,
        working: this.state.fetching
      }, void 0, 'Continue'))));
    }
  }]);

  return Plans;
}(react_default.a.PureComponent);

Plans_Plans.defaultProps = {};


/* harmony default export */ var components_Plans_Plans = (Plans_Plans);
// CONCATENATED MODULE: ./src/components/Licensing/Licensing.js
var Licensing__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Licensing__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Licensing__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Licensing__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Licensing__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Licensing_Licensing = function (_React$PureComponent) {
  Licensing__inherits(Licensing, _React$PureComponent);

  function Licensing() {
    Licensing__classCallCheck(this, Licensing);

    return Licensing__possibleConstructorReturn(this, (Licensing.__proto__ || Object.getPrototypeOf(Licensing)).apply(this, arguments));
  }

  Licensing__createClass(Licensing, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          step = _props.step,
          onCancel = _props.onCancel,
          onLicenseClip = _props.onLicenseClip,
          licensingError = _props.licensingError,
          onPickVersion = _props.onPickVersion,
          desiredVersion = _props.desiredVersion,
          downloadables = _props.downloadables,
          downloadablesFetching = _props.downloadablesFetching,
          onDownloadClip = _props.onDownloadClip,
          downloadClipError = _props.downloadClipError,
          alreadyLicensed = _props.alreadyLicensed,
          pastDue = _props.pastDue,
          chosenPlan = _props.chosenPlan,
          couponCode = _props.couponCode,
          couponError = _props.couponError,
          activePlan = _props.activePlan,
          planSummary = _props.planSummary,
          hasSubscription = _props.hasSubscription,
          paymentError = _props.paymentError,
          onGoToPlan = _props.onGoToPlan,
          onChangePlan = _props.onChangePlan,
          onChangeCoupon = _props.onChangeCoupon,
          onConfirmPlan = _props.onConfirmPlan,
          onUpdateSubscription = _props.onUpdateSubscription,
          otherProps = Licensing__objectWithoutProperties(_props, ['step', 'onCancel', 'onLicenseClip', 'licensingError', 'onPickVersion', 'desiredVersion', 'downloadables', 'downloadablesFetching', 'onDownloadClip', 'downloadClipError', 'alreadyLicensed', 'pastDue', 'chosenPlan', 'couponCode', 'couponError', 'activePlan', 'planSummary', 'hasSubscription', 'paymentError', 'onGoToPlan', 'onChangePlan', 'onChangeCoupon', 'onConfirmPlan', 'onUpdateSubscription']);

      var downloadVersionPickerProps = {
        alreadyLicensed: alreadyLicensed,
        pastDue: pastDue,
        selectedVersion: desiredVersion,
        onPickVersion: onPickVersion,
        downloadables: downloadables,
        downloadablesFetching: downloadablesFetching,
        onDownloadClip: onDownloadClip
      };
      var licenseInputProps = {
        onSubmit: onLicenseClip,
        onCancel: onCancel,
        licensingError: licensingError
      };
      var noMoreLicensesProps = {
        onGoToPlan: onGoToPlan,
        onCancel: onCancel
      };
      var planProps = {
        chosenPlan: chosenPlan,
        activePlan: activePlan,
        onChangePlan: onChangePlan,
        onConfirmPlan: onConfirmPlan
      };
      var paymentProps = {
        allowCoupon: !hasSubscription,
        paymentOnFile: hasSubscription,
        chosenPlan: chosenPlan,
        couponCode: couponCode,
        couponError: couponError,
        paymentError: paymentError,
        planSummary: planSummary,
        onGoToPlan: onGoToPlan,
        onChangeCoupon: onChangeCoupon,
        onCreateSubscription: onUpdateSubscription
      };

      var activeItem = void 0;
      switch (step) {
        case constants["r" /* LICENSING_STEP */].LICENSE_DESCRIPTION:
          activeItem = {
            id: 'description',
            element: react_default.a.createElement(components_LicenseInput_LicenseInput, licenseInputProps)
          };
          break;
        case constants["r" /* LICENSING_STEP */].OUT_OF_LICENSES:
          activeItem = {
            id: 'noMore',
            element: react_default.a.createElement(components_NoMoreLicenses_NoMoreLicenses, noMoreLicensesProps)
          };
          break;
        case constants["r" /* LICENSING_STEP */].PICK_VERSION:
          activeItem = {
            id: 'pickVersion',
            element: react_default.a.createElement(components_DownloadVersionPicker_DownloadVersionPicker, downloadVersionPickerProps)
          };
          break;
        case constants["r" /* LICENSING_STEP */].PLAN:
          activeItem = {
            id: 'plan',
            element: react_default.a.createElement(components_Plans_Plans, planProps)
          };
          break;
        case constants["r" /* LICENSING_STEP */].PAY:
          activeItem = {
            id: 'payment',
            element: react_default.a.createElement(Payment["b" /* default */], paymentProps)
          };
          break;
        default:
          activeItem = { id: 'nothing', element: null };
          break;
      }

      return react_default.a.createElement(ElementTransition["a" /* default */], activeItem);
    }
  }]);

  return Licensing;
}(react_default.a.PureComponent);

Licensing_Licensing.defaultProps = {};


/* harmony default export */ var components_Licensing_Licensing = (Licensing_Licensing);
// EXTERNAL MODULE: ./node_modules/react-motion/lib/react-motion.js
var react_motion = __webpack_require__(353);
var react_motion_default = /*#__PURE__*/__webpack_require__.n(react_motion);

// EXTERNAL MODULE: ./src/lib/Motion.js
var Motion = __webpack_require__(352);

// EXTERNAL MODULE: ./src/components/Hoverable/Hoverable.js
var Hoverable = __webpack_require__(894);

// EXTERNAL MODULE: ./src/components/Aspect/Aspect.js
var Aspect = __webpack_require__(1071);

// EXTERNAL MODULE: ./src/components/Section/Section.js
var Section = __webpack_require__(933);

// CONCATENATED MODULE: ./src/components/Modal/Modal.js
var Modal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Modal__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Modal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Modal__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Modal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Modal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Modal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var FULL_STYLE = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var Modal_Modal = function (_React$PureComponent) {
  Modal__inherits(Modal, _React$PureComponent);

  function Modal(props) {
    Modal__classCallCheck(this, Modal);

    var _this = Modal__possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    Modal__initialiseProps.call(_this);

    var defaultStyles = _this.getStyles(props);
    _this.state = {
      fullContentBaseStyle: Object(Motion["c" /* springable */])(defaultStyles.fullContentStyle),
      leftBaseStyle: Object(Motion["c" /* springable */])(defaultStyles.leftStyle),
      rightBaseStyle: Object(Motion["c" /* springable */])(defaultStyles.rightStyle)
    };
    return _this;
  }

  Modal__createClass(Modal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          layout = _props.layout,
          styles = _props.styles,
          colors = _props.colors,
          onClose = _props.onClose,
          backgroundContent = _props.backgroundContent,
          fullContent = _props.fullContent,
          leftContent = _props.leftContent,
          rightContent = _props.rightContent,
          children = _props.children,
          otherProps = Modal__objectWithoutProperties(_props, ['layout', 'styles', 'colors', 'onClose', 'backgroundContent', 'fullContent', 'leftContent', 'rightContent', 'children']);

      var composedStyles = this.getStyles(this.props);

      return Modal__jsx('div', {
        style: {
          overflowX: 'hidden',
          backgroundColor: color_default()(colors.light).alpha(0.98),
          position: 'fixed',
          zIndex: 3000,
          minHeight: '100vh',
          minWidth: '100vw',
          top: 0,
          left: 0
        }
      }, void 0, Modal__jsx(Section["a" /* default */], {
        style: {
          position: 'absolute',
          top: '30rem',
          width: '100vw',
          zIndex: 1
        },
        angle: 20,
        topMargin: 0,
        backgroundColor: colors.dark
      }), Modal__jsx('div', {
        style: composedStyles.scrollBoxStyle
      }, void 0, Modal__jsx(Hoverable["b" /* default */], {
        style: composedStyles.closeButtonStyle,
        onClick: this.closeClicked
      }, void 0, Modal__jsx(Icons["O" /* X */], {
        style: { maxWidth: composedStyles.closeButtonStyle.maxWidth },
        color: colors.dark
      })), Modal__jsx('div', {
        style: composedStyles.containerStyle
      }, void 0, Modal__jsx('div', {
        style: composedStyles.backgroundStyle
      }, void 0, Modal__jsx('div', {
        style: Modal__extends({}, FULL_STYLE, { pointerEvents: 'none' })
      }, void 0, backgroundContent), Modal__jsx('div', {
        style: Modal__extends({}, FULL_STYLE, { zIndex: 1 })
      }, void 0, Modal__jsx(react_motion["Motion"], {
        defaultStyle: this.state.fullContentBaseStyle,
        style: Object(Motion["d" /* springify */])(composedStyles.fullContentStyle)
      }, void 0, function (tweens) {
        return Modal__jsx('div', {
          style: Modal__extends({}, composedStyles.fullContentStyle, tweens)
        }, void 0, fullContent);
      })), Modal__jsx('div', {
        style: composedStyles.splitterStyle
      }, void 0, Modal__jsx(react_motion["Motion"], {
        defaultStyle: this.state.leftBaseStyle,
        style: Object(Motion["d" /* springify */])(composedStyles.leftStyle)
      }, void 0, function (tweens) {
        return Modal__jsx('div', {
          style: Modal__extends({}, composedStyles.leftStyle, tweens, {
            opacity: tweens.opacity,
            flex: '1 1 ' + tweens.flexBasis + '%',
            width: tweens.width + '%',
            maxWidth: tweens.maxWidth + '%'
          })
        }, void 0, leftContent);
      }), Modal__jsx(react_motion["Motion"], {
        defaultStyle: this.state.rightBaseStyle,
        style: Object(Motion["d" /* springify */])(composedStyles.rightStyle)
      }, void 0, function (tweens) {
        return Modal__jsx('div', {
          style: Modal__extends({}, composedStyles.rightStyle, tweens, {
            flex: '1 1 ' + tweens.flexBasis + '%',
            width: tweens.width + '%',
            maxWidth: tweens.maxWidth + '%'
          })
        }, void 0, rightContent);
      }))))));
    }
  }]);

  return Modal;
}(react_default.a.PureComponent);

Modal_Modal.defaultProps = {
  styles: constants["l" /* EMPTY_OBJECT */]
};

var Modal__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.closeClicked = function (e) {
    _this2.props.onClose();
  };

  this.getStyles = function (props) {
    var containerMargin = '1rem auto 20rem';
    var closeButtonBottomMargin = '-1rem';
    var closeButtonHeight = 0;
    var closeButtonMaxWidth = '2rem';
    var closeButtonPosition = 'relative';
    var leftMax = 0;
    var rightMax = 100;
    var scrollBoxPadding = '1rem';
    var borderRadius = '0.6rem';
    var maxHeight = undefined;

    if (props.responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE) {
      containerMargin = '5rem auto 10rem';
      closeButtonBottomMargin = undefined;
      closeButtonHeight = undefined;
      closeButtonMaxWidth = undefined;
      closeButtonPosition = 'static';
      scrollBoxPadding = '5rem';
    }
    if (props.responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT) {
      leftMax = 20;
    }
    if (props.responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE) {
      containerMargin = '10rem auto 10rem';
      maxHeight = '60rem';
      leftMax = 100;
    }

    var composedStyles = {
      backgroundStyle: {
        backgroundColor: Style["a" /* default */].Colors.black,
        minHeight: '60rem',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch'
      },
      scrollBoxStyle: {
        padding: scrollBoxPadding,
        paddingRight: 'calc(' + scrollBoxPadding + ' + 5rem)',
        marginRight: '-5rem',
        overflowY: 'scroll',
        maxHeight: '100vh'
      },
      closeButtonStyle: {
        position: closeButtonPosition,
        top: '2rem',
        left: '2rem',
        marginBottom: closeButtonBottomMargin,
        zIndex: 500,
        maxWidth: closeButtonMaxWidth,
        maxHeight: closeButtonHeight,
        display: 'block',
        cursor: 'pointer'
      },
      containerStyle: {
        position: 'relative',
        zIndex: 10,
        boxShadow: '2.4rem 2.4rem 0 0 ' + props.colors.highlight,
        borderRadius: borderRadius,
        overflow: 'hidden',
        maxWidth: '105rem',
        margin: containerMargin
      },
      fullContentStyle: Modal__extends({}, FULL_STYLE, {
        zIndex: 1,
        opacity: 0,
        pointerEvents: 'none',
        color: Style["a" /* default */].Colors.white
      }),
      splitterStyle: {
        position: 'relative',
        zIndex: 5,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        width: '100%'
      },
      leftStyle: {
        position: 'relative',
        overflow: 'hidden',
        opacity: 0,
        maxHeight: maxHeight,
        maxWidth: leftMax,
        pointerEvents: 'none',
        color: Style["a" /* default */].Colors.white
      },
      rightStyle: {
        overflow: 'hidden',
        flexBasis: 0,
        width: 0,
        maxWidth: rightMax,
        maxHeight: maxHeight,
        backgroundColor: Style["a" /* default */].Colors.white
      }
    };

    switch (props.layout) {
      case constants["x" /* MODAL_LAYOUT */].BACKGROUND:
        break;
      case constants["x" /* MODAL_LAYOUT */].FULL:
        composedStyles.fullContentStyle.opacity = 1;
        composedStyles.fullContentStyle.pointerEvents = undefined;
        composedStyles.splitterStyle.pointerEvents = 'none';
        composedStyles.leftStyle.maxWidth = 0;
        composedStyles.rightStyle.maxWidth = 0;
        break;
      case constants["x" /* MODAL_LAYOUT */].EQUAL_SPLIT:
        composedStyles.leftStyle.opacity = 1;
        composedStyles.leftStyle.pointerEvents = undefined;
        composedStyles.leftStyle.flexBasis = 50;
        composedStyles.leftStyle.width = 50;
        composedStyles.rightStyle.flexBasis = 50;
        composedStyles.rightStyle.width = 50;
        break;
      case constants["x" /* MODAL_LAYOUT */].LEFT:
        composedStyles.leftStyle.opacity = 1;
        composedStyles.leftStyle.pointerEvents = undefined;
        composedStyles.leftStyle.flexBasis = 80;
        composedStyles.leftStyle.width = 80;
        composedStyles.rightStyle.flexBasis = 20;
        composedStyles.rightStyle.width = 20;
        break;
      case constants["x" /* MODAL_LAYOUT */].RIGHT:
        composedStyles.leftStyle.opacity = 1;
        composedStyles.leftStyle.pointerEvents = undefined;
        composedStyles.leftStyle.flexBasis = 20;
        composedStyles.leftStyle.width = 20;
        composedStyles.rightStyle.flexBasis = 80;
        composedStyles.rightStyle.width = 80;
        break;
      default:
    }

    Object.keys(composedStyles).map(function (styleKey) {
      return composedStyles[styleKey] = Modal__extends({}, composedStyles[styleKey], props.styles[styleKey] || constants["l" /* EMPTY_OBJECT */]);
    });

    return composedStyles;
  };
};

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive
  };
}

/* harmony default export */ var components_Modal_Modal = (Object(es["connect"])(mapStateToProps)(Modal_Modal));
// EXTERNAL MODULE: ./src/components/Video/Video.js
var Video = __webpack_require__(934);

// CONCATENATED MODULE: ./src/containers/LicensingModal/LicensingModal.js
var LicensingModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var LicensingModal__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LicensingModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LicensingModal__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function LicensingModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LicensingModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LicensingModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var LicensingModal_LicensingModal = function (_React$PureComponent) {
  LicensingModal__inherits(LicensingModal, _React$PureComponent);

  function LicensingModal(props) {
    LicensingModal__classCallCheck(this, LicensingModal);

    var _this = LicensingModal__possibleConstructorReturn(this, (LicensingModal.__proto__ || Object.getPrototypeOf(LicensingModal)).call(this, props));

    _this.parseLicensingError = function (err) {
      return String(err);
    };

    _this.doGetDownloadables = function (clipId) {
      _this.setState({ downloadablesFetching: true });
      return _this.props.onGetDownloadables(_this.props.clip.clip_id).then(function (downloadables) {
        return _this.setState({
          downloadables: downloadables,
          downloadablesFetching: false
        });
      });
    };

    _this.doLicenseClip = function (description) {
      var stateUpdate = {};
      return _this.props.onLicenseClip(_this.props.clip.clip_id, description).then(function (license) {
        return stateUpdate['downloadLicense'] = license;
      }).catch(function (err) {
        stateUpdate['licensingError'] = _this.parseLicensingError(err);
        throw err;
      }).then(function () {
        return _this.doGetDownloadables(_this.props.clip.clips_id);
      }).then(function () {
        return _this.setState(stateUpdate);
      }).catch(function (err) {
        _this.setState(stateUpdate);
        throw err;
      });
    };

    _this.doPickVersion = function (version) {
      _this.setState({ desiredVersion: version });
    };

    _this.doDownloadClip = function () {
      var version = _this.state.desiredVersion;

      if (!_this.state.downloadables.downloadableVerions.includes(version)) {
        _this.setState({ overrideStep: constants["r" /* LICENSING_STEP */].PLAN });
        return Promise.resolve();
      }

      return _this.props.onDownloadClip(_this.props.clip.clip_id, version, _this.state.downloadLicense.licensedAt).then(function (url) {
        _this.setState({
          downloadUrl: url,
          overrideStep: constants["r" /* LICENSING_STEP */].DOWNLOADING
        });
        window.location = url;
      });
    };

    _this.doUpdateSubscription = function (tokenId, plan) {
      return _this.props.onUpdateSubscription(tokenId, plan).then(function () {
        return _this.props.refreshSubscription();
      }).then(function () {
        if (_this.state.downloadLicense) {
          return _this.doGetDownloadables(_this.props.clip.clip_id);
        } else {
          return Promise.resolve();
        }
      }).then(function () {
        return _this.setState({ overrideStep: undefined });
      });
    };

    _this.doConfirmPlan = function (plan) {
      return _this.props.onConfirmPlan(plan).then(function () {
        return _this.setState({ overrideStep: constants["r" /* LICENSING_STEP */].PAY });
      });
    };

    _this.doChangePlan = function (plan) {
      if (_this.props.hasSubscription) {
        // Lockout changing the interval of an active subscription.
        return _this.props.onChangePlan({ name: plan.name });
      } else {
        return _this.props.onChangePlan(plan);
      }
    };

    _this.getStep = function () {
      // That's why they call it an override.
      if (_this.state.overrideStep !== undefined) {
        return _this.state.overrideStep;
      }

      if (_this.state.downloadLicense !== undefined) {
        return constants["r" /* LICENSING_STEP */].PICK_VERSION;
      }

      if (!_this.props.hasSubscription) {
        return constants["r" /* LICENSING_STEP */].PLAN;
      }

      if (_this.props.canLicense) {
        return constants["r" /* LICENSING_STEP */].LICENSE_DESCRIPTION;
      }

      // No existing license and cannot create a new license.
      return constants["r" /* LICENSING_STEP */].OUT_OF_LICENSES;
    };

    _this.getLayout = function (step) {
      switch (step) {
        case constants["r" /* LICENSING_STEP */].DOWNLOADING:
          return constants["x" /* MODAL_LAYOUT */].FULL;
        case constants["r" /* LICENSING_STEP */].PLAN:
        case constants["r" /* LICENSING_STEP */].PAY:
          return constants["x" /* MODAL_LAYOUT */].RIGHT;
        default:
          return constants["x" /* MODAL_LAYOUT */].EQUAL_SPLIT;
      }
    };

    _this.state = {
      // Only set on initial render.
      alreadyLicensed: props.usingLicense !== undefined,
      // Will be set if they license the clip.
      downloadLicense: props.usingLicense,
      licensingError: '',
      overrideStep: undefined,
      desiredVersion: undefined,
      downloadUrl: undefined,
      downloadablesFetching: false,
      downloadables: {
        allVersions: constants["k" /* EMPTY_ARRAY */],
        downloadableVerions: constants["k" /* EMPTY_ARRAY */]
      },
      colors: Object(Color["d" /* themeColors */])(_this.props.clip.scene_colors)
    };
    return _this;
  }

  LicensingModal__createClass(LicensingModal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.state.downloadLicense) {
        this.doGetDownloadables(this.props.clip.clip_id);
      }
      this.props.refreshSubscription();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          clip = _props.clip,
          usingLicense = _props.usingLicense,
          backTo = _props.backTo,
          onBackTo = _props.onBackTo,
          goTo = _props.goTo,
          onGoTo = _props.onGoTo,
          onClose = _props.onClose,
          refreshSubscription = _props.refreshSubscription,
          hasSubscription = _props.hasSubscription,
          canLicense = _props.canLicense,
          pastDue = _props.pastDue,
          chosenPlan = _props.chosenPlan,
          couponCode = _props.couponCode,
          couponError = _props.couponError,
          activePlan = _props.activePlan,
          planSummary = _props.planSummary,
          paymentError = _props.paymentError,
          onChangePlan = _props.onChangePlan,
          onChangeCoupon = _props.onChangeCoupon,
          onConfirmPlan = _props.onConfirmPlan,
          onUpdateSubscription = _props.onUpdateSubscription,
          onLicenseClip = _props.onLicenseClip,
          onDownloadClip = _props.onDownloadClip,
          otherProps = LicensingModal__objectWithoutProperties(_props, ['clip', 'usingLicense', 'backTo', 'onBackTo', 'goTo', 'onGoTo', 'onClose', 'refreshSubscription', 'hasSubscription', 'canLicense', 'pastDue', 'chosenPlan', 'couponCode', 'couponError', 'activePlan', 'planSummary', 'paymentError', 'onChangePlan', 'onChangeCoupon', 'onConfirmPlan', 'onUpdateSubscription', 'onLicenseClip', 'onDownloadClip']);

      var step = this.getStep();
      var layout = this.getLayout(step);
      var leftContent = {
        id: 'description',
        element: LicensingModal__jsx(ClipDescription, {
          clip: clip,
          license: this.state.alreadyLicensed ? usingLicense : undefined
        })
      };

      if (layout === constants["x" /* MODAL_LAYOUT */].RIGHT) {
        leftContent = { id: 'logo', element: LicensingModal__ref };
      }

      return LicensingModal__jsx(components_Modal_Modal, {
        onClose: onClose,
        layout: layout,
        colors: this.state.colors,
        backgroundContent: LicensingModal__jsx(VideoBackground, {
          clip: clip
        }),
        fullContent: LicensingModal__jsx(components_ClipDownloading_ClipDownloading, {
          downloadUrl: this.state.downloadUrl,
          backTo: backTo,
          onBackTo: onBackTo,
          goTo: goTo,
          onGoTo: onGoTo
        }),
        leftContent: react_default.a.createElement(ElementTransition["a" /* default */], LicensingModal__extends({}, leftContent, {
          optionsLeave: { stiffness: 300 }
        })),
        rightContent: LicensingModal__jsx(components_Licensing_Licensing, {
          step: step,
          onCancel: onClose,
          onLicenseClip: this.doLicenseClip,
          licensingError: this.state.licensingError,
          onPickVersion: this.doPickVersion,
          desiredVersion: this.state.desiredVersion,
          downloadables: this.state.downloadables,
          downloadablesFetching: this.state.downloadablesFetching,
          onDownloadClip: this.doDownloadClip,
          downloadClipError: this.state.downloadClipError,
          alreadyLicensed: this.state.alreadyLicensed,
          pastDue: pastDue,
          chosenPlan: chosenPlan,
          couponCode: couponCode,
          couponError: couponError,
          activePlan: activePlan,
          planSummary: planSummary,
          hasSubscription: hasSubscription,
          paymentError: paymentError,
          onGoToPlan: function onGoToPlan() {
            return _this2.setState({ overrideStep: constants["r" /* LICENSING_STEP */].PLAN });
          },
          onChangePlan: this.doChangePlan,
          onChangeCoupon: onChangeCoupon,
          onConfirmPlan: this.doConfirmPlan,
          onUpdateSubscription: this.doUpdateSubscription
        })
      });
    }
  }]);

  return LicensingModal;
}(react_default.a.PureComponent);

LicensingModal_LicensingModal.defaultProps = {};


function LicensingModal_mapStateToProps(state) {
  var hasSubscription = state.plan.activePlan.status !== undefined && state.plan.activePlan.status !== constants["A" /* PLAN_STATUS */].CANCELED;

  var inGoodStanding = [constants["A" /* PLAN_STATUS */].TRIALING, constants["A" /* PLAN_STATUS */].ACTIVE].includes(state.plan.activePlan.status);

  var canLicense = inGoodStanding && (state.user.subscription.licensesMax < 0 || state.user.subscription.licensesMax > state.user.subscription.licensesUsed);

  return LicensingModal__extends({
    hasSubscription: hasSubscription,
    canLicense: canLicense,
    pastDue: state.plan.activePlan.status === constants["A" /* PLAN_STATUS */].PAST_DUE,
    chosenPlan: state.plan.chosenPlan,
    couponCode: state.plan.couponCode,
    couponError: state.plan.couponError,
    activePlan: state.plan.activePlan,
    paymentError: state.plan.paymentError,
    planSummary: state.plan.chosenSummary
  }, state.modal.props);
}

function mapDispatchToProps(dispatch) {
  return {
    refreshSubscription: function refreshSubscription() {
      return dispatch(Object(actions_plan["b" /* getActiveSubscription */])());
    },
    onClose: function onClose() {
      return dispatch(Object(modal["a" /* hideModal */])());
    },
    onChangePlan: function onChangePlan(plan) {
      return dispatch(Object(actions_plan["f" /* setChosenPlan */])(plan));
    },
    onChangeCoupon: function onChangeCoupon(code) {
      return dispatch(Object(actions_plan["g" /* setCouponCode */])(code));
    },
    onConfirmPlan: function onConfirmPlan(plan) {
      facebook["a" /* default */].track('AddToCart');
      facebook["a" /* default */].track('InitiateCheckout');
      dispatch(Object(helpers["a" /* buildAction */])(constants["M" /* SET_PAYMENT_ERROR */], undefined));
      return dispatch(Object(actions_plan["f" /* setChosenPlan */])(plan));
    },
    onUpdateSubscription: function onUpdateSubscription(stripeTokenId, plan) {
      return dispatch(Object(actions_plan["h" /* subscribe */])(stripeTokenId, plan)).then(function () {
        if (stripeTokenId) {
          facebook["a" /* default */].track('AddPaymentInfo');
        }
        facebook["a" /* default */].track('Purchase', {
          value: Object(actions_plan["d" /* getPlanPrice */])(plan.name),
          currency: 'USD'
        });
      }).catch(function (err) {
        dispatch(Object(helpers["a" /* buildAction */])(constants["M" /* SET_PAYMENT_ERROR */], err.message));
        throw err;
      });
    },
    onLicenseClip: function onLicenseClip(clipId, description) {
      return dispatch(Object(clips["d" /* licenseClip */])(clipId, description));
    },
    onGetDownloadables: function onGetDownloadables(clipId) {
      return dispatch(Object(clips["a" /* clipDownloadables */])(clipId));
    },
    onDownloadClip: function onDownloadClip(clipId, version, licenseDate) {
      return dispatch(Object(clips["b" /* downloadClip */])(clipId, version, licenseDate));
    }
  };
}

/* harmony default export */ var containers_LicensingModal_LicensingModal = (Object(es["connect"])(LicensingModal_mapStateToProps, mapDispatchToProps)(LicensingModal_LicensingModal));

function VideoBackground(_ref2) {
  var clip = _ref2.clip;

  return LicensingModal__jsx('div', {
    style: {
      height: '100%',
      width: '100%',
      backgroundColor: Style["a" /* default */].Colors.black
    }
  }, void 0, LicensingModal__jsx(Video["a" /* default */], {
    src: clip.clip_preview_large,
    poster: clip.clip_poster,
    style: {
      height: 'calc(100% + 1px)',
      opacity: 0.6
    }
  }));
}

function ClipDescriptionComp(_ref3) {
  var responsive = _ref3.responsive,
      clip = _ref3.clip,
      license = _ref3.license;

  return LicensingModal__jsx('div', {
    style: {
      opacity: responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE ? 1 : 0,
      padding: '10rem 3rem 3rem',
      textAlign: 'center',
      color: Style["a" /* default */].Colors.white
    }
  }, void 0, LicensingModal__jsx(Typography["h" /* L2 */], {
    style: { maxWidth: '35rem', margin: 'auto', opacity: 0.75 }
  }, void 0, clip.scene_name.toUpperCase()), LicensingModal__jsx(Typography["e" /* H5 */], {
    style: { maxWidth: '40rem', margin: '2rem auto', fontWeight: 500 }
  }, void 0, clip.clip_name), license && LicensingModal__jsx('div', {}, void 0, LicensingModal__jsx(Typography["g" /* L1 */], {
    style: { display: 'block', marginTop: '8rem' }
  }, void 0, 'licensed: ', moment_default()(license.licensedAt).format('L')), LicensingModal__jsx(Typography["k" /* L4 */], {
    style: { display: 'block', marginTop: '4rem', opacity: 0.75 }
  }, void 0, 'LICENSE DESCRIPTION'), LicensingModal__jsx(Typography["m" /* P1 */], {
    style: { marginTop: '1rem' }
  }, void 0, license.description)));
}

function mapStateToClipDescriptionProps(state) {
  return {
    responsive: state.runtime.responsive
  };
}

var ClipDescription = Object(es["connect"])(mapStateToClipDescriptionProps)(ClipDescriptionComp);

function Logo() {
  return LicensingModal__jsx('div', {
    style: {
      padding: '6rem 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  }, void 0, LicensingModal__jsx(Icons["b" /* Brandmark */], {
    color: Style["a" /* default */].Colors.white
  }));
}

var LicensingModal__ref = LicensingModal__jsx(Logo, {});
// EXTERNAL MODULE: ./node_modules/lodash/sample.js
var sample = __webpack_require__(361);
var sample_default = /*#__PURE__*/__webpack_require__.n(sample);

// EXTERNAL MODULE: ./src/actions/runtime.js
var runtime = __webpack_require__(354);

// EXTERNAL MODULE: ./src/actions/user.js
var user = __webpack_require__(222);

// EXTERNAL MODULE: ./node_modules/lodash/fromPairs.js
var fromPairs = __webpack_require__(368);
var fromPairs_default = /*#__PURE__*/__webpack_require__.n(fromPairs);

// CONCATENATED MODULE: ./src/components/SignupScroller/SignupScroller.js
var SignupScroller__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SignupScroller__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SignupScroller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SignupScroller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SignupScroller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SignupScroller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var TRANITION_DELAY = 10 * 1000;

var SignupScroller__ref = SignupScroller__jsx(Typography["h" /* L2 */], {}, void 0, 'TOP 3 REASONS TO JOIN STORYTAPE');

var SignupScroller_SignupScroller = function (_React$PureComponent) {
  SignupScroller__inherits(SignupScroller, _React$PureComponent);

  function SignupScroller(props) {
    SignupScroller__classCallCheck(this, SignupScroller);

    var _this = SignupScroller__possibleConstructorReturn(this, (SignupScroller.__proto__ || Object.getPrototypeOf(SignupScroller)).call(this, props));

    _this.setActiveSlide = function (index) {
      _this.setState({ activeSlide: index % MESSAGES.length });
      _this.autoNextSlide(TRANITION_DELAY);
    };

    _this.autoNextSlide = function (delay) {
      clearTimeout(_this.nextTimeout);
      _this.nextTimeout = setTimeout(function () {
        return _this.setActiveSlide(_this.state.activeSlide + 1);
      }, delay);
    };

    _this.state = {
      activeSlide: 0
    };
    _this.nextTimeout = undefined;
    return _this;
  }

  SignupScroller__createClass(SignupScroller, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.autoNextSlide(TRANITION_DELAY);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.nextTimeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var animatedDefault = fromPairs_default()(MESSAGES.map(function (_, index) {
        return ['opacity_' + index, 0];
      }));
      var animatedCurrent = SignupScroller__extends({}, animatedDefault);
      animatedCurrent['opacity_' + this.state.activeSlide] = 1;

      var indicatorRatio = 3;
      var indicatorGrid = 100 / (MESSAGES.length * indicatorRatio + MESSAGES.length - 1);
      var indicatorWidth = 3 * indicatorGrid;

      return SignupScroller__jsx(react_motion["Motion"], {
        defaultStyle: animatedDefault,
        style: Object(Motion["d" /* springify */])(animatedCurrent)
      }, void 0, function (tweens) {
        return SignupScroller__jsx('div', {}, void 0, SignupScroller__ref, SignupScroller__jsx('div', {}, void 0, MESSAGES.map(function (item, index) {
          return SignupScroller__jsx('div', {
            style: { opacity: tweens['opacity_' + index] }
          }, item.headline, SignupScroller__jsx(Typography["e" /* H5 */], {}, void 0, item.headline), SignupScroller__jsx(Typography["m" /* P1 */], {}, void 0, item.statement));
        })), SignupScroller__jsx('div', {}, void 0, MESSAGES.map(function (item, index) {
          var color = color_default()(Style["a" /* default */].Colors.shadow5).mix(color_default()(Style["a" /* default */].Colors.white), tweens['opacity_' + index]);
          var opacity = tweens['opacity_' + index] * 0.25 + 0.75;
          return SignupScroller__jsx('div', {
            style: {
              opacity: opacity,
              backgroundColor: color,
              height: '3px',
              width: indicatorWidth + '%',
              flexBasis: indicatorWidth + '%',
              cursor: 'pointer'
            },
            onClick: function onClick() {
              return _this2.setActiveSlide(index);
            }
          }, item.headline);
        })));
      });
    }
  }]);

  return SignupScroller;
}(react_default.a.PureComponent);

SignupScroller_SignupScroller.defaultProps = {};


/* harmony default export */ var components_SignupScroller_SignupScroller = (SignupScroller_SignupScroller);

var MESSAGES = [{
  headline: '$$$$$$$',
  statement: 'Entire library subscription instead of crazy per clip prices'
}, {
  headline: 'Scenes, not just clips.',
  statement: 'Instead of stand-alone clips, Storytape footage is grouped together in scenes to help you tell a story. And, clips average 20 seconds in length.'
}, {
  headline: '4K Baby!',
  statement: 'So... many... pixels...'
}];
// CONCATENATED MODULE: ./src/components/RegistrationForm/RegistrationForm.js
var RegistrationForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var RegistrationForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function RegistrationForm__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function RegistrationForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RegistrationForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function RegistrationForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var RegistrationForm__ref = RegistrationForm__jsx('div', {}, void 0, RegistrationForm__jsx(Icons["b" /* Brandmark */], {}));

var RegistrationForm__ref2 = RegistrationForm__jsx('span', {}, void 0, '\xA0');

var RegistrationForm__ref3 = RegistrationForm__jsx(Link["a" /* default */], {
  to: '/legal',
  target: '_blank',
  underline: true
}, void 0, 'terms of use');

var RegistrationForm__ref4 = RegistrationForm__jsx(Link["a" /* default */], {
  to: '/legal',
  target: '_blank',
  underline: true
}, void 0, 'privacy policy');

var RegistrationForm_RegistrationForm = function (_React$PureComponent) {
  RegistrationForm__inherits(RegistrationForm, _React$PureComponent);

  function RegistrationForm(props) {
    RegistrationForm__classCallCheck(this, RegistrationForm);

    var _this = RegistrationForm__possibleConstructorReturn(this, (RegistrationForm.__proto__ || Object.getPrototypeOf(RegistrationForm)).call(this, props));

    _this.onSubmit = function () {
      if (!_this.state.formEnabled) {
        return;
      }

      if (!_this.state.agree) {
        _this.setState({ error: 'You must agree to the terms and conditions' });
        return;
      }

      if (_this.state.email.length < 5) {
        _this.setState({ error: 'Please enter an email address.' });
        return;
      }

      if (_this.state.password.length < 8) {
        _this.setState({ error: 'Password must be at least 8 characters.' });
        return;
      }

      _this.setState({ formEnabled: false, fetching: true, error: '' });
      _this.props.onRegister(_this.state.email, _this.state.password).then(function () {
        return _this.setState({
          fetching: false
        });
      }).catch(function (err) {
        return _this.setState({
          fetching: false,
          formEnabled: true,
          error: err.message
        });
      });
    };

    _this.state = {
      fetching: false,
      formEnabled: true,

      email: '',
      password: '',
      agree: false,

      message: '',
      error: ''
    };
    return _this;
  }

  RegistrationForm__createClass(RegistrationForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onRegister = _props.onRegister,
          onGoToLogin = _props.onGoToLogin,
          error = _props.error,
          message = _props.message,
          otherProps = RegistrationForm__objectWithoutProperties(_props, ['onRegister', 'onGoToLogin', 'error', 'message']);

      return RegistrationForm__jsx('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '5rem 6rem 4rem'
        }
      }, void 0, RegistrationForm__ref, RegistrationForm__jsx(Typography["c" /* H3 */], {
        style: { marginTop: '3rem' }
      }, void 0, 'Create Account'), RegistrationForm__jsx(Typography["m" /* P1 */], {
        style: { color: Style["a" /* default */].Colors.shadow3 }
      }, void 0, 'Upgrade, downgrade, or cancel anytime.'), RegistrationForm__jsx(Typography["m" /* P1 */], {
        style: { color: Style["a" /* default */].Colors.shadow3 }
      }, void 0, 'Already have an account?', ' ', RegistrationForm__jsx(Link["a" /* default */], {
        underline: true,
        onClick: onGoToLogin
      }, void 0, 'Sign in.')), RegistrationForm__jsx(Form["b" /* Form */], {
        onSubmit: this.onSubmit,
        enabled: this.state.formEnabled
      }, void 0, RegistrationForm__jsx(Form["c" /* Input */], {
        name: 'email',
        type: 'email',
        value: this.state.email,
        onChange: function onChange(value) {
          return _this2.setState({ email: value });
        }
      }, void 0, 'YOUR EMAIL'), RegistrationForm__jsx(Form["c" /* Input */], {
        name: 'password',
        type: 'password',
        value: this.state.password,
        onChange: function onChange(value) {
          return _this2.setState({ password: value });
        }
      }, void 0, 'CREATE A PASSWORD')), RegistrationForm__jsx('div', {
        style: {
          width: '100%',
          textAlign: 'left',
          color: Style["a" /* default */].Colors.error
        }
      }, void 0, RegistrationForm__jsx(Typography["m" /* P1 */], {}, void 0, this.state.error || error || message || RegistrationForm__ref2)), RegistrationForm__jsx('div', {
        style: {
          marginTop: '1.5rem'
        }
      }, void 0, RegistrationForm__jsx(Form["a" /* Checkbox */], {
        checked: this.state.agree,
        onChange: function onChange(value) {
          return _this2.setState({ agree: value });
        },
        labelStyle: { color: Style["a" /* default */].Colors.shadow3 }
      }, void 0, 'I agree to the', ' ', RegistrationForm__ref3, ', and', ' ', RegistrationForm__ref4, '.')), RegistrationForm__jsx(Button["a" /* default */], {
        style: { marginTop: '3rem' },
        working: this.state.fetching,
        type: 'submit',
        onClick: this.onSubmit,
        arrow: true
      }, void 0, 'Continue'));
    }
  }]);

  return RegistrationForm;
}(react_default.a.PureComponent);

RegistrationForm_RegistrationForm.defaultProps = {};


/* harmony default export */ var components_RegistrationForm_RegistrationForm = (RegistrationForm_RegistrationForm);
// EXTERNAL MODULE: ./node_modules/react-cognito/dist/react-cognito.js
var react_cognito = __webpack_require__(55);
var react_cognito_default = /*#__PURE__*/__webpack_require__.n(react_cognito);

// CONCATENATED MODULE: ./src/components/LoginForm/LoginForm.js
var LoginForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LoginForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LoginForm__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function LoginForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LoginForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var LoginForm__ref = LoginForm__jsx('div', {}, void 0, LoginForm__jsx(Icons["b" /* Brandmark */], {}));

var LoginForm__ref2 = LoginForm__jsx('span', {}, void 0, '\xA0');

var LoginForm_LoginForm = function (_React$PureComponent) {
  LoginForm__inherits(LoginForm, _React$PureComponent);

  function LoginForm(props) {
    LoginForm__classCallCheck(this, LoginForm);

    var _this = LoginForm__possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));

    _this.onSubmit = function () {
      if (!_this.state.formEnabled) {
        return;
      }

      _this.setState({ fetching: true, formEnabled: false, error: '' });
      _this.props.onSubmit(_this.state.email.toLowerCase(), _this.state.password).then(function () {
        return _this.props.onAfterLogin();
      }).then(function () {
        return _this.setState({ fetching: false });
      }).catch(function (error) {
        return _this.setState({
          fetching: false,
          formEnabled: true,
          error: error.message
        });
      });
    };

    _this.state = {
      fetching: false,
      formEnabled: true,

      email: '',
      password: '',
      error: ''
    };
    return _this;
  }

  LoginForm__createClass(LoginForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          email = _props.email,
          error = _props.error,
          onSubmit = _props.onSubmit,
          onGoToRegister = _props.onGoToRegister,
          onForgotPassword = _props.onForgotPassword,
          onAfterLogin = _props.onAfterLogin,
          otherProps = LoginForm__objectWithoutProperties(_props, ['email', 'error', 'onSubmit', 'onGoToRegister', 'onForgotPassword', 'onAfterLogin']);

      return LoginForm__jsx('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '5rem 6rem'
        }
      }, void 0, LoginForm__ref, LoginForm__jsx(Typography["c" /* H3 */], {
        style: { marginTop: '3rem' }
      }, void 0, 'Sign In'), LoginForm__jsx(Typography["m" /* P1 */], {
        style: { color: Style["a" /* default */].Colors.shadow3 }
      }, void 0, 'Don\'t have an account yet?', ' ', LoginForm__jsx(Link["a" /* default */], {
        underline: true,
        onClick: onGoToRegister
      }, void 0, 'Sign up')), LoginForm__jsx(Form["b" /* Form */], {
        onSubmit: this.onSubmit,
        enabled: this.state.formEnabled
      }, void 0, LoginForm__jsx(Form["c" /* Input */], {
        name: 'email',
        type: 'email',
        value: this.state.email,
        onChange: function onChange(value) {
          return _this2.setState({ email: value });
        }
      }, void 0, 'YOUR EMAIL'), LoginForm__jsx(Form["c" /* Input */], {
        name: 'password',
        type: 'password',
        value: this.state.password,
        onChange: function onChange(value) {
          return _this2.setState({ password: value });
        }
      }, void 0, 'AND PASSWORD')), LoginForm__jsx('div', {
        style: {
          width: '100%',
          textAlign: 'left',
          color: Style["a" /* default */].Colors.error
        }
      }, void 0, LoginForm__jsx(Typography["m" /* P1 */], {}, void 0, this.state.error || error || LoginForm__ref2)), LoginForm__jsx(Typography["m" /* P1 */], {
        style: {
          marginTop: '1.5rem'
        }
      }, void 0, 'Forgot your password?', ' ', LoginForm__jsx(Link["a" /* default */], {
        underline: true,
        onClick: onForgotPassword
      }, void 0, 'Reset it')), LoginForm__jsx(Button["a" /* default */], {
        style: { marginTop: '3rem' },
        type: 'submit',
        onClick: this.onSubmit,
        working: this.state.fetching,
        arrow: true
      }, void 0, 'Continue'));
    }
  }]);

  return LoginForm;
}(react_default.a.PureComponent);

LoginForm_LoginForm.defaultProps = {
  onAfterLogin: function onAfterLogin() {}
};


/* harmony default export */ var components_LoginForm_LoginForm = (function (props) {
  return LoginForm__jsx(react_cognito["Login"], {}, void 0, react_default.a.createElement(LoginForm_LoginForm, props));
});
// CONCATENATED MODULE: ./src/components/ConfirmAccountForm/ConfirmAccountForm.js
var ConfirmAccountForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ConfirmAccountForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ConfirmAccountForm__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ConfirmAccountForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ConfirmAccountForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ConfirmAccountForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ConfirmAccountForm__ref = ConfirmAccountForm__jsx(Typography["m" /* P1 */], {}, void 0, 'Check your email for a confirmation code and enter it here.');

var ConfirmAccountForm__ref2 = ConfirmAccountForm__jsx('div', {}, void 0, ConfirmAccountForm__jsx(Typography["h" /* L2 */], {}, void 0, 'YOUR EMAIL'));

var ConfirmAccountForm__ref3 = ConfirmAccountForm__jsx('span', {}, void 0, '\xA0');

var ConfirmAccountForm__ref4 = ConfirmAccountForm__jsx(Button["a" /* default */], {
  type: 'submit'
}, void 0, 'Confirm');

var ConfirmAccountForm_ConfirmAccountForm = function (_React$PureComponent) {
  ConfirmAccountForm__inherits(ConfirmAccountForm, _React$PureComponent);

  function ConfirmAccountForm(props) {
    ConfirmAccountForm__classCallCheck(this, ConfirmAccountForm);

    var _this = ConfirmAccountForm__possibleConstructorReturn(this, (ConfirmAccountForm.__proto__ || Object.getPrototypeOf(ConfirmAccountForm)).call(this, props));

    _this.onSubmit = function (e) {
      e.preventDefault();
      _this.props.onSubmit(_this.state.verificationCode);
    };

    _this.changeVerificationCode = function (e) {
      _this.setState({ verificationCode: e.target.value });
    };

    _this.state = {
      error: props.error,
      verificationCode: ''
    };
    return _this;
  }

  ConfirmAccountForm__createClass(ConfirmAccountForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onSubmit = _props.onSubmit,
          onCancel = _props.onCancel,
          onResend = _props.onResend,
          error = _props.error,
          otherProps = ConfirmAccountForm__objectWithoutProperties(_props, ['onSubmit', 'onCancel', 'onResend', 'error']);

      return ConfirmAccountForm__jsx('div', {}, void 0, ConfirmAccountForm__ref, ConfirmAccountForm__jsx('form', {
        onSubmit: this.onSubmit
      }, void 0, ConfirmAccountForm__jsx('label', {}, void 0, ConfirmAccountForm__ref2, ConfirmAccountForm__jsx('input', {
        type: 'text',
        onChange: this.changeVerificationCode,
        required: true
      })), ConfirmAccountForm__jsx('div', {}, void 0, ConfirmAccountForm__jsx(Typography["m" /* P1 */], {}, void 0, this.state.error || error || this.state.message || ConfirmAccountForm__ref3)), ConfirmAccountForm__ref4), ConfirmAccountForm__jsx(Typography["o" /* P2 */], {}, void 0, 'Don\'t see an email,', ' ', ConfirmAccountForm__jsx(Link["a" /* default */], {
        onClick: onResend,
        underline: true
      }, void 0, 'click here'), ' ', 'to resend it.'));
    }
  }]);

  return ConfirmAccountForm;
}(react_default.a.PureComponent);

ConfirmAccountForm_ConfirmAccountForm.defaultProps = {};


/* harmony default export */ var components_ConfirmAccountForm_ConfirmAccountForm = (function (props) {
  return ConfirmAccountForm__jsx(react_cognito["Confirm"], {}, void 0, react_default.a.createElement(ConfirmAccountForm_ConfirmAccountForm, props));
});
// CONCATENATED MODULE: ./src/components/ForgotPasswordForm/ForgotPasswordForm.js
var ForgotPasswordForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ForgotPasswordForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ForgotPasswordForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ForgotPasswordForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ForgotPasswordForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ForgotPasswordForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ForgotPasswordForm__ref = ForgotPasswordForm__jsx('div', {}, void 0, ForgotPasswordForm__jsx(Icons["b" /* Brandmark */], {}));

var ForgotPasswordForm__ref2 = ForgotPasswordForm__jsx('span', {}, void 0, '\xA0');

var ForgotPasswordForm_ForgotPasswordForm = function (_React$PureComponent) {
  ForgotPasswordForm__inherits(ForgotPasswordForm, _React$PureComponent);

  function ForgotPasswordForm(props) {
    ForgotPasswordForm__classCallCheck(this, ForgotPasswordForm);

    var _this = ForgotPasswordForm__possibleConstructorReturn(this, (ForgotPasswordForm.__proto__ || Object.getPrototypeOf(ForgotPasswordForm)).call(this, props));

    _this.sendVerificationCode = function (e) {
      e.preventDefault();

      if (!_this.state.formEnabled) {
        return;
      }

      if (_this.state.email.length < 5) {
        _this.setState({ error: 'Please enter an email address.' });
        return;
      }

      _this.setState({ fetching: true, formEnabled: false, error: '' });
      _this.props.sendVerificationCode(_this.state.email).then(function () {
        return _this.setState({
          fetching: false,
          message: 'Verification code sent',
          error: ''
        });
      }).then(function () {
        return _this.props.onAfterSendResetCode();
      }).catch(function (err) {
        var stateUpdate = { fetching: false, formEnabled: true };
        if (err.code === 'UserNotFoundException') {
          stateUpdate.error = 'User not found';
        } else {
          stateUpdate.error = err.message;
        }
        _this.setState(stateUpdate);
      });
    };

    _this.changeInput = function (e) {
      _this.setState({ error: '' });
      if (e.target.type === 'checkbox') {
        _this.setState(_defineProperty({}, e.target.name, !_this.state[e.target.name]));
      } else {
        _this.setState(_defineProperty({}, e.target.name, e.target.value));
      }
    };

    _this.onFocus = function (e) {
      _this.setState({ focus: e.target.name });
    };

    _this.onBlur = function (e) {
      if (_this.state.focus === e.target.name) {
        _this.setState({ focus: undefined });
      }
    };

    _this.state = {
      fetching: false,
      formEnabled: true,
      email: '',
      code: '',
      password: '',
      message: '',
      error: ''
    };
    return _this;
  }

  ForgotPasswordForm__createClass(ForgotPasswordForm, [{
    key: 'render',
    value: function render() {
      var formBaseStyle = {
        border: 'none',
        width: '100%'
      };

      var inputBaseStyle = ForgotPasswordForm__extends({}, formBaseStyle, {
        color: Style["a" /* default */].Colors.shadow3,
        opacity: 0.5,
        borderBottom: '0.1rem solid ' + Style["a" /* default */].Colors.shadow3
      });
      var labelBaseStyle = ForgotPasswordForm__extends({}, formBaseStyle, {
        color: Style["a" /* default */].Colors.shadow3,
        opacity: 0.5,
        fontStyle: 'italic',
        fontWeight: 'light',
        fontSize: '2.6rem',
        letterSpacing: -0.18,
        marginTop: '2.5rem',
        display: 'block'
      });
      var inputFocusStyle = {
        opacity: 1
      };
      var labelFocusStyle = {
        opacity: 1
      };

      return ForgotPasswordForm__jsx('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '5rem 6rem'
        }
      }, void 0, ForgotPasswordForm__ref, ForgotPasswordForm__jsx(Typography["c" /* H3 */], {
        style: { marginTop: '3rem' }
      }, void 0, 'Reset your password?'), ForgotPasswordForm__jsx('form', {
        style: ForgotPasswordForm__extends({}, formBaseStyle, {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }),
        onSubmit: this.sendVerificationCode
      }, void 0, ForgotPasswordForm__jsx('label', {
        style: ForgotPasswordForm__extends({}, labelBaseStyle, this.state.focus === 'email' || this.state.email.length > 0 ? labelFocusStyle : constants["l" /* EMPTY_OBJECT */])
      }, void 0, ForgotPasswordForm__jsx('div', {}, void 0, ForgotPasswordForm__jsx(Typography["h" /* L2 */], {
        style: { color: 'inherit' }
      }, void 0, 'YOUR EMAIL')), ForgotPasswordForm__jsx('input', {
        style: ForgotPasswordForm__extends({}, inputBaseStyle, this.state.email.length > 0 ? inputFocusStyle : constants["l" /* EMPTY_OBJECT */]),
        name: 'email',
        type: 'email',
        value: this.state.email,
        onChange: this.changeInput,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        required: true
      }))), ForgotPasswordForm__jsx('div', {
        style: {
          width: '100%',
          textAlign: 'left',
          color: Style["a" /* default */].Colors.error
        }
      }, void 0, ForgotPasswordForm__jsx(Typography["m" /* P1 */], {}, void 0, this.state.error || this.props.error || this.state.message || ForgotPasswordForm__ref2)), ForgotPasswordForm__jsx(Button["a" /* default */], {
        style: { marginTop: '3rem' },
        type: 'submit',
        onClick: this.sendVerificationCode,
        working: this.state.fetching,
        arrow: true
      }, void 0, 'Send Reset Code'), ForgotPasswordForm__jsx(SecondaryAction["a" /* default */], {
        onClick: this.props.onCancel
      }, void 0, 'Cancel'));
    }
  }]);

  return ForgotPasswordForm;
}(react_default.a.PureComponent);

ForgotPasswordForm_ForgotPasswordForm.defaultProps = {
  onAfterSendResetCode: function onAfterSendResetCode() {}
};


/* harmony default export */ var components_ForgotPasswordForm_ForgotPasswordForm = (function (props) {
  return ForgotPasswordForm__jsx(react_cognito["PasswordReset"], {}, void 0, react_default.a.createElement(ForgotPasswordForm_ForgotPasswordForm, props));
});
// CONCATENATED MODULE: ./src/components/ResetPasswordForm/ResetPasswordForm.js
var ResetPasswordForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function ResetPasswordForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ResetPasswordForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ResetPasswordForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ResetPasswordForm__ref = ResetPasswordForm__jsx('div', {}, void 0, ResetPasswordForm__jsx(Icons["b" /* Brandmark */], {}));

var ResetPasswordForm__ref2 = ResetPasswordForm__jsx('span', {}, void 0, '\xA0');

var ResetPasswordForm_ResetPasswordForm = function (_React$PureComponent) {
  ResetPasswordForm__inherits(ResetPasswordForm, _React$PureComponent);

  function ResetPasswordForm(props) {
    ResetPasswordForm__classCallCheck(this, ResetPasswordForm);

    var _this = ResetPasswordForm__possibleConstructorReturn(this, (ResetPasswordForm.__proto__ || Object.getPrototypeOf(ResetPasswordForm)).call(this, props));

    _this.onSubmit = function () {
      if (!_this.state.formEnabled) {
        return;
      }

      _this.setState({ formEnabled: false, fetching: true, error: '' });
      _this.props.setPassword(_this.state.email, _this.state.code, _this.state.password).then(function () {
        return _this.setState({
          fetching: false,
          message: 'Password reset',
          error: ''
        });
      }).then(function () {
        return _this.props.onAfterSetPassword();
      }).catch(function (err) {
        return _this.setState({
          fetching: false,
          formEnabled: true,
          message: '',
          error: err.message
        });
      });
    };

    _this.render = function () {
      return ResetPasswordForm__jsx('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '5rem 6rem'
        }
      }, void 0, ResetPasswordForm__ref, ResetPasswordForm__jsx(Typography["c" /* H3 */], {
        style: { marginTop: '3rem' }
      }, void 0, 'Set new password'), ResetPasswordForm__jsx(Typography["m" /* P1 */], {
        style: { textAlign: 'center' }
      }, void 0, 'Check your email. We just sent you a code to reset\xA0your\xA0password.'), ResetPasswordForm__jsx(Form["b" /* Form */], {
        onSubmit: _this.onSubmit,
        enabled: _this.state.formEnabled
      }, void 0, ResetPasswordForm__jsx(Form["c" /* Input */], {
        name: 'email',
        type: 'email',
        value: _this.state.email,
        onChange: function onChange(value) {
          return _this.setState({ email: value });
        }
      }, void 0, 'YOUR EMAIL'), ResetPasswordForm__jsx(Form["c" /* Input */], {
        name: 'code',
        type: 'text',
        value: _this.state.code,
        onChange: function onChange(value) {
          return _this.setState({ code: value });
        }
      }, void 0, 'YOUR VERIFICATION CODE'), ResetPasswordForm__jsx(Form["c" /* Input */], {
        name: 'password',
        type: 'password',
        value: _this.state.password,
        onChange: function onChange(value) {
          return _this.setState({ password: value });
        }
      }, void 0, 'AND NEW PASSWORD')), ResetPasswordForm__jsx('div', {
        style: {
          width: '100%',
          textAlign: 'left',
          color: Style["a" /* default */].Colors.error
        }
      }, void 0, ResetPasswordForm__jsx(Typography["m" /* P1 */], {}, void 0, _this.state.error || _this.props.error || _this.state.message || ResetPasswordForm__ref2)), ResetPasswordForm__jsx(Button["a" /* default */], {
        type: 'submit',
        onClick: _this.onSubmit,
        working: _this.state.fetching,
        size: 'large'
      }, void 0, 'Set New Password'));
    };

    _this.state = {
      fetching: false,
      formEnabled: true,
      email: '',
      code: '',
      password: '',
      message: '',
      error: ''
    };
    return _this;
  }

  return ResetPasswordForm;
}(react_default.a.PureComponent);

ResetPasswordForm_ResetPasswordForm.defaultProps = {
  onAfterSetPassword: function onAfterSetPassword() {}
};


/* harmony default export */ var components_ResetPasswordForm_ResetPasswordForm = (function (props) {
  return ResetPasswordForm__jsx(react_cognito["PasswordReset"], {}, void 0, react_default.a.createElement(ResetPasswordForm_ResetPasswordForm, props));
});
// CONCATENATED MODULE: ./src/components/Onboarding/Onboarding.js
var Onboarding__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Onboarding__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Onboarding__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Onboarding__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Onboarding__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Onboarding_Onboarding = function (_React$PureComponent) {
  Onboarding__inherits(Onboarding, _React$PureComponent);

  function Onboarding() {
    Onboarding__classCallCheck(this, Onboarding);

    return Onboarding__possibleConstructorReturn(this, (Onboarding.__proto__ || Object.getPrototypeOf(Onboarding)).apply(this, arguments));
  }

  Onboarding__createClass(Onboarding, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onGoToRegister = _props.onGoToRegister,
          onAfterConfirmAccount = _props.onAfterConfirmAccount,
          onForgotPassword = _props.onForgotPassword,
          onAfterLogin = _props.onAfterLogin,
          onAfterSendResetCode = _props.onAfterSendResetCode,
          onAfterSetPassword = _props.onAfterSetPassword,
          onRegister = _props.onRegister,
          onGoToLogin = _props.onGoToLogin,
          registrationError = _props.registrationError,
          registrationMessage = _props.registrationMessage,
          chosenPlan = _props.chosenPlan,
          activePlan = _props.activePlan,
          couponCode = _props.couponCode,
          couponError = _props.couponError,
          paymentError = _props.paymentError,
          planSummary = _props.planSummary,
          step = _props.step,
          onGoToPlan = _props.onGoToPlan,
          onChangePlan = _props.onChangePlan,
          onChangeCoupon = _props.onChangeCoupon,
          onConfirmPlan = _props.onConfirmPlan,
          onCreateSubscription = _props.onCreateSubscription,
          otherProps = Onboarding__objectWithoutProperties(_props, ['onGoToRegister', 'onAfterConfirmAccount', 'onForgotPassword', 'onAfterLogin', 'onAfterSendResetCode', 'onAfterSetPassword', 'onRegister', 'onGoToLogin', 'registrationError', 'registrationMessage', 'chosenPlan', 'activePlan', 'couponCode', 'couponError', 'paymentError', 'planSummary', 'step', 'onGoToPlan', 'onChangePlan', 'onChangeCoupon', 'onConfirmPlan', 'onCreateSubscription']);

      var registrationProps = {
        onRegister: onRegister,
        onGoToLogin: onGoToLogin,
        error: registrationError,
        message: registrationMessage
      };
      var confirmAccountProps = {
        onAfterConfirmAccount: onAfterConfirmAccount
      };
      var loginProps = {
        onGoToRegister: onGoToRegister,
        onForgotPassword: onForgotPassword,
        onAfterLogin: onAfterLogin
      };
      var forgotPasswordProps = {
        onAfterSendResetCode: onAfterSendResetCode,
        onCancel: onGoToLogin
      };
      var resetPasswordProps = {
        onAfterSetPassword: onAfterSetPassword
      };
      var planProps = {
        chosenPlan: chosenPlan,
        activePlan: activePlan,
        onChangePlan: onChangePlan,
        onConfirmPlan: onConfirmPlan
      };
      var paymentProps = {
        chosenPlan: chosenPlan,
        couponCode: couponCode,
        couponError: couponError,
        paymentError: paymentError,
        planSummary: planSummary,
        onGoToPlan: onGoToPlan,
        onChangeCoupon: onChangeCoupon,
        onCreateSubscription: onCreateSubscription
      };

      var activeItem = void 0;
      switch (step) {
        case constants["y" /* ONBOARDING_STEP */].REGISTER:
          activeItem = {
            id: 'registration',
            element: react_default.a.createElement(components_RegistrationForm_RegistrationForm, registrationProps)
          };
          break;
        case constants["y" /* ONBOARDING_STEP */].CONFIRM:
          activeItem = {
            id: 'confirmAccount',
            element: react_default.a.createElement(components_ConfirmAccountForm_ConfirmAccountForm, confirmAccountProps)
          };
          break;
        case constants["y" /* ONBOARDING_STEP */].LOGIN:
          activeItem = {
            id: 'login',
            element: react_default.a.createElement(components_LoginForm_LoginForm, loginProps)
          };
          break;
        case constants["y" /* ONBOARDING_STEP */].FORGOT_PASSWORD:
          activeItem = {
            id: 'forgotPassword',
            element: react_default.a.createElement(components_ForgotPasswordForm_ForgotPasswordForm, forgotPasswordProps)
          };
          break;
        case constants["y" /* ONBOARDING_STEP */].RESET_PASSWORD:
          activeItem = {
            id: 'resetPassword',
            element: react_default.a.createElement(components_ResetPasswordForm_ResetPasswordForm, resetPasswordProps)
          };
          break;
        case constants["y" /* ONBOARDING_STEP */].PLAN:
          activeItem = {
            id: 'plan',
            element: react_default.a.createElement(components_Plans_Plans, planProps)
          };
          break;
        case constants["y" /* ONBOARDING_STEP */].PAY:
          activeItem = {
            id: 'payment',
            element: react_default.a.createElement(Payment["b" /* default */], paymentProps)
          };
          break;
        default:
          activeItem = { id: 'nothing', element: null };
          break;
      }

      return react_default.a.createElement(ElementTransition["a" /* default */], activeItem);
    }
  }]);

  return Onboarding;
}(react_default.a.PureComponent);

Onboarding_Onboarding.defaultProps = {};


/* harmony default export */ var components_Onboarding_Onboarding = (Onboarding_Onboarding);
// CONCATENATED MODULE: ./src/containers/OnboardingContainer/OnboardingContainer.js










function OnboardingContainer_mapStateToProps(state) {
  return {
    step: Object(user["d" /* getStep */])(state),
    chosenPlan: state.plan.chosenPlan,
    activePlan: state.plan.activePlan,
    couponCode: state.plan.couponCode,
    couponError: state.plan.couponError,
    paymentError: state.plan.paymentError,
    planSummary: state.plan.chosenSummary,
    registrationError: state.runtime.registrationError,
    registrationMessage: state.runtime.registrationMessage,
    loginError: state.runtime.loginError
  };
}

function OnboardingContainer_mapDispatchToProps(dispatch, ownProps) {
  return {
    onRegister: function onRegister(email, password) {
      return dispatch(Object(user["i" /* signup */])(email, password)).then(function () {
        dispatch(Object(runtime["a" /* setRuntimeVariable */])('newUser', true));
        return dispatch(Object(runtime["a" /* setRuntimeVariable */])('onboardingStep', constants["y" /* ONBOARDING_STEP */].PLAN));
      });
    },
    onGoToLogin: function onGoToLogin() {
      return dispatch(Object(user["g" /* showLogin */])());
    },
    onGoToRegister: function onGoToRegister() {
      return dispatch(Object(user["h" /* showSignup */])());
    },
    onAfterConfirmAccount: function onAfterConfirmAccount() {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('onboardingStep', constants["y" /* ONBOARDING_STEP */].PLAN));
    },
    onForgotPassword: function onForgotPassword() {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('onboardingStep', constants["y" /* ONBOARDING_STEP */].FORGOT_PASSWORD));
    },
    onAfterLogin: function onAfterLogin() {
      return dispatch(Object(actions_plan["b" /* getActiveSubscription */])()).then(function () {
        return Promise.resolve(ownProps.onAfterLogin !== undefined ? ownProps.onAfterLogin() : undefined).then(function () {
          return dispatch(Object(runtime["a" /* setRuntimeVariable */])('onboardingStep', constants["y" /* ONBOARDING_STEP */].COMPLETE));
        });
      });
    },
    onAfterSendResetCode: function onAfterSendResetCode() {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('onboardingStep', constants["y" /* ONBOARDING_STEP */].RESET_PASSWORD));
    },
    onAfterSetPassword: function onAfterSetPassword() {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('onboardingStep', constants["y" /* ONBOARDING_STEP */].COMPLETE));
    },
    onGoToPlan: function onGoToPlan() {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('onboardingStep', constants["y" /* ONBOARDING_STEP */].PLAN));
    },
    onChangePlan: function onChangePlan(plan) {
      return dispatch(Object(actions_plan["f" /* setChosenPlan */])(plan));
    },
    onChangeCoupon: function onChangeCoupon(code) {
      return dispatch(Object(actions_plan["g" /* setCouponCode */])(code));
    },
    onConfirmPlan: function onConfirmPlan(plan) {
      facebook["a" /* default */].track('AddToCart');
      facebook["a" /* default */].track('InitiateCheckout');
      dispatch(Object(helpers["a" /* buildAction */])(constants["M" /* SET_PAYMENT_ERROR */], undefined));
      dispatch(Object(helpers["a" /* buildAction */])(constants["I" /* SET_COUPON_ERROR */], undefined));
      return dispatch(Object(actions_plan["f" /* setChosenPlan */])(plan)).then(function () {
        return dispatch(Object(runtime["a" /* setRuntimeVariable */])('onboardingStep', constants["y" /* ONBOARDING_STEP */].PAY));
      });
    },
    onCreateSubscription: function onCreateSubscription(stripeTokenId, plan, coupon) {
      return dispatch(Object(actions_plan["h" /* subscribe */])(stripeTokenId, plan, coupon)).then(function () {
        facebook["a" /* default */].track('AddPaymentInfo');
        facebook["a" /* default */].track('Purchase', {
          value: Object(actions_plan["d" /* getPlanPrice */])(plan.name),
          currency: 'USD'
        });
      }).then(function () {
        return dispatch(Object(actions_plan["b" /* getActiveSubscription */])());
      }).then(function () {
        return dispatch(Object(runtime["a" /* setRuntimeVariable */])('onboardingStep', constants["y" /* ONBOARDING_STEP */].COMPLETE));
      }).catch(function (err) {
        dispatch(Object(helpers["a" /* buildAction */])(constants["M" /* SET_PAYMENT_ERROR */], err.message));
        throw err;
      });
    }
  };
}

/* harmony default export */ var OnboardingContainer = (Object(es["connect"])(OnboardingContainer_mapStateToProps, OnboardingContainer_mapDispatchToProps)(components_Onboarding_Onboarding));
// EXTERNAL MODULE: ./src/assets/onboarding.mp4
var onboarding = __webpack_require__(1140);
var onboarding_default = /*#__PURE__*/__webpack_require__.n(onboarding);

// EXTERNAL MODULE: ./src/assets/onboarding.jpg
var assets_onboarding = __webpack_require__(1141);
var assets_onboarding_default = /*#__PURE__*/__webpack_require__.n(assets_onboarding);

// CONCATENATED MODULE: ./src/containers/OnboardingModal/OnboardingModal.js
var OnboardingModal__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





















function OnboardingModal_mapStateToProps(state) {
  var styles = { leftStyle: { opacity: 0 }, closeButtonStyle: {} };
  var layout = constants["x" /* MODAL_LAYOUT */].EQUAL_SPLIT;

  switch (Object(user["d" /* getStep */])(state)) {
    case constants["y" /* ONBOARDING_STEP */].PLAN:
    case constants["y" /* ONBOARDING_STEP */].PAY:
      styles.leftStyle.opacity = 1;
      layout = constants["x" /* MODAL_LAYOUT */].RIGHT;
      break;
    case constants["y" /* ONBOARDING_STEP */].COMPLETE:
      styles.leftStyle.opacity = 0;
      styles.closeButtonStyle.opacity = 0;
      layout = constants["x" /* MODAL_LAYOUT */].FULL;
      break;
  }

  return {
    layout: layout,
    styles: styles,
    backgroundContent: OnboardingModal__ref,
    fullContent: OnboardingModal__ref2,
    leftContent: OnboardingModal__ref3,
    rightContent: react_default.a.createElement(OnboardingContainer, state.modal.props),
    colors: state.ui.colors
  };
}

function OnboardingModal_mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch(Object(modal["a" /* hideModal */])());
    }
  };
}

/* harmony default export */ var OnboardingModal = (Object(es["connect"])(OnboardingModal_mapStateToProps, OnboardingModal_mapDispatchToProps)(components_Modal_Modal));

function WelcomeComp(_ref4) {
  var newUser = _ref4.newUser,
      onClose = _ref4.onClose;

  var headline = 'Welcome back to Storytape.';
  var statement = 'So good to see you again. We love shooting for you.';
  var profileCTA = 'View your profile';
  if (newUser) {
    headline = 'Welcome to Storytape.';
    statement = 'We hope you enjoy the experience. We love shooting for you.';
    profileCTA = 'Complete your profile';
  }

  return OnboardingModal__jsx('div', {
    style: {
      display: 'flex',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)'
    }
  }, void 0, OnboardingModal__jsx('div', {
    style: {
      flexBasis: '20%',
      width: '20%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingTop: '6rem'
    }
  }, void 0, OnboardingModal__jsx(Icons["b" /* Brandmark */], {
    color: Style["a" /* default */].Colors.white
  })), OnboardingModal__jsx('div', {
    style: {
      flexBasis: '80%',
      width: '80%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, void 0, OnboardingModal__jsx(Typography["j" /* L3 */], {
    style: { color: Style["a" /* default */].Colors.shadow3 }
  }, void 0, 'SUCCESS!'), OnboardingModal__jsx(Typography["c" /* H3 */], {}, void 0, headline), OnboardingModal__jsx(Typography["m" /* P1 */], {
    style: { opacity: 0.75, margin: '0 0 4.5rem' }
  }, void 0, statement), OnboardingModal__jsx('div', {}, void 0, OnboardingModal__jsx(Link["a" /* default */], {
    onClick: onClose,
    to: '/browse'
  }, void 0, OnboardingModal__jsx(Button["a" /* default */], {
    baseColor: Style["a" /* default */].Colors.black,
    arrow: true
  }, void 0, 'Start Browsing')), OnboardingModal__jsx('div', {
    style: { display: 'none' }
  }, void 0, OnboardingModal__jsx('span', {
    style: { margin: '0 2rem' }
  }, void 0, 'or'), OnboardingModal__jsx(Link["a" /* default */], {
    onClick: onClose,
    to: '/dashboard/profile'
  }, void 0, OnboardingModal__jsx(Button["a" /* default */], {
    style: { borderWidth: '0.1rem' },
    baseColor: Style["a" /* default */].Colors.black
  }, void 0, profileCTA))))));
}

function mapStateToWelcomeProps(state) {
  return {
    newUser: state.runtime.newUser
  };
}

function mapDispatchToWelcomeProps(dispatch) {
  return {
    onClose: function onClose() {
      return setTimeout(function () {
        return dispatch(Object(modal["a" /* hideModal */])());
      }, 500);
    }
  };
}

var Welcome = Object(es["connect"])(mapStateToWelcomeProps, mapDispatchToWelcomeProps)(WelcomeComp),
    OnboardingModal__ref2 = OnboardingModal__jsx(Welcome, {});

function OnboardingModal_Logo() {
  return OnboardingModal__jsx('div', {
    style: {
      padding: '6rem 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  }, void 0, OnboardingModal__jsx(Icons["b" /* Brandmark */], {
    color: Style["a" /* default */].Colors.white
  }));
}

var OnboardingModal__ref3 = OnboardingModal__jsx(OnboardingModal_Logo, {});

function OnboardingModal_VideoBackground() {
  return OnboardingModal__jsx('div', {
    style: {
      height: '100%',
      width: '100%',
      backgroundColor: Style["a" /* default */].Colors.black
    }
  }, void 0, OnboardingModal__jsx(Video["a" /* default */], {
    src: onboarding_default.a,
    poster: assets_onboarding_default.a,
    style: {
      height: 'calc(100% + 1px)'
    }
  }));
}

var OnboardingModal__ref = OnboardingModal__jsx(OnboardingModal_VideoBackground, {});
// CONCATENATED MODULE: ./src/containers/ModalConductor/ModalConductor.js
var ModalConductor__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalConductor__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ModalConductor__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalConductor__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalConductor__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ModalConductor_ModalConductor = function (_React$PureComponent) {
  ModalConductor__inherits(ModalConductor, _React$PureComponent);

  function ModalConductor() {
    ModalConductor__classCallCheck(this, ModalConductor);

    return ModalConductor__possibleConstructorReturn(this, (ModalConductor.__proto__ || Object.getPrototypeOf(ModalConductor)).apply(this, arguments));
  }

  ModalConductor__createClass(ModalConductor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentModal = _props.currentModal,
          otherProps = ModalConductor__objectWithoutProperties(_props, ['currentModal']);

      switch (currentModal) {
        case constants["w" /* MODAL */].ONBOARDING:
          return react_default.a.createElement(OnboardingModal, otherProps);
        case constants["w" /* MODAL */].LICENSE_CLIP:
          return react_default.a.createElement(containers_LicensingModal_LicensingModal, otherProps);
        default:
          return null;
      }
    }
  }]);

  return ModalConductor;
}(react_default.a.PureComponent);

function ModalConductor_mapStateToProps(state) {
  return { currentModal: state.modal.modal };
}

/* harmony default export */ var containers_ModalConductor_ModalConductor = __webpack_exports__["a"] = (Object(es["connect"])(ModalConductor_mapStateToProps)(ModalConductor_ModalConductor));

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 951,
	"./af.js": 951,
	"./ar": 952,
	"./ar-dz": 953,
	"./ar-dz.js": 953,
	"./ar-kw": 954,
	"./ar-kw.js": 954,
	"./ar-ly": 955,
	"./ar-ly.js": 955,
	"./ar-ma": 956,
	"./ar-ma.js": 956,
	"./ar-sa": 957,
	"./ar-sa.js": 957,
	"./ar-tn": 958,
	"./ar-tn.js": 958,
	"./ar.js": 952,
	"./az": 959,
	"./az.js": 959,
	"./be": 960,
	"./be.js": 960,
	"./bg": 961,
	"./bg.js": 961,
	"./bm": 962,
	"./bm.js": 962,
	"./bn": 963,
	"./bn.js": 963,
	"./bo": 964,
	"./bo.js": 964,
	"./br": 965,
	"./br.js": 965,
	"./bs": 966,
	"./bs.js": 966,
	"./ca": 967,
	"./ca.js": 967,
	"./cs": 968,
	"./cs.js": 968,
	"./cv": 969,
	"./cv.js": 969,
	"./cy": 970,
	"./cy.js": 970,
	"./da": 971,
	"./da.js": 971,
	"./de": 972,
	"./de-at": 973,
	"./de-at.js": 973,
	"./de-ch": 974,
	"./de-ch.js": 974,
	"./de.js": 972,
	"./dv": 975,
	"./dv.js": 975,
	"./el": 976,
	"./el.js": 976,
	"./en-au": 977,
	"./en-au.js": 977,
	"./en-ca": 978,
	"./en-ca.js": 978,
	"./en-gb": 979,
	"./en-gb.js": 979,
	"./en-ie": 980,
	"./en-ie.js": 980,
	"./en-nz": 981,
	"./en-nz.js": 981,
	"./eo": 982,
	"./eo.js": 982,
	"./es": 983,
	"./es-do": 984,
	"./es-do.js": 984,
	"./es-us": 985,
	"./es-us.js": 985,
	"./es.js": 983,
	"./et": 986,
	"./et.js": 986,
	"./eu": 987,
	"./eu.js": 987,
	"./fa": 988,
	"./fa.js": 988,
	"./fi": 989,
	"./fi.js": 989,
	"./fo": 990,
	"./fo.js": 990,
	"./fr": 991,
	"./fr-ca": 992,
	"./fr-ca.js": 992,
	"./fr-ch": 993,
	"./fr-ch.js": 993,
	"./fr.js": 991,
	"./fy": 994,
	"./fy.js": 994,
	"./gd": 995,
	"./gd.js": 995,
	"./gl": 996,
	"./gl.js": 996,
	"./gom-latn": 997,
	"./gom-latn.js": 997,
	"./gu": 998,
	"./gu.js": 998,
	"./he": 999,
	"./he.js": 999,
	"./hi": 1000,
	"./hi.js": 1000,
	"./hr": 1001,
	"./hr.js": 1001,
	"./hu": 1002,
	"./hu.js": 1002,
	"./hy-am": 1003,
	"./hy-am.js": 1003,
	"./id": 1004,
	"./id.js": 1004,
	"./is": 1005,
	"./is.js": 1005,
	"./it": 1006,
	"./it.js": 1006,
	"./ja": 1007,
	"./ja.js": 1007,
	"./jv": 1008,
	"./jv.js": 1008,
	"./ka": 1009,
	"./ka.js": 1009,
	"./kk": 1010,
	"./kk.js": 1010,
	"./km": 1011,
	"./km.js": 1011,
	"./kn": 1012,
	"./kn.js": 1012,
	"./ko": 1013,
	"./ko.js": 1013,
	"./ky": 1014,
	"./ky.js": 1014,
	"./lb": 1015,
	"./lb.js": 1015,
	"./lo": 1016,
	"./lo.js": 1016,
	"./lt": 1017,
	"./lt.js": 1017,
	"./lv": 1018,
	"./lv.js": 1018,
	"./me": 1019,
	"./me.js": 1019,
	"./mi": 1020,
	"./mi.js": 1020,
	"./mk": 1021,
	"./mk.js": 1021,
	"./ml": 1022,
	"./ml.js": 1022,
	"./mr": 1023,
	"./mr.js": 1023,
	"./ms": 1024,
	"./ms-my": 1025,
	"./ms-my.js": 1025,
	"./ms.js": 1024,
	"./my": 1026,
	"./my.js": 1026,
	"./nb": 1027,
	"./nb.js": 1027,
	"./ne": 1028,
	"./ne.js": 1028,
	"./nl": 1029,
	"./nl-be": 1030,
	"./nl-be.js": 1030,
	"./nl.js": 1029,
	"./nn": 1031,
	"./nn.js": 1031,
	"./pa-in": 1032,
	"./pa-in.js": 1032,
	"./pl": 1033,
	"./pl.js": 1033,
	"./pt": 1034,
	"./pt-br": 1035,
	"./pt-br.js": 1035,
	"./pt.js": 1034,
	"./ro": 1036,
	"./ro.js": 1036,
	"./ru": 1037,
	"./ru.js": 1037,
	"./sd": 1038,
	"./sd.js": 1038,
	"./se": 1039,
	"./se.js": 1039,
	"./si": 1040,
	"./si.js": 1040,
	"./sk": 1041,
	"./sk.js": 1041,
	"./sl": 1042,
	"./sl.js": 1042,
	"./sq": 1043,
	"./sq.js": 1043,
	"./sr": 1044,
	"./sr-cyrl": 1045,
	"./sr-cyrl.js": 1045,
	"./sr.js": 1044,
	"./ss": 1046,
	"./ss.js": 1046,
	"./sv": 1047,
	"./sv.js": 1047,
	"./sw": 1048,
	"./sw.js": 1048,
	"./ta": 1049,
	"./ta.js": 1049,
	"./te": 1050,
	"./te.js": 1050,
	"./tet": 1051,
	"./tet.js": 1051,
	"./th": 1052,
	"./th.js": 1052,
	"./tl-ph": 1053,
	"./tl-ph.js": 1053,
	"./tlh": 1054,
	"./tlh.js": 1054,
	"./tr": 1055,
	"./tr.js": 1055,
	"./tzl": 1056,
	"./tzl.js": 1056,
	"./tzm": 1057,
	"./tzm-latn": 1058,
	"./tzm-latn.js": 1058,
	"./tzm.js": 1057,
	"./uk": 1059,
	"./uk.js": 1059,
	"./ur": 1060,
	"./ur.js": 1060,
	"./uz": 1061,
	"./uz-latn": 1062,
	"./uz-latn.js": 1062,
	"./uz.js": 1061,
	"./vi": 1063,
	"./vi.js": 1063,
	"./x-pseudo": 1064,
	"./x-pseudo.js": 1064,
	"./yo": 1065,
	"./yo.js": 1065,
	"./zh-cn": 1066,
	"./zh-cn.js": 1066,
	"./zh-hk": 1067,
	"./zh-hk.js": 1067,
	"./zh-tw": 1068,
	"./zh-tw.js": 1068
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1125;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1127);
    var insertCss = __webpack_require__(907);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./WorkingSpinner.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./WorkingSpinner.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(906)(false);
// imports


// module
exports.push([module.i, "._3lcuu{line-height:0;padding:0;margin:0;border:0;-webkit-transform-origin:50% 50% 0;-ms-transform-origin:50% 50% 0;transform-origin:50% 50% 0}._8m-Cl{-webkit-animation:z8JmQ 1s linear infinite;animation:z8JmQ 1s linear infinite}@-webkit-keyframes z8JmQ{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes z8JmQ{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"WorkingSpinner": "_3lcuu",
	"activeSpinner": "_8m-Cl",
	"spin": "z8JmQ"
};

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1129), __esModule: true };

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(891);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1131);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1134);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1132), __esModule: true };

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(929);
__webpack_require__(921);
module.exports = __webpack_require__(1133);


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1069);
var ITERATOR = __webpack_require__(892)('iterator');
var Iterators = __webpack_require__(909);
module.exports = __webpack_require__(891).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1135), __esModule: true };

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(929);
__webpack_require__(921);
module.exports = __webpack_require__(1136);


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(902);
var get = __webpack_require__(1137);
module.exports = __webpack_require__(891).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1069);
var ITERATOR = __webpack_require__(892)('iterator');
var Iterators = __webpack_require__(909);
module.exports = __webpack_require__(891).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1139);
    var insertCss = __webpack_require__(907);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./typography.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./typography.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(906)(false);
// imports


// module
exports.push([module.i, "._1-re4,._1_sNr,._1dOWZ,._1JbOB,._1LcgB,._1m5bA,._1NQHx,._1S1Ic,._2r2J6,._3Mf9_,._7uN7-,._9_KuO,._11nJE,._11OHv,._16HS4,._28CDF,._39lmd,.e7M8T,.GYkRD,.kmquN,.lCBam{font-family:Calibre;font-size:16px;font-size:1.6rem;font-style:normal;font-weight:400;letter-spacing:0;line-height:1.5em;margin-top:.16em;margin-bottom:.16em}._1_sNr,._1NQHx,._7uN7-,._9_KuO,._11nJE,._16HS4,._28CDF,._39lmd,.GYkRD{font-weight:600}._1dOWZ,._1LcgB,._1S1Ic,._3Mf9_,._11OHv,.kmquN,.lCBam{font-weight:500}._1JbOB,._1m5bA,._2r2J6,.e7M8T{font-weight:300}._9_KuO,._16HS4{font-size:52px;font-size:5.2rem;line-height:.86538em;letter-spacing:-.02em}@media (min-width:900px){._9_KuO,._16HS4{font-size:8rem;line-height:.8125em;letter-spacing:-.01062em}}._1NQHx,._7uN7-{font-size:40px;font-size:4rem;line-height:.85em;letter-spacing:-.02125em}@media (min-width:600px){._1NQHx,._7uN7-{font-size:5.2rem;line-height:.80769em;letter-spacing:-.01635em}}.GYkRD{font-size:30px;font-size:3rem;line-height:.86667em;letter-spacing:-.01267em}@media (min-width:900px){.GYkRD{font-size:4rem;line-height:.95em;letter-spacing:-.0125em}}._28CDF{font-weight:300;font-size:26px;font-size:2.6rem;line-height:1em;letter-spacing:-.01385em}@media (min-width:600px){._28CDF{font-size:3.6rem;line-height:1em;letter-spacing:-.01389em}}._11nJE{font-size:22px;font-size:2.2rem;line-height:1.09091em;letter-spacing:-.01136em}@media (min-width:600px){._11nJE{font-size:3rem;line-height:1.2em;letter-spacing:-.00833em}}._39lmd{font-size:20px;font-size:2rem;line-height:1.25em;letter-spacing:-.01em}@media (min-width:600px){._39lmd{font-size:2.4rem;line-height:1.20833em;letter-spacing:-.00833em}}._7uN7-,._16HS4{font-style:italic}._11OHv{font-size:14px;font-size:1.4rem;line-height:1.21429em;letter-spacing:.10714em}@media (min-width:900px){._11OHv{font-size:1.8rem;line-height:1.22222em;letter-spacing:.11111em}}._11OHv{font-weight:600}.kmquN,.lCBam{font-size:16px;font-size:1.6rem;line-height:1.1875em;letter-spacing:.0625em}.kmquN{letter-spacing:-.00733em;font-weight:400}._1LcgB{font-size:12px;font-size:1.2rem;line-height:1.16667em;letter-spacing:.08333em}@media (min-width:900px){._1LcgB{font-size:1.4rem;line-height:1.21429em;letter-spacing:.07143em}}._1S1Ic,._3Mf9_{font-size:12px;font-size:1.2rem;line-height:1.16667em;letter-spacing:.125em}._1S1Ic{letter-spacing:.05833em;font-weight:400}.e7M8T{font-size:18px;font-size:1.8rem;line-height:1.22222em;letter-spacing:0}._1m5bA{letter-spacing:-.00667em;font-weight:400}._1JbOB{font-size:14px;font-size:1.4rem;line-height:1.14286em;letter-spacing:0}", ""]);

// exports
exports.locals = {
	"Text": "_1-re4",
	"Header": "_1_sNr",
	"Label": "_1dOWZ",
	"Paragraph": "_2r2J6",
	"H1": "_9_KuO",
	"H2": "_1NQHx",
	"H3": "GYkRD",
	"H4": "_28CDF",
	"H5": "_11nJE",
	"H6": "_39lmd",
	"T1": "_16HS4",
	"T2": "_7uN7-",
	"L1": "_11OHv",
	"L2": "lCBam",
	"L2R": "kmquN",
	"L3": "_1LcgB",
	"L4": "_3Mf9_",
	"L4R": "_1S1Ic",
	"P1": "e7M8T",
	"P1R": "_1m5bA",
	"P2": "_1JbOB"
};

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1c61e0aa.mp4";

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6a6c4068.jpg";

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1143);
    var insertCss = __webpack_require__(907);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-rules-2!../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./reset-normalize.css", function() {
        content = require("!!../../node_modules/css-loader/index.js??ref--1-rules-2!../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./reset-normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(906)(false);
// imports


// module
exports.push([module.i, "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}html{-webkit-tap-highlight-color:transparent}body,html{width:100vw;max-width:100%;overflow-x:hidden}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted;cursor:help}b,strong{font-weight:700}dfn,em,i{font-style:italic}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0;outline:transparent}button{overflow:visible}button,select{text-transform:none}button,form,input[type=email],input[type=password],input[type=search],input[type=text],textarea{-webkit-appearance:none;border-radius:0;border:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:none}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}textarea{overflow:auto}optgroup{font-weight:700}@-ms-viewport{width:device-width}@-o-viewport{width:device-width}@viewport{width:device-width}*,:after,:before{-webkit-box-sizing:inherit;box-sizing:inherit}html{-webkit-box-sizing:border-box;box-sizing:border-box}body,html{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:rgba(0,0,0,0)}html{font-family:Calibre,sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;font-size:10px}body{font-size:16px;font-size:1.6rem}@media screen and (min-width:900px) and (max-width:1199px){html{font-size:8px}}@media screen and (min-width:1600px){html{font-size:11px}}@media screen and (min-width:2400px){html{font-size:13px}}[role=button]{cursor:pointer}[role=button],a,area,button,input,label,select,summary,textarea{-ms-touch-action:manipulation;touch-action:manipulation}[hidden]{display:none!important}", ""]);

// exports


/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = remaining;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Typography__ = __webpack_require__(887);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LicenseMeter = function (_React$PureComponent) {
  _inherits(LicenseMeter, _React$PureComponent);

  function LicenseMeter() {
    _classCallCheck(this, LicenseMeter);

    return _possibleConstructorReturn(this, (LicenseMeter.__proto__ || Object.getPrototypeOf(LicenseMeter)).apply(this, arguments));
  }

  _createClass(LicenseMeter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          used = _props.used,
          max = _props.max,
          style = _props.style,
          textStyle = _props.textStyle,
          meterStyle = _props.meterStyle,
          otherProps = _objectWithoutProperties(_props, ['used', 'max', 'style', 'textStyle', 'meterStyle']);

      var message = 'Unlimited';
      var remaining = max;
      if (max >= 0) {
        remaining = Math.max(0, max - used);
        message = remaining + ' of ' + max;
      }
      if (used === undefined && max === undefined) {
        message = '0';
      }

      return _jsx('div', {
        style: _extends({
          position: 'relative',
          height: '100%',
          width: '100%',
          border: '0.3rem solid ' + __WEBPACK_IMPORTED_MODULE_3__Style__["a" /* default */].Colors.black,
          borderRadius: '99999rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }, style)
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__Typography__["f" /* H6 */], {
        style: _extends({}, textStyle, { zIndex: 1 })
      }, void 0, message), _jsx('div', {
        style: _extends({
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 0,
          height: '100%',
          width: remaining / max * 100 + '%',
          borderRadius: '99999rem',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_3__Style__["a" /* default */].Colors.shadow5
        }, meterStyle)
      }));
    }
  }]);

  return LicenseMeter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

LicenseMeter.defaultProps = {
  style: __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* EMPTY_OBJECT */],
  textStyle: __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* EMPTY_OBJECT */]
};


/* harmony default export */ __webpack_exports__["a"] = (LicenseMeter);

function remaining(used, max) {
  var count = 'Unlimited';
  var remaining = max;
  if (max >= 0) {
    count = Math.max(0, max - used);
  }
  if (used === undefined && max === undefined) {
    count = 0;
  }

  return count;
}

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(102), __webpack_require__(1146));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(102));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(102));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(1149),
    isIterateeCall = __webpack_require__(141),
    toInteger = __webpack_require__(359);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 1149 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(144),
    arrayIncludes = __webpack_require__(226),
    arrayIncludesWith = __webpack_require__(227),
    arrayMap = __webpack_require__(71),
    baseUnary = __webpack_require__(143),
    cacheHas = __webpack_require__(145);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(360);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 1152 */,
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setColors;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearColors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(17);



function setColors(colors) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["S" /* SET_UI_COLORS */], colors);
}

function clearColors() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["S" /* SET_UI_COLORS */], __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* EMPTY_OBJECT */]);
}

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(372);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(19);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(33);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(910);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(1075);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(139);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./node_modules/lodash/values.js
var values = __webpack_require__(83);
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(220);

// EXTERNAL MODULE: ./node_modules/react-motion/lib/react-motion.js
var react_motion = __webpack_require__(353);
var react_motion_default = /*#__PURE__*/__webpack_require__.n(react_motion);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(17);

// EXTERNAL MODULE: ./src/actions/runtime.js
var runtime = __webpack_require__(354);

// EXTERNAL MODULE: ./src/lib/Motion.js
var Motion = __webpack_require__(352);

// EXTERNAL MODULE: ./src/containers/ModalConductor/ModalConductor.js + 17 modules
var ModalConductor = __webpack_require__(1124);

// EXTERNAL MODULE: ./src/components/ElementTransition/ElementTransition.js
var ElementTransition = __webpack_require__(911);

// EXTERNAL MODULE: ./src/components/Header/Header.js + 4 modules
var Header = __webpack_require__(1073);

// EXTERNAL MODULE: ./src/components/Icons/Icons.js
var Icons = __webpack_require__(888);

// EXTERNAL MODULE: ./node_modules/react-addons-perf/index.js
var react_addons_perf = __webpack_require__(1169);
var react_addons_perf_default = /*#__PURE__*/__webpack_require__.n(react_addons_perf);

// CONCATENATED MODULE: ./src/components/PerfWidget/PerfWidget.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var boxStyle = {
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  right: '50px',
  top: '20vw',
  padding: '10px',
  background: '#bada55',
  border: '2px solid black',
  textAlign: 'center',
  zIndex: 9999999
};

var buttonStyle = {
  display: 'block',
  marginTop: '10px',
  padding: '5px'
};

var PerfWidget_PerfWidget = function (_React$PureComponent) {
  _inherits(PerfWidget, _React$PureComponent);

  function PerfWidget(props) {
    _classCallCheck(this, PerfWidget);

    var _this = _possibleConstructorReturn(this, (PerfWidget.__proto__ || Object.getPrototypeOf(PerfWidget)).call(this, props));

    _this.toggle = function () {
      var started = _this.state.started;


      started ? react_addons_perf_default.a.stop() : react_addons_perf_default.a.start();

      _this.setState({ started: !started });
    };

    _this.printWasted = function () {
      var lastMeasurements = react_addons_perf_default.a.getLastMeasurements();

      react_addons_perf_default.a.printWasted(lastMeasurements);
    };

    _this.printOperations = function () {
      var lastMeasurements = react_addons_perf_default.a.getLastMeasurements();

      react_addons_perf_default.a.printOperations(lastMeasurements);
    };

    _this.state = { started: false };
    return _this;
  }

  _createClass(PerfWidget, [{
    key: 'render',
    value: function render() {
      if (true) {
        return null;
      }

      var started = this.state.started;


      return _jsx('div', {
        style: boxStyle
      }, void 0, _jsx('button', {
        style: buttonStyle,
        onClick: this.toggle
      }, void 0, started ? 'Stop' : 'Start'), _jsx('button', {
        style: buttonStyle,
        onClick: this.printWasted
      }, void 0, 'Print Wasted'), _jsx('button', {
        style: buttonStyle,
        onClick: this.printOperations
      }, void 0, 'Print Operations'));
    }
  }]);

  return PerfWidget;
}(react_default.a.PureComponent);

PerfWidget_PerfWidget.defaultProps = {};


/* harmony default export */ var components_PerfWidget_PerfWidget = (PerfWidget_PerfWidget);
// EXTERNAL MODULE: ./src/components/Style/Style.js
var Style = __webpack_require__(350);

// EXTERNAL MODULE: ./src/components/reset-normalize.css
var reset_normalize = __webpack_require__(1142);
var reset_normalize_default = /*#__PURE__*/__webpack_require__.n(reset_normalize);

// CONCATENATED MODULE: ./src/components/Layout/Layout.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Layout__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Layout__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Layout__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















// external-global styles must be imported in your JS.


var modalAnimatedDefault = { opacity: 0 };
var headerAnimatedDefault = { show: 0 };
var loadingAnimatedDefault = [{ x: 1 }, { x: 1 }, { x: 0 }];
var triggerPoints = [0, 1, 0.9];

var _ref = Layout__jsx(ModalConductor["a" /* default */], {});

var _ref3 = Layout__jsx(Icons["b" /* Brandmark */], {});

var Layout_Layout = function (_React$PureComponent) {
  Layout__inherits(Layout, _React$PureComponent);

  function Layout(props) {
    Layout__classCallCheck(this, Layout);

    var _this = Layout__possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, props));

    _this.onResize = function () {
      var width = window.innerWidth;
      var size = sortBy_default()(values_default()(constants["C" /* RESPONSIVE_SIZE */])).reduce(function (acc, next) {
        return width >= next ? next : acc;
      });
      _this.props.setResponsiveSize(size);
    };

    _this.modalTransitionDone = function () {
      if (_this.props.showModal) {
        _this.setState({ scrollPrison: true });
      } else {
        _this.setState({ renderModal: false });
      }
    };

    _this.loadingAnimationDone = function () {
      if (_this.props.layoutLoading) {
        return;
      }
      _this.props.setLayoutLoaded(true);
    };

    _this.getStyles = function (prevInterpolatedStyles) {
      if (prevInterpolatedStyles[2].x > 0.95) {
        setTimeout(_this.loadingAnimationDone, 100);
      }

      var progress = 1;
      if (_this.props.layoutLoading) {
        progress = 0.55;
      }

      return [Object(Motion["d" /* springify */])({
        x: _this.props.layoutLoading || !_this.props.layoutLoaded ? 1 : 0
      }), Object(Motion["d" /* springify */])({
        x: _this.state.showLogo ? 1 : 1
      }), Object(Motion["d" /* springify */])({
        x: prevInterpolatedStyles[1].x > triggerPoints[2] ? progress : 0
      }, { stiffness: 80, damping: 25 })];
    };

    _this.setShowHeader = function () {
      _this.setState({ renderHeader: _this.props.showHeader });
    };

    _this.setHideHeader = function () {
      if (!_this.props.showHeader) {
        _this.setState({ renderHeader: _this.props.showHeader });
      }
    };

    _this.state = {
      scrollX: 0,
      scrollY: 0,
      scrollPrison: false,
      renderModal: props.showModal,
      renderHeader: props.showHeader,
      showLogo: false
    };
    return _this;
  }

  Layout__createClass(Layout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', debounce_default()(this.onResize, 100), {
        passive: true
      });
      this.onResize();

      setTimeout(function () {
        return _this2.setState({ showLogo: true });
      }, 400);
      setTimeout(this.props.setLayoutLoading, 1000, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', debounce_default()(this.onResize, 100), {
        passive: true
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.showModal && nextProps.showModal) {
        this.setState({
          scrollX: window.pageXOffset,
          scrollY: window.pageYOffset,
          renderModal: true
        });
      } else if (this.props.showModal && !nextProps.showModal) {
        this.setState({ scrollPrison: false });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.scrollPrison && !this.state.scrollPrison) {
        window.scrollTo(this.state.scrollX, this.state.scrollY);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          responsive = _props.responsive,
          transitionId = _props.transitionId,
          showModal = _props.showModal,
          scrollPrison = _props.scrollPrison,
          layoutLoading = _props.layoutLoading,
          layoutLoaded = _props.layoutLoaded,
          showHeader = _props.showHeader,
          headerNavLinks = _props.headerNavLinks,
          setLayoutLoading = _props.setLayoutLoading,
          setLayoutLoaded = _props.setLayoutLoaded,
          setResponsiveSize = _props.setResponsiveSize,
          otherProps = _objectWithoutProperties(_props, ['children', 'responsive', 'transitionId', 'showModal', 'scrollPrison', 'layoutLoading', 'layoutLoaded', 'showHeader', 'headerNavLinks', 'setLayoutLoading', 'setLayoutLoaded', 'setResponsiveSize']);

      var bodyStyle = { opacity: layoutLoading ? 0 : 1 };
      if (this.state.scrollPrison || scrollPrison) {
        bodyStyle = {
          maxHeight: '100vh',
          position: 'relative',
          top: '-' + this.state.scrollY + 'px'
        };
      }

      var headerTop = 0;
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE) {
        headerTop = 2;
      }

      var modalAnimatedCurrent = Object(Motion["d" /* springify */])({ opacity: showModal ? 1 : 0 });
      var headerAnimatedCurrent = Object(Motion["d" /* springify */])({
        show: this.props.showHeader ? 1 : 0
      });

      var _ref2 = Layout__jsx(Header["a" /* default */], {
        navLinks: headerNavLinks
      });

      return Layout__jsx('div', {
        style: { overflow: 'hidden' }
      }, void 0, this.state.renderModal && Layout__jsx(react_motion["Motion"], {
        defaultStyle: modalAnimatedDefault,
        style: modalAnimatedCurrent,
        onRest: this.modalTransitionDone
      }, void 0, function (tween) {
        return Layout__jsx('div', {
          style: _extends({}, tween, {
            willChange: 'opacity',
            pointerEvents: tween.opacity < 0.75 ? 'none' : undefined,
            position: 'relative',
            zIndex: 2000
          })
        }, void 0, _ref);
      }), Layout__jsx('div', {
        style: bodyStyle
      }, void 0, Layout__jsx(react_motion["Motion"], {
        defaultStyle: headerAnimatedDefault,
        style: headerAnimatedCurrent
      }, void 0, function (tween) {
        if (tween.show > 0) {
          return Layout__jsx('div', {
            style: {
              position: 'absolute',
              top: headerTop + 'rem',
              left: 0,
              right: 0,
              zIndex: 1001,
              opacity: tween.show
            }
          }, void 0, _ref2);
        } else {
          return null;
        }
      }), children), !layoutLoaded && Layout__jsx(react_motion["StaggeredMotion"], {
        defaultStyles: loadingAnimatedDefault,
        styles: this.getStyles
      }, void 0, function (tweens) {
        return Layout__jsx('div', {
          style: _extends({}, constants["n" /* FULL_STYLE */], {
            zIndex: 9999,
            opacity: tweens[0].x,
            pointerEvents: tweens[0].x < 0.75 ? 'none' : undefined,
            position: 'fixed',
            backgroundColor: Style["a" /* default */].Colors.white,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          })
        }, void 0, Layout__jsx('div', {
          style: {
            position: 'relative'
          }
        }, void 0, Layout__jsx('div', {
          style: {
            opacity: tweens[1].x,
            transform: 'scale(' + ((tweens[1].x * -1 + 1) * 0.3 + 1) + ')'
          }
        }, void 0, _ref3), Layout__jsx('div', {
          style: _extends({}, constants["n" /* FULL_STYLE */], {
            left: tweens[2].x * 100 + '%',
            opacity: 0.85,
            transform: 'scale(' + ((tweens[1].x * -1 + 1) * 0.3 + 1) + ')',
            backgroundColor: Style["a" /* default */].Colors.white
          })
        })));
      }));
    }
  }]);

  return Layout;
}(react_default.a.PureComponent);

Layout_Layout.defaultProps = {
  showHeader: false,
  headerNavLinks: constants["k" /* EMPTY_ARRAY */],
  transitionId: '__transitionId__'
};
Layout_Layout.contextTypes = {
  store: prop_types_default.a.object
};


function mapStateToProps(state) {
  return {
    responsive: state.modal.responsive,
    showModal: state.modal.visible,
    scrollPrison: state.runtime.scrollPrison,
    layoutLoading: state.runtime.layoutLoading,
    layoutLoaded: state.runtime.layoutLoaded
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setLayoutLoaded: function setLayoutLoaded(value) {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('layoutLoaded', value));
    },
    setLayoutLoading: function setLayoutLoading(value) {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('layoutLoading', value));
    },
    setResponsiveSize: function setResponsiveSize(size) {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('responsive', size));
    }
  };
}

/* harmony default export */ var components_Layout_Layout = __webpack_exports__["a"] = (Object(es["connect"])(mapStateToProps, mapDispatchToProps)(withStyles_default()(reset_normalize_default.a)(Layout_Layout)));

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_difference__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEqual__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_motion__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_react__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_Motion__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_tasks__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ImageLoader_css__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ImageLoader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ImageLoader_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var ImageLoader = function (_MyPureComponent) {
  _inherits(ImageLoader, _MyPureComponent);

  function ImageLoader(props, context) {
    _classCallCheck(this, ImageLoader);

    var _this = _possibleConstructorReturn(this, (ImageLoader.__proto__ || Object.getPrototypeOf(ImageLoader)).call(this, props, context));

    _initialiseProps.call(_this);

    _this.state = {
      currentImage: '',
      doBlur: false,
      lqipImageLoaded: false
    };

    _this.loadedImages = new Set();
    return _this;
  }

  _createClass(ImageLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.processNewProps(__WEBPACK_IMPORTED_MODULE_7__constants__["l" /* EMPTY_OBJECT */], this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.processNewProps(this.props, nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var rootStyle = {
        backgroundColor: this.props.color
      };

      var lqipStyle = _extends({}, this.props.imageStyle, {
        backgroundImage: 'url(' + this.props.lqip + ')'
      });

      var fullQualityStyle = _extends({}, this.props.imageStyle, {
        backgroundImage: 'url(' + this.state.currentImage + ')'
      });

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__ImageLoader_css___default.a.root,
        style: rootStyle
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_12__ImageLoader_css___default.a.lqipBase, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_12__ImageLoader_css___default.a.lqipLoaded, this.state.lqipImageLoaded)),
        style: lqipStyle
      }), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_12__ImageLoader_css___default.a.fqBase, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_12__ImageLoader_css___default.a.fqLoaded, this.state.currentImage)),
        style: fullQualityStyle
      }));
    }
  }]);

  return ImageLoader;
}(__WEBPACK_IMPORTED_MODULE_8__lib_react__["a" /* MyPureComponent */]);

ImageLoader.propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lqip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  images: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  blurRems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  imageStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
ImageLoader.defaultProps = {
  color: __WEBPACK_IMPORTED_MODULE_11__Style__["a" /* default */].Colors.black,
  lqip: '',
  images: __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* EMPTY_ARRAY */],
  blurRems: 3,
  imageStyle: __WEBPACK_IMPORTED_MODULE_7__constants__["l" /* EMPTY_OBJECT */]
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.processNewProps = function (props, nextProps) {
    var nextImages = nextProps.images.filter(Boolean);
    var currentImage = _this2.state.currentImage;
    var newImages = false;

    if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isEqual___default()(props.images, nextProps.images)) {
      newImages = true;

      if (currentImage && !nextImages.includes(currentImage)) {
        currentImage = '';
        _this2.setState({ currentImage: '' });
      }
    }

    if (props.lqip !== nextProps.lqip) {
      _this2.setState({
        doBlur: !Boolean(currentImage),
        lqipImageLoaded: false
      });
      _this2.loadImages([nextProps.lqip], _this2.markLqipLoaded);
    }

    if (newImages) {
      _this2.loadedImages = new Set();
      _this2.loadImages(nextImages, _this2.checkForNextImage);
    }
  };

  this.loadImages = function (images, thenFunc) {
    images.map(function (url) {
      Object(__WEBPACK_IMPORTED_MODULE_10__lib_tasks__["b" /* loadImage */])(url).then(function () {
        return _this2.loadedImages.add(url);
      }).then(thenFunc).catch(__WEBPACK_IMPORTED_MODULE_8__lib_react__["e" /* noOp */]);
    });
  };

  this.checkForNextImage = function () {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _this2.props.images.filter(Boolean)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var url = _step.value;

        if (_this2.state.currentImage === url) {
          break;
        }

        if (_this2.loadedImages.has(url)) {
          _this2.setState({ currentImage: url });
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };

  this.markLqipLoaded = function () {
    _this2.setState(function (prevState) {
      return {
        doBlur: !Boolean(prevState.currentImage),
        lqipImageLoaded: true
      };
    });
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_12__ImageLoader_css___default.a)(ImageLoader));

// {
//   ...fullQualityStyle,
//   opacity: tween.imageOpacity,
//   filter: `blur(${tween.blur * this.props.blurRems}rem)`,
// }

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(369),
    isObject = __webpack_require__(22);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 1164 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 1165 */,
/* 1166 */,
/* 1167 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 1168 */,
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1170);

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _assign = __webpack_require__(10);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ReactDebugTool = __webpack_require__(1171);
var lowPriorityWarning = __webpack_require__(1176);
var alreadyWarned = false;

function roundFloat(val) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  var n = Math.pow(10, base);
  return Math.floor(val * n) / n;
}

// Flow type definition of console.table is too strict right now, see
// https://github.com/facebook/flow/pull/2353 for updates
function consoleTable(table) {
  console.table(table);
}

function warnInProduction() {
  if (alreadyWarned) {
    return;
  }
  alreadyWarned = true;
  if (typeof console !== 'undefined') {
    console.error('ReactPerf is not supported in the production builds of React. ' + 'To collect measurements, please use the development build of React instead.');
  }
}

function getLastMeasurements() {
  if (true) {
    warnInProduction();
    return [];
  }

  return ReactDebugTool.getFlushHistory();
}

function getExclusive() {
  var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

  if (true) {
    warnInProduction();
    return [];
  }

  var aggregatedStats = {};
  var affectedIDs = {};

  function updateAggregatedStats(treeSnapshot, instanceID, timerType, applyUpdate) {
    var displayName = treeSnapshot[instanceID].displayName;

    var key = displayName;
    var stats = aggregatedStats[key];
    if (!stats) {
      affectedIDs[key] = {};
      stats = aggregatedStats[key] = {
        key: key,
        instanceCount: 0,
        counts: {},
        durations: {},
        totalDuration: 0
      };
    }
    if (!stats.durations[timerType]) {
      stats.durations[timerType] = 0;
    }
    if (!stats.counts[timerType]) {
      stats.counts[timerType] = 0;
    }
    affectedIDs[key][instanceID] = true;
    applyUpdate(stats);
  }

  flushHistory.forEach(function (flush) {
    var measurements = flush.measurements,
        treeSnapshot = flush.treeSnapshot;

    measurements.forEach(function (measurement) {
      var duration = measurement.duration,
          instanceID = measurement.instanceID,
          timerType = measurement.timerType;

      updateAggregatedStats(treeSnapshot, instanceID, timerType, function (stats) {
        stats.totalDuration += duration;
        stats.durations[timerType] += duration;
        stats.counts[timerType]++;
      });
    });
  });

  return Object.keys(aggregatedStats).map(function (key) {
    return _extends({}, aggregatedStats[key], {
      instanceCount: Object.keys(affectedIDs[key]).length
    });
  }).sort(function (a, b) {
    return b.totalDuration - a.totalDuration;
  });
}

function getInclusive() {
  var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

  if (true) {
    warnInProduction();
    return [];
  }

  var aggregatedStats = {};
  var affectedIDs = {};

  function updateAggregatedStats(treeSnapshot, instanceID, applyUpdate) {
    var _treeSnapshot$instanc = treeSnapshot[instanceID],
        displayName = _treeSnapshot$instanc.displayName,
        ownerID = _treeSnapshot$instanc.ownerID;

    var owner = treeSnapshot[ownerID];
    var key = (owner ? owner.displayName + ' > ' : '') + displayName;
    var stats = aggregatedStats[key];
    if (!stats) {
      affectedIDs[key] = {};
      stats = aggregatedStats[key] = {
        key: key,
        instanceCount: 0,
        inclusiveRenderDuration: 0,
        renderCount: 0
      };
    }
    affectedIDs[key][instanceID] = true;
    applyUpdate(stats);
  }

  var isCompositeByID = {};
  flushHistory.forEach(function (flush) {
    var measurements = flush.measurements;

    measurements.forEach(function (measurement) {
      var instanceID = measurement.instanceID,
          timerType = measurement.timerType;

      if (timerType !== 'render') {
        return;
      }
      isCompositeByID[instanceID] = true;
    });
  });

  flushHistory.forEach(function (flush) {
    var measurements = flush.measurements,
        treeSnapshot = flush.treeSnapshot;

    measurements.forEach(function (measurement) {
      var duration = measurement.duration,
          instanceID = measurement.instanceID,
          timerType = measurement.timerType;

      if (timerType !== 'render') {
        return;
      }
      updateAggregatedStats(treeSnapshot, instanceID, function (stats) {
        stats.renderCount++;
      });
      var nextParentID = instanceID;
      while (nextParentID) {
        // As we traverse parents, only count inclusive time towards composites.
        // We know something is a composite if its render() was called.
        if (isCompositeByID[nextParentID]) {
          updateAggregatedStats(treeSnapshot, nextParentID, function (stats) {
            stats.inclusiveRenderDuration += duration;
          });
        }
        nextParentID = treeSnapshot[nextParentID].parentID;
      }
    });
  });

  return Object.keys(aggregatedStats).map(function (key) {
    return _extends({}, aggregatedStats[key], {
      instanceCount: Object.keys(affectedIDs[key]).length
    });
  }).sort(function (a, b) {
    return b.inclusiveRenderDuration - a.inclusiveRenderDuration;
  });
}

function getWasted() {
  var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

  if (true) {
    warnInProduction();
    return [];
  }

  var aggregatedStats = {};
  var affectedIDs = {};

  function updateAggregatedStats(treeSnapshot, instanceID, applyUpdate) {
    var _treeSnapshot$instanc2 = treeSnapshot[instanceID],
        displayName = _treeSnapshot$instanc2.displayName,
        ownerID = _treeSnapshot$instanc2.ownerID;

    var owner = treeSnapshot[ownerID];
    var key = (owner ? owner.displayName + ' > ' : '') + displayName;
    var stats = aggregatedStats[key];
    if (!stats) {
      affectedIDs[key] = {};
      stats = aggregatedStats[key] = {
        key: key,
        instanceCount: 0,
        inclusiveRenderDuration: 0,
        renderCount: 0
      };
    }
    affectedIDs[key][instanceID] = true;
    applyUpdate(stats);
  }

  flushHistory.forEach(function (flush) {
    var measurements = flush.measurements,
        treeSnapshot = flush.treeSnapshot,
        operations = flush.operations;

    var isDefinitelyNotWastedByID = {};

    // Find host components associated with an operation in this batch.
    // Mark all components in their parent tree as definitely not wasted.
    operations.forEach(function (operation) {
      var instanceID = operation.instanceID;

      var nextParentID = instanceID;
      while (nextParentID) {
        isDefinitelyNotWastedByID[nextParentID] = true;
        nextParentID = treeSnapshot[nextParentID].parentID;
      }
    });

    // Find composite components that rendered in this batch.
    // These are potential candidates for being wasted renders.
    var renderedCompositeIDs = {};
    measurements.forEach(function (measurement) {
      var instanceID = measurement.instanceID,
          timerType = measurement.timerType;

      if (timerType !== 'render') {
        return;
      }
      renderedCompositeIDs[instanceID] = true;
    });

    measurements.forEach(function (measurement) {
      var duration = measurement.duration,
          instanceID = measurement.instanceID,
          timerType = measurement.timerType;

      if (timerType !== 'render') {
        return;
      }

      // If there was a DOM update below this component, or it has just been
      // mounted, its render() is not considered wasted.
      var updateCount = treeSnapshot[instanceID].updateCount;

      if (isDefinitelyNotWastedByID[instanceID] || updateCount === 0) {
        return;
      }

      // We consider this render() wasted.
      updateAggregatedStats(treeSnapshot, instanceID, function (stats) {
        stats.renderCount++;
      });

      var nextParentID = instanceID;
      while (nextParentID) {
        // Any parents rendered during this batch are considered wasted
        // unless we previously marked them as dirty.
        var isWasted = renderedCompositeIDs[nextParentID] && !isDefinitelyNotWastedByID[nextParentID];
        if (isWasted) {
          updateAggregatedStats(treeSnapshot, nextParentID, function (stats) {
            stats.inclusiveRenderDuration += duration;
          });
        }
        nextParentID = treeSnapshot[nextParentID].parentID;
      }
    });
  });

  return Object.keys(aggregatedStats).map(function (key) {
    return _extends({}, aggregatedStats[key], {
      instanceCount: Object.keys(affectedIDs[key]).length
    });
  }).sort(function (a, b) {
    return b.inclusiveRenderDuration - a.inclusiveRenderDuration;
  });
}

function getOperations() {
  var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

  if (true) {
    warnInProduction();
    return [];
  }

  var stats = [];
  flushHistory.forEach(function (flush, flushIndex) {
    var operations = flush.operations,
        treeSnapshot = flush.treeSnapshot;

    operations.forEach(function (operation) {
      var instanceID = operation.instanceID,
          type = operation.type,
          payload = operation.payload;
      var _treeSnapshot$instanc3 = treeSnapshot[instanceID],
          displayName = _treeSnapshot$instanc3.displayName,
          ownerID = _treeSnapshot$instanc3.ownerID;

      var owner = treeSnapshot[ownerID];
      var key = (owner ? owner.displayName + ' > ' : '') + displayName;

      stats.push({
        flushIndex: flushIndex,
        instanceID: instanceID,
        key: key,
        type: type,
        ownerID: ownerID,
        payload: payload
      });
    });
  });
  return stats;
}

function printExclusive(flushHistory) {
  if (true) {
    warnInProduction();
    return;
  }

  var stats = getExclusive(flushHistory);
  var table = stats.map(function (item) {
    var key = item.key,
        instanceCount = item.instanceCount,
        totalDuration = item.totalDuration;

    var renderCount = item.counts.render || 0;
    var renderDuration = item.durations.render || 0;
    return {
      Component: key,
      'Total time (ms)': roundFloat(totalDuration),
      'Instance count': instanceCount,
      'Total render time (ms)': roundFloat(renderDuration),
      'Average render time (ms)': renderCount ? roundFloat(renderDuration / renderCount) : undefined,
      'Render count': renderCount,
      'Total lifecycle time (ms)': roundFloat(totalDuration - renderDuration)
    };
  });
  consoleTable(table);
}

function printInclusive(flushHistory) {
  if (true) {
    warnInProduction();
    return;
  }

  var stats = getInclusive(flushHistory);
  var table = stats.map(function (item) {
    var key = item.key,
        instanceCount = item.instanceCount,
        inclusiveRenderDuration = item.inclusiveRenderDuration,
        renderCount = item.renderCount;

    return {
      'Owner > Component': key,
      'Inclusive render time (ms)': roundFloat(inclusiveRenderDuration),
      'Instance count': instanceCount,
      'Render count': renderCount
    };
  });
  consoleTable(table);
}

function printWasted(flushHistory) {
  if (true) {
    warnInProduction();
    return;
  }

  var stats = getWasted(flushHistory);
  var table = stats.map(function (item) {
    var key = item.key,
        instanceCount = item.instanceCount,
        inclusiveRenderDuration = item.inclusiveRenderDuration,
        renderCount = item.renderCount;

    return {
      'Owner > Component': key,
      'Inclusive wasted time (ms)': roundFloat(inclusiveRenderDuration),
      'Instance count': instanceCount,
      'Render count': renderCount
    };
  });
  consoleTable(table);
}

function printOperations(flushHistory) {
  if (true) {
    warnInProduction();
    return;
  }

  var stats = getOperations(flushHistory);
  var table = stats.map(function (stat) {
    return {
      'Owner > Node': stat.key,
      Operation: stat.type,
      Payload: typeof stat.payload === 'object' ? JSON.stringify(stat.payload) : stat.payload,
      'Flush index': stat.flushIndex,
      'Owner Component ID': stat.ownerID,
      'DOM Component ID': stat.instanceID
    };
  });
  consoleTable(table);
}

var warnedAboutPrintDOM = false;
function printDOM(measurements) {
  lowPriorityWarning(warnedAboutPrintDOM, '`ReactPerf.printDOM(...)` is deprecated. Use ' + '`ReactPerf.printOperations(...)` instead.');
  warnedAboutPrintDOM = true;
  return printOperations(measurements);
}

var warnedAboutGetMeasurementsSummaryMap = false;
function getMeasurementsSummaryMap(measurements) {
  lowPriorityWarning(warnedAboutGetMeasurementsSummaryMap, '`ReactPerf.getMeasurementsSummaryMap(...)` is deprecated. Use ' + '`ReactPerf.getWasted(...)` instead.');
  warnedAboutGetMeasurementsSummaryMap = true;
  return getWasted(measurements);
}

function start() {
  if (true) {
    warnInProduction();
    return;
  }

  ReactDebugTool.beginProfiling();
}

function stop() {
  if (true) {
    warnInProduction();
    return;
  }

  ReactDebugTool.endProfiling();
}

function isRunning() {
  if (true) {
    warnInProduction();
    return false;
  }

  return ReactDebugTool.isProfiling();
}

var ReactPerfAnalysis = {
  getLastMeasurements: getLastMeasurements,
  getExclusive: getExclusive,
  getInclusive: getInclusive,
  getWasted: getWasted,
  getOperations: getOperations,
  printExclusive: printExclusive,
  printInclusive: printInclusive,
  printWasted: printWasted,
  printOperations: printOperations,
  start: start,
  stop: stop,
  isRunning: isRunning,
  // Deprecated:
  printDOM: printDOM,
  getMeasurementsSummaryMap: getMeasurementsSummaryMap
};

module.exports = ReactPerfAnalysis;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactInvalidSetStateWarningHook = __webpack_require__(1172);
var ReactHostOperationHistoryHook = __webpack_require__(1173);
var ReactComponentTreeHook = __webpack_require__(228);
var ExecutionEnvironment = __webpack_require__(21);

var performanceNow = __webpack_require__(1174);
var warning = __webpack_require__(7);

var hooks = [];
var didHookThrowForEvent = {};

function callHook(event, fn, context, arg1, arg2, arg3, arg4, arg5) {
  try {
    fn.call(context, arg1, arg2, arg3, arg4, arg5);
  } catch (e) {
     false ? warning(didHookThrowForEvent[event], 'Exception thrown by hook while handling %s: %s', event, e + '\n' + e.stack) : void 0;
    didHookThrowForEvent[event] = true;
  }
}

function emitEvent(event, arg1, arg2, arg3, arg4, arg5) {
  for (var i = 0; i < hooks.length; i++) {
    var hook = hooks[i];
    var fn = hook[event];
    if (fn) {
      callHook(event, fn, hook, arg1, arg2, arg3, arg4, arg5);
    }
  }
}

var isProfiling = false;
var flushHistory = [];
var lifeCycleTimerStack = [];
var currentFlushNesting = 0;
var currentFlushMeasurements = [];
var currentFlushStartTime = 0;
var currentTimerDebugID = null;
var currentTimerStartTime = 0;
var currentTimerNestedFlushDuration = 0;
var currentTimerType = null;

var lifeCycleTimerHasWarned = false;

function clearHistory() {
  ReactComponentTreeHook.purgeUnmountedComponents();
  ReactHostOperationHistoryHook.clearHistory();
}

function getTreeSnapshot(registeredIDs) {
  return registeredIDs.reduce(function (tree, id) {
    var ownerID = ReactComponentTreeHook.getOwnerID(id);
    var parentID = ReactComponentTreeHook.getParentID(id);
    tree[id] = {
      displayName: ReactComponentTreeHook.getDisplayName(id),
      text: ReactComponentTreeHook.getText(id),
      updateCount: ReactComponentTreeHook.getUpdateCount(id),
      childIDs: ReactComponentTreeHook.getChildIDs(id),
      // Text nodes don't have owners but this is close enough.
      ownerID: ownerID || parentID && ReactComponentTreeHook.getOwnerID(parentID) || 0,
      parentID: parentID
    };
    return tree;
  }, {});
}

function resetMeasurements() {
  var previousStartTime = currentFlushStartTime;
  var previousMeasurements = currentFlushMeasurements;
  var previousOperations = ReactHostOperationHistoryHook.getHistory();

  if (currentFlushNesting === 0) {
    currentFlushStartTime = 0;
    currentFlushMeasurements = [];
    clearHistory();
    return;
  }

  if (previousMeasurements.length || previousOperations.length) {
    var registeredIDs = ReactComponentTreeHook.getRegisteredIDs();
    flushHistory.push({
      duration: performanceNow() - previousStartTime,
      measurements: previousMeasurements || [],
      operations: previousOperations || [],
      treeSnapshot: getTreeSnapshot(registeredIDs)
    });
  }

  clearHistory();
  currentFlushStartTime = performanceNow();
  currentFlushMeasurements = [];
}

function checkDebugID(debugID) {
  var allowRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (allowRoot && debugID === 0) {
    return;
  }
  if (!debugID) {
     false ? warning(false, 'ReactDebugTool: debugID may not be empty.') : void 0;
  }
}

function beginLifeCycleTimer(debugID, timerType) {
  if (currentFlushNesting === 0) {
    return;
  }
  if (currentTimerType && !lifeCycleTimerHasWarned) {
     false ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'Did not expect %s timer to start while %s timer is still in ' + 'progress for %s instance.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
    lifeCycleTimerHasWarned = true;
  }
  currentTimerStartTime = performanceNow();
  currentTimerNestedFlushDuration = 0;
  currentTimerDebugID = debugID;
  currentTimerType = timerType;
}

function endLifeCycleTimer(debugID, timerType) {
  if (currentFlushNesting === 0) {
    return;
  }
  if (currentTimerType !== timerType && !lifeCycleTimerHasWarned) {
     false ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'We did not expect %s timer to stop while %s timer is still in ' + 'progress for %s instance. Please report this as a bug in React.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
    lifeCycleTimerHasWarned = true;
  }
  if (isProfiling) {
    currentFlushMeasurements.push({
      timerType: timerType,
      instanceID: debugID,
      duration: performanceNow() - currentTimerStartTime - currentTimerNestedFlushDuration
    });
  }
  currentTimerStartTime = 0;
  currentTimerNestedFlushDuration = 0;
  currentTimerDebugID = null;
  currentTimerType = null;
}

function pauseCurrentLifeCycleTimer() {
  var currentTimer = {
    startTime: currentTimerStartTime,
    nestedFlushStartTime: performanceNow(),
    debugID: currentTimerDebugID,
    timerType: currentTimerType
  };
  lifeCycleTimerStack.push(currentTimer);
  currentTimerStartTime = 0;
  currentTimerNestedFlushDuration = 0;
  currentTimerDebugID = null;
  currentTimerType = null;
}

function resumeCurrentLifeCycleTimer() {
  var _lifeCycleTimerStack$ = lifeCycleTimerStack.pop(),
      startTime = _lifeCycleTimerStack$.startTime,
      nestedFlushStartTime = _lifeCycleTimerStack$.nestedFlushStartTime,
      debugID = _lifeCycleTimerStack$.debugID,
      timerType = _lifeCycleTimerStack$.timerType;

  var nestedFlushDuration = performanceNow() - nestedFlushStartTime;
  currentTimerStartTime = startTime;
  currentTimerNestedFlushDuration += nestedFlushDuration;
  currentTimerDebugID = debugID;
  currentTimerType = timerType;
}

var lastMarkTimeStamp = 0;
var canUsePerformanceMeasure = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function';

function shouldMark(debugID) {
  if (!isProfiling || !canUsePerformanceMeasure) {
    return false;
  }
  var element = ReactComponentTreeHook.getElement(debugID);
  if (element == null || typeof element !== 'object') {
    return false;
  }
  var isHostElement = typeof element.type === 'string';
  if (isHostElement) {
    return false;
  }
  return true;
}

function markBegin(debugID, markType) {
  if (!shouldMark(debugID)) {
    return;
  }

  var markName = debugID + '::' + markType;
  lastMarkTimeStamp = performanceNow();
  performance.mark(markName);
}

function markEnd(debugID, markType) {
  if (!shouldMark(debugID)) {
    return;
  }

  var markName = debugID + '::' + markType;
  var displayName = ReactComponentTreeHook.getDisplayName(debugID) || 'Unknown';

  // Chrome has an issue of dropping markers recorded too fast:
  // https://bugs.chromium.org/p/chromium/issues/detail?id=640652
  // To work around this, we will not report very small measurements.
  // I determined the magic number by tweaking it back and forth.
  // 0.05ms was enough to prevent the issue, but I set it to 0.1ms to be safe.
  // When the bug is fixed, we can `measure()` unconditionally if we want to.
  var timeStamp = performanceNow();
  if (timeStamp - lastMarkTimeStamp > 0.1) {
    var measurementName = displayName + ' [' + markType + ']';
    performance.measure(measurementName, markName);
  }

  performance.clearMarks(markName);
  if (measurementName) {
    performance.clearMeasures(measurementName);
  }
}

var ReactDebugTool = {
  addHook: function (hook) {
    hooks.push(hook);
  },
  removeHook: function (hook) {
    for (var i = 0; i < hooks.length; i++) {
      if (hooks[i] === hook) {
        hooks.splice(i, 1);
        i--;
      }
    }
  },
  isProfiling: function () {
    return isProfiling;
  },
  beginProfiling: function () {
    if (isProfiling) {
      return;
    }

    isProfiling = true;
    flushHistory.length = 0;
    resetMeasurements();
    ReactDebugTool.addHook(ReactHostOperationHistoryHook);
  },
  endProfiling: function () {
    if (!isProfiling) {
      return;
    }

    isProfiling = false;
    resetMeasurements();
    ReactDebugTool.removeHook(ReactHostOperationHistoryHook);
  },
  getFlushHistory: function () {
    return flushHistory;
  },
  onBeginFlush: function () {
    currentFlushNesting++;
    resetMeasurements();
    pauseCurrentLifeCycleTimer();
    emitEvent('onBeginFlush');
  },
  onEndFlush: function () {
    resetMeasurements();
    currentFlushNesting--;
    resumeCurrentLifeCycleTimer();
    emitEvent('onEndFlush');
  },
  onBeginLifeCycleTimer: function (debugID, timerType) {
    checkDebugID(debugID);
    emitEvent('onBeginLifeCycleTimer', debugID, timerType);
    markBegin(debugID, timerType);
    beginLifeCycleTimer(debugID, timerType);
  },
  onEndLifeCycleTimer: function (debugID, timerType) {
    checkDebugID(debugID);
    endLifeCycleTimer(debugID, timerType);
    markEnd(debugID, timerType);
    emitEvent('onEndLifeCycleTimer', debugID, timerType);
  },
  onBeginProcessingChildContext: function () {
    emitEvent('onBeginProcessingChildContext');
  },
  onEndProcessingChildContext: function () {
    emitEvent('onEndProcessingChildContext');
  },
  onHostOperation: function (operation) {
    checkDebugID(operation.instanceID);
    emitEvent('onHostOperation', operation);
  },
  onSetState: function () {
    emitEvent('onSetState');
  },
  onSetChildren: function (debugID, childDebugIDs) {
    checkDebugID(debugID);
    childDebugIDs.forEach(checkDebugID);
    emitEvent('onSetChildren', debugID, childDebugIDs);
  },
  onBeforeMountComponent: function (debugID, element, parentDebugID) {
    checkDebugID(debugID);
    checkDebugID(parentDebugID, true);
    emitEvent('onBeforeMountComponent', debugID, element, parentDebugID);
    markBegin(debugID, 'mount');
  },
  onMountComponent: function (debugID) {
    checkDebugID(debugID);
    markEnd(debugID, 'mount');
    emitEvent('onMountComponent', debugID);
  },
  onBeforeUpdateComponent: function (debugID, element) {
    checkDebugID(debugID);
    emitEvent('onBeforeUpdateComponent', debugID, element);
    markBegin(debugID, 'update');
  },
  onUpdateComponent: function (debugID) {
    checkDebugID(debugID);
    markEnd(debugID, 'update');
    emitEvent('onUpdateComponent', debugID);
  },
  onBeforeUnmountComponent: function (debugID) {
    checkDebugID(debugID);
    emitEvent('onBeforeUnmountComponent', debugID);
    markBegin(debugID, 'unmount');
  },
  onUnmountComponent: function (debugID) {
    checkDebugID(debugID);
    markEnd(debugID, 'unmount');
    emitEvent('onUnmountComponent', debugID);
  },
  onTestEvent: function () {
    emitEvent('onTestEvent');
  }
};

// TODO remove these when RN/www gets updated
ReactDebugTool.addDevtool = ReactDebugTool.addHook;
ReactDebugTool.removeDevtool = ReactDebugTool.removeHook;

ReactDebugTool.addHook(ReactInvalidSetStateWarningHook);
ReactDebugTool.addHook(ReactComponentTreeHook);
var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
if (/[?&]react_perf\b/.test(url)) {
  ReactDebugTool.beginProfiling();
}

module.exports = ReactDebugTool;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var warning = __webpack_require__(7);

if (false) {
  var processingChildContext = false;

  var warnInvalidSetState = function () {
    process.env.NODE_ENV !== 'production' ? warning(!processingChildContext, 'setState(...): Cannot call setState() inside getChildContext()') : void 0;
  };
}

var ReactInvalidSetStateWarningHook = {
  onBeginProcessingChildContext: function () {
    processingChildContext = true;
  },
  onEndProcessingChildContext: function () {
    processingChildContext = false;
  },
  onSetState: function () {
    warnInvalidSetState();
  }
};

module.exports = ReactInvalidSetStateWarningHook;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var history = [];

var ReactHostOperationHistoryHook = {
  onHostOperation: function (operation) {
    history.push(operation);
  },
  clearHistory: function () {
    if (ReactHostOperationHistoryHook._preventClearing) {
      // Should only be used for tests.
      return;
    }

    history = [];
  },
  getHistory: function () {
    return history;
  }
};

module.exports = ReactHostOperationHistoryHook;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var performance = __webpack_require__(1175);

var performanceNow;

/**
 * Detect if we can use `window.performance.now()` and gracefully fallback to
 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
 * because of Facebook's testing infrastructure.
 */
if (performance.now) {
  performanceNow = function performanceNow() {
    return performance.now();
  };
} else {
  performanceNow = function performanceNow() {
    return Date.now();
  };
}

module.exports = performanceNow;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var ExecutionEnvironment = __webpack_require__(21);

var performance;

if (ExecutionEnvironment.canUseDOM) {
  performance = window.performance || window.msPerformance || window.webkitPerformance;
}

module.exports = performance || {};

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(377);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(369),
    baseLodash = __webpack_require__(1179);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 1179 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 1180 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRIORITY; });
/* unused harmony export queueFetch */
/* unused harmony export queueTask */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_double_ended_queue__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_double_ended_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_double_ended_queue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_partial__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_partial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_partial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_values__);
var runTask = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(taskData) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            runningTasks.add(taskData);
            _context.next = 3;
            return Promise.resolve(taskData.func()).then(taskData.resolve).catch(taskData.reject);

          case 3:
            runningTasks.delete(taskData);
            tick();

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function runTask(_x3) {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var PRIORITY = {
  HIGH: 'HIGH',
  LOW: 'LOW'
};

var priorityOrder = [PRIORITY.HIGH, PRIORITY.LOW];
var STARTING_QUEUE_SIZE = 100;
var STARTING_CONCURANCY = 3;
var concurancy = STARTING_CONCURANCY;
var runningTasks = new Set();
var priorityQueues = {};
__WEBPACK_IMPORTED_MODULE_3_lodash_values___default()(PRIORITY).map(function (pKey) {
  return priorityQueues[pKey] = new __WEBPACK_IMPORTED_MODULE_0_double_ended_queue___default.a(100);
});

var fetchCache = {};

function queueFetch(fetch, url, options) {
  var priority = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PRIORITY.LOW;

  var clonedOptions = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(options);

  var cacheKey = JSON.stringify({
    url: url,
    options: clonedOptions
  });

  var cached = fetchCache[cacheKey];
  if (cached !== undefined) {
    return cached;
  }

  var task = __WEBPACK_IMPORTED_MODULE_2_lodash_partial___default()(fetch, url, clonedOptions);
  var taskPromise = queueTask(task, priority);

  fetchCache[cacheKey] = taskPromise;

  return taskPromise;
}

function queueTask(func) {
  var priority = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PRIORITY.LOW;

  var data = { func: func };
  data.promise = new Promise(function (resolve, reject) {
    data.resolve = resolve;
    data.reject = reject;
  });

  priorityQueues[priority].push(data);

  tick();

  return data.promise;
}

function tick() {
  var nextTask = void 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = priorityOrder[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var pKey = _step.value;

      nextTask = priorityQueues[pKey].dequeue();
      if (nextTask !== undefined) {
        break;
      }

      if (runningTasks.size >= concurancy) {
        return;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (nextTask === undefined) {
    return;
  }

  runTask(nextTask);
}

var loadImage = function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(url) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new Promise(function (resolve, reject) {
              var img = new Image();
              img.onload = function () {
                return resolve(url);
              };
              img.onerror = function () {
                return reject(url);
              };
              img.src = url;
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function loadImage(_x4) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_user__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_plan__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Link__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Typography__ = __webpack_require__(887);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_9__Typography__["f" /* H6 */], {}, void 0, 'Unlimited\xA0licenses.', _jsx('br', {}), '500+\xA0New\xA0Clips Every\xA0Month.');

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_9__Typography__["j" /* L3 */], {}, void 0, 'NO DOWNLOAD LIMIT\xA0\xA0\u2022\xA0\xA01080p + 4K ProRes');

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */], {
  size: 'large'
}, void 0, 'Get\xA0Started');

var PricingStrip = function (_React$PureComponent) {
  _inherits(PricingStrip, _React$PureComponent);

  function PricingStrip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PricingStrip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PricingStrip.__proto__ || Object.getPrototypeOf(PricingStrip)).call.apply(_ref, [this].concat(args))), _this), _this.doOnClick = function (e) {
      if (_this.props.onClick) {
        _this.props.onClick(e);
      } else {
        _this.props.showSignup(_this.props.plan, _this.props.annual);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PricingStrip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          responsive = _props.responsive,
          showSignup = _props.showSignup,
          to = _props.to,
          onClick = _props.onClick,
          plan = _props.plan,
          annual = _props.annual,
          otherProps = _objectWithoutProperties(_props, ['responsive', 'showSignup', 'to', 'onClick', 'plan', 'annual']);

      var stacked = responsive < __WEBPACK_IMPORTED_MODULE_3__constants__["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT;

      return _jsx('div', {
        style: {
          backgroundColor: __WEBPACK_IMPORTED_MODULE_8__Style__["a" /* default */].Colors.shadow5
        }
      }, void 0, _jsx('div', {
        style: {
          maxWidth: '80rem',
          margin: 'auto',
          padding: '2rem',
          minHeight: '15rem',
          display: 'flex',
          flexDirection: stacked ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap'
        }
      }, void 0, _jsx('div', {
        style: {
          margin: '2rem 0',
          flexBasis: '50%',
          width: '50%',
          minWidth: '30rem'
        }
      }, void 0, _ref2, _ref3), _jsx('div', {
        style: {
          margin: '2rem 0',
          flexBasis: '50%',
          width: '50%',
          minWidth: '30rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Typography__["d" /* H4 */], {
        style: { margin: '0 2rem' }
      }, void 0, '$', Object(__WEBPACK_IMPORTED_MODULE_5__actions_plan__["d" /* getPlanPrice */])(plan, annual), '/mo.'), _jsx(__WEBPACK_IMPORTED_MODULE_7__Link__["a" /* default */], {
        to: to,
        onClick: this.doOnClick
      }, void 0, _ref4))));
    }
  }]);

  return PricingStrip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

PricingStrip.defaultProps = {
  plan: __WEBPACK_IMPORTED_MODULE_3__constants__["z" /* PLAN */].UNLIMITED,
  annual: true
};


function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showSignup: function showSignup(plan, annual) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_plan__["f" /* setChosenPlan */])({ name: plan, annual: annual }));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_user__["h" /* showSignup */])());
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PricingStrip));

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(103),
    metaMap = __webpack_require__(1199);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(373);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(1201),
    composeArgsRight = __webpack_require__(1202),
    countHolders = __webpack_require__(1249),
    createCtor = __webpack_require__(1163),
    createRecurry = __webpack_require__(1203),
    getHolder = __webpack_require__(1180),
    reorder = __webpack_require__(1258),
    replaceHolders = __webpack_require__(1164),
    root = __webpack_require__(45);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 1201 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 1202 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(1250),
    setData = __webpack_require__(1206),
    setWrapToString = __webpack_require__(1207);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(1199),
    noop = __webpack_require__(379);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(369),
    baseLodash = __webpack_require__(1179);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(1198),
    shortOut = __webpack_require__(375);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(1255),
    insertWrapDetails = __webpack_require__(1256),
    setToString = __webpack_require__(230),
    updateWrapDetails = __webpack_require__(1257);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

var arrayShuffle = __webpack_require__(1263),
    baseShuffle = __webpack_require__(1264),
    isArray = __webpack_require__(18);

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

module.exports = shuffle;


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7f42df5b.mp4";

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5a43151e.mp4";

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cea7ff39.mp4";

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d63f9a09.jpg";

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var arraySampleSize = __webpack_require__(1214),
    baseSampleSize = __webpack_require__(1215),
    isArray = __webpack_require__(18),
    isIterateeCall = __webpack_require__(141),
    toInteger = __webpack_require__(359);

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  var func = isArray(collection) ? arraySampleSize : baseSampleSize;
  return func(collection, n);
}

module.exports = sampleSize;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(1167),
    copyArray = __webpack_require__(362),
    shuffleSelf = __webpack_require__(1154);

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

module.exports = arraySampleSize;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(1167),
    shuffleSelf = __webpack_require__(1154),
    values = __webpack_require__(83);

/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = values(collection);
  return shuffleSelf(array, baseClamp(n, 0, array.length));
}

module.exports = baseSampleSize;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(374),
    castFunction = __webpack_require__(1279),
    toInteger = __webpack_require__(359);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_shuffle__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_color__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Aspect__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_instagram_Storytape_1_jpg__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_instagram_Storytape_1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_instagram_Storytape_1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_instagram_Storytape_2_jpg__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_instagram_Storytape_2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_instagram_Storytape_2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_instagram_Storytape_3_jpg__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_instagram_Storytape_3_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_instagram_Storytape_3_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_instagram_Storytape_4_jpg__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_instagram_Storytape_4_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_instagram_Storytape_4_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_instagram_Storytape_5_jpg__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_instagram_Storytape_5_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_instagram_Storytape_5_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_instagram_Storytape_6_jpg__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_instagram_Storytape_6_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_instagram_Storytape_6_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_instagram_Storytape_7_jpg__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_instagram_Storytape_7_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_instagram_Storytape_7_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_instagram_Storytape_8_jpg__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_instagram_Storytape_8_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_instagram_Storytape_8_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_instagram_Storytape_9_jpg__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_instagram_Storytape_9_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_instagram_Storytape_9_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_instagram_Storytape_10_jpg__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_instagram_Storytape_10_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_instagram_Storytape_10_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_instagram_Storytape_11_jpg__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_instagram_Storytape_11_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_instagram_Storytape_11_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_instagram_Storytape_12_jpg__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_instagram_Storytape_12_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_instagram_Storytape_12_jpg__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var images = [__WEBPACK_IMPORTED_MODULE_6__assets_instagram_Storytape_1_jpg___default.a, __WEBPACK_IMPORTED_MODULE_7__assets_instagram_Storytape_2_jpg___default.a, __WEBPACK_IMPORTED_MODULE_8__assets_instagram_Storytape_3_jpg___default.a, __WEBPACK_IMPORTED_MODULE_9__assets_instagram_Storytape_4_jpg___default.a, __WEBPACK_IMPORTED_MODULE_10__assets_instagram_Storytape_5_jpg___default.a, __WEBPACK_IMPORTED_MODULE_11__assets_instagram_Storytape_6_jpg___default.a, __WEBPACK_IMPORTED_MODULE_12__assets_instagram_Storytape_7_jpg___default.a, __WEBPACK_IMPORTED_MODULE_13__assets_instagram_Storytape_8_jpg___default.a, __WEBPACK_IMPORTED_MODULE_14__assets_instagram_Storytape_9_jpg___default.a, __WEBPACK_IMPORTED_MODULE_15__assets_instagram_Storytape_10_jpg___default.a, __WEBPACK_IMPORTED_MODULE_16__assets_instagram_Storytape_11_jpg___default.a, __WEBPACK_IMPORTED_MODULE_17__assets_instagram_Storytape_12_jpg___default.a];

var InstagramGrid = function (_React$PureComponent) {
  _inherits(InstagramGrid, _React$PureComponent);

  function InstagramGrid(props) {
    _classCallCheck(this, InstagramGrid);

    var _this = _possibleConstructorReturn(this, (InstagramGrid.__proto__ || Object.getPrototypeOf(InstagramGrid)).call(this, props));

    _this.state = {
      images: __WEBPACK_IMPORTED_MODULE_2_lodash_shuffle___default()(images)
    };
    return _this;
  }

  _createClass(InstagramGrid, [{
    key: 'render',
    value: function render() {
      return _jsx('div', {
        style: {
          margin: '-2%',
          width: '100%',
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, void 0, this.state.images.map(function (url) {
        return _jsx('div', {
          style: { width: '26%', flex: '1 1 26%', margin: '2%' }
        }, url, _jsx(__WEBPACK_IMPORTED_MODULE_4__Aspect__["a" /* default */], {}, void 0, _jsx('div', {
          style: {
            backgroundImage: 'url(' + url + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            height: '100%'
          }
        }, void 0, _jsx('div', {
          style: {
            width: '100%',
            height: '100%',
            border: '0.15rem solid ' + __WEBPACK_IMPORTED_MODULE_3_color___default()(__WEBPACK_IMPORTED_MODULE_5__Style__["a" /* default */].Colors.white).alpha(0.5).string()
          }
        }))));
      }));
    }
  }]);

  return InstagramGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InstagramGrid.defaultProps = {
  overlayColor: 'transparent'
};


/* harmony default export */ __webpack_exports__["a"] = (InstagramGrid);

function Row(images) {}

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_difference__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEqual__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_motion__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_tasks__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_Motion__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_react__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Aspect__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ImageLoader__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Hoverable__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Typography__ = __webpack_require__(887);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var INSET = 2.5;
var POSTER_DURATION = 1200;
var CLIP_IMAGES_TO_PRELOAD = 3;

var SceneCard = function (_MyPureComponent) {
  _inherits(SceneCard, _MyPureComponent);

  function SceneCard(props, context) {
    _classCallCheck(this, SceneCard);

    var _this = _possibleConstructorReturn(this, (SceneCard.__proto__ || Object.getPrototypeOf(SceneCard)).call(this, props, context));

    _initialiseProps.call(_this);

    _this.nextClipImageTimeout = undefined;
    _this.state = {
      clipImages: _this.getClipImages(props),
      clipIndex: 0,
      hover: false
    };

    _this.loadingClipImages = new Set();
    _this.loadedClipImages = new Set();

    _this.loadClipImages(CLIP_IMAGES_TO_PRELOAD);
    return _this;
  }

  _createClass(SceneCard, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var clipImages = this.getClipImages(nextProps);

      if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isEqual___default()(clipImages, this.state.clipImages)) {
        this.setState({ clipImages: clipImages });
        this.loadClipImages(CLIP_IMAGES_TO_PRELOAD);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.nextClipImageTimeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          responsive = _props.responsive,
          title = _props.title,
          typeName = _props.typeName,
          backgroundColor = _props.backgroundColor,
          lqip = _props.lqip,
          images = _props.images,
          highlightColor = _props.highlightColor,
          allClips = _props.allClips,
          matchingClips = _props.matchingClips,
          onHoverToggle = _props.onHoverToggle,
          onHoverData = _props.onHoverData,
          otherProps = _objectWithoutProperties(_props, ['responsive', 'title', 'typeName', 'backgroundColor', 'lqip', 'images', 'highlightColor', 'allClips', 'matchingClips', 'onHoverToggle', 'onHoverData']);

      var anyClip = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(allClips, 0, __WEBPACK_IMPORTED_MODULE_7__constants__["l" /* EMPTY_OBJECT */]);

      var matchingClipCount = (matchingClips || __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* EMPTY_ARRAY */]).length;
      var otherClips = __WEBPACK_IMPORTED_MODULE_3_lodash_difference___default()(allClips, matchingClips || __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* EMPTY_ARRAY */]);
      var totalClipCount = anyClip.scene_clip_count || allClips.length;

      var labelString = 'view ' + typeName;
      if (this.state.hover) {
        labelString = 'open ' + typeName;
      }

      var cornerOpacity = 0;
      var SubtextComponent = __WEBPACK_IMPORTED_MODULE_15__Typography__["o" /* P2 */];
      if (responsive >= __WEBPACK_IMPORTED_MODULE_7__constants__["C" /* RESPONSIVE_SIZE */].PHONE) {
        SubtextComponent = __WEBPACK_IMPORTED_MODULE_15__Typography__["m" /* P1 */];
      }
      if (responsive >= __WEBPACK_IMPORTED_MODULE_7__constants__["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE) {
        cornerOpacity = 1;
      }

      var containerStyle = {
        width: '100%',
        margin: 'auto'
      };
      var backgroundStyle = _extends({}, __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* FULL_STYLE */], {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_14__Style__["a" /* default */].Colors.black,
        color: __WEBPACK_IMPORTED_MODULE_14__Style__["a" /* default */].Colors.white,
        padding: '2.2rem 2rem 0',
        borderRadius: '0.6rem',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer'
      });
      var imageContainerStyle = _extends({}, __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* FULL_STYLE */], {
        overflow: 'hidden',
        display: 'flex'
      });
      var clipImageStyle = _extends({}, __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* FULL_STYLE */], {
        backgroundSize: 'cover'
      });
      var borderBoxStyle = _extends({}, __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* FULL_STYLE */], {
        margin: '6%',
        border: 'solid 0.2rem ' + __WEBPACK_IMPORTED_MODULE_14__Style__["a" /* default */].Colors.white
      });
      var countStyle = {
        position: 'absolute',
        bottom: INSET * 1.3 + 'rem',
        right: INSET * 2 + 'rem'
      };
      var buttonBoxStyle = {
        position: 'relative',
        margin: 'auto'
      };
      var cornerStyleBase = {
        margin: 'auto',
        position: 'absolute',
        width: '15%',
        height: '15%',
        border: 'solid 0.4rem ' + __WEBPACK_IMPORTED_MODULE_14__Style__["a" /* default */].Colors.white
      };
      var leftCornerStyle = _extends({}, cornerStyleBase, {
        borderRight: 'none',
        borderTop: 'none'
      });
      var rightCornerStyle = _extends({}, cornerStyleBase, {
        borderLeft: 'none',
        borderBottom: 'none'
      });
      var infoBoxStyle = {
        // flexGrow: 1,
        // display: 'flex',
        // flexDirection: 'column',
        // justifyContent: 'center',
        padding: '0.5rem ' + INSET + 'rem'
      };

      var animatedDefault = {
        matchingCount: 0,
        cornerPositionH: 32,
        cornerPositionV: 40,
        hover: 0,
        lqip: 1,
        clipImagesMult: 0
      };
      var animatedCurrent = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__lib_Motion__["d" /* springify */])({
        matchingCount: matchingClipCount,
        hover: this.state.hover ? 1 : animatedDefault.hover,
        lqip: this.state.scenePosterLoaded ? 0 : 1,
        clipImagesMult: this.loadedClipImages.size > 0 ? 1 : 0
      }), Object(__WEBPACK_IMPORTED_MODULE_9__lib_Motion__["d" /* springify */])({
        cornerPositionH: this.state.hover ? 9 : animatedDefault.cornerPositionH,
        cornerPositionV: this.state.hover ? 16 : animatedDefault.cornerPositionV
      }, {
        stiffness: this.state.hover ? 400 : 170,
        damping: this.state.hover ? 20 : 26
      }));

      var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_12__ImageLoader__["a" /* default */], {
        color: backgroundColor,
        lqip: lqip,
        images: images
      });

      return _jsx(__WEBPACK_IMPORTED_MODULE_6_react_motion__["Motion"], {
        defaultStyle: animatedDefault,
        style: animatedCurrent
      }, void 0, function (tween) {
        // Animated properties.
        var countString = '';
        var infoClipString = '';
        if (matchingClips === undefined) {
          countString = null;
          infoClipString = totalClipCount + ' Clips';
        } else if (totalClipCount) {
          countString = Math.round(tween.matchingCount) + ' of ' + totalClipCount;
          infoClipString = Math.round(tween.matchingCount) + ' Matching Clips';
        }

        var backgroundStyleMerged = _extends({}, backgroundStyle, {
          boxShadow: highlightColor + ' ' + tween.hover * 1.4 + 'rem ' + tween.hover * -1 + 'rem 0 0'
        });
        var borderBoxStyleMerged = _extends({}, borderBoxStyle, {
          opacity: tween.hover * 0.7 + 0.3
        });
        var countStyleMerged = _extends({}, countStyle, {
          opacity: tween.hover * 0.5 + 0.5
        });
        var cornerValueH = tween.cornerPositionH + '%';
        var cornerValueV = tween.cornerPositionV + '%';
        var leftCornerStyleMerged = _extends({}, leftCornerStyle, {
          bottom: cornerValueV,
          left: cornerValueH,
          opacity: cornerOpacity
        });
        var rightCornerStyleMerged = _extends({}, rightCornerStyle, {
          top: cornerValueV,
          right: cornerValueH,
          opacity: cornerOpacity
        });

        var thisClipImage = Array.from(_this2.loadedClipImages)[_this2.state.clipIndex % _this2.loadedClipImages.size];
        // Just "fetching" the image isn't enough. There is a flash as they are loaded
        //  into memory or something. Putting them in the dom early seems to solve this.
        var nextClipImage = Array.from(_this2.loadedClipImages)[(_this2.state.clipIndex + 1) % _this2.loadedClipImages.size];

        return _jsx('div', {
          style: containerStyle
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Hoverable__["b" /* default */], {
          onChange: _this2.toggleHovering
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Aspect__["a" /* default */], {
          ratio: 3 / 4
        }, void 0, _jsx('div', {
          style: backgroundStyleMerged
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Aspect__["a" /* default */], {
          ratio: 9 / 16
        }, void 0, _jsx('div', {
          style: imageContainerStyle
        }, void 0, _ref, _jsx('div', {
          style: _extends({}, clipImageStyle, {
            backgroundImage: 'url(' + nextClipImage + ')',
            opacity: 0
          })
        }), _jsx('div', {
          style: _extends({}, clipImageStyle, {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_14__Style__["a" /* default */].Colors.black,
            backgroundImage: 'url(' + thisClipImage + ')',
            opacity: tween.hover * tween.clipImagesMult
          })
        }), _jsx('div', {
          style: borderBoxStyleMerged
        }), _jsx(__WEBPACK_IMPORTED_MODULE_15__Typography__["e" /* H5 */], {
          style: countStyleMerged
        }, void 0, countString), _jsx('div', {
          style: leftCornerStyleMerged
        }), _jsx('div', {
          style: rightCornerStyleMerged
        }), _jsx('div', {
          style: buttonBoxStyle
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Typography__["g" /* L1 */], {}, void 0, labelString.toUpperCase())))), _jsx('div', {
          style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flexGrow: 1
          }
        }, void 0, _jsx('div', {
          style: infoBoxStyle
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Typography__["e" /* H5 */], {
          style: {
            marginBottom: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }, void 0, title), _jsx(SubtextComponent, {
          style: {
            marginTop: 0,
            color: __WEBPACK_IMPORTED_MODULE_14__Style__["a" /* default */].Colors.shadow4
          }
        }, void 0, typeName, '\xA0\xA0\u2022\xA0\xA0', infoClipString)))))));
      });
    }
  }]);

  return SceneCard;
}(__WEBPACK_IMPORTED_MODULE_10__lib_react__["a" /* MyPureComponent */]);

SceneCard.propTypes = {
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  typeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lqip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  images: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  highlightColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  allClips: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  matchingClips: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  onHoverToggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onHoverData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
SceneCard.defaultProps = {
  title: '',
  typeName: '',
  backgroundColor: __WEBPACK_IMPORTED_MODULE_14__Style__["a" /* default */].Colors.black,
  lqip: undefined,
  images: __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* EMPTY_ARRAY */],
  highlightColor: 'transparent',
  allClips: __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* EMPTY_ARRAY */],
  matchingClips: undefined,
  onHoverToggle: function onHoverToggle(hovering) {},
  onHoverData: undefined
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getClipImages = function (props) {
    return (props.matchingClips || props.allClips).map(function (clip) {
      return clip.clip_thumbnail;
    });
  };

  this.toggleHovering = function (hovering, event) {
    _this3.setState({ hover: hovering });
    _this3.nextClipImage();
    _this3.props.onHoverToggle(hovering, _this3.props.onHoverData);
  };

  this.nextClipImage = function () {
    clearTimeout(_this3.nextClipImageTimeout);
    _this3.nextClipImageTimeout = setTimeout(function () {
      if (_this3.state.hover) {
        _this3.setState({ clipIndex: _this3.state.clipIndex + 1 });
        _this3.nextClipImage();
        _this3.loadClipImages(1, __WEBPACK_IMPORTED_MODULE_8__lib_tasks__["a" /* PRIORITY */].HIGH);
      }
    }, POSTER_DURATION);
  };

  this.loadClipImages = function (count, priority) {
    var loaded = 0;
    _this3.state.clipImages.map(function (image) {
      if (!image) {
        return;
      }
      if (loaded >= count) {
        return;
      }
      if (_this3.loadingClipImages.has(image)) {
        return;
      }
      if (_this3.loadedClipImages.has(image)) {
        return;
      }

      _this3.loadingClipImages.add(image);

      Object(__WEBPACK_IMPORTED_MODULE_8__lib_tasks__["b" /* loadImage */])(image).then(function () {
        _this3.loadedClipImages.add(image);
      });

      loaded += 1;
    });
  };
};

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(SceneCard));

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:</p>
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

function Deque(capacity) {
    this._capacity = getCapacity(capacity);
    this._length = 0;
    this._front = 0;
    if (isArray(capacity)) {
        var len = capacity.length;
        for (var i = 0; i < len; ++i) {
            this[i] = capacity[i];
        }
        this._length = len;
    }
}

Deque.prototype.toArray = function Deque$toArray() {
    var len = this._length;
    var ret = new Array(len);
    var front = this._front;
    var capacity = this._capacity;
    for (var j = 0; j < len; ++j) {
        ret[j] = this[(front + j) & (capacity - 1)];
    }
    return ret;
};

Deque.prototype.push = function Deque$push(item) {
    var argsLength = arguments.length;
    var length = this._length;
    if (argsLength > 1) {
        var capacity = this._capacity;
        if (length + argsLength > capacity) {
            for (var i = 0; i < argsLength; ++i) {
                this._checkCapacity(length + 1);
                var j = (this._front + length) & (this._capacity - 1);
                this[j] = arguments[i];
                length++;
                this._length = length;
            }
            return length;
        }
        else {
            var j = this._front;
            for (var i = 0; i < argsLength; ++i) {
                this[(j + length) & (capacity - 1)] = arguments[i];
                j++;
            }
            this._length = length + argsLength;
            return length + argsLength;
        }

    }

    if (argsLength === 0) return length;

    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = item;
    this._length = length + 1;
    return length + 1;
};

Deque.prototype.pop = function Deque$pop() {
    var length = this._length;
    if (length === 0) {
        return void 0;
    }
    var i = (this._front + length - 1) & (this._capacity - 1);
    var ret = this[i];
    this[i] = void 0;
    this._length = length - 1;
    return ret;
};

Deque.prototype.shift = function Deque$shift() {
    var length = this._length;
    if (length === 0) {
        return void 0;
    }
    var front = this._front;
    var ret = this[front];
    this[front] = void 0;
    this._front = (front + 1) & (this._capacity - 1);
    this._length = length - 1;
    return ret;
};

Deque.prototype.unshift = function Deque$unshift(item) {
    var length = this._length;
    var argsLength = arguments.length;


    if (argsLength > 1) {
        var capacity = this._capacity;
        if (length + argsLength > capacity) {
            for (var i = argsLength - 1; i >= 0; i--) {
                this._checkCapacity(length + 1);
                var capacity = this._capacity;
                var j = (((( this._front - 1 ) &
                    ( capacity - 1) ) ^ capacity ) - capacity );
                this[j] = arguments[i];
                length++;
                this._length = length;
                this._front = j;
            }
            return length;
        }
        else {
            var front = this._front;
            for (var i = argsLength - 1; i >= 0; i--) {
                var j = (((( front - 1 ) &
                    ( capacity - 1) ) ^ capacity ) - capacity );
                this[j] = arguments[i];
                front = j;
            }
            this._front = front;
            this._length = length + argsLength;
            return length + argsLength;
        }
    }

    if (argsLength === 0) return length;

    this._checkCapacity(length + 1);
    var capacity = this._capacity;
    var i = (((( this._front - 1 ) &
        ( capacity - 1) ) ^ capacity ) - capacity );
    this[i] = item;
    this._length = length + 1;
    this._front = i;
    return length + 1;
};

Deque.prototype.peekBack = function Deque$peekBack() {
    var length = this._length;
    if (length === 0) {
        return void 0;
    }
    var index = (this._front + length - 1) & (this._capacity - 1);
    return this[index];
};

Deque.prototype.peekFront = function Deque$peekFront() {
    if (this._length === 0) {
        return void 0;
    }
    return this[this._front];
};

Deque.prototype.get = function Deque$get(index) {
    var i = index;
    if ((i !== (i | 0))) {
        return void 0;
    }
    var len = this._length;
    if (i < 0) {
        i = i + len;
    }
    if (i < 0 || i >= len) {
        return void 0;
    }
    return this[(this._front + i) & (this._capacity - 1)];
};

Deque.prototype.isEmpty = function Deque$isEmpty() {
    return this._length === 0;
};

Deque.prototype.clear = function Deque$clear() {
    var len = this._length;
    var front = this._front;
    var capacity = this._capacity;
    for (var j = 0; j < len; ++j) {
        this[(front + j) & (capacity - 1)] = void 0;
    }
    this._length = 0;
    this._front = 0;
};

Deque.prototype.toString = function Deque$toString() {
    return this.toArray().toString();
};

Deque.prototype.valueOf = Deque.prototype.toString;
Deque.prototype.removeFront = Deque.prototype.shift;
Deque.prototype.removeBack = Deque.prototype.pop;
Deque.prototype.insertFront = Deque.prototype.unshift;
Deque.prototype.insertBack = Deque.prototype.push;
Deque.prototype.enqueue = Deque.prototype.push;
Deque.prototype.dequeue = Deque.prototype.shift;
Deque.prototype.toJSON = Deque.prototype.toArray;

Object.defineProperty(Deque.prototype, "length", {
    get: function() {
        return this._length;
    },
    set: function() {
        throw new RangeError("");
    }
});

Deque.prototype._checkCapacity = function Deque$_checkCapacity(size) {
    if (this._capacity < size) {
        this._resizeTo(getCapacity(this._capacity * 1.5 + 16));
    }
};

Deque.prototype._resizeTo = function Deque$_resizeTo(capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    if (front + length > oldCapacity) {
        var moveItemsCount = (front + length) & (oldCapacity - 1);
        arrayMove(this, 0, this, oldCapacity, moveItemsCount);
    }
};


var isArray = Array.isArray;

function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function pow2AtLeast(n) {
    n = n >>> 0;
    n = n - 1;
    n = n | (n >> 1);
    n = n | (n >> 2);
    n = n | (n >> 4);
    n = n | (n >> 8);
    n = n | (n >> 16);
    return n + 1;
}

function getCapacity(capacity) {
    if (typeof capacity !== "number") {
        if (isArray(capacity)) {
            capacity = capacity.length;
        }
        else {
            return 16;
        }
    }
    return pow2AtLeast(
        Math.min(
            Math.max(16, capacity), 1073741824)
    );
}

module.exports = Deque;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(1229);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(231),
    arrayEach = __webpack_require__(1196),
    assignValue = __webpack_require__(150),
    baseAssign = __webpack_require__(376),
    baseAssignIn = __webpack_require__(1230),
    cloneBuffer = __webpack_require__(1231),
    copyArray = __webpack_require__(362),
    copySymbols = __webpack_require__(1232),
    copySymbolsIn = __webpack_require__(1233),
    getAllKeys = __webpack_require__(378),
    getAllKeysIn = __webpack_require__(380),
    getTag = __webpack_require__(148),
    initCloneArray = __webpack_require__(1234),
    initCloneByTag = __webpack_require__(1235),
    initCloneObject = __webpack_require__(1244),
    isArray = __webpack_require__(18),
    isBuffer = __webpack_require__(149),
    isObject = __webpack_require__(22),
    keys = __webpack_require__(52);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(147),
    keysIn = __webpack_require__(383);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(45);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)(module)))

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(147),
    getSymbols = __webpack_require__(232);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(147),
    getSymbolsIn = __webpack_require__(381);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(1177),
    cloneDataView = __webpack_require__(1236),
    cloneMap = __webpack_require__(1237),
    cloneRegExp = __webpack_require__(1239),
    cloneSet = __webpack_require__(1240),
    cloneSymbol = __webpack_require__(1242),
    cloneTypedArray = __webpack_require__(1243);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(1177);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(1238),
    arrayReduce = __webpack_require__(1197),
    mapToArray = __webpack_require__(229);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 1239 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(1241),
    arrayReduce = __webpack_require__(1197),
    setToArray = __webpack_require__(151);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 1241 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(86);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(1177);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(369),
    getPrototype = __webpack_require__(382),
    isPrototype = __webpack_require__(105);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(140),
    createWrap = __webpack_require__(1246),
    getHolder = __webpack_require__(1180),
    replaceHolders = __webpack_require__(1164);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(1198),
    createBind = __webpack_require__(1247),
    createCurry = __webpack_require__(1248),
    createHybrid = __webpack_require__(1200),
    createPartial = __webpack_require__(1259),
    getData = __webpack_require__(1204),
    mergeData = __webpack_require__(1260),
    setData = __webpack_require__(1206),
    setWrapToString = __webpack_require__(1207),
    toInteger = __webpack_require__(359);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(1163),
    root = __webpack_require__(45);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(371),
    createCtor = __webpack_require__(1163),
    createHybrid = __webpack_require__(1200),
    createRecurry = __webpack_require__(1203),
    getHolder = __webpack_require__(1180),
    replaceHolders = __webpack_require__(1164),
    root = __webpack_require__(45);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(1178),
    getData = __webpack_require__(1204),
    getFuncName = __webpack_require__(1251),
    lodash = __webpack_require__(1253);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(1252);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(1178),
    LodashWrapper = __webpack_require__(1205),
    baseLodash = __webpack_require__(1179),
    isArray = __webpack_require__(18),
    isObjectLike = __webpack_require__(56),
    wrapperClone = __webpack_require__(1254);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(1178),
    LodashWrapper = __webpack_require__(1205),
    copyArray = __webpack_require__(362);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 1255 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 1256 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(1196),
    arrayIncludes = __webpack_require__(226);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(362),
    isIndex = __webpack_require__(104);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(371),
    createCtor = __webpack_require__(1163),
    root = __webpack_require__(45);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(1201),
    composeArgsRight = __webpack_require__(1202),
    replaceHolders = __webpack_require__(1164);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1262);
    var insertCss = __webpack_require__(907);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ImageLoader.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ImageLoader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(906)(false);
// imports


// module
exports.push([module.i, "._1fMH_,._2wAs7,._3QzRN{position:absolute;top:0;right:0;bottom:0;left:0}._2wAs7,._3QzRN{background-position:50%;background-size:cover;opacity:0}._1fMH_{overflow:hidden}._2wAs7{-webkit-transition:opacity .15s cubic-bezier(.165,.84,.44,1);-o-transition:opacity .15s cubic-bezier(.165,.84,.44,1);transition:opacity .15s cubic-bezier(.165,.84,.44,1)}._3hhzR{opacity:1}._3QzRN{-webkit-transition:opacity .25s cubic-bezier(.165,.84,.44,1);-o-transition:opacity .25s cubic-bezier(.165,.84,.44,1);transition:opacity .25s cubic-bezier(.165,.84,.44,1)}._3uWCF{opacity:1}", ""]);

// exports
exports.locals = {
	"root": "_1fMH_",
	"lqipBase": "_2wAs7",
	"fqBase": "_3QzRN",
	"lqipLoaded": "_3hhzR",
	"fqLoaded": "_3uWCF"
};

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(362),
    shuffleSelf = __webpack_require__(1154);

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

module.exports = arrayShuffle;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

var shuffleSelf = __webpack_require__(1154),
    values = __webpack_require__(83);

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

module.exports = baseShuffle;


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6d5e1ea0.jpg";

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8ea82e1d.jpg";

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4381bd55.jpg";

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5a4c82f9.jpg";

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bff6eec4.jpg";

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5b038808.jpg";

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e68459a9.jpg";

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "031e0ac4.jpg";

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bba4bbdf.jpg";

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "73a125c3.jpg";

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8810660e.jpg";

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d58b8baf.jpg";

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_motion__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_Motion__ = __webpack_require__(352);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var animatedDestination = Object(__WEBPACK_IMPORTED_MODULE_3__lib_Motion__["d" /* springify */])({ x: 1 }, { stiffness: 60, damping: 15 });
var triggerPoint = 0.5;
var movement = 5;
var scale = 0.25;

var HeadlineAnimator = function (_React$PureComponent) {
  _inherits(HeadlineAnimator, _React$PureComponent);

  function HeadlineAnimator(props) {
    _classCallCheck(this, HeadlineAnimator);

    var _this = _possibleConstructorReturn(this, (HeadlineAnimator.__proto__ || Object.getPrototypeOf(HeadlineAnimator)).call(this, props));

    _this.markDone = function () {
      if (_this.state.done) {
        return;
      }

      _this.setState({ done: true });
      _this.props.onDone();
    };

    _this.getStyles = function (prevInterpolatedStyles) {
      return prevInterpolatedStyles.map(function (style, i) {
        if (!_this.props.show) {
          return style;
        }

        if (i === 0) {
          return animatedDestination;
        }

        if (prevInterpolatedStyles[0].x >= triggerPoint) {
          return animatedDestination;
        }

        return style;
      });
    };

    _this.state = {
      done: props.show,
      animatedDefault: [{ x: props.show ? 1 : 0 }, { x: props.show ? 1 : 0 }]
    };

    if (props.show) {
      props.onDone();
    }
    return _this;
  }

  _createClass(HeadlineAnimator, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          show = _props.show,
          donePoint = _props.donePoint,
          onDone = _props.onDone,
          topContent = _props.topContent,
          middleContent = _props.middleContent,
          bottomContent = _props.bottomContent,
          otherProps = _objectWithoutProperties(_props, ['show', 'donePoint', 'onDone', 'topContent', 'middleContent', 'bottomContent']);

      return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_motion__["StaggeredMotion"], {
        defaultStyles: this.state.animatedDefault,
        styles: this.getStyles
      }, void 0, function (tweens) {
        var centerStyle = {
          opacity: tweens[0].x,
          transform: 'scale(' + (tweens[0].x * scale + (1 - scale)) + ')'
        };
        var outerStyle = { opacity: tweens[1].x, position: 'relative' };
        var inverted = tweens[1].x * -1 + 1;
        var topStyle = _extends({}, outerStyle, { top: inverted * movement + 'rem' });
        var bottomStyle = _extends({}, outerStyle, {
          bottom: inverted * movement + 'rem'
        });

        if (tweens[1].x >= donePoint) {
          setTimeout(_this2.markDone, 0);
        }

        return _jsx('div', {}, void 0, _jsx('div', {
          style: topStyle
        }, void 0, topContent), _jsx('div', {
          style: centerStyle
        }, void 0, middleContent), _jsx('div', {
          style: bottomStyle
        }, void 0, bottomContent));
      });
    }
  }]);

  return HeadlineAnimator;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

HeadlineAnimator.defaultProps = {
  show: false,
  donePoint: 0.9,
  onDone: function onDone() {}
};


/* harmony default export */ __webpack_exports__["a"] = (HeadlineAnimator);

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

module.exports = [
	{
		"hook": "It's hard to describe just how much of a gamechanger Storytape is for filmmaking.",
		"more": "The time and money I save are alone worth it, but Storytape offers some of the highest quality footage I've seen. Better than anything I could film myself and in locations I could never visit. I'm blown away by how amazing this service is.",
		"author": "JOSH BISSEL"
	},
	{
		"hook": "It's clear the team at Storytape has filmed each clip with purpose.",
		"more": "Being a subscriber to Storytape is like having a high-end production team at your finger tips, and all for less than the price of one clip at other stock video sites.",
		"author": "KARTAL ALYUZ"
	},
	{
		"hook": "Storytape is incredible! Not only does it save money, but it is HUGELY helpful",
		"more": "because individual clips are grouped together in Scenes. I can get as many clips as I want from a specific Scene, and it looks phenomenal! Couldn't be happier!",
		"author": "KATIE WINTON"
	},
	{
		"hook": "Storytape is revolutionizing the stock video industry with its beautifully crafted footage",
		"more": "available at a preposterously affordable price point. There is nothing currently like this anywhere (I've looked) that matches the cinematography and attention to detail, without costing an arm and a leg.",
		"author": "BART ANESTIN"
	},
	{
		"hook": "I always struggled with finding stock video clips that fit within our budget. But with Storytape,",
		"more": "I now have unlimited access to thousands of video clips for the same price as just one clip from other websites.",
		"author": "RYAN NEARHOOD"
	},
	{
		"hook": "I’m a father of six that works two jobs. I was able to produce my first video in less than an hour as I waited for our garage door spring to be replaced.",
		"more": "I have no idea how much time and effort this would have taken without Storytape. To say this changes the game for people like me is an understatement.",
		"author": "ROBERT, Storytape Customer"
	}
];

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(103);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */
/***/ (function(module, exports) {

module.exports = [
	{
		"clip_id": "fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_082cb041-2ef6-45c5-bbb3-4bbefe5e4ed4/lqip_8607c75f-9f4f-4428-b3e0-a21c59b06fec.jpg",
		"scene_clip_count": "40",
		"published_at": "2017-10-30T20:27:49.268Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/sequence_2ee48e83-7e71-428a-ac8f-bf7aeda91a9f/0040.png"
		],
		"keywords": [
			"beach",
			"blacksand",
			"cloudy",
			"coast",
			"coastline",
			"crashing",
			"darken",
			"dusk",
			"evening",
			"green",
			"highlands",
			"iceland",
			"icelandic",
			"laugavegur",
			"lava",
			"lava fields",
			"lichen",
			"moss",
			"mountain landscape",
			"mountains",
			"nature",
			"ocean",
			"path",
			"peak",
			"road",
			"rock",
			"sand",
			"scenery",
			"scenic",
			"summer",
			"tourism",
			"travel",
			"volcanic",
			"volcano",
			"waves"
		],
		"clip_slug": "water-slowly-reaches-the-shore",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/poster_0000_ef89cf86-8c8e-4b23-8a52-c81f13550766.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/preview-large-53578e92-de82-4a5a-96d4-7c80758c8b18.mp4",
		"clip_length": 20000,
		"scene_description": "A unique beach with black sand covers the coast of an Icelandic shore. The waves from the ocean creates squiggly designs in the sand, where patches of grass thrive under the setting sun.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/thumbnail_0000_3a1d7b98-8632-453f-b708-46a4daf2a8c9.png",
		"clip_name": "Water slowly reaches the shore",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_082cb041-2ef6-45c5-bbb3-4bbefe5e4ed4/thumbnail_b13a2893-4411-4cd1-8f5d-37a5fdedadda.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/preview-small-2c9a30e6-f646-4e3f-99e5-b88238e7c586.mp4",
		"tags": [
			2900,
			2700,
			2400,
			2200,
			2100,
			1600,
			4400,
			1100,
			4200,
			900,
			3600,
			200,
			3400
		],
		"featured_at": "2017-11-14T07:12:23.643Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fe2d6fe3-cfae-4af2-9664-3fc5b79ea5f5/lqip_fa01c79a-0ea9-455d-bcf7-f8466b1daa4d.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_082cb041-2ef6-45c5-bbb3-4bbefe5e4ed4/poster_3f7b7d15-deab-4624-b664-f3c00451b160.jpg",
		"scene_slug": "black-sand-beach",
		"clip_colors": {
			"Vibrant": "#1895e6",
			"DarkVibrant": "#041825",
			"Muted": "#5c6171",
			"LightMuted": "#a8adc4",
			"DarkMuted": "#404758"
		},
		"scene_colors": {
			"Vibrant": "#1470ea",
			"DarkVibrant": "#04162e",
			"Muted": "#7685a5",
			"LightMuted": "#a8b3d0",
			"DarkMuted": "#364361"
		},
		"scene_name": "Black Sand Beach",
		"scene_id": "082cb041-2ef6-45c5-bbb3-4bbefe5e4ed4"
	},
	{
		"clip_id": "ff28ef7a-9167-4b92-85c6-72fb16e39c1b",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_a2ab422a-f5c1-45ee-ad22-572817d81d10/lqip_d2b3a0a1-9e98-4106-80c8-45d3376e6331.jpg",
		"scene_clip_count": "20",
		"published_at": "2017-11-07T17:10:01.36Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/sequence_b3c89363-15ad-481a-a6a8-6bcfd73bba05/0031.png"
		],
		"keywords": [
			"adult",
			"background",
			"beach",
			"beautiful",
			"blue",
			"calm",
			"cloud",
			"coastline",
			"color",
			"colorful",
			"dawn",
			"dusk",
			"evening",
			"horizon",
			"landscape",
			"long hair",
			"man",
			"morning",
			"nature",
			"ocean",
			"orange",
			"outdoor",
			"red",
			"reflection",
			"romantic",
			"scene",
			"scenic",
			"sea",
			"seascape",
			"sky",
			"sun",
			"sunlight",
			"sunny",
			"sunrise",
			"sunset",
			"sunshine",
			"tranquil",
			"vacation",
			"watching",
			"water",
			"wave",
			"yellow"
		],
		"clip_slug": "long-haired-man-taking-in-still-sunrise",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/poster_0000_e1201134-5e1e-43f1-aa60-5440f30c0e30.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/preview-large-122f231c-7515-43f1-96d5-871aa06fce70.mp4",
		"clip_length": 15958,
		"scene_description": "A young man with long hair waits by a lakefront for the sun to rise. The early dawn brings unique lighting to evoke a dramatic look on his facial features, hands, and feet.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/thumbnail_0000_7f6b983a-08c7-4c4e-a1e0-405aeec31705.png",
		"clip_name": "Long-haired man taking in still sunrise",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_a2ab422a-f5c1-45ee-ad22-572817d81d10/thumbnail_201cabed-3a94-45af-beb2-ba1e5c60b3ed.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/ff28ef7a-9167-4b92-85c6-72fb16e39c1b/preview-small-7ef3510f-7b21-4bf8-9765-193bbd5b1dc3.mp4",
		"tags": [
			2900,
			1200,
			1100,
			2700,
			4300,
			2300,
			2200,
			2100,
			3700,
			4000,
			100,
			3200
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_ff28ef7a-9167-4b92-85c6-72fb16e39c1b/lqip_f6c26376-8618-40e8-94dc-e6ca49dc5675.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_a2ab422a-f5c1-45ee-ad22-572817d81d10/poster_b6920871-0f45-4d22-ac74-d810b5444a80.jpg",
		"scene_slug": "hands-and-feet",
		"clip_colors": {
			"Vibrant": "#c89c88",
			"DarkVibrant": "#0c131c",
			"Muted": "#6c7281",
			"LightMuted": "#b2b4ba",
			"DarkMuted": "#2d3946"
		},
		"scene_colors": {
			"Vibrant": "#4c8cb2",
			"DarkVibrant": "#244254",
			"Muted": "#495c74",
			"DarkMuted": "#2f3454"
		},
		"scene_name": "Hands And Feet",
		"scene_id": "a2ab422a-f5c1-45ee-ad22-572817d81d10"
	},
	{
		"clip_id": "fcd9f26d-5c84-42ff-8354-e9a83184b620",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_a539ded5-5f45-44aa-85c3-6c7f9cc28952/lqip_507f5f17-b73e-479b-9396-f582c7825c79.jpg",
		"scene_clip_count": "76",
		"published_at": "2017-10-27T15:59:52.047Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/sequence_b9d7aec2-4a21-42cb-b864-55bc25bd594f/0040.png"
		],
		"keywords": [
			"abstract",
			"acrylic",
			"art",
			"artistic",
			"background",
			"bubble",
			"close-up",
			"color",
			"colorful",
			"colour",
			"colourful",
			"design",
			"droplet",
			"dye",
			"flow",
			"fluidity",
			"glitter",
			"grunge",
			"ink",
			"liquid",
			"macro",
			"microscope",
			"mix",
			"mixture",
			"multi-colored",
			"neon",
			"oil",
			"paint",
			"pattern",
			"psychedelic",
			"rainbow",
			"ripple",
			"saturated",
			"texture",
			"wallpaper",
			"wet"
		],
		"clip_slug": "sparkles-appear-in-neon-green-paint-circle",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/poster_0000_664d3e03-9383-4993-9cf7-7a8545c342a5.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/preview-large-684db6c9-761a-4c88-85c3-b615e2843b25.mp4",
		"clip_length": 20000,
		"scene_description": "Experimental and mesmerizing abstract visuals of acrylic paint swirling in milk, water, and oil. Various neon colors, some with glitter and metallic finishes, give each color its own unique texture.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/thumbnail_0000_1c2fb9ee-5be4-4e74-8645-81ff3a96ad99.png",
		"clip_name": "Sparkles appear in neon green paint circle",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_a539ded5-5f45-44aa-85c3-6c7f9cc28952/thumbnail_7fdac6c9-54c6-4414-b394-809bdbb6c812.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fcd9f26d-5c84-42ff-8354-e9a83184b620/preview-small-4fa41407-0878-4a84-afb1-db45fd469ee2.mp4",
		"tags": [
			4300,
			2300,
			3900,
			2100,
			4000,
			1800,
			100
		],
		"featured_at": "2017-11-14T07:11:51.209Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fcd9f26d-5c84-42ff-8354-e9a83184b620/lqip_70806926-f43c-4ff6-b072-f535711d9953.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_a539ded5-5f45-44aa-85c3-6c7f9cc28952/poster_3da94441-2462-4723-a523-a2ba4d23fd77.jpg",
		"scene_slug": "swirling-colors",
		"clip_colors": {
			"Vibrant": "#b4cc7c",
			"LightVibrant": "#b4dc8c",
			"DarkVibrant": "#797534",
			"Muted": "#acc177",
			"LightMuted": "#c8acad",
			"DarkMuted": "#8c8b4a"
		},
		"scene_colors": {
			"Vibrant": "#caad52",
			"LightVibrant": "#de7baa",
			"DarkVibrant": "#7f2350",
			"Muted": "#a7aa5d",
			"LightMuted": "#d7a7bf",
			"DarkMuted": "#4e5052"
		},
		"scene_name": "Swirling Colors",
		"scene_id": "a539ded5-5f45-44aa-85c3-6c7f9cc28952"
	},
	{
		"clip_id": "f2d70040-badd-425b-9eb1-35aba491dc0e",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_b65bd153-a225-4ed3-9740-e994af5e64c8/lqip_716dc8f8-b040-4e13-92d6-fcc5701bd498.jpg",
		"scene_clip_count": "30",
		"published_at": "2017-10-30T15:22:39.538Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/sequence_f9bfeb2f-1ae7-418c-84d4-4bde91e8b9fc/0039.png"
		],
		"keywords": [
			"African American",
			"business",
			"businessman",
			"communication",
			"company",
			"creativity",
			"data",
			"design",
			"development",
			"digital",
			"economy",
			"effort",
			"entrepreneur",
			"future",
			"global",
			"growth",
			"hands",
			"information",
			"laptop",
			"management",
			"project",
			"report",
			"research",
			"resource",
			"solution",
			"strategy",
			"sustainable",
			"technical",
			"technology",
			"typing",
			"using",
			"work"
		],
		"clip_slug": "bearded-man-with-glasses-scrolling-on-laptop",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/poster_0000_8791d045-e399-48fa-9418-ff63786eb5c1.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/preview-large-dd5118f4-c007-46de-9fbd-515017502eb5.mp4",
		"clip_length": 19875,
		"scene_description": "Working at a small table by himself, a young man types away at his laptop and uses his phone to keep up to date with current social media. The open-concept office space makes for the perfect workplace setting.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/thumbnail_0000_2d47a45c-d011-4230-b769-897256bf4f64.png",
		"clip_name": "Bearded man with glasses scrolling on laptop",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_b65bd153-a225-4ed3-9740-e994af5e64c8/thumbnail_2ea4a776-12c1-4792-88aa-1ebdc8628892.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/f2d70040-badd-425b-9eb1-35aba491dc0e/preview-small-b1fd95b1-d4bf-4259-a7a5-172cfe3a3a67.mp4",
		"tags": [
			1200,
			4300,
			2600,
			2300,
			3800,
			2100,
			4000,
			400,
			1000,
			1800,
			3300,
			1500
		],
		"featured_at": "2017-11-14T07:11:23.13Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_f2d70040-badd-425b-9eb1-35aba491dc0e/lqip_65665f36-7437-4334-9b5f-0bd2ae307a7f.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_b65bd153-a225-4ed3-9740-e994af5e64c8/poster_798291ad-18d2-491b-a428-ded2e23d70f3.jpg",
		"scene_slug": "laptop-at-table",
		"clip_colors": {
			"Vibrant": "#34547c",
			"DarkVibrant": "#243f5d",
			"Muted": "#78847f",
			"LightMuted": "#c4cfc7",
			"DarkMuted": "#433b3a"
		},
		"scene_colors": {
			"Vibrant": "#219871",
			"DarkVibrant": "#1c6444",
			"Muted": "#758884",
			"LightMuted": "#b6c2c2",
			"DarkMuted": "#2f3f48"
		},
		"scene_name": "Laptop At Table",
		"scene_id": "b65bd153-a225-4ed3-9740-e994af5e64c8"
	},
	{
		"clip_id": "da07bea8-f432-487e-99ad-c8f41ebfff45",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_a22ffdd8-138b-4b3f-a615-facb61c6dd59/lqip_d819d9e4-6bea-405a-a3c7-ed9a3c677766.jpg",
		"scene_clip_count": "20",
		"published_at": "2017-10-26T13:14:14.956Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/sequence_8055fce0-080c-4058-977e-f73a225c2978/0040.png"
		],
		"keywords": [
			"above",
			"air",
			"airplane",
			"background",
			"beautiful",
			"cloud",
			"cloudscape",
			"dreams",
			"evening",
			"flight",
			"flying",
			"freedom",
			"god",
			"heaven",
			"high",
			"horizon",
			"intro",
			"loop",
			"loopable",
			"morning",
			"motion",
			"nature",
			"over",
			"purple",
			"relax",
			"relaxation",
			"seamless",
			"sky",
			"space",
			"sun",
			"sunbeam",
			"sunrise",
			"sunset",
			"sunshine"
		],
		"clip_slug": "beams-of-light-from-sun-above-purple-clouds",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/poster_0000_ae34e5e4-58ec-40e2-b23f-921cb0a57b29.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/preview-large-a6e75c1d-9793-4ffc-80fd-472712d52140.mp4",
		"clip_length": 20000,
		"scene_description": "In an almost heavenly realm above the clouds, the sun radiates pink, peach, and purple hues, giving the clouds a unique look and texture.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/thumbnail_0000_62c99a44-3f2d-4a76-ad28-2c0fd8bc5a10.png",
		"clip_name": "Beams of light from sun above purple clouds",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_a22ffdd8-138b-4b3f-a615-facb61c6dd59/thumbnail_6017d767-3452-4cb6-ae4c-9f0e52735aec.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/da07bea8-f432-487e-99ad-c8f41ebfff45/preview-small-3be3c63b-462d-46ed-a754-c1a7fe10eea1.mp4",
		"tags": [
			4400,
			1100,
			2700,
			4200,
			900,
			2300,
			2100,
			3000,
			3600,
			200,
			3400
		],
		"featured_at": "2017-11-14T07:11:02.36Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_da07bea8-f432-487e-99ad-c8f41ebfff45/lqip_28226e15-1820-4453-8f9f-e038c83b0fb9.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_a22ffdd8-138b-4b3f-a615-facb61c6dd59/poster_d1f5a057-3c44-4885-bcb8-50bd93ba9b98.jpg",
		"scene_slug": "above-the-clouds",
		"clip_colors": {
			"Vibrant": "#d0a691",
			"LightVibrant": "#ecc09f",
			"DarkVibrant": "#5c3927",
			"Muted": "#907a85",
			"LightMuted": "#ceb3a6",
			"DarkMuted": "#5c5366"
		},
		"scene_colors": {
			"Vibrant": "#cca48c",
			"LightVibrant": "#d2b29c",
			"DarkVibrant": "#5b3b28",
			"Muted": "#9a7f81",
			"LightMuted": "#dccab9",
			"DarkMuted": "#544d5b"
		},
		"scene_name": "Above The Clouds",
		"scene_id": "a22ffdd8-138b-4b3f-a615-facb61c6dd59"
	},
	{
		"clip_id": "fcae6fdd-880c-4900-938b-ae3137940a28",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_80ccac39-2d47-42ba-b498-d1ba304ad1d1/lqip_16261d85-454a-4f0a-ac82-9c06ed922c36.jpg",
		"scene_clip_count": "75",
		"published_at": "2017-11-02T20:57:37.863Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/sequence_9cafe10c-ac14-4072-a3de-255f4c5f3143/0040.png"
		],
		"keywords": [
			"abstract",
			"backgrounds",
			"chalk",
			"color",
			"colour",
			"concepts",
			"dust",
			"flash",
			"fog",
			"fumes",
			"ideas",
			"light",
			"motion",
			"multi",
			"smoke",
			"smoking",
			"speaker",
			"steam",
			"strobe",
			"white"
		],
		"clip_slug": "multi-colored-light-strobing-as-chalk-bounces-around-middle-of-speaker-cone",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/poster_0000_7df432d7-a3eb-4e5e-9542-d6cdda395f8f.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/preview-large-4a0d8e72-97f3-4850-b854-2099f79bfdbd.mp4",
		"clip_length": 20000,
		"scene_description": "Using chalk dust, strobe lights, a speaker, and a synthesizer, an experimental scene is born. As the music passes through the speakers, the light reveals the chalk in control of the sound waves.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/thumbnail_0000_5ac0604a-4fba-4def-90b6-d0a274678cb3.png",
		"clip_name": "Multi colored light strobing as chalk bounces around middle of speaker cone",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_80ccac39-2d47-42ba-b498-d1ba304ad1d1/thumbnail_8dcfa6e6-24f8-478e-b3a7-7c21663e57e6.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fcae6fdd-880c-4900-938b-ae3137940a28/preview-small-91429676-a80b-4ded-b1e5-c81566e6b7d2.mp4",
		"tags": [
			4600,
			4400,
			2500,
			3900,
			2200,
			4000,
			1900,
			2000,
			100,
			1500
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fcae6fdd-880c-4900-938b-ae3137940a28/lqip_cc1efd24-b174-4619-bb6b-5449351985e0.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_80ccac39-2d47-42ba-b498-d1ba304ad1d1/poster_38f9b661-9e7e-409b-896f-ce07193f95c3.jpg",
		"scene_slug": "strange-speaker",
		"clip_colors": {
			"Vibrant": "#44c854",
			"LightVibrant": "#88a0e0",
			"DarkVibrant": "#1e6626",
			"Muted": "#8ca5a9",
			"LightMuted": "#b3c7ce",
			"DarkMuted": "#292c32"
		},
		"scene_colors": {
			"Vibrant": "#d41744",
			"LightVibrant": "#cb4f88",
			"DarkVibrant": "#7e0827",
			"Muted": "#303a70",
			"DarkMuted": "#28345a"
		},
		"scene_name": "Strange Speaker",
		"scene_id": "80ccac39-2d47-42ba-b498-d1ba304ad1d1"
	},
	{
		"clip_id": "e419978c-7c93-48d0-9cfa-cefa25750378",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_726d7ed1-a7a0-42a4-94d7-7ca403201ade/lqip_246da8eb-2e86-4d88-926c-7bd1441720f5.jpg",
		"scene_clip_count": "18",
		"published_at": "2017-11-07T17:06:31.561Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/sequence_21347f55-b3e3-444e-a913-d1d8092e4465/0040.png"
		],
		"keywords": [
			"aerial",
			"agriculture",
			"arctic",
			"awe",
			"cliff",
			"colour",
			"destination",
			"eco",
			"energy",
			"environment",
			"fertile",
			"flowing",
			"freshness",
			"frozen",
			"glacial",
			"green",
			"holidays",
			"ice",
			"iceland",
			"land",
			"landscape",
			"mineral",
			"misty",
			"mountain",
			"nature",
			"nautical vessel",
			"northern",
			"northern hemisphere",
			"plain",
			"plateau",
			"power",
			"research",
			"ridge",
			"rural",
			"scenic",
			"spray",
			"terrain",
			"tourism",
			"tourist",
			"tradition",
			"travel",
			"vacation",
			"vibrant",
			"view",
			"water",
			"waterfall",
			"wild",
			"wilderness"
		],
		"clip_slug": "pouring-waterfall-at-the-end-of-a-grassy-cliff",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/poster_0000_2a43d021-ff29-4be1-8a9f-07d2cbf1203d.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/preview-large-fca8d88d-0817-404e-bc33-b01162777f92.mp4",
		"clip_length": 20000,
		"scene_description": "A thin waterfall flowing with ice-cold glacier water. A mossy landscape drops off where the river crashes down below and continues to flow.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/thumbnail_0000_ad7c7160-70a6-4bd3-bf75-49ef37753e93.png",
		"clip_name": "Pouring waterfall at the end of a grassy cliff",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_726d7ed1-a7a0-42a4-94d7-7ca403201ade/thumbnail_b48ae8cf-20a3-4d0e-a1d2-0093c36736ba.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/e419978c-7c93-48d0-9cfa-cefa25750378/preview-small-59b5d554-1933-4e77-9e3c-f3352b90d7d5.mp4",
		"tags": [
			2900,
			4400,
			1100,
			2700,
			4200,
			900,
			2300,
			2100,
			3600,
			200,
			3300
		],
		"featured_at": "2017-11-14T07:10:22.41Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_e419978c-7c93-48d0-9cfa-cefa25750378/lqip_f6975bf3-84a7-4fba-ac8f-862a79e5a4ce.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_726d7ed1-a7a0-42a4-94d7-7ca403201ade/poster_c7402bd9-2302-433f-8c97-a02e5937160d.jpg",
		"scene_slug": "green-waterfall",
		"clip_colors": {
			"Vibrant": "#c7ad37",
			"DarkVibrant": "#64571c",
			"Muted": "#655a36",
			"LightMuted": "#d4d4dc",
			"DarkMuted": "#564d36"
		},
		"scene_colors": {
			"Vibrant": "#74642c",
			"DarkVibrant": "#5b5229",
			"Muted": "#747c8c",
			"LightMuted": "#d4d4dc",
			"DarkMuted": "#4a4627"
		},
		"scene_name": "Green Waterfall",
		"scene_id": "726d7ed1-a7a0-42a4-94d7-7ca403201ade"
	},
	{
		"clip_id": "f4e4e867-0247-40ef-9991-1062e24e88d1",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_b76ac89f-6a2d-4e9f-ae17-9bc45a89624d/lqip_51fd0416-a384-4b5a-9ad0-809500b1f6f5.jpg",
		"scene_clip_count": "18",
		"published_at": "2017-11-06T19:30:26.317Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/sequence_14995587-fe63-465b-9fb9-d82cdb8775a4/0028.png"
		],
		"keywords": [
			"autumn",
			"beautiful",
			"bond",
			"boy",
			"cabin",
			"coat",
			"cottage",
			"couple",
			"cute",
			"date",
			"embrace",
			"emotion",
			"fall",
			"forest",
			"fun",
			"girl",
			"hand",
			"handsome",
			"happy",
			"hold",
			"hug",
			"husband",
			"intense",
			"joy",
			"love kiss",
			"man",
			"marriage",
			"romantic",
			"rover",
			"skin",
			"smile",
			"sweater",
			"together",
			"touch",
			"tree",
			"walk",
			"water",
			"wife",
			"woman"
		],
		"clip_slug": "young-couple-looking-out-over-the-water",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/poster_0000_522e5168-7916-4770-9a36-73ad43f04a77.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/preview-large-ac1defc0-c168-4846-9142-690c6b364832.mp4",
		"clip_length": 14167,
		"scene_description": "Two young lovers display their love and affection with hand-holding, hugs, and kisses. On a crisp evening in the forest by a lake, standing on the dock makes for a very romantic scene.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/thumbnail_0000_dd50fc21-827d-4dcd-941e-2f7355b1a131.png",
		"clip_name": "Young couple looking out over the water",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_b76ac89f-6a2d-4e9f-ae17-9bc45a89624d/thumbnail_0baaab63-e594-4baf-b21b-d1ab788264db.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/f4e4e867-0247-40ef-9991-1062e24e88d1/preview-small-e6e94bf6-61d2-4963-8f8e-1b10add8600e.mp4",
		"tags": [
			1200,
			1100,
			2700,
			4300,
			4200,
			2300,
			3700,
			3000,
			2000,
			1000,
			1800,
			3400
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_f4e4e867-0247-40ef-9991-1062e24e88d1/lqip_cd558ee2-a8f8-4bd5-b61a-44133455ac3b.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_b76ac89f-6a2d-4e9f-ae17-9bc45a89624d/poster_5ad2905e-775c-490d-bc35-39a9cdbe70d1.jpg",
		"scene_slug": "couple-in-love",
		"clip_colors": {
			"Vibrant": "#b44a5f",
			"DarkVibrant": "#441c24",
			"Muted": "#808492",
			"LightMuted": "#bbc0cb",
			"DarkMuted": "#2c3454"
		},
		"scene_colors": {
			"Vibrant": "#b94547",
			"DarkVibrant": "#552021",
			"Muted": "#737a8a",
			"LightMuted": "#bec1ca",
			"DarkMuted": "#5a2f2b"
		},
		"scene_name": "Couple In Love",
		"scene_id": "b76ac89f-6a2d-4e9f-ae17-9bc45a89624d"
	},
	{
		"clip_id": "fbb61ca3-d8aa-4333-818a-bf881348525b",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_3b8a9c7b-3847-477e-bb01-73350e86ca81/lqip_417c133e-b745-4c58-b88e-e72d0de7270b.jpg",
		"scene_clip_count": "32",
		"published_at": "2017-10-30T20:28:22.754Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/sequence_8e718f8c-6f5c-464f-bb9a-5ed6c23d10a8/0040.png"
		],
		"keywords": [
			"100",
			"american",
			"ashes",
			"backdrop",
			"bank",
			"banking",
			"bill",
			"black",
			"bond",
			"bucks",
			"bundle",
			"burning",
			"business",
			"cash",
			"close-up",
			"currency",
			"current",
			"dollar",
			"expenses",
			"fall",
			"fast",
			"finance",
			"financial",
			"franklin",
			"green",
			"greenback",
			"group",
			"hundred",
			"jackpot",
			"loan",
			"many",
			"money",
			"motion",
			"note",
			"pay",
			"pile",
			"rain",
			"salary",
			"slow",
			"stock",
			"stream",
			"usa",
			"wages",
			"waste",
			"wealth"
		],
		"clip_slug": "money-falling-from-the-sky",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/poster_0000_7d1afc25-598c-4eb4-a917-b7bea3434bb1.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/preview-large-a1b43392-1110-46ce-873c-8fdf53ca78da.mp4",
		"clip_length": 20000,
		"scene_description": "Stacks on stacks on stacks of cash. American bills are tossed, flipped through, and burned in a black and white retro themed scene.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/thumbnail_0000_ef2cfcec-d3e8-44f6-acca-19289016ea82.png",
		"clip_name": "Money falling from the sky",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_3b8a9c7b-3847-477e-bb01-73350e86ca81/thumbnail_8850ebae-47ae-4d4c-9285-be52259fd739.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fbb61ca3-d8aa-4333-818a-bf881348525b/preview-small-9e89d6b8-909e-4f25-9319-955e8f0e5984.mp4",
		"tags": [
			4300,
			4200,
			2400,
			2200,
			3800,
			400,
			1900,
			100
		],
		"featured_at": "2017-11-14T07:09:49.761Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fbb61ca3-d8aa-4333-818a-bf881348525b/lqip_77be2bb1-6ce5-43d7-9b96-71cf5fc130b9.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_3b8a9c7b-3847-477e-bb01-73350e86ca81/poster_20377d78-e2ba-4430-8cff-c2ca540d403e.jpg",
		"scene_slug": "cash-money",
		"clip_colors": {
			"Vibrant": "#7f4cb2",
			"DarkVibrant": "#140c1c",
			"Muted": "#7c7860",
			"LightMuted": "#929092",
			"DarkMuted": "#140c14"
		},
		"scene_colors": {
			"Vibrant": "#888428",
			"DarkVibrant": "#207c80",
			"Muted": "#7c7c7c",
			"LightMuted": "#afafaf",
			"DarkMuted": "#444444"
		},
		"scene_name": "Cash Money",
		"scene_id": "3b8a9c7b-3847-477e-bb01-73350e86ca81"
	},
	{
		"clip_id": "d990ce33-247c-450e-8789-7972e1f4e084",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fb843602-97f9-4422-8ab4-48ec39687de0/lqip_58d804f2-d2a5-4814-9944-235b4a3d5c8e.jpg",
		"scene_clip_count": "24",
		"published_at": "2017-10-11T14:03:57.491Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/sequence_43e80913-0b07-4314-95d3-bf86c83230f9/0040.png"
		],
		"keywords": [
			"abstract",
			"background",
			"beautiful",
			"blue",
			"breathtaking",
			"bubbles",
			"color",
			"cool",
			"crystal",
			"dark",
			"design",
			"floating",
			"flow",
			"geometry",
			"graphics",
			"hexagon",
			"ice",
			"ink",
			"macro",
			"micro",
			"motion",
			"motion graphics",
			"paraffin",
			"science",
			"sequence",
			"shapes",
			"soap",
			"structure",
			"texture",
			"water"
		],
		"clip_slug": "light-and-dark-bubbles-splitting-in-half",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/poster_0000_b0425e8c-cae3-4e33-b8c4-eefbf6ea199a.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/preview-large-4e6d9a86-156b-45e6-9cb7-156997bb7018.mp4",
		"clip_length": 20000,
		"scene_description": "Combining a mixture of soap and food coloring, these bubbles form diverse polygonal shapes to fill a variety of abstract footage needs.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/thumbnail_0000_f7e1a1d6-29b1-4469-85fc-510e57623639.png",
		"clip_name": "Light and dark bubbles splitting in half",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_fb843602-97f9-4422-8ab4-48ec39687de0/thumbnail_caa7d55f-b93a-4893-9c1c-797ce7928bd3.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/d990ce33-247c-450e-8789-7972e1f4e084/preview-small-729f5120-346a-48a4-a36a-3100c432dcd4.mp4",
		"tags": [
			4400,
			2600,
			2300,
			3900,
			2200,
			4000,
			1900,
			100
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_d990ce33-247c-450e-8789-7972e1f4e084/lqip_351cf3ed-feb5-4bd8-9b8e-87907e7b1b36.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_fb843602-97f9-4422-8ab4-48ec39687de0/poster_6c65ef40-549a-4da8-b619-9fa75ac766eb.jpg",
		"scene_slug": "abstract-inky-foam",
		"clip_colors": {
			"Vibrant": "#3c667d",
			"LightVibrant": "#b1cadc",
			"DarkVibrant": "#274552",
			"Muted": "#4a7284",
			"LightMuted": "#a8c2d1",
			"DarkMuted": "#2f4f60"
		},
		"scene_colors": {
			"Vibrant": "#6295b4",
			"LightVibrant": "#7caccc",
			"DarkVibrant": "#2d5162",
			"Muted": "#538097",
			"LightMuted": "#a2c4d1",
			"DarkMuted": "#25444b"
		},
		"scene_name": "Abstract Inky Foam",
		"scene_id": "fb843602-97f9-4422-8ab4-48ec39687de0"
	},
	{
		"clip_id": "e5e85418-1761-4aae-87e6-e8b1c0189bff",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_476dd1e6-992e-448c-afdd-ca2383fa15b1/lqip_72bd7a5e-cb7c-4700-a9b3-a2b976f1a4c0.jpg",
		"scene_clip_count": "12",
		"published_at": "2017-09-22T06:00:47.929Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/sequence_eadeed0d-0b6d-4ce1-a8c7-0d298eb7a9b6/0037.png"
		],
		"keywords": [
			"crater",
			"desert",
			"dreamscape",
			"dry",
			"green",
			"highlands",
			"hilly",
			"iceland",
			"icelandic",
			"landscape",
			"majestic",
			"mountain",
			"nature",
			"nordic",
			"polar",
			"river",
			"rock",
			"sand",
			"scenery",
			"scenic",
			"sky",
			"tourism",
			"touristic",
			"travel",
			"trip",
			"unbelievable",
			"unreal",
			"valley",
			"volcanic",
			"volcano",
			"wilderness"
		],
		"clip_slug": "red-and-green-crater-in-mountainous-terrain",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/poster_0000_9d717672-d9bd-4f95-bda0-52dd29600617.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/preview-large-1ff33ed4-b05f-4030-ae9b-f82c3351f805.mp4",
		"clip_length": 18750,
		"scene_description": "The Secret Life of Walter Mitty didn't get to explore this volcanic mountain range. Enjoy footage from one of Iceland's many volcanoes and the rocky landscape that surrounds it under the setting sun.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/thumbnail_0000_04c3a705-0ffd-47d5-a1d3-14f0e858f386.png",
		"clip_name": "Red and green crater in mountainous terrain",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_476dd1e6-992e-448c-afdd-ca2383fa15b1/thumbnail_a2be0b1f-cd1b-4411-9a1f-4dfaf9e5aa42.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/e5e85418-1761-4aae-87e6-e8b1c0189bff/preview-small-1d611fdb-a1c3-4a03-aba8-4d8f0aa1404e.mp4",
		"tags": [
			1100,
			2700,
			4300,
			4200,
			900,
			2400,
			2100,
			3000,
			3600,
			200,
			3400
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_e5e85418-1761-4aae-87e6-e8b1c0189bff/lqip_4e961e79-8704-4322-9bc9-fa49bf3b7ba9.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_476dd1e6-992e-448c-afdd-ca2383fa15b1/poster_fe34ccbc-c0aa-4b5a-af47-4f37f0ca93d5.jpg",
		"scene_slug": "volcanic-mountain-range",
		"clip_colors": {
			"Vibrant": "#ac8e52",
			"DarkVibrant": "#5c4c2c",
			"Muted": "#71788e",
			"LightMuted": "#c8ccda",
			"DarkMuted": "#625239"
		},
		"scene_colors": {
			"Vibrant": "#ac9052",
			"DarkVibrant": "#5c4d2c",
			"Muted": "#8c7552",
			"LightMuted": "#cad0db",
			"DarkMuted": "#61523a"
		},
		"scene_name": "Volcanic Mountain Range",
		"scene_id": "476dd1e6-992e-448c-afdd-ca2383fa15b1"
	},
	{
		"clip_id": "ffcdd117-c3bc-43d8-a4f1-0dac3212cab6",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_1c6f06ba-9731-4bef-8878-d04dcff2d1ba/lqip_5f36eb13-dbca-4328-a5e5-03d233c05e21.jpg",
		"scene_clip_count": "59",
		"published_at": "2017-11-03T15:20:08.027Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/sequence_28cc5f70-2f98-468e-ae16-b60b9fdc0676/0040.png"
		],
		"keywords": [
			"annual event",
			"background",
			"beautiful",
			"beauty",
			"big",
			"black",
			"bright",
			"burst",
			"celebrate",
			"celebration",
			"closed",
			"colorful",
			"dark",
			"detail",
			"event",
			"explode",
			"explosion",
			"festival",
			"festive",
			"fire",
			"firework",
			"firework display",
			"fun",
			"glowing",
			"holiday",
			"isolated",
			"large",
			"new year's",
			"night",
			"outburst",
			"party",
			"pyrotechnics",
			"real",
			"sky",
			"texture"
		],
		"clip_slug": "fireworks-of-purple-balls-and-golden-streams",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/poster_0000_4158ac89-2ad0-4ecd-849e-cb6fb2d4b0ab.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/preview-large-713f9337-99a0-4023-8c8f-557b0d80ff84.mp4",
		"clip_length": 20000,
		"scene_description": "CRACK! KA-BOOM! Light flashes and sparkles of confetti fire reign down from the night sky. What better way to celebrate any festival than with the brilliant lights of fireworks?",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/thumbnail_0000_5fac52f8-376f-4f8b-9739-f97b72d3a3a1.png",
		"clip_name": "Fireworks of purple balls and golden streams",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_1c6f06ba-9731-4bef-8878-d04dcff2d1ba/thumbnail_13afb96b-1068-4d23-8f32-bac75e249262.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/preview-small-25641507-68c5-4085-a374-95fd04efca3a.mp4",
		"tags": [
			2900,
			4400,
			2700,
			800,
			2400,
			500,
			4000,
			3600,
			2000,
			3500,
			1000
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_ffcdd117-c3bc-43d8-a4f1-0dac3212cab6/lqip_cc8409cc-31d9-4d60-9fa9-a197e69a60d2.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_1c6f06ba-9731-4bef-8878-d04dcff2d1ba/poster_18428bf0-f763-44b4-82a1-00b43b67ddbc.jpg",
		"scene_slug": "fireworks",
		"clip_colors": {
			"Vibrant": "#8f2fcf",
			"DarkVibrant": "#240c34",
			"Muted": "#7e6e6e",
			"DarkMuted": "#543c64"
		},
		"scene_colors": {
			"Vibrant": "#8c5e3c",
			"LightVibrant": "#dcb69b",
			"DarkVibrant": "#4c1c64",
			"Muted": "#a68873",
			"LightMuted": "#d4bbab",
			"DarkMuted": "#634937"
		},
		"scene_name": "Fireworks",
		"scene_id": "1c6f06ba-9731-4bef-8878-d04dcff2d1ba"
	},
	{
		"clip_id": "e9b5e009-4ae7-4654-9249-3ed6cace45ca",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_974d17b4-5848-45c2-8f15-f1d7dbd5a898/lqip_ecc3b2ab-9119-4b69-b768-95101aab5931.jpg",
		"scene_clip_count": "39",
		"published_at": "2017-11-06T19:52:48.56Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0040.png",
			"https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/sequence_4c80e006-6f01-45c5-829a-0699a3f98be0/0041.png"
		],
		"keywords": [
			"beach",
			"beautiful",
			"calm",
			"dark",
			"deep",
			"early",
			"flower",
			"grass",
			"great",
			"horizon",
			"lake",
			"morning",
			"niagara",
			"ontario",
			"rock",
			"rural",
			"sand",
			"shore",
			"still",
			"sunrise",
			"water"
		],
		"clip_slug": "first-light-on-a-lake",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/poster_0000_133bbed7-fc65-44e6-9448-447334a639ee.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/preview-large-ed10a79a-c150-4e4b-8c44-4179fe8a78ca.mp4",
		"clip_length": 20667,
		"scene_description": "Reflective. Thoughtful. Serene. This scene encompasses these emotions as a solitary man wakes up early in the morning and spends time on the shores of a peaceful lake as he watches the sunrise.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/thumbnail_0000_ee612610-3bba-4b17-b1fc-a8cc14fa28f0.png",
		"clip_name": "First light on a lake",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_974d17b4-5848-45c2-8f15-f1d7dbd5a898/thumbnail_2203ff9d-f774-4f50-b8e9-12a772ab5bd7.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/e9b5e009-4ae7-4654-9249-3ed6cace45ca/preview-small-041f2a42-0ad3-47b9-bbb2-49ad6825b0e7.mp4",
		"tags": [
			2900,
			2700,
			2300,
			2100,
			1800,
			1200,
			1100,
			4300,
			900,
			4000,
			3600,
			1000,
			3200
		],
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_e9b5e009-4ae7-4654-9249-3ed6cace45ca/lqip_387fa72f-b123-497f-97a6-5670d7415827.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_974d17b4-5848-45c2-8f15-f1d7dbd5a898/poster_6b58e9e1-89ac-483e-a2ab-22e250881a71.jpg",
		"scene_slug": "early-morning-at-the-lake",
		"clip_colors": {
			"Muted": "#535d64",
			"DarkMuted": "#2c444c"
		},
		"scene_colors": {
			"Muted": "#6f7988",
			"LightMuted": "#bab1b1",
			"DarkMuted": "#35465a"
		},
		"scene_name": "Early Morning At The Lake",
		"scene_id": "974d17b4-5848-45c2-8f15-f1d7dbd5a898"
	},
	{
		"clip_id": "fd578057-81db-44de-95ff-46662345dc09",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_3fc3c600-7d8c-4c7e-99b4-ac1d065a0234/lqip_491989d8-a2bb-4b41-9d05-b1d4d76a90a2.jpg",
		"scene_clip_count": "108",
		"published_at": "2017-11-07T21:00:00.457Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0039.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/sequence_272deedd-f4c9-4292-9648-cc9c7faaacfb/0040.png"
		],
		"keywords": [
			"alluring",
			"ash",
			"attractive",
			"backdrop",
			"background",
			"basic",
			"beautiful",
			"black",
			"bonfire",
			"bright",
			"burn",
			"burnt",
			"captivating",
			"compelling",
			"concept",
			"danger",
			"distinctive",
			"embers",
			"energy",
			"fiery",
			"fire",
			"fire embers",
			"fireplace",
			"flame",
			"flaming",
			"flying",
			"glow",
			"glowing",
			"heat",
			"hell",
			"hot",
			"isolated",
			"light",
			"night",
			"power",
			"simple",
			"spark",
			"striking",
			"stylish",
			"texture"
		],
		"clip_slug": "feathers-melt-into-droplets-under-white-flames",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/poster_0000_631c248d-293a-45e6-8272-79e9d8abca22.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/preview-large-b9413c15-0f54-4b0a-a085-db0d801f69a3.mp4",
		"clip_length": 20000,
		"scene_description": "Pyrotechnics can be dangerous - so why not leave it behind a screen? Hot red fire burn various materials as bright flames flicker into the dark in a mesmerizing fashion.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/thumbnail_0000_eb972bf0-b7cd-41c3-88a8-51f23d90c06b.png",
		"clip_name": "Feathers melt into droplets under white flames",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_3fc3c600-7d8c-4c7e-99b4-ac1d065a0234/thumbnail_cb3e56d8-5630-465e-bde7-87bbcd3b2f3d.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fd578057-81db-44de-95ff-46662345dc09/preview-small-189d61bf-63d4-4e4d-b09d-7a1e06ccc580.mp4",
		"tags": [
			4400,
			2600,
			4100,
			2300,
			2200,
			3800,
			100
		],
		"featured_at": "2017-11-14T07:07:50.396Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fd578057-81db-44de-95ff-46662345dc09/lqip_92c29451-62e4-4d1a-81b6-a99d1df6ade9.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_3fc3c600-7d8c-4c7e-99b4-ac1d065a0234/poster_8bb5555f-f276-4d7a-af6e-1aca6972a404.jpg",
		"scene_slug": "flames-and-embers",
		"clip_colors": {
			"DarkMuted": "#0c0c0c"
		},
		"scene_colors": {
			"Vibrant": "#fb731b",
			"LightVibrant": "#fce28d",
			"DarkVibrant": "#bd2404",
			"DarkMuted": "#080404"
		},
		"scene_name": "Flames And Embers",
		"scene_id": "3fc3c600-7d8c-4c7e-99b4-ac1d065a0234"
	},
	{
		"clip_id": "f8e9ce10-fa2b-46b0-864b-d13232566dfd",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_54bb3628-65f3-49e6-9f49-e7837d179887/lqip_57c04113-8fc7-4ec1-965e-4964d677b8c6.jpg",
		"scene_clip_count": "33",
		"published_at": "2017-10-25T19:28:26.067Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/sequence_37774c3f-e23b-42be-935b-9c11935a0e82/0037.png"
		],
		"keywords": [
			"adventure",
			"aerial",
			"beautiful",
			"ecology",
			"environment",
			"high",
			"hill",
			"horizon",
			"iceland",
			"landscape",
			"majestic",
			"mountains",
			"nature",
			"nobody",
			"outdoor",
			"peak",
			"range",
			"ridge",
			"river",
			"rocks",
			"scene",
			"scenery",
			"scenic",
			"stream",
			"summit",
			"sun",
			"sunrise",
			"sunset",
			"tourism",
			"travel",
			"view",
			"water",
			"wild",
			"wilderness"
		],
		"clip_slug": "majestic-snow-capped-mountain-range",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/poster_0000_a505ed5a-cc8e-4670-bc50-0ac24ca11d7a.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/preview-large-a2192c68-6890-4856-99f0-81c87e583a32.mp4",
		"clip_length": 18625,
		"scene_description": "Under the sunset light, a river splits into a thousand separate channels in a valley between mountain ranges. As the sun goes down, the green grass gets lost in the dark shadows, while the sun glistens on the water below.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/thumbnail_0000_65b41095-3cb9-401f-a488-c9438cf236c5.png",
		"clip_name": "Majestic snow-capped mountain range",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_54bb3628-65f3-49e6-9f49-e7837d179887/thumbnail_e4d1c679-90b0-43f7-afd3-371b439d2d70.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/f8e9ce10-fa2b-46b0-864b-d13232566dfd/preview-small-0a28f524-3f97-45da-851b-bb3b01330e7b.mp4",
		"tags": [
			1100,
			2700,
			4300,
			4200,
			900,
			2300,
			2100,
			3000,
			3600,
			200,
			3400
		],
		"featured_at": "2017-11-14T07:07:26.814Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_f8e9ce10-fa2b-46b0-864b-d13232566dfd/lqip_960aa0ea-fe14-46d5-88f0-9c752bf42f31.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_54bb3628-65f3-49e6-9f49-e7837d179887/poster_151323f3-978a-477c-b517-5e0730f964cd.jpg",
		"scene_slug": "rivers-and-mountains",
		"clip_colors": {
			"Vibrant": "#b28a4c",
			"DarkVibrant": "#544124",
			"Muted": "#676471",
			"LightMuted": "#acb3c3",
			"DarkMuted": "#443b44"
		},
		"scene_colors": {
			"Vibrant": "#ad6851",
			"LightVibrant": "#f4ecdc",
			"DarkVibrant": "#3c241c",
			"Muted": "#947c5c",
			"LightMuted": "#d5cabf",
			"DarkMuted": "#5e4c34"
		},
		"scene_name": "Rivers And Mountains",
		"scene_id": "54bb3628-65f3-49e6-9f49-e7837d179887"
	},
	{
		"clip_id": "fd87184f-e985-4630-a073-7a02f2c89834",
		"scene_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_6d6b5477-65b5-498a-81e7-f0de3772f87f/lqip_2adaff57-e756-4e3a-a43c-6c04bf0e8abc.jpg",
		"scene_clip_count": "61",
		"published_at": "2017-10-30T19:02:50.178Z",
		"clip_sequence": [
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0000.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0001.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0002.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0003.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0004.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0005.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0006.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0007.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0008.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0009.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0010.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0011.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0012.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0013.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0014.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0015.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0016.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0017.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0018.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0019.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0020.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0021.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0022.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0023.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0024.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0025.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0026.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0027.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0028.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0029.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0030.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0031.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0032.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0033.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0034.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0035.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0036.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0037.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0038.png",
			"https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/sequence_c33477bc-b32c-4ff5-9697-6f86e948e008/0039.png"
		],
		"keywords": [
			"Europe",
			"Ireland",
			"Irish",
			"autumn",
			"bay",
			"boat",
			"buildings",
			"calm",
			"coast",
			"coastal",
			"community",
			"dawn",
			"drone",
			"early",
			"fall",
			"harbor",
			"harbour",
			"houses",
			"inlet",
			"morning",
			"ocean",
			"peaceful",
			"quaint",
			"quiet",
			"sail",
			"sea",
			"seaside",
			"sunrise",
			"town",
			"vessel",
			"village",
			"water"
		],
		"clip_slug": "algae-patches-float-on-harbor-water",
		"clip_poster": "https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/poster_0000_686c3488-87cd-4d09-8762-0dfe8c0b01c3.png",
		"clip_preview_large": "https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/preview-large-4fd5839d-1c02-4503-a812-ffaf4a20e8ea.mp4",
		"clip_length": 19917,
		"scene_description": "An early morning in an Irish seaside town. The slow rising sun gives light to the still sailboats in the quiet harbor and quaint community below.",
		"clip_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/thumbnail_0000_2e223917-9a1e-473a-a9dd-ee3a96814fb3.png",
		"clip_name": "Algae patches float on harbor water",
		"scene_thumbnail": "https://s3.amazonaws.com/storytape-prod-static/scene_6d6b5477-65b5-498a-81e7-f0de3772f87f/thumbnail_431287c8-6e54-431d-b250-02b7cb832367.jpg",
		"clip_preview_small": "https://s3.amazonaws.com/storytape-prod-static/fd87184f-e985-4630-a073-7a02f2c89834/preview-small-fa648597-ea6c-40f5-84e2-577c0651ae34.mp4",
		"tags": [
			4400,
			2700,
			4200,
			900,
			2300,
			500,
			2100,
			3000,
			3600,
			200,
			3200
		],
		"featured_at": "2017-11-14T07:06:54.945Z",
		"clip_lqip": "https://s3.amazonaws.com/storytape-prod-static/scene_fd87184f-e985-4630-a073-7a02f2c89834/lqip_2aee7f4b-d9ab-4a14-8c12-0893998bc373.jpg",
		"scene_poster": "https://s3.amazonaws.com/storytape-prod-static/scene_6d6b5477-65b5-498a-81e7-f0de3772f87f/poster_24954ecc-c2df-499a-ab5d-48789264ee8c.jpg",
		"scene_slug": "seaside-harbor-town-at-sunrise",
		"clip_colors": {
			"Vibrant": "#4797b7",
			"DarkVibrant": "#244c5c",
			"Muted": "#73747c",
			"LightMuted": "#c4cbd0",
			"DarkMuted": "#463f3b"
		},
		"scene_colors": {
			"Vibrant": "#bc946e",
			"LightVibrant": "#f4e4c4",
			"DarkVibrant": "#553c24",
			"Muted": "#847f7d",
			"LightMuted": "#c3b3a5",
			"DarkMuted": "#41352e"
		},
		"scene_name": "Seaside Harbor Town At Sunrise",
		"scene_id": "6d6b5477-65b5-498a-81e7-f0de3772f87f"
	}
];

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(384),
    baseFilter = __webpack_require__(1286),
    baseIteratee = __webpack_require__(85),
    isArray = __webpack_require__(18);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(152);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dc372d50.mp4";

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "413f5629.mp4";

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "09f12856.mp4";

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "59499326.jpg";

/***/ }),
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(19);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/actions/search.js + 1 modules
var search = __webpack_require__(915);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(17);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 1 modules
var Layout = __webpack_require__(1161);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(33);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(220);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(366);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/sample.js
var sample = __webpack_require__(361);
var sample_default = /*#__PURE__*/__webpack_require__.n(sample);

// EXTERNAL MODULE: ./node_modules/color/index.js
var color = __webpack_require__(351);
var color_default = /*#__PURE__*/__webpack_require__.n(color);

// EXTERNAL MODULE: ./src/actions/user.js
var user = __webpack_require__(222);

// EXTERNAL MODULE: ./src/actions/plan.js
var plan = __webpack_require__(223);

// EXTERNAL MODULE: ./src/actions/ui.js
var ui = __webpack_require__(1153);

// EXTERNAL MODULE: ./src/lib/Color.js
var Color = __webpack_require__(899);

// EXTERNAL MODULE: ./src/lib/react.js
var lib_react = __webpack_require__(221);

// EXTERNAL MODULE: ./src/components/Header/Header.js + 4 modules
var Header = __webpack_require__(1073);

// EXTERNAL MODULE: ./src/components/Footer/Footer.js
var Footer = __webpack_require__(1077);

// EXTERNAL MODULE: ./src/components/Section/Section.js
var Section = __webpack_require__(933);

// EXTERNAL MODULE: ./src/components/Button/Button.js
var Button = __webpack_require__(889);

// EXTERNAL MODULE: ./src/components/Link/Link.js
var Link = __webpack_require__(890);

// EXTERNAL MODULE: ./src/components/ImageLoader/ImageLoader.js
var ImageLoader = __webpack_require__(1162);

// CONCATENATED MODULE: ./src/components/NewsletterForm/NewsletterForm.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var NewsletterForm__ref = _jsx('div', {
  className: '_form_190'
});

var NewsletterForm_NewsletterForm = function (_React$PureComponent) {
  _inherits(NewsletterForm, _React$PureComponent);

  function NewsletterForm() {
    _classCallCheck(this, NewsletterForm);

    return _possibleConstructorReturn(this, (NewsletterForm.__proto__ || Object.getPrototypeOf(NewsletterForm)).apply(this, arguments));
  }

  _createClass(NewsletterForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scriptTag = document.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.charset = 'utf-8';
      scriptTag.src = 'https://prochurchtools.activehosted.com/f/embed.php?id=190';
      scriptTag.async = true;
      this.containerDiv.appendChild(scriptTag);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return react_default.a.createElement(
        'div',
        { ref: function ref(el) {
            return _this2.containerDiv = el;
          }, style: { textAlign: 'center' } },
        NewsletterForm__ref
      );
    }
  }]);

  return NewsletterForm;
}(react_default.a.PureComponent);

NewsletterForm_NewsletterForm.defaultProps = {};


/* harmony default export */ var components_NewsletterForm_NewsletterForm = (NewsletterForm_NewsletterForm);
// EXTERNAL MODULE: ./src/components/Toggle/Toggle.js
var Toggle = __webpack_require__(935);

// EXTERNAL MODULE: ./src/components/InstagramGrid/InstagramGrid.js
var InstagramGrid = __webpack_require__(1225);

// EXTERNAL MODULE: ./src/components/PricingStrip/PricingStrip.js
var PricingStrip = __webpack_require__(1195);

// EXTERNAL MODULE: ./src/components/Video/Video.js
var Video = __webpack_require__(934);

// EXTERNAL MODULE: ./node_modules/react-motion/lib/react-motion.js
var react_motion = __webpack_require__(353);
var react_motion_default = /*#__PURE__*/__webpack_require__.n(react_motion);

// EXTERNAL MODULE: ./src/actions/runtime.js
var runtime = __webpack_require__(354);

// EXTERNAL MODULE: ./src/lib/Motion.js
var Motion = __webpack_require__(352);

// EXTERNAL MODULE: ./src/components/HeadlineAnimator/HeadlineAnimator.js
var HeadlineAnimator = __webpack_require__(1277);

// EXTERNAL MODULE: ./src/components/Style/Style.js
var Style = __webpack_require__(350);

// EXTERNAL MODULE: ./src/components/Typography/Typography.js
var Typography = __webpack_require__(887);

// CONCATENATED MODULE: ./src/components/SectionHomeTop/SectionHomeTop.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SectionHomeTop__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SectionHomeTop__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function SectionHomeTop__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SectionHomeTop__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SectionHomeTop__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var triggerPoints = [0, 0.7, 0.9];
var posterMovementVw = 10;

var SectionHomeTop__ref = SectionHomeTop__jsx('br', {});

var _ref2 = SectionHomeTop__jsx('span', {}, void 0, '\xA0\xA0\u2022\xA0\xA0');

var SectionHomeTop_SectionHomeTop = function (_React$PureComponent) {
  SectionHomeTop__inherits(SectionHomeTop, _React$PureComponent);

  function SectionHomeTop(props) {
    SectionHomeTop__classCallCheck(this, SectionHomeTop);

    var _this = SectionHomeTop__possibleConstructorReturn(this, (SectionHomeTop.__proto__ || Object.getPrototypeOf(SectionHomeTop)).call(this, props));

    _this.setHeadlineDone = function () {
      _this.setState({ headlineDone: true });
    };

    _this.getStyles = function (prevInterpolatedStyles) {
      return [Object(Motion["d" /* springify */])({
        x: _this.state.headlineDone ? 1 : _this.state.animatedDefault[0].x
      }, { stiffness: 140, damping: 30 }), Object(Motion["d" /* springify */])({
        x: prevInterpolatedStyles[0].x > triggerPoints[1] ? 1 : _this.state.animatedDefault[1].x
      }), Object(Motion["d" /* springify */])({
        x: prevInterpolatedStyles[1].x > triggerPoints[2] ? 1 : _this.state.animatedDefault[2].x
      }, { stiffness: 60, damping: 14 })];
    };

    _this.state = {
      headlineDone: false,
      animatedDefault: [{ x: props.marketingVanityAnimation ? 1 : 0 }, { x: props.marketingVanityAnimation ? 1 : 0 }, { x: props.marketingVanityAnimation ? 1 : 0 }],
      fixedClipCount: 6500,
      libraryClipCount: 6500
    };
    return _this;
  }

  SectionHomeTop__createClass(SectionHomeTop, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.props.getLibraryClipCount().then(function (count) {
        return _this2.setState({ libraryClipCount: count });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          responsive = _props.responsive,
          posterClip = _props.posterClip,
          colors = _props.colors,
          layoutLoaded = _props.layoutLoaded,
          onShowSignup = _props.onShowSignup,
          otherProps = _objectWithoutProperties(_props, ['responsive', 'posterClip', 'colors', 'layoutLoaded', 'onShowSignup']);

      if (!posterClip) {
        return null;
      }

      var topSlice = -70;
      var headerTop = 0;
      var headingTopPadding = 13;
      var changesBottomMargin = 1.6;
      var headingMaxWidth = 35;
      var headerFontSize = undefined;
      var showFinally = false;
      var headerBreakLine = true;
      var statementTopMargin = 2;

      var posterWidth = 38;
      var posterBottom = '-3rem';
      var posterHeight = '30rem';
      var posterWordOffset = 0;

      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE) {
        topSlice = -60;
      }
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT) {
        topSlice = -50;
        headingTopPadding = 20;
        showFinally = true;
        headingMaxWidth = 60;
        headerBreakLine = false;
        posterWidth = 50;
        posterBottom = 'calc(50% - 30vw)';
        posterHeight = '60vw';
        posterWordOffset = -3;
      }
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE) {
        topSlice = -40;
        headingTopPadding = 25;
        headerTop = 2;
        headingMaxWidth = 80;
        posterWordOffset = -9;
      }
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].DESKTOP) {
        topSlice = -32;
        changesBottomMargin = 2.5;
        headerFontSize = '7rem';
        statementTopMargin = 3;
        posterWordOffset = -11;
      }

      var animatedCurrent = Object(Motion["d" /* springify */])({
        light: this.state.animatedLight,
        dark: this.state.animatedDark,
        poster: this.state.animatedPoster
      });

      return SectionHomeTop__jsx(react_motion["StaggeredMotion"], {
        defaultStyles: this.state.animatedDefault,
        styles: this.getStyles
      }, void 0, function (tweens) {
        if (tweens[2].x === 1) {
          setTimeout(_this3.props.setMarketingVanityAnimation, 0);
        }

        return SectionHomeTop__jsx('div', {}, void 0, SectionHomeTop__jsx(Section["a" /* default */], {
          style: {
            position: 'relative',
            backgroundColor: colors.light,
            backgroundImage: 'linear-gradient(135deg, ' + colors.light + ' 0%,' + colors.light + ' ' + tweens[0].x * 100 + '%,' + Style["a" /* default */].Colors.white + ' ' + tweens[0].x * 100 + '%,' + Style["a" /* default */].Colors.white + ' 100%)',
            minHeight: '62vw'
          }
        }, void 0, SectionHomeTop__jsx(Section["a" /* default */], {
          bottomAngle: topSlice,
          backgroundColor: Style["a" /* default */].Colors.white,
          style: {
            zIndex: 1,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0
          }
        }), SectionHomeTop__jsx('div', {
          style: {
            zIndex: 2,
            position: 'relative',
            maxWidth: headingMaxWidth + 'rem',
            margin: 'auto',
            padding: headingTopPadding + 'rem 2rem 40vw',
            textAlign: 'center'
          }
        }, void 0, SectionHomeTop__jsx(HeadlineAnimator["a" /* default */], {
          show: layoutLoaded,
          donePoint: 0.75,
          onDone: _this3.setHeadlineDone,
          topContent: SectionHomeTop__jsx(react_motion["Motion"], {
            defaultStyle: { clipCount: _this3.state.fixedClipCount },
            style: Object(Motion["d" /* springify */])({
              clipCount: _this3.state.libraryClipCount
            })
          }, void 0, function (tween) {
            var count = Math.min(Math.round(tween.clipCount), _this3.state.libraryClipCount);
            if (count.toLocaleString) {
              count = count.toLocaleString();
            }

            return SectionHomeTop__jsx(Typography["j" /* L3 */], {
              style: {
                color: Style["a" /* default */].Colors.shadow3,
                display: 'block',
                margin: '0 auto ' + statementTopMargin + 'rem'
              }
            }, void 0, count, ' Cinematic Clips\xA0\xA0\u2022\xA0\xA04K ProRes', headerBreakLine && SectionHomeTop__ref, !headerBreakLine && _ref2, '500+ New Clips Each Month');
          }),
          middleContent: SectionHomeTop__jsx(Typography["b" /* H2 */], {
            style: { fontSize: headerFontSize }
          }, void 0, showFinally ? 'Finally. ' : null, 'One subscription. Unlimited stock footage downloads.'),
          bottomContent: SectionHomeTop__jsx('div', {
            style: {
              paddingLeft: '2rem',
              marginTop: statementTopMargin + 'rem'
            }
          }, void 0, SectionHomeTop__jsx(Button["a" /* default */], {
            border: false,
            arrow: true,
            onClick: onShowSignup,
            style: {
              fontSize: '2rem',
              letterSpacing: '2px',
              fontWeight: 600
            },
            lightColor: 'transparent'
          }, void 0, SectionHomeTop__jsx('span', {
            style: {
              position: 'relative',
              top: '0.2rem'
            }
          }, void 0, 'JOIN STORYTAPE')))
        }))), SectionHomeTop__jsx(Section["a" /* default */], {
          style: { position: 'relative', zIndex: 4 },
          angle: 17,
          bottomMargin: 0,
          backgroundColor: colors.dark
        }, void 0, tweens[1].x < 1 && SectionHomeTop__jsx('div', {
          style: _extends({}, constants["n" /* FULL_STYLE */], {
            transformOrigin: 'top right',
            transform: 'skewY(-17deg) scale(1.1)',
            top: '-1px',
            backgroundImage: 'linear-gradient(-90deg, transparent 0%,transparent ' + tweens[1].x * 100 + '%,' + Style["a" /* default */].Colors.white + ' ' + tweens[1].x * 100 + '%,' + Style["a" /* default */].Colors.white + ' 100%)'
          })
        }), SectionHomeTop__jsx('div', {
          style: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center'
          }
        }, void 0, SectionHomeTop__jsx('div', {
          style: {
            width: posterWidth + '%',
            flexBasis: posterWidth + '%',
            position: 'relative',
            opacity: tweens[2].x,
            top: tweens[2].x * -1 * posterMovementVw + posterMovementVw + 'vw'
          }
        }, void 0, SectionHomeTop__jsx('div', {
          style: {
            position: 'absolute',
            left: '-1.4vw',
            right: 0,
            bottom: posterBottom,
            height: posterHeight,
            boxShadow: '0 0 0 1.4vw ' + color_default()(Style["a" /* default */].Colors.black).alpha(0.75).string() + ', 1.4vw -1.4vw 0 1.4vw ' + color_default()(colors.highlight).alpha(0.75).string()
          }
        }, void 0, SectionHomeTop__jsx(ImageLoader["a" /* default */], {
          color: Object(Color["a" /* imageColors */])(posterClip.scene_colors).dark,
          lqip: posterClip.scene_lqip,
          images: [posterClip.scene_poster, posterClip.scene_thumbnail],
          imageStyle: {
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat'
          }
        }))), SectionHomeTop__jsx('div', {
          style: {
            width: 100 - posterWidth + '%',
            flexBasis: 100 - posterWidth + '%',
            color: Object(Color["c" /* textColor */])(colors.dark),
            padding: '0 2rem 0 7vw'
          }
        }, void 0, SectionHomeTop__jsx('div', {
          style: {
            maxWidth: '50rem',
            position: 'relative',
            top: posterWordOffset + 'rem'
          }
        }, void 0, SectionHomeTop__jsx(Typography["c" /* H3 */], {
          style: { marginBottom: '1.5rem' }
        }, void 0, 'Tell a story with complete\xA0scenes.'), SectionHomeTop__jsx(Typography["m" /* P1 */], {
          style: { maxWidth: '85%' }
        }, void 0, 'Instead of stand-alone clips, our footage is grouped together in scenes, to help you tell a\xA0story.')))), SectionHomeTop__jsx('div', {
          style: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            paddingTop: responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT ? '4rem' : '6rem'
          }
        }, void 0, responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT && SectionHomeTop__jsx('div', {
          style: { width: '50%', flexBasis: '50%' }
        }), SectionHomeTop__jsx('div', {
          style: {
            width: '50%',
            flexBasis: '50%',
            padding: '0 2rem 0 7vw',
            display: 'flex',
            position: 'relative',
            top: posterWordOffset + 'rem',
            justifyContent: responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT ? 'flex-start' : 'center'
          }
        }, void 0, SectionHomeTop__jsx(Link["a" /* default */], {
          to: '/browse'
        }, void 0, SectionHomeTop__jsx(Button["a" /* default */], {
          arrow: true,
          baseColor: colors.dark
        }, void 0, 'Start\xA0Browsing'))))));
      });
    }
  }]);

  return SectionHomeTop;
}(react_default.a.PureComponent);

SectionHomeTop_SectionHomeTop.defaultProps = {};


function mapStateToProps(state, ownProps) {
  return {
    responsive: state.runtime.responsive,
    colors: state.ui.colors,
    layoutLoaded: state.runtime.layoutLoaded,
    marketingVanityAnimation: state.runtime.marketingVanityAnimation
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onShowSignup: function onShowSignup() {
      return dispatch(Object(user["h" /* showSignup */])());
    },
    setMarketingVanityAnimation: function setMarketingVanityAnimation() {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('marketingVanityAnimation', true));
    },
    getLibraryClipCount: function getLibraryClipCount() {
      return dispatch(Object(search["i" /* getLibraryClipCount */])());
    }
  };
}

/* harmony default export */ var components_SectionHomeTop_SectionHomeTop = (Object(es["connect"])(mapStateToProps, mapDispatchToProps)(SectionHomeTop_SectionHomeTop));
// EXTERNAL MODULE: ./src/components/SubscriptionPlans/SubscriptionPlans.js
var SubscriptionPlans = __webpack_require__(1076);

// EXTERNAL MODULE: ./src/assets/4k-1920.mp4
var _k_1920 = __webpack_require__(1209);
var _k_1920_default = /*#__PURE__*/__webpack_require__.n(_k_1920);

// EXTERNAL MODULE: ./src/assets/4k-1280.mp4
var _k_1280 = __webpack_require__(1210);
var _k_1280_default = /*#__PURE__*/__webpack_require__.n(_k_1280);

// EXTERNAL MODULE: ./src/assets/4k-640.mp4
var _k_640 = __webpack_require__(1211);
var _k_640_default = /*#__PURE__*/__webpack_require__.n(_k_640);

// EXTERNAL MODULE: ./src/assets/4k.jpg
var _k = __webpack_require__(1212);
var _k_default = /*#__PURE__*/__webpack_require__.n(_k);

// EXTERNAL MODULE: ./src/assets/testimonials.json
var testimonials = __webpack_require__(1278);
var testimonials_default = /*#__PURE__*/__webpack_require__.n(testimonials);

// EXTERNAL MODULE: ./src/assets/homepage_scenes.json
var homepage_scenes = __webpack_require__(1284);
var homepage_scenes_default = /*#__PURE__*/__webpack_require__.n(homepage_scenes);

// CONCATENATED MODULE: ./src/routes/home/Home.js
var Home__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Home__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Home__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Home__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Home__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







































var Home__ref = Home__jsx('br', {});

var Home__ref2 = Home__jsx('br', {});

var _ref3 = Home__jsx(Typography["b" /* H2 */], {}, void 0, '500+ New Clips Every\xA0Month.');

var _ref4 = Home__jsx(Typography["c" /* H3 */], {}, void 0, 'Join our community on\xA0Instagram');

var _ref5 = Home__jsx(components_NewsletterForm_NewsletterForm, {});

var _ref6 = Home__jsx(Section["a" /* default */], {}, void 0, Home__jsx(PricingStrip["a" /* default */], {}));

var Home_Home = function (_React$PureComponent) {
  Home__inherits(Home, _React$PureComponent);

  function Home(props) {
    Home__classCallCheck(this, Home);

    var _this = Home__possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));

    _this.state = {
      testimonial: sample_default()(testimonials_default.a),
      posterClip: undefined,
      colors: {}
    };
    return _this;
  }

  Home__createClass(Home, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.props.getLatestScenes().then(function (scenes) {
        var clip = sample_default()(sample_default()(scenes));
        var colors = Object(Color["d" /* themeColors */])(clip.scene_colors);
        _this2.setState({
          posterClip: clip,
          colors: colors
        });
        _this2.props.updateColors(colors);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _style;

      var corporateMaxWidth = 30;

      var fourKWidth = '177.7777778%';
      var fourKPadding = 2.5;

      var newClipsPadding = '7rem ' + fourKPadding + 'rem 15rem';
      var instagramOpacity = 0.2;
      var instagramWidth = 100;
      var instagramOffsetX = 15;
      var instagramOffsetY = 3;

      var testimonialWidth = 90;

      var fourKVideo = _k_640_default.a;

      if (this.props.responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE) {
        fourKWidth = '100%';
        fourKPadding = 5;
        newClipsPadding = '7rem ' + fourKPadding + 'rem 15rem';
        testimonialWidth = 80;
      }
      if (this.props.responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT) {
        fourKVideo = _k_1280_default.a;
        corporateMaxWidth = 50;
        testimonialWidth = 60;
      }
      if (this.props.responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE) {
        fourKVideo = _k_1920_default.a;
        newClipsPadding = '12rem 12rem 19rem';
        instagramOpacity = 1;
        instagramWidth = 50;
        instagramOffsetX = 10;
        instagramOffsetY = 5;
        testimonialWidth = 50;
      }

      return Home__jsx('div', {}, void 0, Home__jsx('div', {}, void 0, Home__jsx(components_SectionHomeTop_SectionHomeTop, {
        posterClip: this.state.posterClip
      })), this.props.marketingVanityAnimation && Home__jsx('div', {}, void 0, Home__jsx(Section["a" /* default */], {
        topAngle: 17,
        backgroundColor: Style["a" /* default */].Colors.white,
        style: { position: 'relative', zIndex: 3 }
      }, void 0, Home__jsx(Typography["d" /* H4 */], {
        style: {
          padding: 'calc(14rem - 10vw) 0 14rem',
          maxWidth: corporateMaxWidth + 'rem',
          margin: 'auto',
          textAlign: 'center'
        }
      }, void 0, 'No more lifeless, corporate stock. Storytape is radically\xA0different.')), Home__jsx(Section["a" /* default */], {
        style: {
          position: 'relative',
          lineHeight: 0,
          backgroundColor: Style["a" /* default */].Colors.black
        }
      }, void 0, Home__jsx(Video["a" /* default */], {
        src: fourKVideo,
        poster: _k_default.a,
        style: { minWidth: '100%', width: fourKWidth }
      }), Home__jsx('div', {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          textAlign: 'right',
          color: Style["a" /* default */].Colors.white,
          paddingRight: fourKPadding + 'rem'
        }
      }, void 0, Home__jsx(Typography["a" /* H1 */], {
        style: { lineHeight: '0.9em' }
      }, void 0, 'Storytape', Home__ref, 'is beautifully', Home__ref2, 'cinematic 4K.'))), Home__jsx(Section["a" /* default */], {
        backgroundColor: 'rgba(137,130,121,0.42)',
        contentStyle: { padding: newClipsPadding }
      }, void 0, Home__jsx('div', {}, void 0, _ref3, Home__jsx(Typography["f" /* H6 */], {
        style: {
          color: '#53503C',
          maxWidth: '45rem',
          marginTop: '2.4rem'
        }
      }, void 0, 'All shot in incredible, ultra-high definition 4K. Available in a variety of different\xA0formats.'), Home__jsx(Link["a" /* default */], {
        to: '/how-it-works'
      }, void 0, Home__jsx(Button["a" /* default */], {
        style: { marginTop: '4.1rem' },
        arrow: true
      }, void 0, 'See how it works')))), Home__jsx(Section["a" /* default */], {
        style: { position: 'relative', zIndex: 2 },
        angle: 14,
        backgroundColor: Style["a" /* default */].Colors.white,
        contentStyle: { padding: '6rem 3rem', textAlign: 'center' }
      }, void 0, Home__jsx(Typography["c" /* H3 */], {
        style: { maxWidth: '16em', margin: 'auto' }
      }, void 0, 'Storytape is\xA0remarkably affordable. Less than the cost of 1 clip on the big\xA0sites.'), Home__jsx(Typography["m" /* P1 */], {
        style: {
          paddingTop: '1.5rem',
          maxWidth: '31em',
          margin: 'auto'
        }
      }, void 0, 'While others charge you $200 - $500 for a single clip, we\xA0give\xA0you\xA0unlimited access to our entire 4K library for one low price.'), Home__jsx('div', {
        style: { margin: '6rem auto 2rem' }
      }, void 0, Home__jsx('span', {
        style: {
          display: 'inline-block',
          minWidth: '12rem',
          textAlign: 'left'
        }
      }, void 0, 'Paying ', this.props.plan.annual ? 'Annually' : 'Monthly'), ' ', Home__jsx(Toggle["a" /* default */], {
        checked: this.props.plan.annual,
        onToggle: this.props.onSetAnnual,
        style: { display: 'inline-block' }
      })), Home__jsx('div', {
        style: (_style = {
          maxWidth: '110rem'
        }, _defineProperty(_style, 'maxWidth', '75rem'), _defineProperty(_style, 'margin', 'auto'), _style)
      }, void 0, Home__jsx(SubscriptionPlans["a" /* default */], {
        plan: this.props.plan,
        onSelectPlan: this.props.onSelectPlan,
        bannerColor: this.state.colors.highlight
      }))), Home__jsx(Section["a" /* default */], {
        topAngle: 14,
        style: { position: 'relative', zIndex: 1 },
        backgroundColor: Style["a" /* default */].Colors.shadow2
      }, void 0, Home__jsx('div', {}, void 0, Home__jsx('div', {
        style: {
          position: 'relative',
          zIndex: 1,
          padding: newClipsPadding,
          width: instagramWidth + '%',
          color: Style["a" /* default */].Colors.white
        }
      }, void 0, Home__jsx('div', {
        style: { maxWidth: '40rem' }
      }, void 0, _ref4, Home__jsx(Typography["m" /* P1 */], {
        style: { marginTop: '1.5rem' }
      }, void 0, 'Get a behind the scenes look at where we\u2019re shooting, and find out when we\u2019re on location near\xA0you!'), Home__jsx(Link["a" /* default */], {
        to: 'https://www.instagram.com/storytape/'
      }, void 0, Home__jsx(Button["a" /* default */], {
        style: { marginTop: '3.5rem' },
        arrow: true,
        baseColor: Style["a" /* default */].Colors.shadow2
      }, void 0, 'Open in Instagram')))), Home__jsx('div', {
        style: {
          position: 'absolute',
          zIndex: 0,
          opacity: instagramOpacity,
          right: '-' + instagramOffsetX + '%',
          bottom: '-' + instagramOffsetY + '%',
          width: instagramWidth + instagramOffsetX + '%',
          minWidth: '45rem'
        }
      }, void 0, Home__jsx(InstagramGrid["a" /* default */], {
        overlayColor: color_default()(Style["a" /* default */].Colors.shadow2).alpha(0.8).string()
      })))), Home__jsx(Section["a" /* default */], {
        backgroundColor: Style["a" /* default */].Colors.white,
        style: {
          position: 'relative',
          zIndex: 2,
          textAlign: 'center'
        },
        contentStyle: { padding: '10rem 2rem 19vw' }
      }, void 0, Home__jsx(Typography["d" /* H4 */], {
        style: { maxWidth: '56rem', margin: 'auto' }
      }, void 0, 'Not on social? Want the latest happenings delivered right to your\xA0inbox?'), _ref5), Home__jsx(Section["a" /* default */], {
        style: {
          position: 'relative',
          zIndex: 3
        },
        topAngle: 14,
        backgroundColor: this.state.colors.light
      }, void 0, Home__jsx('div', {
        style: { display: 'flex', paddingBottom: '10vw' }
      }, void 0, Home__jsx('div', {
        style: {
          flex: '1 1 ' + (100 - testimonialWidth) + '%',
          width: 100 - testimonialWidth + '%',
          backgroundColor: this.state.colors.dark,
          transformOrigin: '100% 100%',
          transform: 'skewY(14deg)'
        }
      }), Home__jsx('div', {
        style: {
          flex: '1 1 ' + testimonialWidth + '%',
          width: testimonialWidth + '%',
          padding: '5.5vw 7% 6vw 4rem'
        }
      }, void 0, Home__jsx('div', {
        style: { maxWidth: '50rem' }
      }, void 0, Home__jsx(Typography["c" /* H3 */], {}, void 0, '\u201C' + this.state.testimonial.hook), Home__jsx(Typography["m" /* P1 */], {
        style: { margin: '1.4rem 0' }
      }, void 0, this.state.testimonial.more + '\u201D'), Home__jsx(Typography["g" /* L1 */], {
        style: { margin: '2rem 0' }
      }, void 0, '\u2014 ' + this.state.testimonial.author))))), _ref6));
    }
  }]);

  return Home;
}(react_default.a.PureComponent);

Home_Home.defaultProps = {};


function Home_mapStateToProps(state, ownProps) {
  return {
    responsive: state.runtime.responsive,
    plan: state.plan.chosenPlan,
    layoutLoading: state.runtime.layoutLoading,
    layoutLoaded: state.runtime.layoutLoaded,
    marketingVanityAnimation: state.runtime.marketingVanityAnimation
  };
}

function Home_mapDispatchToProps(dispatch) {
  return {
    onSelectPlan: function onSelectPlan(planName) {
      return dispatch(Object(plan["f" /* setChosenPlan */])({ name: planName })).then(function () {
        return setTimeout(dispatch, 500, Object(user["h" /* showSignup */])());
      });
    },
    onSetAnnual: function onSetAnnual(annual) {
      return dispatch(Object(plan["f" /* setChosenPlan */])({ annual: annual }));
    },
    updateColors: function updateColors(colors) {
      return dispatch(Object(ui["b" /* setColors */])(colors));
    },
    onShowSignup: function onShowSignup() {
      return dispatch(Object(user["h" /* showSignup */])());
    },
    getLatestScenes: function getLatestScenes() {
      return dispatch(Object(search["h" /* getLatestScenes */])());
    }
  };
}

/* harmony default export */ var home_Home = (Object(lib_react["b" /* compose */])(Object(Footer["a" /* withFooterDrawer */])(), Object(es["connect"])(Home_mapStateToProps, Home_mapDispatchToProps))(Home_Home));
// CONCATENATED MODULE: ./src/routes/home/index.js
var home__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var action = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(context) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([context.store.dispatch(Object(search["h" /* getLatestScenes */])()), context.store.dispatch(Object(search["i" /* getLibraryClipCount */])())]);

          case 2:
            return _context.abrupt('return', {
              chunks: ['marketing'],
              title: 'Storytape - One subscription. Unlimited 4K stock footage video clips.',
              description: 'Storytape is an unlimited stock footage platform. Each month we add more than 500+ new 4K video clips. Browse the full cinematic library for free.',
              component: home__ref2
            });

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var home__ref2 = home__jsx(Layout["a" /* default */], {
  transitionId: 'home',
  showHeader: true,
  headerNavLinks: constants["u" /* MARKETING_NAV_LINKS */]
}, void 0, home__jsx(home_Home, {}));

/* harmony default export */ var home = __webpack_exports__["default"] = (action);

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(19);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/sample.js
var sample = __webpack_require__(361);
var sample_default = /*#__PURE__*/__webpack_require__.n(sample);

// EXTERNAL MODULE: ./src/actions/search.js + 1 modules
var search = __webpack_require__(915);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(17);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 1 modules
var Layout = __webpack_require__(1161);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(33);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(220);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(138);
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(225);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);

// EXTERNAL MODULE: ./node_modules/lodash/sampleSize.js
var sampleSize = __webpack_require__(1213);
var sampleSize_default = /*#__PURE__*/__webpack_require__.n(sampleSize);

// EXTERNAL MODULE: ./node_modules/lodash/values.js
var values = __webpack_require__(83);
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/color/index.js
var color = __webpack_require__(351);
var color_default = /*#__PURE__*/__webpack_require__.n(color);

// EXTERNAL MODULE: ./src/lib/Color.js
var Color = __webpack_require__(899);

// EXTERNAL MODULE: ./src/lib/react.js
var lib_react = __webpack_require__(221);

// EXTERNAL MODULE: ./src/actions/runtime.js
var runtime = __webpack_require__(354);

// EXTERNAL MODULE: ./src/actions/user.js
var user = __webpack_require__(222);

// EXTERNAL MODULE: ./src/components/Footer/Footer.js
var Footer = __webpack_require__(1077);

// EXTERNAL MODULE: ./src/components/Aspect/Aspect.js
var Aspect = __webpack_require__(1071);

// EXTERNAL MODULE: ./src/components/Button/Button.js
var Button = __webpack_require__(889);

// EXTERNAL MODULE: ./src/components/Header/Header.js + 4 modules
var Header = __webpack_require__(1073);

// EXTERNAL MODULE: ./src/components/Section/Section.js
var Section = __webpack_require__(933);

// EXTERNAL MODULE: ./src/components/Icons/Icons.js
var Icons = __webpack_require__(888);

// EXTERNAL MODULE: ./src/components/Link/Link.js
var Link = __webpack_require__(890);

// EXTERNAL MODULE: ./src/components/HeadlineAnimator/HeadlineAnimator.js
var HeadlineAnimator = __webpack_require__(1277);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(1075);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/lodash/filter.js
var filter = __webpack_require__(1285);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);

// EXTERNAL MODULE: ./node_modules/lodash/shuffle.js
var shuffle = __webpack_require__(1208);
var shuffle_default = /*#__PURE__*/__webpack_require__.n(shuffle);

// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(142);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(1216);
var times_default = /*#__PURE__*/__webpack_require__.n(times);

// EXTERNAL MODULE: ./node_modules/react-motion/lib/react-motion.js
var react_motion = __webpack_require__(353);
var react_motion_default = /*#__PURE__*/__webpack_require__.n(react_motion);

// EXTERNAL MODULE: ./src/lib/Motion.js
var Motion = __webpack_require__(352);

// EXTERNAL MODULE: ./src/components/ImageLoader/ImageLoader.js
var ImageLoader = __webpack_require__(1162);

// EXTERNAL MODULE: ./src/components/Style/Style.js
var Style = __webpack_require__(350);

// CONCATENATED MODULE: ./src/components/HowItWorksGrid/HowItWorksGrid.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var cellSizeMultiplyer = 0.5;
var cellWidth = 25 * cellSizeMultiplyer;
var cellHeight = 14 * cellSizeMultiplyer;
var cellMargin = 0.2 * cellSizeMultiplyer;
var cellsOverflow = 3;
var scale = 2;

var HowItWorksGrid_HowItWorksGrid = function (_React$PureComponent) {
  _inherits(HowItWorksGrid, _React$PureComponent);

  function HowItWorksGrid(props) {
    _classCallCheck(this, HowItWorksGrid);

    var _this = _possibleConstructorReturn(this, (HowItWorksGrid.__proto__ || Object.getPrototypeOf(HowItWorksGrid)).call(this, props));

    _this.loadClips = function () {
      return _this.props.getClips().then(function (clips) {
        return _this.setState({
          clips: shuffle_default()(clips)
        });
      });
    };

    _this.state = {
      rowCount: 8,
      clips: constants["k" /* EMPTY_ARRAY */]
    };

    _this.loadClips();
    return _this;
  }

  _createClass(HowItWorksGrid, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var columnCount = Math.ceil(this.props.responsive / (cellWidth * 10)) + cellsOverflow * 2;
      var available = this.state.clips.length;

      return _jsx('div', {
        style: {
          perspective: '260rem',
          transformStyle: 'preserve-3d'
        }
      }, void 0, _jsx('div', {
        style: {
          transform: 'rotateX(68deg) rotateY(4deg) rotateZ(15deg) scale(' + scale + ') translateX(-' + cellsOverflow * cellWidth / (scale * 2) + 'rem)',
          transformOrigin: 'center center',
          width: columnCount * (cellMargin + cellWidth) + 'rem'
        }
      }, void 0, times_default()(this.state.rowCount, function (rowIndex) {
        return _jsx('div', {
          style: {
            display: 'flex',
            width: columnCount * (cellMargin + cellWidth) + 'rem'
          }
        }, 'row ' + rowIndex, times_default()(columnCount, function (columnIndex) {
          var clip = constants["l" /* EMPTY_OBJECT */];
          var opacity = Math.random() * 0.4 + 0.3;
          if (available > 0) {
            var index = (rowIndex * columnCount + columnIndex) % available;
            clip = _this2.state.clips[index];
            // opacity = 1;
          }

          return _jsx('div', {
            style: {
              transform: 'translate3d(0,0,0)',
              position: 'relative',
              flex: '0 0 ' + cellWidth + 'rem',
              width: cellWidth + 'rem',
              height: cellHeight + 'rem',
              margin: cellMargin + 'rem',
              boxShadow: '1.8rem 9rem 1rem 0 ' + color_default()('#283036').alpha(0.2)
            }
          }, 'row ' + rowIndex + ' column ' + columnIndex, _jsx(ImageLoader["a" /* default */], {
            color: color_default()(Object(Color["a" /* imageColors */])(clip.clip_colors || constants["l" /* EMPTY_OBJECT */]).dark).alpha(opacity),
            lqip: clip.clip_lqip,
            images: [clip.clip_thumbnail]
          }));
        }));
      })));
    }
  }]);

  return HowItWorksGrid;
}(react_default.a.PureComponent);

HowItWorksGrid_HowItWorksGrid.defaultProps = {};


function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClips: function getClips() {
      return dispatch(Object(search["j" /* search */])(Object(search["b" /* buildSearchParams */])('', [900]))).then(function (results) {
        return results.clips;
      });
    }
  };
}

/* harmony default export */ var components_HowItWorksGrid_HowItWorksGrid = (Object(es["connect"])(mapStateToProps, mapDispatchToProps)(HowItWorksGrid_HowItWorksGrid));
// EXTERNAL MODULE: ./src/components/SceneCard/SceneCard.js
var SceneCard = __webpack_require__(1226);

// EXTERNAL MODULE: ./src/components/PricingStrip/PricingStrip.js
var PricingStrip = __webpack_require__(1195);

// EXTERNAL MODULE: ./src/components/Video/Video.js
var Video = __webpack_require__(934);

// EXTERNAL MODULE: ./src/components/Typography/Typography.js
var Typography = __webpack_require__(887);

// EXTERNAL MODULE: ./src/assets/graded-ungraded-1920.mp4
var graded_ungraded_1920 = __webpack_require__(1287);
var graded_ungraded_1920_default = /*#__PURE__*/__webpack_require__.n(graded_ungraded_1920);

// EXTERNAL MODULE: ./src/assets/graded-ungraded-1280.mp4
var graded_ungraded_1280 = __webpack_require__(1288);
var graded_ungraded_1280_default = /*#__PURE__*/__webpack_require__.n(graded_ungraded_1280);

// EXTERNAL MODULE: ./src/assets/graded-ungraded-640.mp4
var graded_ungraded_640 = __webpack_require__(1289);
var graded_ungraded_640_default = /*#__PURE__*/__webpack_require__.n(graded_ungraded_640);

// EXTERNAL MODULE: ./src/assets/graded-ungraded-poster.jpg
var graded_ungraded_poster = __webpack_require__(1290);
var graded_ungraded_poster_default = /*#__PURE__*/__webpack_require__.n(graded_ungraded_poster);

// CONCATENATED MODULE: ./src/routes/howItWorks/HowItWorks.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var HowItWorks__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HowItWorks__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function HowItWorks__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HowItWorks__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HowItWorks__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




































var HowItWorks__ref = HowItWorks__jsx(Typography["b" /* H2 */], {}, void 0, 'Cinematic 4K stock footage. Unlimited access. One low\xA0price.', HowItWorks__jsx('br', {}), HowItWorks__jsx('br', {}), 'Seriously.');

var _ref2 = HowItWorks__jsx(components_HowItWorksGrid_HowItWorksGrid, {});

var _ref3 = HowItWorks__jsx(Button["a" /* default */], {
  arrow: true
}, void 0, 'Start Browsing');

var _ref4 = HowItWorks__jsx(Typography["b" /* H2 */], {}, void 0, 'Incredible footage.', HowItWorks__jsx('br', {}), '1080p + 4K ProRes');

var _ref5 = HowItWorks__jsx(Typography["d" /* H4 */], {}, void 0, 'Graded & Ungraded');

var _ref6 = HowItWorks__jsx('div', {}, void 0, HowItWorks__jsx(Typography["d" /* H4 */], {}, void 0, 'Graded & Ungraded?'));

var _ref7 = HowItWorks__jsx(Typography["m" /* P1 */], {}, void 0, 'When you download a clip that is \u201Cungraded,\u201D it simply means we provide it without any adjustment. You\u2019re getting the file directly \u201Cas-is\u201D out of the camera. No coloring, stabilization, noise reduction, etc. has been added.');

var _ref8 = HowItWorks__jsx(Icons["l" /* Details */], {});

var _ref9 = HowItWorks__jsx(Icons["E" /* Refresh */], {});

var _ref10 = HowItWorks__jsx(Icons["t" /* Grid */], {});

var _ref11 = HowItWorks__jsx(Section["a" /* default */], {}, void 0, HowItWorks__jsx(PricingStrip["a" /* default */], {}));

var HowItWorks_HowItWorks = function (_React$PureComponent) {
  HowItWorks__inherits(HowItWorks, _React$PureComponent);

  function HowItWorks(props) {
    HowItWorks__classCallCheck(this, HowItWorks);

    var _this = HowItWorks__possibleConstructorReturn(this, (HowItWorks.__proto__ || Object.getPrototypeOf(HowItWorks)).call(this, props));

    _this.state = {
      tvScene: undefined,
      cardScene: undefined
    };
    return _this;
  }

  HowItWorks__createClass(HowItWorks, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.props.getLatestScenes().then(function (scenes) {
        var choices = sampleSize_default()(scenes, 2);
        _this2.setState({ tvScene: sample_default()(choices[0]), cardScene: choices[1] });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          responsive = _props.responsive,
          allClips = _props.allClips,
          showSignup = _props.showSignup,
          otherProps = _objectWithoutProperties(_props, ['responsive', 'allClips', 'showSignup']);

      var forTheTapeBottomMargin = 1.6;
      var gridPadding = '';
      var gradedUngradedWidth = '177.7777778%';
      var tvWidth = '95%';
      var gradedUngradedVideo = graded_ungraded_640_default.a;
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE) {
        gradedUngradedWidth = '100%';
      }
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT) {
        gridPadding = '5rem';
        tvWidth = '85%';
        gradedUngradedVideo = graded_ungraded_1280_default.a;
      }
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE) {
        tvWidth = '75%';
        gradedUngradedVideo = graded_ungraded_1920_default.a;
      }
      if (responsive >= constants["C" /* RESPONSIVE_SIZE */].DESKTOP) {
        forTheTapeBottomMargin = 2.5;
        gridPadding = '10rem';
      }

      return HowItWorks__jsx('div', {}, void 0, HowItWorks__jsx(Section["a" /* default */], {
        backgroundColor: '#F1F1CD',
        bottomAngle: 14
      }, void 0, HowItWorks__jsx('div', {
        style: {
          maxWidth: '75rem',
          margin: 'auto',
          padding: 'calc(14rem + 8vw) 2rem 2rem',
          textAlign: 'center',
          transform: 'translate3d(0,0,0)',
          transformStyle: 'preserve-3d',
          position: 'relative'
        }
      }, void 0, HowItWorks__jsx(HeadlineAnimator["a" /* default */], {
        show: this.props.layoutLoaded,
        onDone: this.props.setMarketingVanityAnimation,
        topContent: HowItWorks__jsx(Typography["g" /* L1 */], {
          style: {
            display: 'block',
            marginBottom: forTheTapeBottomMargin + 'rem',
            color: '#5E5E4E',
            opacity: 0.65
          }
        }, void 0, 'WE DO IT FOR THE TAPE'),
        middleContent: HowItWorks__ref
      })), HowItWorks__jsx('div', {
        style: { margin: '7vw 0 calc(5rem + -7vw)' }
      }, void 0, _ref2)), HowItWorks__jsx(Section["a" /* default */], {
        topAngle: 14,
        backgroundColor: '#E3E6E8'
      }, void 0, HowItWorks__jsx('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }
      }, void 0, HowItWorks__jsx(Typography["c" /* H3 */], {
        style: {
          padding: '5rem 0 0',
          margin: 'auto',
          maxWidth: '9em',
          textAlign: 'center',
          color: Style["a" /* default */].Colors.shadow2
        }
      }, void 0, 'Be the director. Craft\xA0your own story.'), HowItWorks__jsx(Typography["m" /* P1 */], {
        style: {
          margin: '1.5rem auto 3.5rem',
          maxWidth: '20em',
          textAlign: 'center'
        }
      }, void 0, 'No more sorting through piles of unusable stock footage. Choose the right angle from intelligently grouped scenes to tell the perfect story.'), HowItWorks__jsx(Link["a" /* default */], {
        to: '/browse',
        style: { margin: 'auto' }
      }, void 0, _ref3)), HowItWorks__jsx('div', {
        style: { padding: '6vw 2rem 10vw' }
      }, void 0, HowItWorks__jsx('div', {
        style: {
          maxWidth: '64rem',
          margin: 'auto',
          boxShadow: '0 0.2rem 7.6rem 0 ' + color_default()(Style["a" /* default */].Colors.shadow2).alpha(0.5),
          borderRadius: '1rem'
        }
      }, void 0, HowItWorks__jsx(Link["a" /* default */], {
        to: this.state.cardScene ? '/browse/scene/' + get_default()(this.state.cardScene, '[0].scene_slug') : undefined
      }, void 0, HowItWorks__jsx(SceneCard["a" /* default */], {
        title: get_default()(this.state.cardScene, '[0].scene_name', ''),
        typeName: 'Scene',
        backgroundColor: Object(Color["a" /* imageColors */])(get_default()(this.state.cardScene, '[0].scene_colors', constants["l" /* EMPTY_OBJECT */])).dark,
        lqip: get_default()(this.state.cardScene, '[0].scene_lqip'),
        images: [get_default()(this.state.cardScene, '[0].scene_thumbnail')],
        highlightColor: Object(Color["d" /* themeColors */])(get_default()(this.state.cardScene, '[0].scene_colors', constants["l" /* EMPTY_OBJECT */])).highlight,
        allClips: this.state.cardScene ? this.state.cardScene : [constants["l" /* EMPTY_OBJECT */]]
      }))))), HowItWorks__jsx(Section["a" /* default */], {
        backgroundColor: Style["a" /* default */].Colors.black,
        style: { position: 'relative', lineHeight: 0 },
        contentStyle: { overflow: 'hidden' }
      }, void 0, HowItWorks__jsx(Video["a" /* default */], {
        src: gradedUngradedVideo,
        poster: graded_ungraded_poster_default.a,
        style: {
          minWidth: '100%',
          width: gradedUngradedWidth,
          position: 'relative',
          left: 'calc((' + gradedUngradedWidth + ' - 100%) / -2)'
        }
      }), HowItWorks__jsx('div', {
        style: _extends({}, constants["n" /* FULL_STYLE */], {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          justifyContent: 'center',
          textAlign: 'right',
          color: Style["a" /* default */].Colors.white,
          padding: '5rem'
        })
      }, void 0, _ref4, _ref5), HowItWorks__jsx('div', {
        style: _extends({}, constants["n" /* FULL_STYLE */], {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
          color: color_default()(Style["a" /* default */].Colors.white).alpha(0.8).string()
        })
      }, void 0, HowItWorks__jsx(Typography["h" /* L2 */], {
        style: {
          margin: '3vw',
          width: '45%',
          flexBasis: '45%',
          textAlign: 'right'
        }
      }, void 0, 'GRADED'), HowItWorks__jsx('div', {
        style: { height: '100%', width: 0, border: '1px solid white' }
      }), HowItWorks__jsx(Typography["h" /* L2 */], {
        style: { margin: '3vw', width: '45%', flexBasis: '45%' }
      }, void 0, 'UNGRADED'))), HowItWorks__jsx(Section["a" /* default */], {
        backgroundColor: Style["a" /* default */].Colors.black,
        bottomAngle: 14
      }, void 0, HowItWorks__jsx('div', {
        style: {
          color: Style["a" /* default */].Colors.white,
          position: 'relative',
          top: 'calc(2rem + 7vw)',
          left: 'calc(2rem + 8.5vw)',
          paddingRight: 'calc((2rem + 8.5vw) * 2)',
          paddingBottom: '8rem'
        }
      }, void 0, HowItWorks__jsx('div', {
        style: { display: 'flex', alignItems: 'center' }
      }, void 0, HowItWorks__jsx('div', {
        style: {
          width: 'calc(6vw + 5rem)',
          flex: '0 0 calc(6vw + 5rem)'
        }
      }, void 0, HowItWorks__jsx(Icons["b" /* Brandmark */], {
        color: Style["a" /* default */].Colors.white
      })), _ref6), HowItWorks__jsx('div', {
        style: { display: 'flex' }
      }, void 0, HowItWorks__jsx('div', {
        style: {
          width: 'calc(6vw + 5rem)',
          flex: '0 0 calc(6vw + 5rem)'
        }
      }, void 0, '\xA0'), HowItWorks__jsx('div', {
        style: { maxWidth: '57rem' }
      }, void 0, _ref7)))), HowItWorks__jsx(Section["a" /* default */], {
        backgroundColor: '#E2EFF3',
        topAngle: 14
      }, void 0, HowItWorks__jsx(Typography["b" /* H2 */], {
        style: {
          padding: '5rem 0 0',
          margin: '2rem auto 5rem',
          maxWidth: '10em',
          textAlign: 'center'
        }
      }, void 0, 'Everything you like, Nothing you don\u2019t.'), HowItWorks__jsx('div', {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          paddingLeft: gridPadding,
          paddingBottom: '10rem'
        }
      }, void 0, HowItWorks__jsx('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          margin: '0 6rem'
        }
      }, void 0, HowItWorks__jsx('div', {
        style: { margin: '3rem 0 3rem' }
      }, void 0, _ref8, HowItWorks__jsx(Typography["c" /* H3 */], {
        style: {
          margin: '2rem 0 1.5rem',
          color: Style["a" /* default */].Colors.shadow1
        }
      }, void 0, 'Licensing, simplified'), HowItWorks__jsx(Typography["m" /* P1 */], {
        style: { margin: '1.5rem 0 2.5rem', maxWidth: '38rem' }
      }, void 0, 'Get any clip at any resolution with just a couple clicks. Re-license it as many times as you need.'), [{ res: '4K', name: 'ProRes Graded' }, {
        res: '4K',
        name: 'ProRes Ungraded',
        overlayColor: color_default()('#a7a7a766')
      }, { res: '1080p', name: 'Graded' }].map(function (entry) {
        return HowItWorks__jsx('div', {
          style: { display: 'flex', alignItems: 'center' }
        }, entry.name, HowItWorks__jsx('div', {
          style: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: '15.7rem',
            minHeight: '8.7rem',
            margin: '0.6rem 0',
            backgroundColor: Style["a" /* default */].Colors.shadow5,
            backgroundImage: 'url(' + get_default()(_this3.state.cardScene, '[0].scene_thumbnail') + ')',
            backgroundSize: 'cover',
            border: '0.3rem solid ' + Style["a" /* default */].Colors.black,
            borderRadius: '0.6rem'
          }
        }, void 0, HowItWorks__jsx(Typography["c" /* H3 */], {
          style: {
            position: 'relative',
            zIndex: 1,
            color: Style["a" /* default */].Colors.white
          }
        }, void 0, entry.res), entry.overlayColor && HowItWorks__jsx('div', {
          style: _extends({}, constants["n" /* FULL_STYLE */], {
            zIndex: 0,
            backgroundColor: entry.overlayColor
          })
        })), HowItWorks__jsx(Typography["f" /* H6 */], {
          style: { marginLeft: '2rem' }
        }, void 0, entry.name));
      }))), HowItWorks__jsx('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          margin: '0 6rem'
        }
      }, void 0, HowItWorks__jsx('div', {
        style: { margin: '3rem 0 3rem' }
      }, void 0, _ref9, HowItWorks__jsx(Typography["c" /* H3 */], {
        style: {
          margin: '2rem 0 1.5rem',
          color: Style["a" /* default */].Colors.shadow1
        }
      }, void 0, 'Access anytime, anywhere'), HowItWorks__jsx(Typography["m" /* P1 */], {
        style: { margin: '1.5rem 0 2.5rem', maxWidth: '38rem' }
      }, void 0, 'Browse and license wherever you are. Re-download any clip any time you need it.'), HowItWorks__jsx(Button["a" /* default */], {
        onClick: this.props.showSignup,
        size: 'large'
      }, void 0, 'Get Started')), HowItWorks__jsx('div', {
        style: { margin: '3rem 0 3rem' }
      }, void 0, _ref10, HowItWorks__jsx(Typography["c" /* H3 */], {
        style: {
          margin: '2rem 0 1.5rem',
          color: Style["a" /* default */].Colors.shadow1
        }
      }, void 0, 'Professionally curated'), HowItWorks__jsx(Typography["m" /* P1 */], {
        style: { margin: '1.5rem 0 2.5rem', maxWidth: '38rem' }
      }, void 0, 'From licensed drone operators to experienced videographers, our team of professionals delivers the highest level of quality in every scene.'))))), HowItWorks__jsx(Section["a" /* default */], {
        backgroundColor: Style["a" /* default */].Colors.white,
        bottomAngle: 14
      }, void 0, HowItWorks__jsx(Typography["a" /* H1 */], {
        style: {
          padding: '13rem 2rem 0',
          margin: '0 auto',
          maxWidth: '9em',
          textAlign: 'center',
          color: Style["a" /* default */].Colors.black
        }
      }, void 0, 'A never-ending supply of footage.')), HowItWorks__jsx(Section["a" /* default */], {}, void 0, HowItWorks__jsx('div', {
        style: {
          maxWidth: tvWidth,
          width: '100%',
          margin: '6rem auto 7rem'
        }
      }, void 0, HowItWorks__jsx(Aspect["a" /* default */], {
        ratio: 9 / 16
      }, void 0, HowItWorks__jsx('div', {
        style: _extends({}, constants["n" /* FULL_STYLE */], {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: Style["a" /* default */].Colors.black,
          backgroundImage: 'url(' + get_default()(this.state.tvScene, 'scene_poster') + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          border: '0.4vw solid ' + Style["a" /* default */].Colors.black,
          boxShadow: '0 1.6rem 5.6rem 0 ' + color_default()(Style["a" /* default */].Colors.shadow2).alpha(0.5)
        })
      }, void 0, HowItWorks__jsx(Typography["c" /* H3 */], {
        style: {
          margin: 'auto',
          maxWidth: '9em',
          textAlign: 'center',
          color: Style["a" /* default */].Colors.white
        }
      }, void 0, '500+ cinematic clips added every month.'))), HowItWorks__jsx('div', {
        style: {
          position: 'relative',
          margin: 'auto',
          width: '22%',
          height: '0.4vw',
          backgroundColor: Style["a" /* default */].Colors.black
        }
      }, void 0, '\xA0'))), this.state.tvScene && HowItWorks__jsx(Section["a" /* default */], {
        backgroundColor: Object(Color["d" /* themeColors */])(this.state.tvScene.scene_colors).light,
        topAngle: 14
      }, void 0, HowItWorks__jsx('div', {
        style: {
          padding: '0 0 17rem',
          display: 'flex',
          justifyContent: 'center'
        }
      }, void 0, HowItWorks__jsx(Link["a" /* default */], {
        to: '/browse'
      }, void 0, HowItWorks__jsx(Button["a" /* default */], {
        arrow: true,
        baseColor: Object(Color["d" /* themeColors */])(this.state.tvScene.scene_colors).light
      }, void 0, 'Browse new scenes')))), _ref11);
    }
  }]);

  return HowItWorks;
}(react_default.a.PureComponent);

HowItWorks_HowItWorks.defaultProps = {
  allClips: constants["l" /* EMPTY_OBJECT */]
};


function HowItWorks_mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
    allClips: values_default()(state.clips.clips),
    layoutLoaded: state.runtime.layoutLoaded
  };
}
function HowItWorks_mapDispatchToProps(dispatch) {
  return {
    showSignup: function showSignup() {
      return dispatch(Object(user["h" /* showSignup */])());
    },
    getLatestScenes: function getLatestScenes() {
      return dispatch(Object(search["h" /* getLatestScenes */])());
    },
    setMarketingVanityAnimation: function setMarketingVanityAnimation() {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('marketingVanityAnimation', true));
    }
  };
}

/* harmony default export */ var howItWorks_HowItWorks = (Object(lib_react["b" /* compose */])(Object(Footer["a" /* withFooterDrawer */])(), Object(es["connect"])(HowItWorks_mapStateToProps, HowItWorks_mapDispatchToProps))(HowItWorks_HowItWorks));
// CONCATENATED MODULE: ./src/routes/howItWorks/index.js
var howItWorks__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var action = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(context) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return context.store.dispatch(Object(search["h" /* getLatestScenes */])());

          case 2:
            return _context.abrupt('return', {
              chunks: ['marketing'],
              title: 'How It Works - Storytape',
              description: 'Instead of paying $200-$500 for a single clip, Storytape gives you access to thousands of cinematic 4K stock footage files on a single monthly subscription.',
              component: howItWorks__ref2
            });

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








var howItWorks__ref2 = howItWorks__jsx(Layout["a" /* default */], {
  transitionId: 'how-it-works',
  showHeader: true,
  headerNavLinks: constants["u" /* MARKETING_NAV_LINKS */]
}, void 0, howItWorks__jsx(howItWorks_HowItWorks, {}));

/* harmony default export */ var howItWorks = __webpack_exports__["default"] = (action);

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(19);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/actions/search.js + 1 modules
var search = __webpack_require__(915);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 1 modules
var Layout = __webpack_require__(1161);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(17);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(33);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(220);

// EXTERNAL MODULE: ./node_modules/react-cognito/dist/react-cognito.js
var react_cognito = __webpack_require__(55);
var react_cognito_default = /*#__PURE__*/__webpack_require__.n(react_cognito);

// EXTERNAL MODULE: ./node_modules/color/index.js
var color = __webpack_require__(351);
var color_default = /*#__PURE__*/__webpack_require__.n(color);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(1075);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(225);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);

// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(1216);
var times_default = /*#__PURE__*/__webpack_require__.n(times);

// EXTERNAL MODULE: ./node_modules/lodash/values.js
var values = __webpack_require__(83);
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./src/actions/user.js
var user = __webpack_require__(222);

// EXTERNAL MODULE: ./src/actions/plan.js
var plan = __webpack_require__(223);

// EXTERNAL MODULE: ./src/actions/runtime.js
var runtime = __webpack_require__(354);

// EXTERNAL MODULE: ./src/actions/ui.js
var ui = __webpack_require__(1153);

// EXTERNAL MODULE: ./src/lib/Color.js
var Color = __webpack_require__(899);

// EXTERNAL MODULE: ./src/lib/react.js
var lib_react = __webpack_require__(221);

// EXTERNAL MODULE: ./src/components/HeadlineAnimator/HeadlineAnimator.js
var HeadlineAnimator = __webpack_require__(1277);

// EXTERNAL MODULE: ./src/components/Header/Header.js + 4 modules
var Header = __webpack_require__(1073);

// EXTERNAL MODULE: ./src/components/Footer/Footer.js
var Footer = __webpack_require__(1077);

// EXTERNAL MODULE: ./src/components/Section/Section.js
var Section = __webpack_require__(933);

// EXTERNAL MODULE: ./src/components/Button/Button.js
var Button = __webpack_require__(889);

// EXTERNAL MODULE: ./src/components/Link/Link.js
var Link = __webpack_require__(890);

// EXTERNAL MODULE: ./src/components/Toggle/Toggle.js
var Toggle = __webpack_require__(935);

// EXTERNAL MODULE: ./src/components/InstagramGrid/InstagramGrid.js
var InstagramGrid = __webpack_require__(1225);

// EXTERNAL MODULE: ./src/components/PricingStrip/PricingStrip.js
var PricingStrip = __webpack_require__(1195);

// EXTERNAL MODULE: ./src/components/SceneCard/SceneCard.js
var SceneCard = __webpack_require__(1226);

// EXTERNAL MODULE: ./src/components/SubscriptionPlans/SubscriptionPlans.js
var SubscriptionPlans = __webpack_require__(1076);

// EXTERNAL MODULE: ./src/components/Style/Style.js
var Style = __webpack_require__(350);

// EXTERNAL MODULE: ./src/components/Typography/Typography.js
var Typography = __webpack_require__(887);

// CONCATENATED MODULE: ./src/routes/pricing/Pricing.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
































var Pricing__ref = _jsx('br', {});

var _ref2 = _jsx(Link["a" /* default */], {
  to: '#plans'
}, void 0, 'SEE PLANS');

var _ref3 = _jsx('br', {});

var _ref4 = _jsx(Typography["m" /* P1 */], {}, void 0, 'We travel the world, shooting thousands of 4K clips every month. Then we organize it by scene to make crafting the perfect\xA0story\xA0simple.');

var _ref5 = _jsx(Section["a" /* default */], {}, void 0, _jsx(PricingStrip["a" /* default */], {}));

var Pricing_Pricing = function (_React$PureComponent) {
  _inherits(Pricing, _React$PureComponent);

  function Pricing(props) {
    _classCallCheck(this, Pricing);

    var _this = _possibleConstructorReturn(this, (Pricing.__proto__ || Object.getPrototypeOf(Pricing)).call(this, props));

    _this.state = {
      baseColors: {
        dark: '#35211c',
        light: '#EFE1D4',
        highlight: '#AB5C47'
      },
      scenes: constants["k" /* EMPTY_ARRAY */]
    };

    props.updateColors(_this.state.baseColors);
    return _this;
  }

  _createClass(Pricing, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.getLatestScenes(8).then(function (scenes) {
        return _this2.setState({ scenes: scenes });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var headingPadding = '15rem 2rem 15rem';
      var seePlans = false;
      var justDoItWidth = 50;

      var sceneColumn = true;
      var sceneCardWidth = 250;
      var sceneCardMargin = 10;

      if (this.props.responsive >= constants["C" /* RESPONSIVE_SIZE */].PHONE) {
        seePlans = true;
      }
      if (this.props.responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_PORTRAIT) {
        headingPadding = '22rem 2rem 30rem';
        justDoItWidth = 55;
        sceneCardWidth = 450;
        sceneColumn = false;
      }
      if (this.props.responsive >= constants["C" /* RESPONSIVE_SIZE */].TABLET_LANDSCAPE) {
        sceneCardWidth = 640;
      }
      if (this.props.responsive >= constants["C" /* RESPONSIVE_SIZE */].DESKTOP) {}

      var count = Math.max(Math.ceil(this.props.responsive / sceneCardWidth) + 1, 1);
      var bias = 100 / count;

      return _jsx('div', {}, void 0, _jsx(Section["a" /* default */], {
        backgroundColor: color_default()(this.props.colors.light).alpha(0.3).string(),
        contentStyle: { padding: headingPadding, textAlign: 'center' }
      }, void 0, _jsx(HeadlineAnimator["a" /* default */], {
        show: this.props.layoutLoaded,
        onDone: this.props.setMarketingVanityAnimation,
        topContent: _jsx(Typography["d" /* H4 */], {}, void 0, '$', Object(plan["d" /* getPlanPrice */])(constants["z" /* PLAN */].UNLIMITED, true), '/mo'),
        middleContent: _jsx('div', {}, void 0, _jsx(Typography["b" /* H2 */], {
          style: {
            margin: '2rem auto 0',
            maxWidth: '48rem',
            color: Style["a" /* default */].Colors.shadow1
          }
        }, void 0, 'Unlimited licenses.', Pricing__ref, 'Ridiculously affordable.'), _jsx(Typography["j" /* L3 */], {
          style: {
            display: 'block',
            margin: '1.5rem auto 0',
            color: Style["a" /* default */].Colors.shadow3
          }
        }, void 0, 'No Download Limit\xA0\xA0\u2022\xA0\xA01080p +\xA04K\xA0ProRes')),
        bottomContent: _jsx('div', {
          style: { margin: '2.5rem auto 0' }
        }, void 0, _jsx(Button["a" /* default */], {
          onClick: this.props.showSignup,
          size: 'large',
          style: { margin: '2rem 1rem' }
        }, void 0, 'Get Started'), seePlans && _jsx(Typography["g" /* L1 */], {
          style: { margin: '2rem 1rem', opacity: 0.75 }
        }, void 0, _ref2))
      })), _jsx(Section["a" /* default */], {
        topAngle: 14,
        backgroundColor: this.props.colors.highlight,
        style: { position: 'relative' }
      }, void 0, _jsx('div', {
        style: {
          color: Object(Color["c" /* textColor */])(this.props.colors.highlight),
          textAlign: 'center',
          maxWidth: justDoItWidth + 'rem',
          padding: '0 2rem',
          margin: 'calc(-12vw + 12rem) auto 10rem'
        }
      }, void 0, _jsx(Typography["c" /* H3 */], {
        style: { margin: '0.5em 0 1.5rem' }
      }, void 0, 'Start browsing.', _ref3, 'You\u2019ll love Storytape.'), _ref4), this.state.scenes.length > 0 && _jsx('div', {
        style: { position: 'relative', zIndex: 1 }
      }, void 0, sceneColumn && _jsx('div', {}, void 0, _jsx(SceneRow, {
        allSenes: this.state.scenes,
        count: 1,
        offset: 0,
        width: sceneCardWidth,
        margin: sceneCardMargin,
        cardStyle: { width: '100%' }
      }), _jsx(SceneRow, {
        allSenes: this.state.scenes,
        count: 1,
        offset: 1,
        width: sceneCardWidth,
        margin: sceneCardMargin,
        cardStyle: { width: '100%' },
        style: {
          margin: sceneCardMargin / 10 * 2 + 'rem 0'
        }
      }), _jsx(SceneRow, {
        allSenes: this.state.scenes,
        count: 1,
        offset: 2,
        width: sceneCardWidth,
        margin: sceneCardMargin,
        cardStyle: { width: '100%' }
      })), !sceneColumn && _jsx('div', {}, void 0, _jsx(SceneRow, {
        allSenes: this.state.scenes,
        count: count,
        offset: 0,
        width: sceneCardWidth,
        margin: sceneCardMargin,
        style: { left: '-' + sceneCardWidth * 0.033 + 'rem' }
      }), _jsx(SceneRow, {
        allSenes: this.state.scenes,
        count: count,
        offset: count,
        width: sceneCardWidth,
        margin: sceneCardMargin,
        style: {
          left: '-' + sceneCardWidth * 0.066 + 'rem',
          margin: sceneCardMargin / 10 * 2 + 'rem 0'
        }
      })), _jsx('div', {
        style: {
          margin: '6rem auto calc(-12vw + 12rem)',
          display: 'flex',
          justifyContent: 'center'
        }
      }, void 0, _jsx(Link["a" /* default */], {
        to: '/browse'
      }, void 0, _jsx(Button["a" /* default */], {
        baseColor: this.props.colors.light,
        arrow: true
      }, void 0, 'Continue\xA0Browsing')))), _jsx(Section["a" /* default */], {
        angle: 14,
        backgroundColor: this.props.colors.light,
        style: {
          pointerEvents: 'none',
          position: 'absolute',
          zIndex: 0,
          top: '75%',
          bottom: 0
        },
        contentStyle: {
          height: '100%'
        }
      })), _jsx(Section["a" /* default */], {
        topAngle: 14,
        topMargin: 0,
        backgroundColor: Style["a" /* default */].Colors.white,
        contentStyle: { padding: '6rem 3rem 10rem', textAlign: 'center' }
      }, void 0, _jsx('a', {
        id: 'plans',
        style: { position: 'relative', top: '-10rem' }
      }), _jsx(Typography["c" /* H3 */], {
        style: { maxWidth: '16em', margin: 'auto' }
      }, void 0, 'A plan for every budget.'), _jsx(Typography["m" /* P1 */], {
        style: { paddingTop: '1.5rem', maxWidth: '22em', margin: 'auto' }
      }, void 0, 'Upgrade, downgrade or cancel\xA0anytime.'), _jsx('div', {
        style: { margin: '6rem auto 2rem' }
      }, void 0, _jsx('span', {
        style: {
          display: 'inline-block',
          minWidth: '12rem',
          textAlign: 'left'
        }
      }, void 0, 'Paying ', this.props.plan.annual ? 'Annually' : 'Monthly'), ' ', _jsx(Toggle["a" /* default */], {
        checked: this.props.plan.annual,
        onToggle: this.props.onSetAnnual,
        style: { display: 'inline-block' }
      })), _jsx('div', {}, void 0, _jsx(SubscriptionPlans["a" /* default */], {
        plan: this.props.plan,
        onSelectPlan: this.props.onSelectPlan,
        bannerColor: this.props.colors.highlight
      }))), _ref5);
    }
  }]);

  return Pricing;
}(react_default.a.PureComponent);

Pricing_Pricing.defaultProps = {};


function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
    plan: state.plan.chosenPlan,
    loggedIn: state.cognito.state === react_cognito["CognitoState"].LOGGED_IN,
    colors: state.ui.colors,
    layoutLoaded: state.runtime.layoutLoaded
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLatestScenes: function getLatestScenes(min, max) {
      return dispatch(Object(search["h" /* getLatestScenes */])(min, max));
    },
    showSignup: function showSignup() {
      return dispatch(Object(user["h" /* showSignup */])());
    },
    onSelectPlan: function onSelectPlan(planName) {
      return dispatch(Object(plan["f" /* setChosenPlan */])({ name: planName })).then(function () {
        return setTimeout(dispatch, 1000, Object(user["h" /* showSignup */])());
      });
    },
    onSetAnnual: function onSetAnnual(annual) {
      return dispatch(Object(plan["f" /* setChosenPlan */])({ annual: annual }));
    },
    updateColors: function updateColors(colors) {
      return dispatch(Object(ui["b" /* setColors */])(colors));
    },
    setMarketingVanityAnimation: function setMarketingVanityAnimation() {
      return dispatch(Object(runtime["a" /* setRuntimeVariable */])('marketingVanityAnimation', true));
    }
  };
}

/* harmony default export */ var pricing_Pricing = (Object(lib_react["b" /* compose */])(Object(Footer["a" /* withFooterDrawer */])(), Object(es["connect"])(mapStateToProps, mapDispatchToProps))(Pricing_Pricing));

function SceneRow(_ref6) {
  var allSenes = _ref6.allSenes,
      count = _ref6.count,
      offset = _ref6.offset,
      width = _ref6.width,
      margin = _ref6.margin,
      style = _ref6.style,
      _ref6$cardStyle = _ref6.cardStyle,
      cardStyle = _ref6$cardStyle === undefined ? constants["l" /* EMPTY_OBJECT */] : _ref6$cardStyle;

  return _jsx('div', {
    style: _extends({
      position: 'relative',
      display: 'flex',
      flexDirection: 'row'
    }, style)
  }, void 0, times_default()(count, function (index) {
    var sceneClips = allSenes[(index + offset) % allSenes.length];
    var anyClip = sceneClips[0];
    var colorsImage = Object(Color["a" /* imageColors */])(anyClip.scene_colors);
    var colorsTheme = Object(Color["d" /* themeColors */])(anyClip.scene_colors);
    return _jsx('div', {
      style: _extends({
        minWidth: width / 10 + 'rem',
        maxWidth: '95vw',
        margin: '0 ' + margin / 10 + 'rem'
      }, cardStyle)
    }, index + '_' + anyClip.scene_id, _jsx(Link["a" /* default */], {
      to: '/browse/scene/' + anyClip.scene_slug
    }, void 0, _jsx(SceneCard["a" /* default */], {
      title: anyClip.scene_name,
      typeName: 'Scene',
      backgroundColor: colorsImage.dark,
      lqip: anyClip.scene_lqip,
      images: [anyClip.scene_thumbnail],
      highlightColor: colorsTheme.highlight,
      allClips: sceneClips
    })));
  }));
}
// CONCATENATED MODULE: ./src/routes/pricing/index.js
var pricing__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var action = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(context) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return context.store.dispatch(Object(search["h" /* getLatestScenes */])());

          case 2:
            return _context.abrupt('return', {
              chunks: ['marketing'],
              title: 'Plans & Pricing - Storytape',
              description: 'Storytape is remarkably affordable. Less than the cost of 1 clip on the big sites. There are no contracts either. Upgrade, downgrade, or cancel at any time.',
              component: pricing__ref2
            });

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var pricing__ref2 = pricing__jsx(Layout["a" /* default */], {
  transitionId: 'pricing',
  showHeader: true,
  headerNavLinks: constants["u" /* MARKETING_NAV_LINKS */]
}, void 0, pricing__jsx(pricing_Pricing, {}));

/* harmony default export */ var pricing = __webpack_exports__["default"] = (action);

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(19);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 1 modules
var Layout = __webpack_require__(1161);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(17);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(33);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./src/components/Footer/Footer.js
var Footer = __webpack_require__(1077);

// EXTERNAL MODULE: ./src/components/Header/Header.js + 4 modules
var Header = __webpack_require__(1073);

// EXTERNAL MODULE: ./src/components/Section/Section.js
var Section = __webpack_require__(933);

// EXTERNAL MODULE: ./src/components/PricingStrip/PricingStrip.js
var PricingStrip = __webpack_require__(1195);

// EXTERNAL MODULE: ./src/components/Style/Style.js
var Style = __webpack_require__(350);

// EXTERNAL MODULE: ./src/components/Typography/Typography.js
var Typography = __webpack_require__(887);

// CONCATENATED MODULE: ./src/routes/privacy/Privacy.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var _ref = _jsx(Typography["d" /* H4 */], {}, void 0, 'Storytape Agreements');

var _ref2 = _jsx('strong', {}, void 0, 'TERMS AND CONDITIONS OF USE');

var _ref3 = _jsx('strong', {}, void 0, 'Last Modified: November 10, 2017');

var _ref4 = _jsx('em', {}, void 0, 'Business Corporations Act');

var _ref5 = _jsx('strong', {}, void 0, 'Terms');

var _ref6 = _jsx('strong', {}, void 0, 'Website');

var _ref7 = _jsx('strong', {}, void 0, 'Clips');

var _ref8 = _jsx('strong', {}, void 0, 'Service');

var _ref9 = _jsx('a', {
  href: 'https://www.storytape.com',
  'class': 'uri'
}, void 0, 'https://www.storytape.com');

var _ref10 = _jsx('strong', {}, void 0, 'you');

var _ref11 = _jsx('strong', {}, void 0, 'your');

var _ref12 = _jsx('strong', {}, void 0, 'Licensing Video Clips ');

var _ref13 = _jsx('strong', {}, void 0, 'Subscription Models');

var _ref14 = _jsx('strong', {}, void 0, 'Starter Subscription');

var _ref15 = _jsx('strong', {}, void 0, 'Basic Subscription');

var _ref16 = _jsx('strong', {}, void 0, 'Unlimited Subscription');

var _ref17 = _jsx('strong', {}, void 0, 'Licensing Terms');

var _ref18 = _jsx('strong', {}, void 0, 'ICP\u2019s');

var _ref19 = _jsx('em', {}, void 0, 'Single Project Use ');

var _ref20 = _jsx('strong', {}, void 0, 'Single Use Restriction');

var _ref21 = _jsx('em', {}, void 0, 'Restrictions on Sublicensing or Selling our Clips (License Restrictions)');

var _ref22 = _jsx('strong', {}, void 0, '25% Restriction');

var _ref23 = _jsx('em', {}, void 0, 'Use of our Clips (License Restrictions)');

var _ref24 = _jsx('strong', {}, void 0, 'Models');

var _ref25 = _jsx('strong', {}, void 0, 'Pricing and Taxes ');

var _ref26 = _jsx('a', {
  href: 'https://www.storytape.com/pricing',
  'class': 'uri'
}, void 0, 'https://www.storytape.com/pricing');

var _ref27 = _jsx('strong', {}, void 0, 'Payment');

var _ref28 = _jsx('strong', {}, void 0, 'Terms');

var _ref29 = _jsx('strong', {}, void 0, 'Payment Processor');

var _ref30 = _jsx('strong', {}, void 0, 'Refunds ');

var _ref31 = _jsx('strong', {}, void 0, 'Your Content');

var _ref32 = _jsx('strong', {}, void 0, 'User Content');

var _ref33 = _jsx('strong', {}, void 0, 'Property and Feedback');

var _ref34 = _jsx('strong', {}, void 0, 'Feedback');

var _ref35 = _jsx('strong', {}, void 0, 'Intellectual Property Rights');

var _ref36 = _jsx('strong', {}, void 0, _jsx('span', {
  'class': 'underline'
}, void 0, 'ACCEPTANCE OF RISK AND DISCLAIMERS'));

var _ref37 = _jsx('strong', {}, void 0, 'EVERYTHING ON OUR WEBSITE AND ALL PRODUCTS (INCLUDING OUR CLIPS) OFFERED AS PART OF OUR SERVICE ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND INCLUDING ALL IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.', ' ');

var _ref38 = _jsx('strong', {}, void 0, 'YOU AGREE THAT WHILE WE STRIVE TO HAVE ERROR FREE AND UNINTERRUPTED SERVICE, WE DO NOT GUARANTEE THE ABSENCE OF INTERRUPTIONS NOR SHALL YOU HOLD US LIABLE FOR ANY DAMAGE SUCH INTERRUPTIONS MAY CAUSE.');

var _ref39 = _jsx('strong', {}, void 0, _jsx('span', {
  'class': 'underline'
}, void 0, 'LIMITATION OF OUR LIABILITY'));

var _ref40 = _jsx('strong', {}, void 0, 'YOU AGREE THAT, TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL WE, OUR AFFILIATES, OFFICERS, DIRECTORS, SHAREHOLDERS, EMPLOYEES, CONTRACTORS, AGENTS, SUPPLIERS, OR LICENSORS BE LIABLE, HOWSOEVER CAUSED, FOR ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY OR CONSEQUENTIAL DAMAGES, REGARDLESS OF LEGAL THEORY AND WHETHER OR NOT WE HAVE BEEN WARNED OF THE POSSIBILITY OF SUCH DAMAGES AND WHETHER THOSE DAMAGES WERE FORESEEABLE OR NOT.');

var _ref41 = _jsx('strong', {}, void 0, 'IF YOU ARE DISSATISFIED WITH THE WEBSITE OR SERVICE, OR DO NOT AGREE WITH ANY PART OF THESE TERMS, OR HAVE ANY OTHER DISPUTE OR CLAIM WITH OR AGAINST US, OUR AFFILATES, OFFICERS, DIRECTORS, SHAREHOLDERS, EMPLOYEES, CONTRACTORS, AGENTS, SUPPLIERS OR LICENSORS, THEN YOUR REMEDIES ARE TO (I) DISCONTINUE ACCESSING AND USING THE WEBSITE AND SERVICE; AND (II) TERMINATE YOUR SUBSCRIPTION WITH US, IN ACCORDANCE WITH THESE TERMS.');

var _ref42 = _jsx('strong', {}, void 0, 'IN ADDITION TO YOUR AGREEMENT TO NOT HOLD THE ABOVE ENTITIES AND PERSONS LIABLE FOR ANY DAMAGES, IN THE EVENT A COURT OR ARBITRATOR OF COMPETENT JURISDICTION DECLINES TO UPHOLD SAID CLAUSE, YOU AGREE THAT IN NO CIRCUMSTANCES SHALL THE AGGREGATE LIABILITY FOR ANY AND ALL CLAIMS RELATING TO OR IN ANY WAY ARISING FROM THE USE OF OUR WEBSITE OR SERVICE, OR IN ANY WAY RELATED TO THESE TERMS, BE MORE THAN THE AMOUNT PAID BY YOU TO US (IF ANY).');

var _ref43 = _jsx('strong', {}, void 0, _jsx('span', {
  'class': 'underline'
}, void 0, 'YOU AGREE AND ACKNOWLEDGE THAT ACCESS TO OUR WEBSITE AND SERVICE, AND IF YOU ARE A PAYING CUSTOMER, THE FEES PAID BY YOU, REFLECT THE ALLOCATION OF RISK SET FORTH IN THESE TERMS AND THAT WE WOULD NOT ENTER INTO THIS AGREEMENT OR GRANT ACCESS TO THE WEBSITE OR SERVICE WITHOUT THESE RESTRICTIONS AND LIMITATIONS ON OUR LIABILITY.'));

var _ref44 = _jsx('strong', {}, void 0, _jsx('span', {
  'class': 'underline'
}, void 0, 'INDEMNIFICATION AND HOLD HARMLESS'));

var _ref45 = _jsx('strong', {}, void 0, 'YOU AGREE TO INDEMNIFY US, OUR AFFILIATES, EMPLOYEES, SHAREHOLDERS, DIRECTORS, AGENTS, REPRESENTATIVES AND CONTRACTORS, AND TO DEFEND AND HOLD EACH OF THEM HARMLESS, FROM ANY AND ALL CLAIMS AND LIABILITIES (INCLUDING REASONABLE LEGAL FEES) WHICH MAY ARISE FROM, AMONG OTHER THINGS (I) YOUR VIOLATION OF THESE TERMS, OR ANY POLICY INCOROPRATED BY REFERENCE; (II) YOUR VIOLATION OF ANY THIRD-PARTY RIGHT; OR (III) ANY BREACH OF A REPRESENTATION OR WARRANTY MADE BY YOU TO US, EITHER IN THESE TERMS, PRIVACY POLICY OR OTHERWISE.');

var _ref46 = _jsx('strong', {}, void 0, _jsx('span', {
  'class': 'underline'
}, void 0, 'AMENDMENTS '));

var _ref47 = _jsx('strong', {}, void 0, 'AS OUR WEBSITE AND SERVICE CONTINUE TO CHANGE, WE MAY, AT ANY TIME, REVISE THESE TERMS AND OUR POLICIES BY UPDATING THIS PAGE OR THE PAGE HOSTING THE RELEVANT POLICY. THE DATE OF THE LAST VERSION OF THESE TERMS IS POSTED ABOVE. AS YOU ARE BOUND BY THESE TERMS EACH TIME YOU VISIT OUR WEBSITE OR USE OUR SERVICE, YOU ARE RESPONSIBLE FOR PERIODICALLY REVIEWING THE AMENDMENTS TO THESE TERMS AND YOU ARE DEEMED TO HAVE ACCEPTED AND AGREED TO SUCH AMENDMENTS BY ACCESSING AND USING THE WEBSITE AND SERVICE AFTER SUCH AMENDMENTS HAVE BEEN POSTED. IF YOU DO NOT AGREE WITH THE AMENDMENTS, YOU CAN TERMINATE YOUR SUBSCRIPTION AND STOP ACCESSING THE WEBSITE AND SERVICE. WE MAY ALSO UNDERTAKE TO SEND YOU NOTICE OF ANY CHANGES TO THE TERMS OR POLICIES.', ' ');

var _ref48 = _jsx('strong', {}, void 0, 'Copyright Notice');

var _ref49 = _jsx('strong', {}, void 0, 'Linked Sites');

var _ref50 = _jsx('strong', {}, void 0, 'Linked Sites');

var _ref51 = _jsx('strong', {}, void 0, 'Law of the Contract (Governing Law) and Jurisdiction.', ' ');

var _ref52 = _jsx('strong', {}, void 0, 'Severability ');

var _ref53 = _jsx('strong', {}, void 0, 'No Construction Against Drafter');

var _ref54 = _jsx('strong', {}, void 0, 'Waiver of Class Proceedings and Trial By Jury');

var _ref55 = _jsx('strong', {}, void 0, 'Incorporation by Reference');

var _ref56 = _jsx('strong', {}, void 0, 'Termination');

var _ref57 = _jsx('strong', {}, void 0, 'Assignment ');

var _ref58 = _jsx('strong', {}, void 0, 'Right to Seek Injunction');

var _ref59 = _jsx('strong', {}, void 0, 'Waiver');

var _ref60 = _jsx('strong', {}, void 0, 'Other Terms ');

var _ref61 = _jsx('strong', {}, void 0, 'Entire Agreement');

var _ref62 = _jsx('strong', {}, void 0, 'PRIVACY POLICY');

var _ref63 = _jsx('strong', {}, void 0, 'Last Modified: May 25, 2018');

var _ref64 = _jsx('a', {
  href: 'https://www.storytape.com',
  'class': 'uri'
}, void 0, 'https://www.storytape.com');

var _ref65 = _jsx('em', {}, void 0, 'Collection of Personal and Business Information');

var _ref66 = _jsx('a', {
  href: 'https://www.google.com/analytics'
}, void 0, 'Google Analytics');

var _ref67 = _jsx('strong', {}, void 0, 'TO THE EXTENT YOU PROVIDE US WITH, OR UPLOAD DATA THAT INCLUDES THE PERSONAL INFORMATION OF ANOTHER PERSON, YOU REPRESENT AND WARRANT THAT YOU HAVE THEIR AUTHORIZATION TO PROVIDE US WITH THAT INFORMATION IN ACCORDANCE WITH THIS PRIVACY POLICY AND OUR TERMS AND CONDITIONS OF USE.', ' ');

var _ref68 = _jsx('em', {}, void 0, 'Credit Card and Payment Processing Companies');

var _ref69 = _jsx('em', {}, void 0, 'The Use of Your Personal Information');

var _ref70 = _jsx('strong', {}, void 0, 'IN ADDITION, WE RESERVE THE RIGHT TO PROVIDE YOUR CONTENT AND INFORMATION (INCLUDING BUT NOT LIMITED TO YOUR PERSONAL INFORMATION) UPLOADED OR COLLECTED BY OUR WEBSITE OR OTHERWISE PROVIDED TO US, TO THIRD PARTIES IF REQUIRED BY LAW IN ANY JURISDICTION.');

var _ref71 = _jsx('strong', {}, void 0, 'IF WE ARE REQUIRED BY LAW TO MAKE ANY DISCLOSURE OF YOUR CONTENT OR PERSONAL OR BUSINESS INFORMATION, WE ', _jsx('em', {}, void 0, 'MAY'), ' (', _jsx('span', {
  'class': 'underline'
}, void 0, 'BUT ARE NOT OBLIGATED TO'), ') PROVIDE YOU WITH WRITTEN NOTICE (TO THE EXTENT PERMITTED BY LAW) PRIOR TO SUCH DISCLOSURE SO THAT YOU MAY TAKE APPROPRIATE ACTION.', ' ');

var _ref72 = _jsx('em', {}, void 0, 'The Disclosure of Your Personal Information and Access to It');

var _ref73 = _jsx('a', {
  href: 'https://aws.amazon.com/compliance/gdpr-center',
  'class': 'uri'
}, void 0, 'https://aws.amazon.com/compliance/gdpr-center');

var _ref74 = _jsx('a', {
  href: 'https://rollbar.com',
  'class': 'uri'
}, void 0, 'https://rollbar.com');

var _ref75 = _jsx('a', {
  href: 'https://rollbar.com/privacy',
  'class': 'uri'
}, void 0, 'https://rollbar.com/privacy');

var _ref76 = _jsx('em', {}, void 0, 'European Union\u2019s General Data Protection Regulation (\u201CGDPR\u201D)');

var _ref77 = _jsx('strong', {}, void 0, 'WHILE WE TAKE MEASURES TO PROTECT PERSONAL INFORMATION, YOU AGREE THAT, TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL WE, OUR AFFILIATES, OFFICERS, DIRECTORS, SHAREHOLDERS, EMPLOYEES, CONTRACTORS, AGENTS, SUPPLIERS, OR LICENSORS BE LIABLE, HOWSOEVER CAUSED, FOR THE LOSS OR THEFT OF YOUR PERSONAL INFORMATION OR ANY DAMAGES CAUSED AS A RESULT THEREOF, SO LONG AS WE WERE NOT GROSSLY NEGLIGENT IN THE PROTECTION OF THAT INFORMATION.');

var _ref78 = _jsx('em', {}, void 0, 'Retention of Your Personal Information');

var _ref79 = _jsx('em', {}, void 0, 'Inquiries');

var _ref80 = _jsx('a', {
  href: 'mailto:hello@storytape.com'
}, void 0, 'hello@storytape.com');

var _ref81 = _jsx('em', {}, void 0, 'Use of Cookies');

var _ref82 = _jsx('strong', {}, void 0, 'ACCEPTABLE USE POLICY ');

var _ref83 = _jsx('strong', {}, void 0, 'Last Modified: November 10, 2017 ');

var _ref84 = _jsx(PricingStrip["a" /* default */], {});

var Privacy_Privacy = function (_React$PureComponent) {
  _inherits(Privacy, _React$PureComponent);

  function Privacy() {
    _classCallCheck(this, Privacy);

    return _possibleConstructorReturn(this, (Privacy.__proto__ || Object.getPrototypeOf(Privacy)).apply(this, arguments));
  }

  _createClass(Privacy, [{
    key: 'render',
    value: function render() {
      var pagePadding = '7rem 2rem 0';
      var P1Margin = '0 0 2rem';

      return _jsx('div', {
        style: { position: 'relative' }
      }, void 0, _jsx(Section["a" /* default */], {
        backgroundColor: Style["a" /* default */].Colors.shadow4,
        angle: 17,
        style: {
          position: 'absolute',
          top: 'calc(15rem + 30vw)',
          left: 0,
          zIndex: 0,
          opacity: 0.1
        },
        contentStyle: { height: '30rem' }
      }), _jsx(Section["a" /* default */], {
        style: { position: 'relative', zIndex: 1 },
        contentStyle: { padding: pagePadding }
      }, void 0, _jsx('div', {
        style: { maxWidth: '70rem', margin: '3rem auto' }
      }, void 0, _ref), _jsx('div', {
        style: { maxWidth: '70rem', margin: '3rem auto' }
      }, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref2), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref3), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Pro Church Tools Inc., also operating under the trade name Storytape, is a corporation formed pursuant to the', ' ', _ref4, ', R.S.O. 1990, c. B.16 in Ontario, Canada. In consideration for permitting your access to our website, products and services, and other good and valuable consideration, you agree as follows:'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'These terms and conditions (the "', _ref5, '") form a legally binding agreement which govern your access to and use of Pro Church Tools Inc.\'s, ("we", "us" or "our") website ("', _ref6, '") and our online service, in which we license non-exclusive rights to stock video clips (\u201C', _ref7, '\u201D) on a per project basis (the "', _ref8, '"). The Website and Service are hosted at', ' ', _ref9, ' ', 'and other domains and sub-domains.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'By using our Website and Service, you, the user ("', _ref10, '" or "', _ref11, '"), represent that you are at least 18 years old. If you are using the Website and/or Service or are licensing content from us on behalf of, or in the employ of, an organization (corporation, trust, partnership, church, not-for-profit, etc.), you are agreeing to these Terms for that organization and representing and warranting that you have the authority to bind that organization to these Terms. In such a case, "you" and "your" will also refer to that organization and yourself individually. For greater clarity, both you as an individual and your organization are legally bound by these terms which form an agreement between you and Pro Church Tools Inc.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref12), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'We offer three different subscription models to access and license our Clips; Starter, Basic and Unlimited (collectively the \u201C', _ref13, '\u201D):'), _jsx('ul', {}, void 0, _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref14, ' \u2013 Credits you to license a maximum of 5 Clips per month, each in 1080p resolution;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref15, ' \u2013 Credits you to license a maximum of 20 Clips per month, each in 1080p resolution; and')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref16, ' \u2013 Allows you to license an unlimited number of Clips per month in either 1080p or 4K resolution.'))), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Credits under both the Starter and Basic Subscriptions do not carry forward month-to-month.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref17), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Where you apply your account credits, under any Subscription Model, to download a Clip from us, we grant you, and only you, a non-exclusive, royalty-free, worldwide license to use the Clip in a single video project, in accordance with the terms of this agreement.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'You agree and acknowledge that we, or where applicable, our independent content providers (\u201C', _ref18, '\u201D), will continue to own the Clips licensed to you under each Subscription Model. We are not transferring, selling or assigning title or ownership of any Clips to you. Nor are we waiving any copyright or moral rights to Clips.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref19), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Our Service is different from most stock video licensing websites. Our Clips are licensed on a per project basis. This means that you are only permitted to use Clips licensed and downloaded from us in a single video project (the \u201C', _ref20, '\u201D).'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Each time you select a Clip to license and download, you will be prompted to provide a brief description of the project you will use the Clip in. This helps us identify what video projects you licensed our content for. It is your responsibility to accurately describe the video project(s). You agree that we may ask you, at any time, to update or provide more clarity on which video project(s) you have, or intend to use, our Clips in. We may also temporarily suspend your ability to download a Clip until you provide an accurate description of your project(s), or if we believe your use or intended use is in breach of these Terms.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Under both the Starter and Basic subscriptions, if you wish to use a Clip more than once, for example in a second video project, you are required to use a second credit for the same Clip. However, if you subscribe to our Unlimited plan, you can use each Clip you download in multiple video projects. Under the Unlimited plan, we still ask that you provide a description of each project you are using our Clips in. This helps us track and monitor permitted usage of our Clips.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref21), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'You agree that our Clips shall not be used on, or in connection with, any other stock video website or business that is competitive in nature with our Service.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Where you create a video project that uses a Clip from us, you may only sell or license your video where our Clip(s) do not comprise more than twenty-five percent (25%) of the overall duration of the video (the \u201C', _ref22, '\u201D).'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Notwithstanding the above, where you create a video for a single customers or client in the course of carrying on a video production service, you are permitted to license the right to use your video, with our Clips comprising in excess of 25% of the overall video, so long as; (1) you comply with our Single Use Restriction; and (2) your customer or client is restricted from sub-licensing or selling the video, or any of our Clips or portions of our Clips.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Prior to the sale or licensing of your videos, which include our Clips, you shall disclose to the purchaser, licensee or other applicable third-party, the fact that we own the Clips and that their use is restricted by these Terms, including for example, the Single Use Restriction and the 25% Restriction. This means that your customers or clients are restricted from on-selling or re-licensing our Clips, or using our Clips, or portions thereof, in any other video, project or business.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref23), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'You agree that you will not use, or allow the use of our Clips in videos, advertisements, or in a context (for example on a website) that associates our Clips with unlawful, obscene, defamatory, libelous, harmful, hateful, harassing, bullying, pornographic, threatening, racially or ethnically offensive or abusive content, products or services.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'You further agree that you will not use, or allow the use of our Clips in videos, movies, advertisements, or in a context (for example on a website) that may encourage a criminal offense, give rise to civil liability (including for example intellectual property infringement), or violate any local, state, provincial, national or international law or regulation, or that is otherwise inappropriate.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Some of our Clips may feature individual (\u201C', _ref24, '\u201D). You agree that you will not use any of our Clips and will not display Models in any videos or other content in a manner which a reasonable person, in the Model\u2019s circumstances, would find offensive or objectionable. Without limiting the forgoing, you agree that Clips displaying a Model will not be used in connection with, or in any way related to videos, businesses, projects or websites which:'), _jsx('ul', {}, void 0, _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Have or display pornographic, nude, unlawful or immoral content;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Have or display, whether for sale or otherwise, unlawful drugs or tobacco products;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Portray the Model negatively or are derogatory to him or her;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Portray the Model as accepting of or promoting defamatory, libelous, harmful, hateful, harassing, bullying, pornographic, threatening, racially or ethnically offensive or abusive content, products or services; or')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Advertise or promote adult entertainment establishments or businesses, escort or dating services.'))), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Where our Clips are used in violation of these Terms, you agree to immediately delete any such infringing content and remove it from the Internet.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref25), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'For current pricing on each Subscription Model, please visit', ' ', _ref26, '. Prices listed are subject to change, however, we will not change the pricing for current subscribers, so long as you remain a subscriber.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Prices displayed are an invitation to make an offer and are subject to acceptance by us. Even in the event of an automated acceptance by us, you agree that we shall have the opportunity to review and accept subscription orders and confirm your payment information for a period of seven (7) days following your subscription.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Prices are subject to the addition of sales taxes. You agree to pay all sales taxes applicable to this agreement, arising from your subscription or the licensing of Clips from us.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Additional terms, including but not limited to, price, tax, payment, discounts, refunds or cancellations may be specified on the Website and Service. Those terms, as amended from time to time, are incorporated by reference and form part of this agreement.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref27, ' ', _ref28), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Payment for your subscription is due monthly, in advance. In the alternative, you may elect to pay for your subscription on an annual basis.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'We collect credit card information from you online via a third-party payment processor (\u201C', _ref29, '\u201D). You agree and authorize us to bill your credit card via our Payment Processor.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Your personal and payment information is collected and processed in accordance with our Privacy Policy. By providing your payment information, you consent to such processing and warrant that all information provided by you is accurate.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Although the Payment Processor\u2019s electronic forms may be hosted on our Website or Service, we accept no responsibility or liability for their collection and storage of your payment details or personal information. The Payment Processor may have their own terms and conditions and privacy policies, which apply to your personal information and payment transactions. Please contact us if you have any questions concerning our Payment Processor.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref30), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Once you select a Clip to license and it is made available for download, your account credit(s) are non-refundable under the Starter and Basic plans, please choose Clips carefully.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Proprietary Rights'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Our Website and Service contain open source and public domain content, licenced content as well as proprietary content owned by us and by third parties (including ICPs).'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Aside from Clips which you are licensed to use, on a limited basis in accordance with these Terms, you are not permitted to copy, share, sell or distribute any other content (including but not limited to text, images, trademarks, videos and audio) on the Website or Service, without the express consent of the owner. All other contents of the Website and Service, including but not limited to, the computer code, is the property of Pro Church Tools Inc. and/or our ICP\u2019s with all rights reserved.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Without limiting the forgoing, you are not permitted to, (a) record, copy, share, reproduce, remove watermarks, sell or distribute any content on our Website or Service without our express written permission; or (b) use any trademark or trade name of Pro Church Tools Inc. including our logo, without our express permission.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref31), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'In some cases, our Website and Service may permit you and other third-parties to upload, contribute and post content ("', _ref32, '"). We do not pre-screen User Content uploaded or posted to the Website or Service by you or other users. You grant us a non-exclusive, transferable, sub-licensable, royalty-free, worldwide license to use any of your User Content that you post, record, upload or otherwise contribute in order to facilitate the ordinary use of the Website and Service.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'We may, but have no obligation to, remove User Content that we determine in our sole discretion to be unlawful, damaging, or violate any third-party\'s intellectual property rights, these Terms or any policy incorporated by reference herein.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'In addition to our Acceptable Use Policy, you agree not to use the Website or Service in any manner which may infringe the copyright or other intellectual property rights of any third party or in any manner which is unlawful, offensive, threatening, libelous, defamatory, obscene or in violation of these Terms.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref33), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'All rights, title and interest in and to the Website, the Service and their contents (including our Clips) are and will remain the exclusive property of Pro Church Tools Inc., our ICP\u2019s and licensors, including all Intellectual Property Rights (as defined below), even if we incorporate any of your Feedback (as defined below) into subsequent versions.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'The Website, Service and their contents, including our video Clips are protected by copyright, trademark and other laws of Canada, the United States and foreign countries. Except as expressly permitted in these Terms, you may not reproduce, modify or prepare derivative works, distribute, sell, transfer, publicly display, publicly perform, transmit, or otherwise use our Website, Service, Clips or any portion of their contents.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'All feedback, comments, and suggestions for improvements (\u201C', _ref34, '\u201D) that you provide to us, in any form, will immediately become our sole and exclusive property. You agree to transfer and assign to us all of your rights, title and interest in and to all of your Feedback, including all worldwide patent rights, copyright rights, and other intellectual property rights (collectively, the \u201C', _ref35, '\u201D).'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref36), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref37), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref38), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref39), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref40), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref41), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref42), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref43), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref44), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref45), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref46), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref47), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref48), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'If you believe that your copyrighted work has been used in a way that constitutes copyright infringement and is accessible on our Website or Service, please notify us at hello@storytape.com. While we take no responsibility for any user other third-party who breaches your copyright or other intellectual property rights, we may, in our sole discretion and without liability, undertake to attempt to contact the infringer on your behalf and remove the content from our Service.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref49), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Whether or not we are affiliated with sites or third-party vendors that may be linked to our Website or Service, we are not responsible for their content (the "', _ref50, '"). The Linked Sites are for your convenience only and you access them at your own risk. We and other users provide links and references to material on other websites not owned or operated by us. Links found on our Website or Service are not an endorsement and we do not represent or warrant the accuracy or truth of the contents of information found on said websites. You access those links and corresponding sites at your own risk.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref51), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'These Terms, all documents incorporated by reference and your relationship with us shall be governed by, construed and enforced in accordance with the laws of the Province of Ontario, Canada, (and any Canadian federal laws applicable therein) as it is applied to agreements entered into and to be performed entirely within such province.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'You hereby agree to irrevocably and unconditionally submit to the jurisdiction of the courts and tribunals of Ontario, Canada (including the Federal courts and tribunals as applicable therein) to settle any disputes arising out of or in any way related to these Terms, all documents incorporated by reference and your relationship with us.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref52), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'If any provision of these Terms are found to be unlawful, void, or for any reason unenforceable, then that provision shall be deemed severable from this agreement and shall not affect the validity and enforceability of any remaining provisions.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref53), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'If an ambiguity or question of intent arises with respect to any provision of these Terms, the Terms shall be construed as if drafted jointly by the parties and no presumption or burden of proof will arise favouring or disfavouring either party by virtue of authorship of any of the provisions of these Terms.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref54), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'To the extent permitted by law, you hereby waive your right to participate in any class action lawsuits against us, our contractors, employees, shareholders, successors, assigns and directors.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'To the extent permitted by law, you further waive any right to a trial by jury, should such a right exist, in relation to any legal dispute connected to or in any way arising out of these Terms.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref55), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'All policies referred to in these Terms or anywhere on our Website or Service are hereby incorporated by reference and form part of this agreement, including but not limited to our Privacy Policy and Acceptable Use Policy.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref56), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'You may cancel your subscription or account with us at any time. However, monthly subscription credits purchased to download Clips from us are not refundable. You should ensure that you use all of your account credits prior to canceling your subscription.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'We may also cancel, suspend or terminate your account if we reasonably believe you have or may breach these Terms or any policy incorporated by reference.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'The cancellation, suspension or termination of your subscription or account with us shall not terminate this agreement. In particular, and without limiting the generality of the foregoing, any provision concerning the limitation of our liability, your indemnification obligations, intellectual property rights and obligations, settling disputes (including the jurisdiction and choice of law) shall remain binding.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref57), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'You agree that we may assign this agreement to any successor or assignee, whether pursuant to the purchase of our Website and Service, the transfer of control of Pro Church Tools Inc., or otherwise.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref58), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Violation of these Terms may cause us irreparable harm and, therefore, you agree that we will be entitled to seek extraordinary relief including, but not limited to, temporary restraining orders, preliminary injunctions and permanent injunctions without the necessity of posting a bond or other security, in addition to and without prejudice to any other rights or remedies that we may have for a breach of these Terms.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref59), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Our failure to enforce any right or provision of these Terms will not be deemed a waiver of such right or provision.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref60), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Any new features that augment or enhance the current Website and Service, including the release of new versions, new Clips, products or services, tools and resources, shall be subject to these Terms. Continued use of the Website and Service after any such changes shall constitute your consent to such changes.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref61), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'This is the entire agreement between the parties relating to the matters contained herein and shall not be modified except in writing, signed by a duly authorized representative of Pro Church Tools Inc.')), _jsx('div', {
        style: { maxWidth: '70rem', margin: '3rem auto' }
      }, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref62), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref63), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'This privacy policy applies to the collection and use of your personal information via our (Pro Church Tools Inc.\u2019s) website, hosted at', ' ', _ref64, '.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'By accessing our website and uploading your personal information, you consent to the collection and use of your personal information in accordance with this privacy policy, which may be updated from time to time.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref65), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'When using our website and licensing content from us, we may collect your personal and business information, including your:'), _jsx('ul', {}, void 0, _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Name;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Business or Organization Name;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Address;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Email address;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Phone number;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Comments, feedback, reviews and other information you upload or provide via the website;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'IP address and location data, including such data collected via', ' ', _ref66, ';')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Website statistics and analytics data regarding your use of the website;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Other types of raw data relating to how you interact with the website, for example, your browser information and session duration;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Payment, banking and credit card information, which is collected and stored via a third-party payment provider; and')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'All other information you provide to us on our website or otherwise.'))), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Third-party service providers we use may have their own privacy policies on the collection and use of your information which either we or you provide them.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref67), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref68), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'We collect credit card and payment information from you via a third-party. Their additional terms of service and privacy policies may apply to the collection and use of your personal information. If you have questions regarding our payment processor, please contact us.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Although the payment processor\u2019s electronic forms may be displayed on our website, you are providing the payment information directly to them. We will have access to your personal information via the payment provider, although not your full credit card number(s).'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref69), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'The collection of your personal information may be used to:'), _jsx('ul', {}, void 0, _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Facilitate the operation of the website, including:'), _jsx('ul', {}, void 0, _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'providing your personal information to third-party service providers, such as payment processors; and')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'delivering licensed content to you;')))), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Verify your contact information;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Promote our website and offerings to you in various forms of communication;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Support and improve the website and service we offer;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Provide customer support;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Communicate with you about your account, subscription and services we offer;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Bill and collect money owed to us;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Pursue available legal remedies to us and to prosecute or defend a court, arbitration or similar proceeding;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Send or display informational and promotional materials from us, our partners, advertisers or third parties to you;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'To meet legal requirements;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'To enforce compliance with any terms and conditions and applicable law; and')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Enhance our service offerings to you and offer you related products and services, whether by email, advertisements or otherwise.'))), _jsx('blockquote', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref70), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref71)), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref72), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'We may share your personal information with our payment providers, advertisers, partners and employees to use that information for one or more of the purposes in which that information was collected.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'We also operate the website in conjunction with our independent contractors and independent web developers and designers. Our independent contractors may have access to your personal information in providing services to us, or providing you with access to the website and your licensed content. We may use a variety of service providers, contractors, servers or employees in locations both inside and outside of Canada, which may make your personal information the subject of foreign laws and foreign legal proceedings.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'As at the date of the last version of this privacy policy, we use the following additional service providers, aside from our independent contractors and web development and design firm:'), _jsx('ul', {}, void 0, _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Amazon Web Services, Inc. and/or its affiliates (\u201CAWS\u201D) is used for hosting website data, including the data you submit, and which may include personal information. For more information on AWS\u2019s privacy practices, visit', ' ', _ref73, ';')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Rollbar Inc. (', _ref74, ') is used for error monitoring related to the Website. For more information on Rollbar Inc.\u2019s privacy practices, visit', ' ', _ref75, '; and'))), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'We may also disclose your personal information to our successors (if our business or the website is acquired by another legal entity) or any assignee of our assets relating to the website and our content.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref76), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Our privacy practices intend to meet the requirements of the GDPR. As a company that may process the personal information of persons who reside in or are citizens of the European Union (a \u201CEuropean person\u201D), we have implemented appropriate technical and organizational measures to meet the GDPR\u2019s requirements and protect European persons personal information. Our technical measures to protect personal information take into account current technology available and the costs of implementing that technology in addition to the nature, scope, context and purposes of the personal information collected and processed. If you have any questions about our technical and organizational measures to meet the GDPR requirements, please contact us.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref77), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref78), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'We keep your\xA0personal information for as long as it is required\xA0for the purpose for which it was collected.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref79), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'If you believe that we have not adhered to this Privacy Policy or would like to request an amendment to your personal information being held by us, please contact our Privacy Officer by e-mail at', ' ', _ref80, '.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref81), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Our Website may place a "cookie" in the browser files of your computer. You can disable cookies on your web browser, however, doing so may interrupt the proper use of our Website.')), _jsx('div', {
        style: { maxWidth: '70rem', margin: '3rem auto' }
      }, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref82), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, _ref83), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'You agree to use our Website and Service in accordance with the following acceptable use policy.'), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'You agree that you:'), _jsx('ol', {
        type: '1'
      }, void 0, _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not disclose your password or transfer your account to any third-party, or allow any third-party to access your account;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not use your account for your own commercial purposes by sublicensing any rights granted by the Terms without permission or, in any way, sharing the benefit of your account with others. Your account is non-transferrable and may only be used by you;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not upload, copy, distribute, share, or otherwise use content that is unlawful, obscene, defamatory, libelous, harmful, hateful, harassing, bullying, pornographic, threatening, racially or ethnically offensive or abusive, that would violate another person\'s rights (including their intellectual property rights), constitute or encourage a criminal offense, give rise to civil liability, or violate any local, state, provincial, national or international law or regulation, or that is otherwise inappropriate;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not upload, copy, distribute, share or otherwise use content that contains or embodies software viruses or any other malicious computer code that is designed to interrupt, undermine, destroy or limit the functionality of any computer software, hardware or communications equipment, or that is designed to perform functions on any software, hardware or equipment without the owner\'s express consent;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not impersonate any person or entity;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not access the Website and Service by any means other than through the interface provided by us for use in accessing the Website and Service. This includes not using or launching any automated system including, without limitation, any spider, robot (or "bot") or scraper.')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not interfere with or disrupt the Website, Service or servers or networks connected thereto, make the Service available over a network (other than our network) where it could be used by others or disobey any requirements,')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not collect, harvest or store any personally identifiable information, including user account information, from us;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not use the Website or Service in a way that has any unlawful or fraudulent purpose or effect;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not translate, reverse engineer, decompile, disassemble, modify or create derivative works based on the Website or Service, in whole or in part;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not circumvent, disable, violate or otherwise interfere with any security related feature of the Website or Service;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not rent, lease, sublicense, transfer, sell, trade, resell or exploit for any commercial purposes any portion of the Website or Service (including, without limitation, your account information, use of the Service or access to the Service;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not use the Website or Service in any way that violates the Terms, or that aids, encourages, or purports to authorize anyone else to violate the Terms or this policy;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not use the Website or Service in any way that intentionally or unintentionally violates any applicable local, state, provincial, national or international law, rule or regulation;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not employ misleading e-mail addresses or falsify information in any part of any communication;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'Will not upload, transmit, disseminate, post, store or post links to any content that:'), _jsx('ol', {
        type: 'a'
      }, void 0, _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'prohibits from transmitting or posting by law, or by contractual or fiduciary relationship;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'facilitates hacking or unauthorized access or use of data, systems, servers or networks including any attempt to probe, scan or test for vulnerabilities, or to breach security or authentication measures;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'interferes with service to any user, system or network by using flooding techniques, overloading a system or a network, staging or broadcasting an attack or any other means resulting in a crash of a host either deliberately or by negligence;')), _jsx('li', {}, void 0, _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'infringes on, or contributes to any infringement of, any intellectual property, material protected by copyright, trademark, patent, trade secret or proprietary right of any party.'))))), _jsx(Typography["m" /* P1 */], {
        style: { margin: P1Margin }
      }, void 0, 'We reserve the right in our sole discretion to revise this policy, which shall be posted on the Website and Service.')), _ref84));
    }
  }]);

  return Privacy;
}(react_default.a.PureComponent);

/* harmony default export */ var privacy_Privacy = (Object(Footer["a" /* withFooterDrawer */])()(Privacy_Privacy));
// CONCATENATED MODULE: ./src/routes/privacy/index.js
var privacy__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var privacy__ref = privacy__jsx(Layout["a" /* default */], {
  transitionId: 'privacy',
  showHeader: true
}, void 0, privacy__jsx(privacy_Privacy, {}));

function action() {
  return {
    chunks: ['marketing'],
    title: 'Legal',
    component: privacy__ref
  };
}

/* harmony default export */ var privacy = __webpack_exports__["default"] = (action);

/***/ })
]));


// WEBPACK FOOTER //
// marketing.57700e72.chunk.js